export default {
  country: {
    "CN": "中国大陆",
    "HK": "中国香港",
    "MO": "中国澳门",
    "TW": "中国台湾",
    "KR": "韩国",
    "JP": "日本",
    "AU": "澳大利亚",
    "SG": "新加坡",
    "MY": "马来西亚",
    "TH": "泰国",
    "VN": "越南",
    "PH": "菲律宾",
    "ID": "印度尼西亚",
    "DE": "德国",
    "IT": "意大利",
    "FR": "法国",
    "RU": "俄罗斯",
    "NZ": "新西兰",
    "NL": "荷兰",
    "SE": "瑞典",
    "UA": "乌克兰",
    "AE": "阿联酋",
    "AR": "阿根廷",
    "AT": "奥地利",
    "BE": "比利时",
    "BG": "保加利亚",
    "BR": "巴西",
    "BS": "巴哈马",
    "BY": "白俄罗斯",
    "BZ": "伯利兹",
    "CH": "瑞士",
    "CL": "智利",
    "CO": "哥伦比亚",
    "DK": "丹麦",
    "EE": "爱沙尼亚",
    "EG": "埃及",
    "ES": "西班牙",
    "FI": "芬兰",
    "HU": "匈牙利",
    "GR": "希腊",
    "IE": "爱尔兰",
    "IL": "以色列",
    "IN": "印度",
    "JO": "约旦",
    "KG": "吉尔吉斯斯坦",
    "KH": "柬埔寨",
    "LK": "斯里兰卡",
    "LT": "立陶宛",
    "LU": "卢森堡",
    "MA": "摩洛哥",
    "MN": "蒙古",
    "MV": "马尔代夫",
    "NG": "尼日利亚",
    "MX": "墨西哥",
    "NO": "挪威",
    "PA": "巴拿马",
    "PE": "秘鲁",
    "PL": "波兰",
    "PT": "葡萄牙",
    "QA": "卡塔尔",
    "RO": "罗马尼亚",
    "RS": "塞尔维亚",
    "SC": "塞舌尔",
    "SA": "沙特阿拉伯",
    "TN": "突尼斯",
    "TR": "土耳其",
    "VE": "委内瑞拉",
    "VG": "英属维尔京群岛",
    "ZA": "南非",
    "AL": "阿尔巴尼亚",
    "AO": "安哥拉",
    "AZ": "阿塞拜疆",
    "BF": "布基纳法索",
    "BH": "巴林",
    "BJ": "贝宁",
    "BN": "文莱",
    "BO": "玻利维亚",
    "CM": "喀麦隆",
    "CR": "哥斯达黎加",
    "CV": "佛得角",
    "CY": "塞浦路斯",
    "DJ": "吉布提",
    "GA": "加蓬",
    "GD": "格林纳达",
    "GE": "格鲁吉亚",
    "GM": "冈比亚",
    "GN": "几内亚",
    "GQ": "赤道几内亚",
    "GT": "危地马拉",
    "GW": "几内亚比绍",
    "GY": "圭亚那",
    "HN": "洪都拉斯",
    "HR": "克罗地亚",
    "JM": "牙买加",
    "KE": "肯尼亚",
    "KM": "科摩罗",
    "KW": "科威特",
    "KY": "开曼群岛",
    "LS": "莱索托",
    "LV": "拉脱维亚",
    "MD": "摩尔多瓦",
    "MG": "马达加斯加",
    "ML": "马里",
    "MR": "毛里塔尼亚",
    "MU": "毛里求斯",
    "MW": "马拉维",
    "MZ": "莫桑比克",
    "NA": "纳米比亚",
    "NE": "尼日尔",
    "NI": "尼加拉瓜",
    "OM": "阿曼",
    "PG": "巴布亚新几内亚",
    "PS": "巴勒斯坦",
    "RW": "卢旺达",
    "SI": "斯洛文尼亚",
    "SK": "斯洛伐克",
    "SL": "塞拉利昂",
    "SN": "塞内加尔",
    "SR": "苏里南",
    "SV": "萨尔瓦多",
    "SZ": "斯威士兰",
    "TD": "乍得",
    "TG": "多哥",
    "TJ": "塔吉克斯坦",
    "TM": "土库曼斯坦",
    "TT": "特立尼达和多巴哥",
    "TZ": "坦桑尼亚",
    "UG": "乌干达",
    "UY": "乌拉圭",
    "UZ": "乌兹别克斯坦",
    "YE": "也门",
    "ZM": "赞比亚",
    "ZW": "津巴布韦",
    "AD": "安道尔",
    "AF": "阿富汗",
    "AM": "亚美尼亚",
    "BA": "波黑",
    "BD": "孟加拉国",
    "BI": "布隆迪",
    "BW": "博茨瓦纳",
    "CD": "刚果（金）",
    "CF": "中非",
    "CG": "刚果（布）",
    "CI": "科特迪瓦",
    "CW": "库拉索",
    "DO": "多米尼加",
    "CZ": "捷克",
    "DZ": "阿尔及利亚",
    "EC": "厄瓜多尔",
    "GH": "加纳",
    "IQ": "伊拉克",
    "KZ": "哈萨克斯坦",
    "LA": "老挝",
    "LB": "黎巴嫩",
    "LR": "利比里亚",
    "LY": "利比亚",
    "ME": "黑山",
    "MF": "法属圣马丁",
    "MK": "北马其顿",
    "MM": "缅甸",
    "PK": "巴基斯坦",
    "PR": "波多黎各",
    "SO": "索马里",
    "VC": "圣文森特和格林纳丁斯",
    "XK": "科索沃",
    "NP": "尼泊尔",
    "MT": "马耳他",
    "GB": "英国",
    "US": "美国",
    "CA": "加拿大",
  },

  common: {
    and: "和",
    Success: "成功",
    Login: "登录",
    SignUp: "注册",
    Recovery: "账号找回",
    "Start-Date": "开始日期",
    "End-Date": "结束日期",
    "range-separator": "至",
    "change-lang-btn": "English",
    "go-back": "返回",
    "back-home": "回首页",
    "guan-zhu-gong-zhong-hao": "关注公众号",
    "jia-zai-zhong": "加载中...",
    "Select-All": "全选",
    "No-more": "没有更多了",
    Authorize: "授权",
    "All-Status": "全部状态",
    Confirm: "确定",
    Cancel: "取消",
    Home: "首页",
    Bot: "智能机器人 ",
    Insights: "舆情",
    Publish: "内容发布",
    Chat: "对话",
    Docs: "文档撰写",
    Advisor: "行业顾问",
    Templates: "模板中心",
    Wiki: "团队知识库",
    Team: "团队管理",
    Media: "媒体管理",
    Tools: "营销工具",
    Users: "用户管理",
    Text: "文字",
    Images: "图片",
    Emojis: "表情",
    Videos: "视频",
    Links: "链接",
    "Facebook-desc": "Facebook 是一个连接全球用户的社交媒体平台，主要提供个人社交、内容分享和商业广告推广服务。",
    "X-desc":
      "X平台（原Twitter）是一个全球性的社交媒体平台，用户可发布简短消息、图片、视频，与其他用户互动，还支持话题讨论、内容创作。",
    "TikTok-desc":
      "TikTok 是一个全球流行的短视频创作与分享平台，用户可创作音乐、舞蹈、搞笑、教育等内容，并通过点赞、评论、分享互动，平台通过算法推荐个性化内容。",
    "Instagram-desc": "Instagram，是Meta公司的一款免费提供在线图片及视频分享的社群应用软件。",
    "YouTube-desc": "YouTube是全球最大视频分享平台，用户可上传、观看及分享视频。",
    "VK-desc": "VK 是俄罗斯热门社交平台，集社交、音视频、支付等多功能于一体，在俄语区拥有庞大用户群体。",
    Access: "访问",
    Edit: "编辑",
    Delete: "删除",
    Tips: "提示",
    Upload: "上传",
    Local: "本地",
    Helper: "助手",
    Preview: "预览",
    "AI-Assisted": "AI辅助编写",
    Options: "选项",
    Story: "快拍",
    Posts: "帖文",
    Like: "点赞",
    Comment: "评论",
    Share: "分享",
    IamAIassistant: "我是AI小助手～",
    alwaysaskquestions: "您可以随时向我提问",
    Regenerate: "重新生成",
    Insert: "插入",
    Replace: "替换",
    "Stop-generating": "停止生成",
    "Please-enter-your-question": "请输入您的问题",
    Record: "操作记录",

    SmartFeatures: "智能功能",
    FriendlyLinks: "友情链接",
    aihub: "AIHub工具导航",
    ai2: "爱AI工具库",
    ai138: "AI工具网",
    toolsai: "AI工具导航",
    aishenqi: "AI神器大全",
    ttdh: "人工智能工具集",

    PrivacyPolicy: "隐私政策",
    TermsofUse: "使用须知",
    "Start-Date": "开始日期",
    "End-Date": "结束日期",
    "Range-Separator": "至",
    "Next-Step": "下一步",
    Verified: "已认证",
    Unverified: "未认证",
    Fans: "粉丝",
    Authorized: "已授权",
    "Not-Authorized": "未授权",
    "Grade-A": "高级",
    "Grade-B": "普通",
    "Grade-C": "可忽略",
    English: "英语",
    "Product-Preview": "商品预览图",
    "Product-Title": "商品标题信息",
    "View-Details": "查看详情",
    "Scan-Follow": "扫描关注JoinMC公众号",
    "Follow-Official": "关注公众号",
    "Video-Not-Supported": "您的浏览器不支持 video 标签。",
    "Input-Language-Name": "输入语言名称",
    "Bot-Name": "机器人名称",
    "Email-Address": "邮箱地址",
    Gender: "性别",
    "Country-Region": "国家和地区",
    Language: "语种",
    Timezone: "时区",
    "Last-Chat-Time": "最后对话时间",
    Unknown: "未知",
    Remark: "备注",
    "Add-Remark": "添加备注",
    "Remark-Placeholder": "请输入5～200的备注内容",
    "Resend-In-Seconds": "秒后重新获取",
    "Your-Colleague": "您的同事",
    "Contact-Advisor": "联系产品顾问",
    "Scan-To-Contact-Advisor": "请扫描二维码联系产品顾问",
    "Wechat-Pay": "微信支付",
    "Alipay-Pay": "支付宝支付",
    "Team-Balance": "团队余额",
    "JoinMC-Scene": "JoinMC 场景",
    "AI-Assistant": "AI 小助手",
    Info: "信息",
    Scene: "场景",
    "Payment-Success": "支付成功",
    "Payment-Failed": "支付失败",
    "Payment-Failed-Contact": "若已经付款成功，请联系产品顾问！",
    "Paying-Wait": "正在支付，请稍候...",
    "Confirm-Recharged": "是否已完成充值？",
    "Got-It": "知道了",
    Close: "关闭",
    "Order-Not-Found": "未找到支付宝订单号，请重新发起支付！",
    Notice: "提示",
    "Enable-Auto-Renew": "开启自动续费",
    "Not-Enable": "不开启",
    "Auto-Renew-Success": "自动续费开启成功",
    "Go-View": "去看看",
    "Qr-Expired": "二维码已过期",
    "Scan-Wechat": "请用微信扫一扫",
    "Scan-Qr-Pay": "扫描二维码支付",
    "Complete-Pay-In": "请于 {time} 内完成支付！",
    "Switch-Payment-Method": "更换支付方式",
    "Select-Template": "选择模板",
    "Cancel-Reply": "取消回复",
    Translating: "正在翻译...",
    Uploading: "正在上传...",
    "Translate-Result": "翻译结果",
    "Translate-Reply": "翻译回复",
    "Send-Translation": "发送翻译",
    "Only-One-Image": "仅支持发送一张图片",
    "Image-Max-4MB": "图片大小不能超过 4MB!",
    "Image-Max-1MB": "图片不能大于1MB",
    "Standalone-Site": "独立站",
    Recommendable: "可推荐",
    "Not-Recommendable": "不可推荐",
    "Recommend-Tip": "用于控制商品在场景中的使用权限。当商品设置为不可推荐时，已在场景中使用的该商品将被自动移除。",
    Currency: "币种",
    "Price-Range": "商品售价范围",
    "Variant-Stock": "款式及库存",
    "Total-Variants": "共{n}个款式",
    Spec: "规格",
    Price: "价格",
    Stock: "库存",
    "In-Stock": "有",
    "Out-Of-Stock": "无",
    "Variants-In-Stock": "{n}个款式有库存",
    Brand: "品牌",
    "Updated-At": "更新时间",
    "Product-Info": "商品信息",
    "Message-Preview": "消息预览",
    "No-Preview": "暂无预览",
    "No-Preview-Desc": "选择模板后<br/>在此预览消息效果",
    America: "美国",
    "Please-Select": "请选择 ",
    "Enter-Phone-Number": "请输入手机号",
    "Auto-Renew-Intro":
      "<p>感谢您的购买！您还可以开通自动续费功能，系统会在次月一日自动为您的机器人进行续费操作，确保您持续享受不间断的机器人服务。</p><p style=\"color: #E90000\">自动续费的金额来自团队的余额</p>",
    "Auto-Renew-From-Balance": "自动续费的金额来自团队的余额",
    "Auto-Renew-Desc":
      "系统将于每月一日，依据当前机器人的套餐进行自动扣款。请务必保证您的团队余额充足，以确保自动续费顺利进行。<br />若您希望关闭自动续费功能，可在 \"团队套餐 -> 下月套餐设置\" 中进行关闭操作。",
    "Content-Generating": "内容正在生成...",
    "Replace-Selected": "替换已选内容",
    "Insert-Next-Line": "插入到下一行",
    Insert: "插入",
    "Ask-AI-Here": "在此处提问 AI",
    "Template-Output": "将以「{name}」模板输出，请输入问题...",
    "History-Instructions": "历史指令",
    "More-Instructions": "更多指令",
    Saving: "正在保存...",
    "Saved-Success": "保存成功!",
    "Article-Title-Placeholder": "请输入文章标题",
    "Space-AI-Placeholder": "按下空格键可调起AI工具...",
    Bold: "文字加粗",
    Settings: "设置",
    Invite: "邀请",
    "No-Team": "暂无团队",
    "Main-Nav": "主导航",
    "Qrcode-Load-Failed": "二维码加载失败",
    "Qrcode-Expired": "二维码已过期",
    Refresh: "刷新",
    "Fix-Nav": "固定导航",
    "Unfix-Nav": "取消固定导航",
    AdAccounts: "广告账号",
    PageAuth: "主页授权",
    AccountAuth: "账号授权",
    ShopAuth: "店铺授权",
    Add: "添加",
    "No-Data": "暂无数据",
    Closed: "已关闭",
    Opened: "已开启",
  },
  gender: {
    "Select-Platform": "选择您需要发帖的平台：",
    "Cannot-Be-Empty": "{label}不能为空",
    "Select-Language": "选择您需要输出的语种",
    "AI-Model": "使用的AI模型",
    "Output-Language": "输出语种",
    "Start-Generate": "开始生成",
    Generating: "正在生成...",
    Back: "返回",
    "Stop-Generate": "终止生成",
    "Insert-Doc": "插入文档",
    Example: "示例",
  },
  Login: {
    Account: "账号",
    SignIn: "去登录",
    SMS: "短信",
    passwordInvalid: "密码长度至少6位，包括至少大写字母、小写字母和数字各一个",
    passwordRequired: "请输入登录密码",
    "invites-you-to-join-the": '邀请您加入',
    Passwordmismatch: "密码不一致",
    Pleaseenteryourpasswordagain: "请再次输入密码",
    Verificationcodehasbeensent: "验证码已发送",
    createdLogin :"您的账号已创建，请前往登录",
    accountChanged: "修改账号密码成功，是否登录",

    accountLogin: "账号登录",
    SMSLogin: "短信登录",
    phoneRegist: "手机号注册",
    emailRegist: "邮箱注册",
    phoneRecover: "手机号找回",
    emailRecover: "邮箱找回",

    existingAccount: "已有账号？",
    Logonafterverification: "验证即登录，未注册将自动创建JoinMC账号",
    Pleaseenteryourloginaccount: "请输入登录账号/手机/邮箱",
    Enterthepassword: "请输入密码",
    Enteryourphonenumber: "请输入手机号",
    EnterSMSverificationcode: "请输入短信验证码",

    Obtainverificationcode : "获取验证码",
    Enteremailaddress: "请输入邮箱号",
    EnterVerificationCode: "请输入验证码",
    Enteryourloginaccount: "请输入登录账号",
    verificationCode: "验证码",
    PasswordRecovery: "找回密码",
    ByclickingRegister: "点击注册即代表同意",

    UserAgreement: "《用户协议》",
    PrivacyPolicy: "《隐私政策》",
    Resetpassword: "重置密码",

    TheyreonJoinMC: "他们在使用JoinMC",
    Seewhattheyhavetosay: "看看他们怎么说",

    case1name: "深圳京**公司客服团队负责人",
    case1content: "自从用了JoinMC，我的工作简直开了挂。它把那些让人头大的跨平台沟通和客户服务变得轻松多了。自动回复和差评管理让我有更多时间去做策略规划，效率和客户满意度都上了一个新台阶。",
    case2name: "北京山**公司客服团队负责人",
    case2content: "JoinMC对我们团队来说，就像是找到了宝藏。它的场景化回复让每个客户都感到被重视，差评隐藏功能更是让我们的品牌形象保持得光鲜亮丽。现在，我们能更专注于提升服务质量。",
    case3name: "广州纬**公司客户关系经理",
    case3content: "客户关系管理是我的日常工作，而JoinMC让我的工作更加轻松。它能够自动处理那些让人头疼的差评，让我有更多时间去做我擅长的事情——建立和维护客户关系。",
    case4name: "深圳未**公司初创公司CEO",
    case4content: "作为初创公司的CEO，我得说JoinMC挺实在的。它帮我们省了不少客服和营销上的麻烦，而且成本控制得不错。简单来说，它让我们的团队能更专注于核心业务，这点挺赞的。",
    case5name: "广州利**公司资深客服代表",
    case5content: "客服工作挺考验耐心的，JoinMC帮了大忙。自动回复和差评管理让日常工作轻松不少，这样我就能多花点时间在真正需要帮助的客户上了。",
    case6name: "成都宏**公司运营经理",
    case6content: "运营工作千头万绪，JoinMC算是个不错的帮手。Shopify集成和自动回复功能，让我们的订单处理和客户沟通都顺畅了许多。工作效率提高，团队压力自然就小了。",
    case7name: "执行官",
    case7content: "作为执行官，我看重的是结果。JoinMC在提升我们客户服务效率方面表现不错，而且它对品牌形象的保护也起到了积极作用。这对我们来说，是实实在在的价值。",
    case8name: "资深客服代表",
    case8content: "老实说，JoinMC让我的工作变得轻松多了。客户问东问西，它总能迅速给到答案。回复准确吗？那是必须的！现在有问题立马解决，客户满意度自然up up！\n\n 客户问包裹情况，JoinMC直接就从shopify上抓取信息回复了，都不用我动手。这效率，客户都夸我们响应快。",
    case9name: "市场分析师",
    case9content: "数据控如我，JoinMC提供的实时分析太对我胃口了。它把那些枯燥的数字变得有意义，帮助我们把握市场脉搏。有问题？JoinMC立马搞定，这效率，赞一个！",
    case10name: "社交媒体经理",
    case10content: "社交媒体这潭水深，JoinMC就是我们的救星！自动回复、差评处理，它全包了。客户互动？JoinMC让我们的媒体平台活跃得不行，继续支持是必须的！",
  },
  Head: {
    "add-new-team": "新建团队",
    "personal-center": "个人中心",
    "tui-chu-deng-lu": "退出登录",
    "scan-qrcode-follow-joinmc": "扫描下方二维码，关注JoinMC",
    "expires-on": "过期时间：",
    "Refresh-QR-Code": "刷新二维码",
    "help-doc": "帮助文档",
    "developer-doc": "开发者文档",
    "bot-suffix": "机器人",
    "go-back-up": "返回上级",
    "become-super-admin-title": "成为超级管理员",
    "become-super-admin-msg": "您已经成为「{name}」团队的超级管理员！",
    "confirm": "确定",
    "go-check": "去看看",
    "got-it": "知道了",
    "fb-auth-expired-title": "主页授权到期",
    "fb-auth-expired-msg":
      "您的{num}个Facebook主页授权已过期，导致相关机器人无法继续提供服务。请尽快重新授权，以确保服务的正常运行。",
    "email-auth-expired-title": "邮箱授权到期",
    "email-auth-expired-msg":
      "您的{num}个邮箱授权已过期，导致相关机器人无法继续提供服务。请尽快重新授权，以确保服务的正常运行。",
    "notice": "提示",
    "create-new-team": "创建新团队",
    "confirm-logout": "是否继续退出",
    "cancel": "取消",
  },
  dashboard: {
    Hot: "推荐",
    "smart-bot-desc":
      "智能机器人具备智能应答、高效处理客户咨询，显著提升客户满意度。目前支持Messenger、独立站客服、Facebook帖文、邮箱自动回复四种客服。",
    "public-opinion-monitoring-desc": "舆情功能实时监测、分析公众舆论，助力风险管理和决策支持，提升品牌声誉管理能力。",
    "content-publishing-desc": "轻松将您的优质内容一键发布至全球主流社交媒体平台。",
    "conversations-desc":
      "对话是一种通过自然语言处理技术与用户进行交互的人工智能程序，可以回答问题、提供信息和执行任务。",
    "document-writing-desc":
      "可以使用 AI 自动生成高质量原创内容，内容创作覆盖多种类型，满足不同场景、人群的 AI 创作需求，并提供个性化的自定义选项。",
    "Advisor-desc": "行业顾问具备丰富的专业知识，能提供定制化服务，帮助用户解决各领域问题。",
    "Templates-desc": "创建和管理团队专属的写作模板和行业顾问模板。",
    "Wiki-desc": "集中存储和应用团队资料，提高工作效率。",
    "Team-desc": "管理团队成员、查询付费信息。",
    "Media-desc": "集中管理授权的媒体平台。",
    "Tools-desc": "用于推广和促销产品或服务的工具和策略的集合",
    "Users-desc": "与团队智能机器人所互动过的用户",
    "Access-Title": "重磅通知",
    "Access-Online-Notice": "JoinMC智能客服上线通知：",
    "Access-Online-Content":
      "JoinMC智能AI客服产品将于<span class=\"danger-color-text\">11月21日</span>正式上线！测试客户体验资格将于<span class=\"danger-color-text\">11月30日</span>结束；从<span class=\"danger-color-text\">12月1日</span>起，产品将正式开始收费。",
    "Access-Online-Footer": "详情请咨询产品运营人员，衷心感谢您对我们产品测试阶段的大力支持与帮助！！！",
    "JoinMC-Assistant": "JoinMC小助手",
    "Welcome-Guide": "欢迎体验JoinMC！为了让您快速上手并高效使用平台功能，我们为您准备了简短的功能引导。",
    "Welcome-Guide-2": "简单几步，即可对 JoinMC 功能完成初步了解。让我们一起开始吧！",
    "Skip-Guide": "跳过引导",
    Next: "下一步",
    Prev: "上一步",
    "Driver-Step1-Desc": "欢迎来到 JoinMC 的核心功能区！每一个图标都代表着一个独特的功能模块，助您轻松应对各类任务。",
    "Driver-Step2-Desc": "在这里，您可以随时切换团队或快速创建新团队。",
    "Driver-Step3-Desc":
      "关注我们的公众号，即可第一时间接收系统发出的预警提示信息，确保您随时掌握重要动态，及时响应关键需求！",
    "Driver-Step4-Desc":
      "这里是快速切换功能的入口，一键切换，轻松实现功能的灵活切换。无论您在哪个页面，都能随时切换所需功能，提升操作效率！",
    "Driver-Step5-Desc": "在这里，您可以轻松管理个人资料或安全退出系。",
    "Package-Expired-Title": "套餐已过期",
    "Package-Expired-Content": "您的套餐已过期，当前机器人已停止服务，请续费后再使用！",
    "Go-Renew": "去续费",
    "Package-Expired-Dialog-Title": "套餐已到期",
    "Package-Expired-Dialog-Content": "当前套餐已到期，相关套餐权益已暂停，请联系您的销售/客服订阅套餐。",
    "Package-Expired-Dialog-Subscribe": "订阅套餐",
    "Package-Locked-Dialog-Title": "授权账号功能已被冻结",
    "Package-Locked-Dialog-Content": "请联系您的专属客服人员进行处理",
    "Package-Locked-Dialog-Confirm": "我知道了",
    "Package-Limit-Dialog-Title": "账号已达上限",
    "Package-Limit-Dialog-Content": "当前账号数量已达到套餐上限，您可升级套餐或购买加量包后继续操作。",
    "Package-Limit-Dialog-Subscribe": "升级套餐",
    "Package-Limit-Dialog-Expansion": "拓展叠加包",
    "Team-Balance-Not-Enough": "团队余额不足",
    "Team-Balance-Content": "团队套餐将于{date}到期，当前团队余额还差¥{amount}。为确保机器人正常服务，请尽快进行充值。",
    "Go-Recharge": "去充值",
    // 站内通知卡片文案。
    "Site-Notification-WhatsApp-Title": "WhatsApp 新会话",
    "Site-Notification-WhatsApp-Content": "您有 {count} 个新的客户咨询，请尽快处理。",
    "Site-Notification-View": "去查看",
    // WhatsApp WebSocket 发送失败时使用的余额不足弹窗文案。
    "WhatsApp-Balance-Insufficient-Title": "当前团队余额不足",
    "WhatsApp-Balance-Insufficient-Content": "当前团队余额不足，无法继续发送消息。请先为团队充值，充值到账后即可恢复发送。",
    "WhatsApp-Estimated-Send-Cost": "本次发送预估花费",
    "Auto-Renew-Upcoming": "即将自动续费",
    "Auto-Renew-Content":
      "<p>您的机器人套餐将于{date1}到期。根据自动续费规则，系统将在{date2}进行续费，金额为 ¥{amount}。请确保您的团队账户余额充足。</p><br /><p>如果您不想自动续费，请在{date2}前，前往“团队管理”>“团队套餐”>“下月套餐”模块中关闭自动续费功能。</p>",
    Understood: "已知晓",
  },
  Publish: {
    // 发布列表和编辑页统一使用“帖子发布”称谓，移除旧版“帖文发布”文案。
    "Post-Publishing": "帖子发布",
    "Target-Home-Page": "目标主页",
    "Publishing-List": "发布列表",
    "Publishing-Calendar": "发布日历",
    "Please-enter-the-content-to-be-published": "请输入要发布的内容",
    Publish: "发布",
    "Select-Publishing-Homepages": "选择发布主页 ",
    FilterByLabel: "按标签筛选",
    More: "更多",
    Republish: "重新发布",
    "Status-Pending": "待发布",
    "Status-Publishing": "发布中",
    "Status-Success": "发布成功",
    "Status-Failed": "发布失败",
    "Status-Cancelled": "已取消",
    "Status-Deleted": "已删除",
    "Joined-Queue": "已加入发布队列",
    "Stopped-Publishing": "已终止发布",
    "Social-Account": "社交账号",
    "Operation-Record": "帖文操作记录",
    "Operation-Time": "操作时间",
    "Operation-Description": "操作说明",
    Operator: "操作人",
    "p-e-t-h-n-y-w-t-s": "请输入您需要搜索的主页名称",
    "homepages-selected": "已选择{count}个主页",
    "Authorize-New-Homepage": "新增授权账号",
    "had-selected": "该主页已添加，无需重复选择！",
    "Select-Page-to-Publish": "添加要发布的主页",
    "Add-new-public-page": "新增公开账号",
    "Supported-platforms": "支持的平台：",
    "p-e-t-h-n-h-a-m-l-a": "请输入主页名称、主页地址、媒体登录账号",
    "All-Media-Platforms": "全部媒体平台",
    "All-Publisher": "全部发布者",
    "p-e-p-c-o-t-n": "请输入帖文内容或任务编号",
    "Release-time": "发布时间：",
    "Task-Number": "任务编号：",
    "Create-a-Post": "创建帖文",
    "No-posts-published": "您还没发布任何帖文",
    "ins-no-text-only": "Instagram平台不支持单独发布文字内容！",
    "tiktok-empty-content-warning": "TikTok平台发布内容和素材不能同时为空！",
    "empty-content-warning": "因平台限制，请输入贴文内容！",
    Settings: "设置",
    "Allow-Comments": "允许评论",
    "Allow-Co-production": "允许合拍",
    "Allow-Splicing": "允许拼接",
    "Privacy-Settings": "隐私设置",
    "Add-media-page-to-create-a-post": "添加媒体主页，即可创建帖文。",
    "Add-Pages": "添加主页",
    "Click-uploader-btn-alert":
      "{old_type}和{new_type}无法同时存在。上传其他类型素材时，{old_type}将被自动移除。为了避免内容显示异常，请提前确认是否需要切换！",
    "Platform-limit-number": "由于 {platform} 平台的限定条件，发布{postType}时，单次最多支持添加{maxAllowed}个{type}",
    "Image-Upload-Tip": "请上传JPG、JPEG、PNG、GIF格式、大小在10M以内的图片，一次最多上传10张图片",
    "Video-Upload-Tip": "请上传视频，大小在1GB以内",
    "Social-Media-Posting-Rules": "社交媒体发帖规则",
    "Please-stay-tuned": "功能暂未开放，敬请期待",
    "Maximum-characters": "最多可输入",
    "Material-Editing": "素材编辑",
    "p-u-m-p-c-b-u": "已上传{length}张，还可以上传{number}张",
    "Video-Title": "视频标题",
    "c-v-t-a-o-s-o": "自定义视频的名称",
    // "c-v-t-a-o-s-o": "自定义视频标题仅支持 Facebook、LinkedIn 和 VKontakte 平台",
    "Add-title-to-your-video": "为视频添加标题",
    "Set-video-cover": "设置视频封面",
    "Add-pictures-or-videos": "添加图片或视频",
    "Content-Name": "内容名称",
    "Support-Notes": "支持说明",
    "p-does-not-support-image-posts": "{platform} 不支持发布图片帖文",
    "p-does-not-support-links": "{platform} 不支持链接",
    Notice: "注意",
    "Validation-Warnings": "警告（{count}）",
    "X-image-ratio-warning":
      "X: 图片比例推荐 16:9 或 1:1。建议您根据展示场景手动裁剪或调整图片比例，合适的比例能让画面更聚焦、排版更整齐，也能提升整体视觉效果。",
    "c-c-n-p": "正在编辑的帖文内容不符合媒体平台的帖文发布规则，无法进行发布",
    "Delete-the-non-compliant-homepage": "删除和内容不符的主页",
    "When-publishing-postType": `发布{postType}时`,
    "Size-does-not-match": "尺寸不符合要求",
    "Aspect-ratio-does-not-match": "比例不符合要求",
    "video-cover-setting-description":"视频默认的封面图",

    // "video-cover-setting-description":
    //   "支持自定义上传图片作为视频封面图的内容类型有：Facebook 帖子，Facebook Reels、Instagram Reels、LinkedIn 帖子、VKontakte 帖子；支持以视频中的切片图作为视频封面图的内容类型有：Facebook 帖子、Facebook Reels、Instagram Reels、LinkedIn 帖子、TikTok 视频、VKontakte 帖子",
    "Post-Preview": "帖文预览",
    "youtube-only-videos": "YouTube 仅支持视频帖文，请上传视频",
    "youtube-video-title": "YouTube 视频标题不能为空",
    // 定时发布字段缺失时直接展示表单红框提示，不再用弹窗打断操作。
    "Schedule-Timezone-Required": "请选择发布时区",
    "Schedule-Date-Required": "请选择发布日期",
    "Schedule-Time-Required": "请选择发布时间",
    // 草稿箱列表页使用独立文案，避免中英文切换时继续显示硬编码中文。
    "Publishing-Draft": "草稿箱",
    "No-Permission": "内容发布没权限",
    "Video-Cover": "视频封面",
    "Select-From-Video": "视频中选取",
    "Drag-Slider-Tip": "拖动滑块选择视频中的某一帧为封面图",
    "Custom-Upload": "自定义上传",
    "Upload-5M-Tip": "请上传 5M 以内的图片为封面",
    "Click-Upload": "点击上传",
    "Second-Format": "第{val}秒",
    "Post-Data": "帖文数据",
    "No-Data-Support": "当前平台暂不支持查看数据",
    "Mark-Publisher": "标记发布者",
    "Current-Publisher": "当前发布者：",
    "Replace-Publisher": "替换发布者：",
    "Select-Publisher": "请选择发布者",
    "No-Publisher": "暂无可选发布者",
    "Publisher": "发布者",
    "Expand": "展开",
    "Collapse": "收起",
    "Translate": "翻译",
    "Translating": "翻译中...",
    "Collapse-Translation": "收起译文",
    "No-Translation": "暂无译文",
    "Translate-Failed": "翻译失败，请稍后重试",
    "Translate-Language": "中文",
    "Published-Via": "通过{platform}发布",
    "More": "更多",
    "Operation-Record": "贴文操作记录",
    "Operation-Time": "操作时间",
    "Operation-Description": "操作说明",
    "Operator": "操作人",
    "View-On-Platform": "在{platform}中查看",
    "Republish": "再次发布",
    "Edit-Original": "编辑原文",
    "Delete": "删除",
    "View-Data": "查看数据",
    "Copy-Post-Link": "复制帖子链接",
    "Copy-Post-ID": "复制帖子ID",
    "Operation-Record-Menu": "操作记录",
    "Edit": "编辑",
    "Cancel-Publish": "取消发布",
    "PublishNow": "立即发布",
    "Tooltip-Republish-Only-Joinmc": "只支持通过Joinmc发布的帖子进行此操作",
    "Tooltip-Not-Support-Joinmc": "通过Joinmc发布的帖子不支持此操作",
    "Tooltip-Facebook-Only": "仅支持标记通过Facebook发布的帖子",
    "Tooltip-Edit-Only-Joinmc": "只支持编辑Joinmc平台发布的帖子",
    "Tooltip-Joinmc-Only": "只支持Joinmc发布的帖子",
    "Tooltip-Edit-Time-Limit": "距离发布时间少于10分钟，禁止编辑内容",
    "Member-Format": "成员{id}",
    "No-Copy-Content": "暂无可复制内容",
    "Copy-Failed": "复制失败，请稍后重试",
    "Operation-Failed": "操作失败，请稍后重试",
    "Post-Link-Copied": "帖子链接已复制",
    "Post-ID-Copied": "帖子ID已复制",
    "Feature-Placeholder": "该功能入口已展示，后续可继续接入具体逻辑",
    "Publish-Now-Confirm": "您确定要将未到预定发布时间的帖子，立即发布到媒体平台吗？",
    "Operation-Confirm-Title": "操作确认",
    "Cancel-Publish-Confirm": "取消发布后，该任务将停止执行，是否继续？",
    "Republish-Deleted-Confirm": "是否希望将已删除内容重新发布到{platform}？新内容将作为独立帖子发布，不会影响已删除的原始帖子。",
    "Republish-Confirm": "是否需要将内容发布到{platform}？",
    "Join-Publish-Queue": "加入发布队列",
    "Stop-Publish": "终止发布",
    "Operation-Success": "操作成功",
    "Open-Republish-Failed": "打开再次发布页面失败，请稍后重试",
    "Delete-Confirm-Not-Publish": "帖子删除后，将不能发布到媒体平台。",
    "Delete-Confirm-Sync": "在此处删除帖子，系统将同步删除媒体平台上发布的帖子。",
    "Deleted": "已删除",
    "Delete-Failed": "删除失败，请稍后重试",
    "No-Accessible-Post-Link": "暂无可访问的帖子链接",
    "Delete-Platform-Post-Confirm": "系统即将删除您在{platform}上的帖文。一旦删除，帖文将无法恢复。建议您在确认无误后谨慎操作！",
    "Delete-Task-Confirm": "任务删除后，内容将被永久删除且无法恢复。请务必确认无误后谨慎操作",
    "Delete-Forbidden-Title": "禁止删除",
    "Delete-Blocked-Task": "当前链接存在引导评论任务，无法执行删除操作！",
    "Delete-Link-Confirm": "链接删除后将不能恢复，是否确认删除？",
    "Delete-Success": "删除成功",
    "Validation-Errors": "错误（{count}）",
    "Detail-Missing-Page": "详情数据缺少主页信息，无法回填编辑页",
    "Detail-Fetch-Failed": "详情获取失败",
    "Store-Title": "内容发布",
    "List-Title": "发布列表",
    "Calendar-Title": "发布日历",
    "Draft-Title": "发布草稿",
    "Free-Ratio": "自由",
    "Image-Edit": "图片编辑",
    "View-Day": "日",
    "View-Week": "周",
    "View-Month": "月",
    "Uploading": "正在上传...",
    "Subscribers-Format": "{count}位订阅者",
    "Subscribers": "{count}订阅",
    "MemberCount": "{count}成员",
    "Now": "现在",
    "Impressions-Format": "{count} 次展示",
    "View-Data-Analysis": "查看数据分析",
    "Unknown-Platform": "未知平台",
    "Favorite": "收藏",
    "Get-Publisher-List-Failed": "获取发布者列表失败，请稍后重试",
    "Mark-Publisher-Success": "标记发布者成功",
    "Mark-Publisher-Failed": "标记发布者失败，请稍后重试",
    "Tag-Delete-Success": "标签删除成功",
    "Tag-Delete-Failed": "标签删除失败，请稍后重试",
    "Please-Upload-First": "请先上传{name}",
    "Size-Exceed-MB": "大小不能超过{size}MB!",
    "Today-Badge": "今日",
    "Marketing-Events": "营销事件",
    "No-Marketing-Events": "暂无营销事件",
    "Posts-Label": "帖子",
    "No-Post-Data": "暂无帖子数据",
    "Year-Format": "{year}年",
    "Month-Format": "{month}月",
    "Year-Month-Format": "{year}年{month}月",
    "Marketing-Settings-Title": "营销事件设置",
    "Regional-Festival": "区域性节日",
    "Search-Country-Region": "搜索国家/地区",
    "No-Festival-Data": "暂无节日数据",
    "Selected-Festivals": "已选择节日 ({count})",
    "Clear": "清空",
    "No-Selected-Festivals": "暂无已选择的节日",
    "Submitting": "提交中...",
    "Select-At-Least-One-Festival": "请至少选择一个节日",
    "Country-Religion-Not-Empty": "国家和宗教不能同时为空",
    "Marketing-Settings-Success": "营销事件设置成功",
    "Marketing-Settings-Failed": "营销事件设置失败",
    "Post-Detail-Title": "帖子详情",
    "Add-Tag": "添加标签",
    "Unselected-Tag-Area": "待选择标签区",
    "New-Tag": "新建标签",
    "Selected-Tags": "已选中的标签",
    "No-Selected-Tag": "暂无已选标签",
    "Tag-Classify": "标签分类：",
    "Select-Tag-Classify": "请选择标签分类",
    "New-Classify": "新建分类",
    "Tag-Name": "标签名称：",
    "Input-Tag-Names": "请输入标签名称，多个标签请用回车换行",
    "New-Tag-Classify": "新建标签分类",
    "Input-Tag-Classify": "请输入标签分类",
    "Unnamed-Tag": "未命名标签",
    "Unnamed-Classify": "未命名分类",
    "Select-Tag": "请选择标签",
    "Tag-Add-Success": "标签添加成功",
    "Tag-Add-Failed": "标签添加失败，请稍后重试",
    "Classify-Create-Success": "分类创建成功",
    "Classify-Create-Failed": "分类创建失败，请稍后重试",
    "Tag-Content-Not-Empty": "标签内容不能为空",
    "Tag-Create-Success": "标签创建成功",
    "Tag-Create-Failed": "标签创建失败，请稍后重试",
    "Tag-Max-20": "单个标签最多支持20个字",
    "Tag-Only-Charset": "仅支持数字、字母、汉字，不支持其他特殊符号",
    "Week-Holiday": "节日",
    "Week-Memorial": "纪念日",
    "Week-Festival-Or-Memorial": "节日或纪念日",
    "Week-Religious": "宗教节日",
    "Date-Full-Format": "{month}月{day}日 | {week}",
    "Header-Date-Format": "{year}年{month}月{day}日",
    "Week-Sun": "日",
    "Week-Mon": "一",
    "Week-Tue": "二",
    "Week-Wed": "三",
    "Week-Thu": "四",
    "Week-Fri": "五",
    "Week-Sat": "六",
    "Week-Name-Format": "周{week}",
    "Month-Day-Format": "{month}月{day}日",
    "AI-Create-Publish": "AI 创作内容并发布",
    "Google-Search-Link": "Google搜索相关链接",
    "X-Search-Link": "X搜索相关链接",
    "Facebook-Search-Link": "Facebook搜索相关链接",
    "More-Events": "+{num}事件",
    "Festival-Date-Format": "{year}年{month}月{day}日（星期{week}）",
    Unnamed: "未命名",
    "Platform-Label": "平台",
    "Type-Text": "文本",
    "Type-Image": "图片",
    "Type-Image-Text": "图文",
    "Type-Video": "视频",
    "Type-Video-Text": "视频+文本",
    "Type-Link": "链接",
    "Type-Video-Snap": "视频快拍",
    "Type-Image-Snap": "图片快拍",
    "Type-Unknown": "未知",
    "Date-Range-Format": "{start} - {end}",
    "All-Draft-Creators": "全部创建人",
    "Draft-Search-Placeholder": "请输入帖文内容",
    "Draft-Attachment": "草稿附件",
    "Image-Draft-Content": "图片帖文草稿",
    "Video-Draft-Content": "视频帖文草稿",
    "Link-Draft-Content": "链接帖文草稿",
    "Link-Draft-Domain": "链接",
    "Image-Count-Suffix": "{count}张",
    "View-Translation": "查看翻译",
    "Hide-Translation": "隐藏翻译",
    Translating: "翻译中...",
    "Creator-Label": "创建人：",
    "Created-At-Label": "创建时间：",
    "Social-Account-Label": "社交账号：",
    "No-Drafts": "暂无草稿",
    "Draft-List-Failed": "草稿列表获取失败",
    "No-Translation": "暂无译文",
    "Translation-Failed": "翻译失败，请稍后重试",
    "Draft-Missing-Task-Num": "草稿缺少任务编号，无法删除",
    "Draft-Delete-Confirm": "删除后该内容将从系统中永久移除，无法恢复，请确认是否继续？",
    "Draft-Delete-Success": "删除成功",
    "Draft-Delete-Failed": "删除失败",
    "Save-As-Draft": "保存为草稿",
    "Saving-Draft": "保存草稿中...",
    "Draft-Detail-Failed": "草稿详情获取失败",
    "Draft-Missing-Pages": "草稿详情缺少投递主页，无法回填编辑页",
    "Media-Page": "媒体主页",
    DocImport: "文档导入",
    SelectDoc: "选择文档",
    PublishAs: "将素材发布为：",
    DocFormatTip: "支持.docx/.doc/.pdf/.txt 格式，不超过 15MB 的文件",
    DocSizeLimit: "文档大小不能超过 {size}MB!",
    "local-upload": "本地上传",
    "local-upload-image-desc": "从电脑选择图片上传",
    "local-upload-video-desc": "从电脑选择视频上传",
    "local-upload-doc-desc": "从电脑选择文档上传",
    "library-select": "资源库选择",
    "library-select-desc": "JoinSpark 平台资源库",
    "joinspark-auth-title": "需授权 JoinSpark AI 素材制作平台",
    "joinspark-auth-desc": "授权后资源库、AI 创作历史自动互通同步，跨端无缝联动，灵活调用全部创作资源。",
    "joinspark-auth-confirm": "去授权",
    Fleets: "随拍",
    PublishNow: "立即发布",
    SchedulePublish: "定时发布",
    // YouTube 发布设置
    Playlist: "播放列表：",
    "Select-Playlist": "选择播放列表",
    "New-Playlist": "新建播放列表",
    "Made-For-Kids-Label": "观众，视频是面向儿童的内容吗？",
    "Made-For-Kids-Yes": "是，内容是面向儿童的",
    "Made-For-Kids-No": "不，内容不是面向儿童的",
    "Select-Made-For-Kids": "请选择是否是面向儿童的内容",
    "Synthetic-Media-Label": "加工的内容，你的内容是否符合以下任何一项描述？",
    "Synthetic-Media-Desc-1": "呈现真实人物的言论或行为，但实际并非本人言行",
    "Synthetic-Media-Desc-2": "篡改有关真实事件或地点的视频片段",
    "Synthetic-Media-Desc-3": "生成逼真但与实情不符的场景",
    Yes: "是",
    No: "否",
    Language: "语言：",
    "Select-Video-Language": "请选择视频语言",
    "Select-Default-Language": "请选择默认语言",
    "Recording-Date": "录制日期：",
    "Select-Recording-Date": "选择视频的录制日期",
    License: "许可",
    "Allow-Embedding": "允许嵌入",
    Category: "类别：",
    "Select-Category": "请选择类别",
    Visibility: "公开范围：",
    "Select-Visibility": "请设置视频公开范围",
    "Playlist-Title": "标题",
    "Playlist-Description": "说明",
    // YouTube 视频标题与说明属于发布元数据，和新建播放列表字段分开维护。
    "Video-Description": "说明",
    "Enter-Video-Title": "添加一个可描述你视频的标题（输入 @ 可提及某个频道）",
    "Enter-Video-Description": "向观看者介绍你的视频（输入 @ 可提及某个频道）",
    "Please-Enter-Title": "请输入标题",
    "Please-Enter-Playlist-Title": "请输入播放列表标题",
    "Please-Enter-Playlist-Description": "请输入播放列表说明",
    Public: "公开",
    Private: "私享",
    Unlisted: "不公开列出",
    "Please-Enter-Video-Title": "请输入视频标题",
    "System-Error": "系统错误",
    "Post-To-Channel": "发布到频道",
    "Post-To-Page": "发布到主页",
  },
  SocialListening: {
    SocialMedia: "社媒",
    HomepageManagement: "主页管理",
    DataSummary: "数据汇总",
    InteractionTasks: "互动任务",
    DataStatistics: "数据统计",
    MonitorList: "监控列表",
    SocialListening: "社交聆听",
    ListeningTasks: "聆听任务",
    ListeningComparison: "聆听对比",
    AudienceTasks: "受众任务",
    NewTopic: "新建主题",
    EditTopic: "编辑主题",
    PleaseEnterTopicName: "请输入聆听主题名称",
    PleaseEnterTopicNameShort: "请输入主题名称",
    Add: "新增",
    // 聆听对比列表操作按钮单独用 SocialListening 命名空间，避免 tooltip 直接显示 key。
    Edit: "编辑",
    Delete: "删除",
    Topic: "主题",
    Creator: "创建人",
    CreatedAt: "创建时间",
    Actions: "操作",
    NoData: "暂无数据",
    Data: "数据",
    KeywordSettings: "提及关键词设置",
    "Keyword-Quota-Fetch-Failed": "关键词额度获取失败，请稍后重试",
    TopicNameLabel: "主题名称:",
    PleaseEnterTaskName: "请输入任务名称",
    MediaPlatformLabel: "媒体平台:",
    IncludeKeywordsLabel: "包含的关键词:",
    KeywordInputPlaceholder: "输入关键词，按回车键添加下一个，最多添加5个关键词",
    TargetCountryLabel: "目标国家:",
    TargetCountryPlaceholder: "将内容或作者限定为特殊的国家",
    TargetLanguageLabel: "目标语言:",
    TargetLanguagePlaceholder: "将内容或作者限定为特定的语言",
    DeleteConfirmMessage: "社交聆听主题任务删除后将不能恢复，是否确认删除任务？",
    OperationConfirm: "操作确认",
    ConfirmDelete: "确定删除",
    Executing: "执行中...",
    SelectAtLeastOnePlatform: "请至少选择一个媒体平台",
    PleaseEnterKeyword: "请输入关键词",
    MaxFiveKeywords: "关键词最多只能添加5个",
    KeywordCannotRepeat: "关键词不能重复",
    KeywordExists: "关键词已存在，请输入其他关键词",
    FacebookSupport: "支持帖子、分享、评论",
    InstagramSupport: "支持帖子、Reels、评论",
    YouTubeSupport: "支持视频、Shorts、评论",
    LinkedInSupport: "支持帖子、转发、评论",
    Sentiment: "舆情",
    TopicDetail: "{topic}详情",
    BasicInfo: "基本信息",
    TopicName: "主题名称",
    MonitoringPlatform: "监控平台",
    IncludedKeywords: "包含的关键词",
    TargetCountry: "目标国家",
    TargetLanguage: "目标语言",
    AllMediaPlatforms: "全部媒体平台",
    AllLanguages: "全部语言",
    AllCountries: "全部国家",
    StartTime: "开始时间",
    EndTime: "结束时间",
    Overview: "概览",
    Content: "内容",
    Author: "作者",
    Dialogue: "对话",
    KeyMetrics: "关键指标",
    SearchKeywordPlaceholder: "请输入你需要搜索的关键词，多个关键词用enter分隔",
    TotalMonitoredContent: "总监控内容",
    TotalMonitoredContentDesc: "抓取内容的帖子总数",
    PositiveContent: "正面内容",
    PositiveContentDesc: "帖子的整体内容情感是正面的内容数",
    NegativeContent: "负面内容",
    NegativeContentDesc: "帖子的整体内容情感是负面的内容数",
    NeutralContent: "中立内容",
    NeutralContentDesc: "帖子的整体内容情感是中立的内容数",
    UnknownUser: "未知用户",
    Positive: "正面",
    Negative: "负面",
    Neutral: "中性",
    NoPostData: "暂无帖子数据",
    NoRelatedPosts: "当前条件下没有找到相关帖子",
    CreatedAtWithColon: "创建于：",
    SerialNumberWithColon: "编号：",
    ImageLoadFailed: "图片加载失败",
    VideoLoadFailed: "视频加载失败",
    LikeCount: "点赞数",
    ShareCount: "分享数",
    CommentCount: "评论数",
    AIAnalysisSummary: "AI智能分析总结",
    AIAnalysisSummaryTip: "基于当前监控数据的智能分析总结",
    OperationSuggestions: "运营建议",
    MentionTrend: "提及趋势",
    MentionTrendTip: "在单位时间范围内，提及趋势的变化量",
    PlatformMentionVolume: "各平台提及声量",
    PlatformMentionVolumeTip: "不同的媒体平台的提及声量变化趋势",
    MentionEmotionRatio: "提及内容情绪占比",
    MentionEmotionRatioTip: "提及内容的正向、负向、中立占所有内容的百分比",
    MentionEmotionTrend: "提及内容情绪趋势变化",
    MentionEmotionTrendTip: "在单位时间范围内，正向、负向、中立情绪的变化趋势",
    MentionPlatformDistribution: "提及按平台分布",
    MentionPlatformDistributionTip: "提及的内容在不同平台的占比情况",
    MentionLanguageDistribution: "提及按语言分布",
    MentionLanguageDistributionTip: "提及的内容按语言分布的占比情况",
    MentionCountryDistribution: "提及按国家分布",
    MentionCountryDistributionTip: "提及的内容按国家分布的占比情况",
    InteractionTrend: "互动趋势",
    InteractionTrendTip: "在单位时间范围内，提及内容中用户的表情数、评论数、转发数",
    VideoViewTrend: "视频观看趋势",
    VideoViewTrendTip: "在单位时间范围内，提及内容中的视频播放的次数",
    HotContent: "热门内容",
    HotContentTip: "在单位时间范围内，覆盖人数最多的9篇帖子",
    InteractionCount: "互动次数",
    VideoViewCount: "视频观看次数",
    PlatformEffectData: "按平台的效果数据",
    PlatformEffectDataTip: "各平台的详细效果数据",
    Platform: "平台",
    Other: "其他",
    MentionCount: "提及数",
    MentionCountDesc: "讨论该主题的内容",
    MentionCountTableDesc: "讨论该主题的内容数",
    InteractionCountDesc: "相关内容的公开互动次数（包含心情/点赞、评论/回复和分享/转推）",
    VideoViewCountDesc: "相关内容的视频观看次数",
    UniqueAuthors: "唯一作者数",
    UniqueAuthorsDesc: "讨论该主题的唯一作者数",
    ReachCount: "覆盖人数",
    ReachCountDesc: "讨论该主题内容覆盖的人数",
    ReachCountShortDesc: "提及内容覆盖的用户人数",
    VolumeTrend: "声量趋势",
    EmotionTendency: "情感倾向",
    InteractionEffect: "互动效果",
    EmotionRatio: "情绪占比",
    PositiveMentions: "积极提及数",
    PositiveMentionsDesc: "积极情绪的内容数量",
    NegativeMentions: "消极提及数",
    NegativeMentionsDesc: "消极情绪的内容数量",
    NeutralMentions: "中性提及数",
    NeutralMentionsDesc: "中性情绪的内容数量",
    ReactionsOrLikes: "心情数/点赞数",
    ReactionsOrLikesDesc: "内容的心情数/点赞数",
    CommentsOrReplies: "评论数/回复数",
    CommentsOrRepliesDesc: "内容的评论数/回复数",
    SharesOrReposts: "分享数/转发数",
    SharesOrRepostsDesc: "内容的分享数/转发数",
    Total: "总计",
    AuthorGrowthTrend: "作者增长趋势",
    AuthorGrowthTrendTip: "发布帖子作者数量的变化趋势。",
    AuthorCountryDistribution: "作者国家分布",
    AuthorCountryDistributionTip: "作者的国家分布。",
    AuthorEmotionTrend: "作者情感变化",
    AuthorEmotionTrendTip: "作者的情感变化趋势。",
    AuthorProfileAnalysis: "作者画像分析",
    AgeDistribution: "年龄分布",
    AgeDistributionTip: "作者的年龄分布情况。",
    GenderDistribution: "性别分布",
    GenderDistributionTip: "作者的性别分布。",
    AuthorCount: "作者数",
    Ratio: "占比",
    PositiveEmotion: "正面情感",
    NegativeEmotion: "负面情感",
    NeutralEmotion: "中性情感",
    Male: "男性",
    Female: "女性",
    Unknown: "未知",
    TopMentionedKeywords: "提及最多的关键词",
    TopMentionedKeywordsTip: "提及最多的关键词。",
    TopMentionedTopics: "提及最多的话题",
    TopMentionedTopicsTip: "内容中提及最多的话题。",
    TopMentionedAccounts: "提及最多的账号",
    TopMentionedAccountsTip: "内容中提及最多的社交媒体账号。",
    TopMentionedEmojis: "提及最多的表情",
    TopMentionedEmojisTip: "内容中使用最多的表情符号。",
    ContentPublishTimeDistribution: "内容发布的时间分布",
    ContentPublishTimeDistributionTip: "内容的发布时间分布。",
    TopMentionedDomains: "提及最多的域名",
    TopMentionedDomainsTip: "内容中提及最多的域名。",
    MaterialTypeDistribution: "素材类型分布",
    MaterialTypeDistributionTip: "内容的素材类型分布。",
    ContentTypeDistribution: "内容类型分布",
    ContentTypeDistributionTip: "内容的类型分布。",
    MentionTimes: "提及次数",
    PublishVolume: "发布量",
    Post: "贴文",
    Comment: "评论",
    Share: "分享",
    ContentType: "内容类型",
    TenThousandFormat: "{value}万",
    AuthorDetail: "作者详情",
    FanCount: "粉丝数",
    FanInteractionRate: "粉丝互动率",
    AuthorEmotionIdentification: "作者情感辨别",
    PositiveEmotionDesc: "对品牌持积极态度，经常发布正面内容",
    NeutralEmotionDesc: "对品牌态度中立，内容倾向客观表达",
    NegativeEmotionDesc: "对品牌持消极态度，经常发布负面内容",
    ActiveTime: "活跃时间",
    MentionHistory: "提及历史",
    RelatedAuthors: "关联作者",
    UnknownAuthor: "未知作者",
    NoRelatedData: "无相关数据",
    FansWithColon: "粉丝：",
    Follow: "关注",
    MutualFollow: "互相关注",
    CompareAnalysis: "对比分析",
    ComparisonName: "对比名称",
    TopicCount: "主题数",
    PleaseEnterComparisonName: "请输入对比名称",
    TargetTopic: "目标主题",
    ComparedTopic: "对比主题",
    PleaseSelectTargetTopic: "请选择目标主题",
    PleaseSelectComparedTopic: "请选择对比主题",
    PleaseSelectTargetTopicFirst: "请先选择目标主题",
    AddTopic: "添加主题",
    AtLeastOneComparedTopic: "请至少选择一个对比主题",
    MaxThreeComparedTopics: "最多只能添加三个对比主题",
    KeepOneComparedTopic: "至少保留一个对比主题",
    EditFailed: "编辑操作失败",
    CreateFailed: "创建失败",
    ComparisonDeleteConfirmMessage: "聆听对比任务删除后将不能恢复，是否确认删除聆听对比任务？",
    ComparisonDetailFallback: "对比名称详情",
    CoreMetricsComparison: "核心指标对比",
    NoCoreMetricsComparisonData: "暂无核心指标对比数据",
    TotalMentions: "总提及数",
    TotalMentionsTip: "该主题内容的总提及数",
    TotalInteractions: "互动总数",
    TotalInteractionsTip: "该主题相关内容的公开互动次数（包含心情/点赞、评论/回复和分享/转推）",
    PositiveSentimentRatio: "正面情感占比",
    PositiveSentimentRatioTip: "该主题获取正面内容的占比",
    TotalContentCount: "总内容数",
    TotalContentCountTip: "该主题的总内容数",
    TopicNameColumn: "主题名称",
    MentionTrendComparisonTip: "多个主题讨论内容数的对比趋势",
    NoMentionTrendData: "暂无提及趋势数据",
    PlatformMentionComparison: "平台提及对比",
    PlatformMentionComparisonTip: "多个主题的不同平台上的提及对比",
    NoPlatformMentionComparisonData: "暂无平台提及对比数据",
    MentionRatio: "提及占比",
    MentionRatioTip: "多个主题讨论内容数的占比",
    NoMentionRatioData: "暂无提及占比数据",
    SentimentDistributionComparison: "情感分布对比",
    SentimentDistributionComparisonTip: "多个主题讨论内容的情感占比",
    NoSentimentDistributionComparisonData: "暂无情感分布对比数据",
    PositiveSentimentTrend: "正面情感趋势",
    PositiveSentimentTrendTip: "多个主题讨论内容中正面情感内容的对比趋势",
    NoPositiveSentimentTrendData: "暂无正面情感趋势数据",
    ContentTotalComparison: "内容总数对比",
    ContentTotalComparisonTip: "对比各主题产生的内容数量",
    NoContentTotalComparisonData: "暂无内容总数对比数据",
    ContentTypeComparison: "内容类型对比",
    ContentTypeComparisonTip: "展示各主题不同内容类型的占比,包括视频、图片、文字等",
    NoContentTypeComparisonData: "暂无内容类型对比数据",
    PopularContentComparison: "热门内容对比",
    PopularContentComparisonTip: "互动量超过10,000的内容占比",
    NoPopularContentComparisonData: "暂无热门内容对比数据",
    AverageContentInteractionComparison: "内容平均互动对比",
    AverageContentInteractionComparisonTip: "平均互动量衡量单条内容的吸引力,是内容质量的核心指标。平均互动高说明每条内容都能获得较好反馈。\n平均互动 = 总互动数 / 内容总数",
    NoAverageContentInteractionComparisonData: "暂无内容平均互动对比数据",
    AuthorCountComparison: "作者数对比",
    AuthorCountComparisonTip: "多个主题发布内容的作者数的占比",
    NoAuthorCountComparisonData: "暂无作者数对比数据",
    AuthorAvgContributionComparison: "作者平均贡献提及数对比",
    AuthorAvgContributionComparisonTip: "平均每个作者贡献的提及数量,可以衡量作者对品牌的讨论热情度。\n平均提及 = 总提及数 / 活跃作者数",
    NoAuthorAvgContributionComparisonData: "暂无作者平均贡献提及数对比数据",
    AuthorGenderComparison: "作者性别对比",
    AuthorGenderComparisonTip: "展示多个主题作者的性别分布比例,可以了解品牌在不同性别群体中的吸引力差异,帮助制定精准营销策略。\n性别占比 = 该性别作者数 / 总作者数 × 100%",
    NoAuthorGenderComparisonData: "暂无作者性别对比数据",
    AuthorAgeComparison: "作者年龄对比",
    AuthorAgeComparisonTip: "展示多个主题作者的年龄分布情况,可以了解品牌受众的年龄结构,为产品定位和营销策略提供参考。\n年龄占比 = 该年龄段作者数 / 总作者数 × 100%",
    NoAuthorAgeComparisonData: "暂无作者年龄对比数据",
    PositiveSentiment: "正面",
    NeutralSentiment: "中立",
    NegativeSentiment: "负面",
    HotContentCount: "热门内容数",
    AverageInteractions: "平均互动数",
    AverageContributionMentions: "平均贡献提及数",
    AgeUnder18: "<18岁",
    Age18To24: "18-24岁",
    Age34To44: "34-44岁",
    AuthorAvatar: "作者头像",
    UserAvatar: "用户头像",
    VideoThumbnail: "视频缩略图",
    PlatformLogo: "平台 logo",
    PlatformIcon: "平台图标",
  },
  Audience: {
    // 受众任务列表面包屑单独使用，避免继续展示旧的“受众分析/受众监控”层级。
    AudienceTask: "受众任务",
    AudienceAnalysis: "受众分析",
    AudienceMonitoring: "受众监控",
    NewAudienceTask: "新建受众任务",
    EditAudienceTask: "编辑受众任务",
    AudienceTaskDetail: "{task}详情",
    SearchPageNamePlaceholder: "请输入社交号名称",
    Add: "新增",
    TaskName: "任务名称",
    SocialAccountName: "社交号名称",
    DataPeriod: "数据时段",
    Creator: "创建人",
    CreatedAt: "创建时间",
    Actions: "操作",
    NoData: "暂无数据",
    Data: "数据",
    Edit: "编辑",
    Delete: "删除",
    TaskNameLabel: "任务名称:",
    DataPeriodLabel: "统计时段:",
    SocialAccountLabel: "社交号:",
    PleaseEnterAudienceTaskName: "请输入受众任务名称",
    PleaseEnterTaskName: "请输入任务名称",
    PleaseSelectDataPeriod: "请选择统计时段",
    PleaseAddSocialAccount: "请至少添加一个社交号",
    PleaseSelectSocialAccount: "请选择社交号",
    AddSocialAccount: "+ 添加社交号",
    Confirm: "确定",
    Cancel: "取消",
    StartDate: "开始日期",
    EndDate: "结束日期",
    RangeSeparator: "至",
    DeleteConfirmMessage: "社交号受众任务删除后不能恢复，是否确认删除任务？",
    OperationConfirm: "操作确认",
    ConfirmDelete: "确定删除",
    Executing: "执行中...",
    DeleteSuccess: "删除成功!",
    BasicInfo: "基本信息",
    SocialAccountInfo: "社交号信息",
    Platform: "平台",
    UnknownPlatform: "未知平台",
    Unknown: "未知",
    None: "无",
    FansSuffix: "粉丝",
    Verified: "已认证",
    NotVerified: "未认证",
    AISummary: "AI总结",
    DataDetails: "数据详情",
    AIAnalysisSummary: "AI智能分析总结",
    AudienceQuality: "受众质量",
    BestTiming: "最佳时机",
    OperationSuggestions: "运营建议",
    GenderDistribution: "性别分布",
    GenderDistributionTip: "产生互动的用户的性别分布占比",
    Female: "女性",
    Male: "男性",
    AgeDistribution: "年龄分布",
    AgeDistributionTip: "产生互动的用户的年龄分布占比",
    LanguageDistribution: "语言分布",
    LanguageDistributionTip: "产生互动的用户的语言分布占比",
    CityDistribution: "城市分布",
    CityDistributionTip: "产生互动的用户的城市分布占比",
    CountryDistribution: "国家分布",
    CountryDistributionTip: "产生互动的用户的国家分布占比",
    ActiveTimeDistribution: "受众活跃时间分布",
    ActiveTimeDistributionTip: "产生互动的用户的活跃时间分布占比",
    MostActivePeriod: "最活跃时段",
    WeekendAverageActivity: "周末平均活跃度",
    WeekdayActivePeak: "工作日活跃高峰",
    DailyAverageActivity: "每日平均活跃度",
    ConstellationDistribution: "受众星座分布",
    ConstellationDistributionTip: "产生互动的用户的星座分布占比",
    InteractionLevelDistribution: "互动层级分布",
    InteractionLevelDistributionTip: "仅发表了表情和进行了评论和转发的用户占比",
    InteractionTypeDistribution: "互动类型分布",
    InteractionTypeDistributionTip: "发布了表情、进行了评论、进行了转发的用户占比",
    ShallowInteraction: "浅层互动",
    DeepInteraction: "深层互动",
    Reaction: "表情反应",
    CommentAndShare: "评论+分享",
    Comment: "评论",
    Like: "点赞",
    Share: "分享",
    AudienceUserList: "受众用户列表",
    UserInfo: "用户信息",
    UserInfoTip: "展示关注的头像、昵称、登录账号、年龄、性别",
    AgeSuffix: "岁",
    InteractionCount: "互动次数",
    InteractionCountTip: "用户在统计时段范围内进行的发表表情、评论、转发的次数之和",
    Horoscope: "星座",
    HoroscopeTip: "用户的星座",
    Country: "国家",
    CountryTip: "用户所在的国家",
    City: "城市",
    CityTip: "用户所在的城市",
    Language: "语言",
    LanguageTip: "用户使用的语言",
    TenThousand: "万",
    HundredMillion: "亿",
    Activity: "活跃度",
    Proportion: "占比",
    PeopleCount: "人数",
    Monday: "周一",
    Tuesday: "周二",
    Wednesday: "周三",
    Thursday: "周四",
    Friday: "周五",
    Saturday: "周六",
    Sunday: "周日",
    Capricorn: "摩羯",
    Aquarius: "水瓶",
    Pisces: "双鱼",
    Aries: "白羊",
    Taurus: "金牛",
    Gemini: "双子",
    Cancer: "巨蟹",
    Leo: "狮子",
    Virgo: "处女",
    Libra: "天秤",
    Scorpio: "天蝎",
    Sagittarius: "射手",
    ZodiacSuffix: "座",
  },
  Homepage: {
    Features: "功能",
    AIChatbot: "智能机器人",
    IndustryConsulting: "行业顾问",
    DocumentWriting: "文档撰写",
    CustomerCases: "客户案例",
    UserManual: "使用手册",
    ContactUs: "联系我们",
    OfficialWeChataccount: "官方公众号",
    ProductContact: "产品联系人",
    "CrossBorder": "您的专属出海营销助手",
    gotouse: "去使用",
    trynow: "立即体验",
    AIChatbotDesc: "智能机器人能够迅速、高效地处理客户咨询，显著提升客户满意度。目前支持Messenger、独立站客服、Facebook帖文、邮箱自动回复四种客服。",
    IndustryConsultingDesc: "行业顾问具备丰富的专业知识，能提供定制化服务，帮助用户解决各领域问题。",
    DocumentWritingDesc: "可以使用 AI 自动生成高质量原创内容，内容创作覆盖多种类型，满足不同场景、人群的 AI 创作需求，并提供个性化的自定义选项。",

    GmailDataNoticeTitle: "Gmail 数据使用说明",
    GmailDataNoticeDesc1: "JoinMC 的操作功能需要接入你的 Gmail 数据，仅限于将数据用于对应功能。",
    GmailDataNoticeDesc2: "我们不销售 Gmail 数据，不用于广告，不用于训练 AI 模型，你可随时撤销授权。",
    GmailDataNoticeDesc3Prefix: "取得 Gmail 数据的使用声明请",
    GmailDataNoticeDesc3Suffix: "（含 Limited Use 要求）。",
    GoogleAPIPolicy: "Google API Services User Data Policy",
    ViewPrivacyPolicy: "查看隐私政策",
    ViewUserAgreement: "查看用户协议",
    GmailScopeReadonly: "gmail_readonly",
    GmailScopeReadonlyTitle: "读取邮件",
    GmailScopeReadonlyDesc: "用于理解用户意图并生成回复建议。",
    GmailScopeSend: "gmail_send",
    GmailScopeSendTitle: "发送邮件",
    GmailScopeSendDesc: "创作自定义发送话题智能邮件。",

    PrivateKnowledgeBase: "专属知识库",
    PrivateKnowledgeBaseDesc: "个性化定制专属知识库，搭建便捷，调用精准",
    OmnichannelIntegration: "多渠道整合",
    OmnichannelIntegrationDesc: "Messenger/Facebook帖文/邮件，各种渠道轻松绑定。",
    PersonalizedReminders: "个性化提醒",
    PersonalizedRemindersDesc: "重点消息定时提醒，客户响应快速有效",
    MultilingualTranslation: "多语言转换",
    MultilingualTranslationDesc: "百种语言智能识别，目标语言实时转换",
    ScenarioReplies: "场景化回复",
    ScenarioRepliesDesc: "多场景智能识别，客户需求精准对接",
    PublicOpinionRiskControl: "舆论风险管控",
    PublicOpinionRiskControlDesc: "敏感评论智能隐藏，专业维护品牌形象",

    GlobalInsights: "海量出海知识",
    GlobalInsightsDesc: "媒体信息实时查询，让投放更智慧",
    MediaMonitoring: "全球行业洞察",
    MediaMonitoringDesc: "市场洞察及时掌握，让决策更精准",

    CreativeInspiration: "创意源泉",
    CreativeInspirationDesc: "激发无限灵感，创意新颖独特。",
    EfficientWriting: "高效写作",
    EfficientWritingDesc: "智能生成文稿，提升写作效率。",
  },
  // WhatsApp 客服工作台的操作提示与结束服务确认文案集中维护，避免组件内出现固定文案。
  "whatsapp-service": {
    ConversationAssignment: "会话分配",
    AllConversations: "全部会话",
    AssignedToMe: "分配给我的",
    Unassigned: "待分配的",
    Members: "客服成员",
    // 侧栏本人徽标空间仅容纳一个汉字，完整“我自己”保留给其他页面。
    SelfBadge: "我",
    Conversations: "会话",
    WabaAccounts: "WABA 账号",
    History: "历史对话",
    Online: "在线",
    Busy: "忙碌",
    // 侧栏、筛选与分配弹窗共用“离线”状态文案。
    Offline: "离线",
    UnknownStatus: "状态未知",
    Approved: "已批准",
    Rejected: "已拒绝",
    Pending: "审核中",
    SearchPlaceholder: "搜索昵称/备注/手机号",
    // 未分配按钮使用该短文案，和已分配时显示的客服昵称保持同一按钮结构。
    AssignAgent: "客服分配",
    Tags: "标签",
    EndService: "结束服务",
    ServiceEnded: "已结束",
    EndServiceTitle: "确认结束服务？",
    EndServiceDescription: "本次会话结束后状态置为已结束。客户后续发送消息会重新激活会话。",
    Close: "关闭",
    CancelEndService: "取消",
    ConfirmEndService: "结束",
    // 结束会话的请求状态与“保存规则”区分，确认框使用当前动作的文案。
    EndingService: "正在结束...",
    NoConversation: "请选择一个会话",
    NoMessages: "暂无消息",
    // 会话和消息请求失败时保留重试入口；筛选尚有未加载页时不提前宣告无结果。
    MessagesLoadFailed: "聊天记录加载失败",
    SearchMoreMatches: "继续加载以查找匹配会话",
    Retry: "重试",
    ManualReply: "人工回复",
    AiReply: "由 AI 自动回复",
    SendFailed: "发送失败",
    Emoji: "表情",
    Attachment: "附件",
    // 输入区附件图标的悬浮提示与附件菜单名称区分显示。
    AttachmentUploadTooltip: "附件上传",
    TranslateReply: "翻译回复",
    // WhatsApp 回复语种弹层独立使用设计稿中的标题与搜索占位文案。
    SelectReplyLanguage: "选择回复语言",
    SearchLanguageName: "搜索语言名称",
    Send: "发送",
    TypeMessage: "请输入消息...",
    // WhatsApp 附件共用数量上限，单文件大小按图片、视频、音频和文件分别提示。
    SendTranslation: "发送翻译",
    TranslationSuffix: "译文",
    TranslationFailed: "翻译失败，请重试",
    Translating: "翻译中...",
    UploadDocument: "上传文档",
    UploadImage: "上传图片",
    UploadImageVideo: "上传图片/视频",
    // 场景预览把图片与视频拆成独立入口，视频当前禁用。
    UploadVideo: "上传视频",
    UploadAudio: "上传音频",
    AttachmentTypeUnavailable: "不支持该文件格式",
    AttachmentLimit: "一次最多添加 10 个附件",
    AttachmentSizeLimitTitle: "文件超过大小限制",
    AttachmentSizeLimitIntro: "以下文件超过大小限制：",
    AttachmentSizeLimitDetail: "{name}（{type}，{size} MB，上限 {limit} MB）",
    AttachmentSizeSelectionHint: "超限文件未添加，其他符合要求的文件已保留。",
    AttachmentSizeSendHint: "请移除或更换超限文件后再发送。",
    AttachmentTypeImage: "图片",
    AttachmentTypeVideo: "视频",
    AttachmentTypeAudio: "音频",
    AttachmentTypeDocument: "文件",
    RemoveAttachment: "删除附件",
    CloseTranslation: "关闭译文",
    WindowExpiredTitle: "距客户最后一条消息已超过24小时，暂不支持发送消息",
    WindowExpiredDescription: "超出24小时客服服务窗口后无法主动发送消息，需等客户再次发来消息后才能继续沟通",
    PendingAccountTitle: "当前 WABA 状态为「待审核」，暂不支持发送消息",
    PendingAccountDescription: "Meta 审核通过后即可正常发送",
    // 账号拒绝和审核状态未知要分别说明，避免只读输入区误显示待审核提示。
    RejectedAccountTitle: "当前 WABA 未获批准，暂不支持发送消息",
    RejectedAccountDescription: "请确认账号通过 Meta 审核后再发送",
    UnknownAccountTitle: "无法确认当前 WABA 的审核状态，暂不支持发送消息",
    UnknownAccountDescription: "请刷新账号状态，确认审核通过后再发送",
    ServiceEndedTitle: "服务已结束，暂不支持发送消息",
    ServiceEndedDescription: "客户后续再次发送消息后可继续沟通",
    UnassignedReplyTitle: "当前会话尚未分配客服，暂不支持发送消息",
    UnassignedReplyDescription: "请先将会话分配给自己后再回复",
    OtherAgentReplyTitle: "当前会话已分配给其他客服，暂不支持发送消息",
    OtherAgentReplyDescription: "仅负责该会话的客服可以回复",
    // 可转派的只读会话按 Figma 显示统一引导和输入区按钮，不改变原有负责人权限。
    AssignBeforeReply: "需要先将该会话分配给指定的成员后才可以进行回复",
    AssignAgentInComposer: "分配客服",
    // 分配推送后需重新核实负责人，区分核实中与请求失败的只读提示。
    AssignmentCheckingTitle: "正在核实会话负责人，暂时无法发送消息",
    AssignmentCheckingDescription: "核实完成后会自动恢复可用状态",
    AssignmentCheckFailedTitle: "会话负责人核实失败，暂时无法发送消息",
    AssignmentCheckFailedDescription: "请重试获取会话信息",
    // 分配刷新可能使已打开的联系人离开当前列表，此时聊天继续可读但不能按旧归属发送。
    ConversationOutOfScope: "当前会话已不在会话列表，请重新选择会话",
    Reply: "回复",
    You: "你",
    Customer: "客户",
    TranslateMessage: "翻译",
    CollapseTranslation: "收起译文",
    TranslationLabel: "译文",
    Collapse: "收起",
    Quote: "引用",
    ReplyPrefix: "回复：",
    By: "由",
    Replied: "回复",
    UnknownAgent: "人工客服",
    AgentRemovedDescription: "已离开团队，资料已删除",
    // 消息没有明确离队标记且客服目录缺少该人时，用中性文案避免误报离队。
    AgentProfileUnavailable: "暂无客服资料",
    // 其他系统事件没有正文时使用中性占位，避免误写成转接通知。
    SystemNotice: "系统通知",
    // 转接事件缺少目标姓名时仍展示明确的系统提示，避免聊天流出现空白胶囊。
    TransferNotice: "会话已转接给人工客服",
    TransferToAgent: "会话已转接给人工客服 {name}",
    AssignmentRulesTitle: "分配规则",
    AssignmentMechanism: "会话分配机制",
    MechanismInfo: "设置会话由谁接待以及客服接待容量与时效。",
    NoAssignment: "不分配",
    NoAssignmentDescription: "拥有账号权限的用户都可以处理会话",
    ManualAssignment: "人工分配",
    ManualAssignmentDescription: "转人工策略分配客服",
    DistributionStrategy: "分配策略",
    ManualAllocation: "手动分配",
    ManualAllocationDescription: "不自动分配，由管理员在会话列表中指定或调整接待客服",
    AverageAllocation: "平均分配",
    AverageAllocationDescription: "在所有客服中按接待数平均分配，优先分配给当前接待数最少的可接待客服",
    CountryAllocation: "按国家分配",
    CountryAllocationDescription: "按客户国家匹配客服，其他国家交由剩余客服接待",
    CountryRules: "国家分配规则",
    CountryRegion: "国家/地区",
    // 国家与客服规则使用相同的居中多选弹窗，以下文案供两个模式共用。
    SetRuleCountries: "设置规则国家",
    SetReceptionAgents: "设置接待客服",
    SearchCountryName: "请输入国家名称",
    SearchAgentNameOrPhone: "请输入客服昵称 / 手机号",
    Continent: "大洲",
    Asia: "亚洲",
    Americas: "美洲",
    Europe: "欧洲",
    Africa: "非洲",
    Oceania: "大洋洲",
    OtherCountries: "其他",
    SelectedCountryCount: "已选中 {count} 个国家",
    SelectedAgentCount: "已选中 {count} 个客服",
    // 中文数量不区分单复数，单数键与复数键保留相同文案。
    SelectedCountryCountOne: "已选中 {count} 个国家",
    SelectedAgentCountOne: "已选中 {count} 个客服",
    ReceptionAgents: "接待客服",
    Operation: "操作",
    DefaultRule: "默认规则",
    DefaultCountryRuleDescription: "未单独设置规则的国家",
    AllAgents: "全部客服",
    AddCountryRule: "添加国家规则",
    DeleteRule: "删除",
    CountryPlaceholder: "选择国家/地区",
    AgentPlaceholder: "选择接待客服",
    NoCountryOptions: "暂无可选国家/地区",
    // 国家目录由接口加载；未返回前不要把本地国家目录当作规则候选项。
    LoadingCountryCatalog: "正在加载国家/地区列表...",
    // 已保存的旧国家若不再由国家接口返回，仍可在选择窗中取消。
    SavedCountriesOutsideCatalog: "已保存的其他国家/地区",
    NoAgentOptions: "暂无可选客服",
    CountryRulesRequired: "请为每条规则设置国家 / 地区和接待客服",
    ServiceSettings: "客服接待设置",
    CapacityAndTimeout: "接待容量与时效",
    SingleWabaLimit: "单 WABA 同时接待上限",
    SingleWabaLimitDescription: "客服在单 WABA 的接待上限，满额暂停分配。",
    PeopleUnit: "人",
    ServiceExpiry: "服务过期时间",
    ServiceExpiryDescription: "会话接待超过该时长仍未结束服务，到期自动结束。",
    MinuteUnit: "分钟",
    ConversationRelease: "会话释放时间",
    ConversationReleaseDescription: "客服超时未回复，会话自动回到队列重新分配。",
    HistoricalContacts: "历史联系人",
    AssignToPreviousAgent: "指定分配给上次接待客服",
    AssignToPreviousAgentDescription: "会话固定分配给上次接待的客服，不会自动转派给其他客服。",
    UseCurrentStrategy: "按当前分配策略分配",
    UseCurrentStrategyDescription: "与新联系人使用相同的分配策略。",
    Cancel: "取消",
    SaveRules: "保存规则",
    AssignmentRulesSaved: "分配规则已保存",
    LoadFailed: "加载 WhatsApp 会话失败",
    LoadMore: "加载更多会话",
    SendUnavailable: "当前会话暂时无法发送消息",
    AssignmentUnavailable: "当前接口没有提供会话分配信息",
    FeatureUnavailable: "此功能尚未接入服务端",
    AttachmentUnavailable: "附件发送尚未接入此页面",
    TranslateUnavailable: "翻译回复尚未接入此页面",
    NoBoundAccount: "暂无已绑定客服机器人的 WABA 账号",
    UnboundAccount: "此 WABA 账号尚未绑定客服机器人",
    // 工作台的列表、资料卡、分配浮层与空状态统一从语言包读取，切换语言时即时更新。
    ListAssignAgent: "分配",
    AssignConversationAgent: "分配 {name} 的负责客服",
    ConversationFallback: "会话",
    ViewContactDetails: "查看 {name} 的资料",
    ContactFallback: "联系人",
    FilterAgentShort: "客服",
    FilterAccountShort: "账号",
    SearchByAgent: "按客服查询",
    SearchByAccount: "按账号查询",
    LinkedTags: "关联标签",
    ConversationTags: "会话标签",
    ClearFilters: "清空",
    RemoveFilterKind: "清除{kind}筛选",
    SelectedFilterAria: "{title}已选项",
    SelectedFilterCount: "· {count}个",
    RemoveFilterItem: "移除{name}",
    FilterChipCount: "{label}：{count}",
    NoMatchingAgents: "暂无匹配客服",
    NoMatchingAccounts: "暂无匹配账号",
    SelectedAccountCount: "已选中 {count} 个账号",
    SelectedAccountCountOne: "已选中 {count} 个账号",
    SearchWabaAccount: "请输入 WABA 账号",
    ConversationCount: "会话 {count}",
    ConversationCountOne: "会话 {count}",
    ContactProfile: "联系人资料",
    EditRemarkName: "编辑备注名",
    Nickname: "昵称",
    PhoneNumber: "手机号",
    Email: "电子邮件",
    RemarkName: "备注名",
    AddContactTag: "添加联系人标签",
    SourceChannel: "来源渠道",
    LinkedWaba: "关联 WABA",
    // 顶栏 WABA 悬浮卡展示该账号的客服手机号，而非联系人的手机号。
    CustomerServicePhone: "客服手机号",
    FirstConversation: "首次沟通",
    RecentConversation: "最近沟通",
    EnterRemark: "请输入备注内容",
    SaveRemark: "保存备注",
    CancelReply: "取消引用回复",
    Assigning: "分配中...",
    CurrentAgent: "当前负责",
    SavingRules: "正在保存...",
    NoConversationHintLine1: "从左侧列表选择会话，查看对话记录，",
    NoConversationHintLine2: "可按 WABA 账号与客服成员筛选。",
    UnknownCountry: "未知国家/地区",
    // 历史与实时媒体卡片共用类型文案；列表中无正文的媒体单独显示文件占位。
    MediaAttachment: "媒体附件",
    MediaFilePreview: "[媒体文件]",
    MediaImage: "图片",
    MediaVideo: "视频",
    MediaAudio: "音频",
    MediaDocument: "文档",
    MediaSticker: "贴纸",
    MediaLocation: "位置",
    MediaContact: "联系人",
    MediaProducts: "商品",
    MediaTemplate: "模板消息",
    MediaViewDetails: "查看详情",
    OpenDocument: "打开文档",
    AudioNotSupported: "浏览器不支持音频播放",
    VideoNotSupported: "浏览器不支持视频播放",
    // 视频缩略图的独立按钮会随播放状态切换读屏文案。
    PlayVideo: "播放视频",
    PauseVideo: "暂停视频",
    MediaPreview: "媒体预览",
    TemplateButton: "按钮 {index}",
    // 接口可能返回英文成功词或中文错误；这些兜底文案保证提示跟随当前界面语言。
    TeamPushConnectionFailed: "团队推送连接失败",
    AgentStatusMissingContext: "缺少团队或成员信息，客服状态未更新",
    AgentStatusUpdateFailed: "客服状态更新失败",
    AgentStatusUpdated: "客服状态已更新",
    AgentProfileLoadFailed: "当前客服资料加载失败",
    MembersLoadFailed: "客服成员加载失败",
    WabaAccountsLoadFailed: "WhatsApp 账号加载失败",
    MessageCountLoadFailed: "会话数量加载失败",
    AssignmentVerificationFailed: "会话归属核实失败",
    ReadConversationFailed: "标记会话已读失败",
    MissingConversationUserId: "缺少会话用户 ID，无法加载聊天记录",
    TeamLabelsLoadFailed: "团队标签加载失败",
    UnnamedCategory: "未命名分类",
    TeamTags: "团队标签",
    ExistingTagUnknown: "无法识别已有标签“{name}”，请刷新后重试",
    UnnamedTag: "未命名",
    AssignedTagsReadFailed: "无法读取联系人已有标签，请稍后重试",
    AssignAgentFailed: "分配客服失败",
    AssignSucceeded: "分配成功",
    AssignmentOnlyToSelf: "无权限分配，未分配的会话只能分配给自己",
    CountryCatalogLoadFailed: "国家列表读取失败",
    // 超级管理员和管理员都能查看并保存分配规则。
    RulesOnlyAdminView: "仅团队超级管理员或管理员可以查看分配规则",
    RulesMissingTeamView: "缺少团队信息，无法读取分配规则",
    NoRulesConfigured: "该团队暂无客服配置",
    RulesLoadFailed: "分配规则读取失败",
    RulesOnlyAdminSave: "仅团队超级管理员或管理员可以保存分配规则",
    RulesMissingTeamSave: "缺少团队信息，无法保存分配规则",
    RulesSaveFailed: "分配规则保存失败",
    EndServiceFailed: "结束服务失败",
    TagsNotSynced: "标签尚未同步，请重新选择",
    AssignedTagsVerifyFailed: "无法核对联系人已有标签，请稍后重试",
    AssignedTagsChanged: "联系人标签已变化，请关闭弹窗重新打开后再保存",
    TagSaveFailed: "标签保存失败",
    TagsUpdated: "标签已更新",
    RemarkSaveFailed: "备注名保存失败",
    RemarkUpdated: "备注名已更新",
    CategoryCreateFailed: "分类创建失败",
    CategoryCreatedRefresh: "分类已创建，请重新打开标签弹窗",
    SelectTagCategory: "请先选择一个标签分类",
    TagCreateFailed: "标签创建失败",
    TagCreatedRefresh: "标签已创建，请重新打开标签弹窗",
    SendConnectionMissing: "缺少消息服务连接信息，无法发送",
    // 上传接口复用原图片方法名；弹窗同时指出失败文件和接口返回的具体原因。
    AttachmentUploadFailed: "附件上传失败",
    AttachmentUploadFailureDetail: "{name}：{reason}",
    ImageUploadSizeExceeded: "图片不能大于 {size} MB",
    UploadFailureConfirm: "确认",
    MessageSocketConnectionFailed: "消息服务连接失败",
  },
  route: {
    "social-account": "社交账号",
    "social-monitor": "社媒监控",
    "content-publish": "内容发布",
    "message-center": "消息中心",
    // AI 机器人作为独立一级导航，文案与主侧栏的路由配置共用。
    "ai-robot": "AI 机器人",
    "social-listening": "社交聆听",
    "marketing-tools": "营销工具",
    "library": "知识库",
    "data-report": "数据报表",
    "team-management": "团队管理",
    "monitor-list": "监控列表",
    "data-summary": "数据汇总",
    "config-bot": "配置机器人",
    "service-bot": "客服机器人",
    // WhatsApp 客服的菜单与页面共用同一名称。
    "whatsapp-service": "WhatsApp 客服",
    "publish-list": "发布列表",
    "publish-post": "帖文发布",
    "publish-calendar": "发布日历",
    "publish-draft": "发布草稿",
    "whatsapp-blast": "WhatsApp 群发",
    "whatsapp-contacts": "WhatsApp 联系人",
    "tag-management": "标签管理",
    // 优惠券库为营销工具新增的二级入口，路由和侧栏统一复用此文案。
    "coupon-library": "优惠券库",
    // 优惠券详情是列表的三级页面，仅用于路由标题和面包屑展示。
    "coupon-detail": "优惠券详情",
    "listening-task": "聆听任务",
    "listening-comparison": "聆听对比",
    "audience-task": "受众任务",
    "team-package": "团队套餐",
    "member-management": "成员管理",
    "team-settings": "团队设置",
    "consumption-records": "消费记录",
    "token-expired-title": "提示",
    "token-expired-message": "登录状态已过期，请重新登录",
    "mass-email-list": "邮件群发",
    "mail-bot-statistics": "邮箱机器人统计",
    "robot-report": "机器人报表",
    "automateTaskList":"自动化任务",
    "automateTaskStatistics":"任务详情",
    "mail-bot-statistics": "邮箱机器人统计",
    "robot-report": "机器人报表",
    CTWAReport: "CTWA 报表",
    "CTWA-Detail": "广告账户详情",
    "CTWA-Auth-Callback": "广告账户授权回调"
  },

  "route.adviser": "行业顾问",
  "route.ai-chatbot": "JoinMC - 智能机器人",
  "route.ai-chatbot-crumb": "JoinMC - 智能机器人",
  "route.ai-writing": "AI写作",
  "route.ai-writing-crumb": "JoinMC - 智能文档写作",
  "route.alipay": "支付宝支付",
  "route.audience-task": "受众分析",
  "route.audience-task-crumb": "JoinMC - 社交聆听 - 受众分析",
  "route.audience-task-home-crumb": "JoinMC - 社交聆听 - 受众分析 - 主页详情",
  "route.blast-template": "新建群发任务模板",
  "route.blast-template-crumb": "群发任务模板",
  "route.bot": "客服管理",
  "route.bot-create": "创建机器人",
  "route.bot-create-crumb": "JoinMC - 创建机器人",
  "route.bot-statistics-crumb": "JoinMC - 机器人数据统计",
  "route.bot-store": "设置机器人",
  "route.bot-store-crumb": "JoinMC - 设置机器人",
  "route.cases": "JoinMC - 客户案例",
  "route.chat": "对话",
  "route.config-bot": "客服列表",
  "route.config-bot-crumb": "JoinMC - 消息中心 - 配置机器人",
  "route.content-publish": "内容发布",
  "route.content-publish-crumb": "JoinMC - 内容发布",
  "route.dashboard": "首页",
  "route.dashboard-crumb": "欢迎体验JoinMC",
  "route.data-report": "数据报表",
  "route.data-report-crumb": "JoinMC - 数据报表",
  "route.data-summary": "数据汇总",
  "route.data-summary-crumb": "JoinMC - 社媒监控 - 数据汇总",
  "route.ecommerce-crumb": "媒体管理,电商平台",
  "route.expense-detail": "支出详情",
  "route.expense-detail-crumb": "JoinMC 团队管理 - 支出详情",
  "route.fb-posts": "Facebook 帖文助手",
  "route.fb-posts-crumb": "JoinMC - Facebook 帖文助手信息",
  "route.finance": "财务信息",
  "route.finance-crumb": "JoinMC 团队管理 - 财务信息",
  "route.inspiration-writing": "💡灵感写作",
  "route.instruct-center": "模板创作中心",
  "route.instruct-center-crumb": "JoinMC - 模板创作中心",
  "route.instruct-create": "创建模板",
  "route.instruct-create-crumb": "JoinMC - 创建模板",
  "route.library": "知识库",
  "route.library-crumb": "JoinMC - 知识库",
  "route.library-grab": "抓取链接",
  "route.library-grab-crumb": "知识库-抓取链接",
  "route.library-store-crumb": "JoinMC - 在线撰写资料",
  "route.linkedin-auth": "Linkedin 授权",
  "route.linkedin-auth-crumb": "JoinMC - Linkedin授权",
  "route.listening-comparison": "聆听对比",
  "route.listening-comparison-crumb": "JoinMC - 社交聆听 - 聆听对比",
  "route.listening-comparison-home-crumb": "JoinMC - 社交聆听 - 聆听对比 - 主页详情",
  "route.listening-task-crumb": "JoinMC - 社交聆听 - 聆听任务",
  "route.listening-task-home-crumb": "JoinMC - 社交聆听 - 聆听任务 - 主页详情",
  "route.mail": "邮箱邮件",
  "route.mail-crumb": "JoinMC - 邮箱邮件",
  "route.mail-reply": "邮件回复",
  "route.mail-reply-crumb": "JoinMC - 回复邮件",
  "route.marketing-tools": "营销工具",
  "route.media-management": "媒体管理",
  "route.member-detail": "成员详情",
  "route.member-detail-crumb": "JoinMC 团队管理 - 成员详情",
  "route.member-management": "成员管理",
  "route.member-management-crumb": "JoinMC 团队管理 - 成员管理",
  "route.messenger": "Messenger 客服",
  "route.messenger-crumb": "JoinMC - Messenger客服信息",
  // Facebook 独立详情路由的浏览器标签标题，需与 route meta.crumbs 的 key 保持一致。
  "route.facebook-platform-crumb": "JoinMC - 社媒监控 - Facebook 主页详情",
  "route.monitor-detail-crumb": "JoinMC - 社媒监控 - 主页管理 - 主页详情",
  "route.monitor-list-crumb": "JoinMC - 社媒监控 - 主页管理",
  "route.order-product": "订单和商品",
  "route.personal": "个人中心",
  "route.post-detail": "帖文详情",
  "route.post-detail-crumb": "JoinMC - 帖文详情",
  "route.privacy-policy": "隐私政策",
  "route.profile": "个人资料",
  "route.profile-crumb": "JoinMC 个人中心-个人资料",
  "route.publish-calendar": "发布日历",
  "route.publish-calendar-crumb": "JoinMC - 内容发布 - 发布日历",
  "route.publish-draft": "发布草稿",
  "route.publish-draft-crumb": "JoinMC - 内容发布 - 发布草稿",
  "route.publish-list": "我的发布",
  "route.publish-list-crumb": "JoinMC - 内容发布 - 发布列表",
  "route.publish-not-activated": "内容发布 - 未开通",
  "route.publish-not-activated-crumb": "JoinMC - 内容发布 - 未开通",
  "route.publish-post-crumb": "JoinMC - 内容发布 - 帖文发布",
  "route.recharge": "充值",
  "route.recharge-crumb": "JoinMC 团队管理 - 充值",
  "route.scene-store": "运营场景设置",
  "route.scene-store-crumb": "JoinMC - 运营场景设置",
  "route.sentiment": "舆情",
  "route.service-bot-crumb": "JoinMC - 消息中心 - 客服机器人",
  "route.shopify-auth": "Shopify 授权",
  "route.shopline-auth": "Shopline 授权",
  "route.signal-post-crumb": "JoinMC - 社媒监控 - 单一帖文详情",
  "route.social-account-crumb": "JoinMC - 社交账号",
  "route.social-listening": "社交聆听",
  "route.social-listening-crumb": "JoinMC - 社交聆听",
  "route.social-monitor": "社媒监控",
  "route.social-monitor-crumb": "JoinMC - 社媒监控",
  "route.specific-store": "独立帖文运营设置",
  "route.specific-store-crumb": "JoinMC - 独立帖文运营设置",
  "route.tag-management": "标签管理",
  "route.tag-management-crumb": "JoinMC - 营销工具 - 标签管理",
  // 优惠券库的页面标题与浏览器面包屑文案。
  "route.coupon-library": "优惠券库",
  "route.material-creation": "AI素材制作",
  "route.coupon-library-crumb": "JoinMC - 营销工具 - 优惠券库",
  "route.material-creation-crumb": "JoinMC - AI素材制作",
  // 素材创作（JoinSpark 授权绑定）页文案
  "material.banner-title": "解锁 JoinSpark AI 广告素材 智造引擎",
  "material.banner-subtitle": "一键授权绑定 JoinMC 与 JoinSpark 账号。从灵感搜索到高转化素材生成，无缝衔接，提升出海广告投放效率。",
  "material.use-joinspark": "去使用JoinSpark",
  "material.start-bind": "开始授权绑定",
  "material.need-super-admin-tip": "当前功能尚未开通，请联系超级管理员完成授权。开通后可对接 AI 内容制作平台，实现数据互通。",
  "material.cards-title": "授权后，解锁完整广告创意流程",
  "material.cards-subtitle": "从发现广告灵感、素材生成到投放分析与团队协作，一站式完成",
  "material.card1-title": "创意广告素材库",
  "material.card1-desc": "集成全球热门广告创意平台，实时检索 Meta、TikTok、Google 等渠道爆款素材，按行业/渠道/国家精准筛选，一键获取灵感",
  "material.card2-title": "AI素材制作",
  "material.card2-desc": "接入 Seedance、Kling 3.0、Vidu、Veo 3.1 等多款主流大模型，支持视频生视频、图生视频、文生视频等 5+ 种生成模式",
  "material.card3-title": "投放分析报告",
  "material.card3-desc": "基于社交聆听 + 竞品拆解 + 智能拉片，产出结构化投放执行方案，让高转化素材的生产有据可依",
  "material.card4-title": "团队管理",
  "material.card4-desc": "多团队协作管理，积分统筹分配与预警，成员权限精细化管控。",
  "material.step-agreement": "用户协议",
  "material.step-verify": "手机验证",
  "material.step-done": "完成授权",
  "material.agreement-title": "确认授权协议",
  "material.agreement-subtitle": "请仔细阅读并同意以下授权协议，完成账号绑定",
  "material.protocol1-name": "JoinSpark用户服务协议",
  "material.protocol1-desc": "了解 JoinSpark 平台服务及账号使用规则",
  "material.protocol2-name": "JoinSpark隐私政策",
  "material.protocol2-desc": "了解个人信息收集、使用及保护方式",
  "material.protocol3-name": "JoinMC 与 JoinSpark 账号授权与数据共享协议",
  "material.protocol3-desc": "了解账号绑定及必要数据共享范围",
  "material.protocol4-name": "AI 内容生成服务使用规范",
  "material.protocol4-desc": "了解 AI 内容生成及合规使用要求",
  "material.agree-checkbox": "我已阅读并同意以上全部协议",
  "material.agree-required": "请先同意协议",
  "material.next-step": "下一步",
  "material.prev-step": "上一步",
  "material.verify-title": "手机号验证",
  "material.verify-subtitle": "验证手机号以完成账号绑定授权",
  "material.enter-phone": "请输入手机号",
  "material.sms-placeholder": "请输入短信验证码",
  "material.get-code": "获取验证码",
  "material.resend-code": "{second}s后重新获取",
  "material.enter-sms-code": "请输入正确的短信验证码",
  "material.complete-bind": "完成绑定",
  "material.bind-success": "绑定成功",
  "material.bind-success-subtitle": "JoinMC与JoinSpark账号已打通，点击下方按钮或等待自动跳转，无需重复登录",
  "material.enter-joinspark": "立即进入JoinSpark",
  "material.auto-redirect": "即将自动跳转",
  "material.bind-fail": "绑定失败",
  "material.rebind": "重新绑定",
  "material.sms-sent": "获取验证码成功",
  "material.bind-success-msg": "绑定成功，5秒后自动跳转JoinSpark",
  "material.bind-fail-retry": "绑定失败，请稍后重试",
  "route.coupon-detail": "优惠券详情",
  "route.coupon-detail-crumb": "JoinMC - 营销工具 - 优惠券详情",
  "route.task-data": "任务数据",
  "route.team-management": "团队管理",
  "route.team-package": "团队套餐",
  "route.team-package-crumb": "JoinMC 团队管理 - 团队套餐",
  "route.team-profile": "团队资料",
  "route.team-profile-crumb": "JoinMC 个人中心-团队资料",
  "route.team-settings": "团队设置",
  "route.team-settings-crumb": "JoinMC 团队管理 - 团队设置",
  "route.template-edit": "新增/编辑模板",
  "route.test-cases": "测试用例",
  "route.tiktok-auth": "TikTok 授权",
  "route.tiktok-auth-crumb": "JoinMC - TikTok账号授权",
  "route.tiktok-platform-crumb": "JoinMC - 社媒监控 - tiktok 平台",
  "route.tiktok-post-crumb": "JoinMC - 社媒监控 - tiktok 帖文详情",
  "route.user": "用户管理",
  "route.user-agreement": "用户协议",
  "route.view": "查看",
  "route.view-settings": "查看设置",
  "route.vk-auth": "VK 授权",
  "route.vk-auth-crumb": "JoinMC - VK授权",
  "route.whatsapp-api": "WhatsApp API 管理",
  "route.whatsapp-api-crumb": "媒体管理,WhatsApp API 管理",
  "route.whatsapp-blast": "WhatsApp 群发",
  "route.whatsapp-blast-crumb": "JoinMC - 营销工具 - WhatsApp群发",
  "route.whatsapp-contacts": "WhatsApp联系人",
  "route.whatsapp-contacts-crumb": "JoinMC - 营销工具 - WhatsApp 联系人",
  // 独立客服入口的浏览器标题沿用消息中心层级。
  "route.whatsapp-service-crumb": "JoinMC - 消息中心 - WhatsApp 客服",
  "route.whatsapp-template": "WhatsApp 模板",
  "route.whatsapp-template-crumb": "媒体管理,WhatsApp 模板",
  "route.workbench": "工作台",
  "route.writing": "写作",
  "route.writing-templates": "写作模板库",
  "route.x-auth": "X 授权",
  "route.x-auth-crumb": "JoinMC - X账号授权",
  platform: {
    "Api-Settings": "API 设置",
    "Label-Management": "标签管理",
    "New-Authorization": "新增授权",
    "All-Auth-Status": "全部授权状态",
    "All-Page-Labels": "全部主页标签",
    "Page-Info": "主页信息",
    Verified: "已认证",
    Unverified: "未认证",
    Fans: "{count}粉丝",
    "Auth-Status": "授权状态",
    Authorized: "已授权",
    Unauthorized: "未授权",
    "Related-Labels": "关联标签",
    Add: "添加",
    "Join-Time": "加入时间",
    Actions: "操作",
    Unauth: "解除授权",
    Reauth: "重新授权",
    More: "更多",
    "Delete-Page": "删除主页",
    "Search-Label": "搜索标签",
    "Add-Label": "添加标签",
    "Label-Name": "标签名称",
    "Label-Account-Count": "关联账号数量",
    "Edit-Label": "编辑标签",
    "Delete-Label": "删除标签",
    "New-Label": "新增标签",
    "Enter-Label-Name": "请输入标签名称",
    "Manage-Labels": "管理标签",
    "Label-Dialog-Desc": "关联标签后，您在数据筛选环节可直接按标签进行选择。",
    "Linked-Labels": "已关联标签",
    "Label-Select": "标签选择",
    "Not-Set": "未设置",
    "Operation-Failed": "操作失败",
    "Linked-Bots": "已关联的机器人：",
    "Chat-Bot": "对话机器人",
    "Page-Bot": "主页机器人",
    "Social-Monitor": "社媒监控：",
    "Monitor-Days": "已监控 {days} 天",
    "Got-It": "知道了",
    "Info-Update-Success": "信息更新成功",
    "Search-Shop-Placeholder": "请输入店铺名称",
    "Search-Account-Placeholder": "请输入账号信息",
    "Search-Page-Placeholder": "请输入主页名称",
    "Delete-Bound-Failed": "主页已关联智能机器人或社媒监控，无法删除",
    "Unauth-Bound-Failed": "主页已关联智能机器人或社媒监控，无法取消授权",
    "Delete-Page-Confirm": "主页删除后，主页相关的数据将同步删除！",
    "Operation-Confirm": "操作确认",
    Deleted: "已删除",
    "Unauth-Confirm": "主页授权解除后，社媒监控模块仅能监控主页的公开数据，授权相关数据将不再展示！",
    Unauthed: "已解除授权",
    "Auth-Window-Failed": "授权窗口打开失败，请检查浏览器弹窗拦截设置",
    "Auth-Sync-Loading": "授权成功，正在同步主页...",
    "Label-Add-Success": "标签添加成功",
    "Fans": "{count}粉丝",
    "Verified": "已认证",
    "Unverified": "未认证",
    "Back": "返回",
    "Label-Update-Success": "标签更新成功",
    "Delete-Label-Confirm": "确定要删除这个标签吗？",
    "Label-Delete-Success": "标签删除成功",
    // ===== 新增授权弹窗 =====
    "Add-Social-Page": "新增社交主页",
    "Select-Page": "选择主页",
    "Add-Page-Desc": "添加需登录社交主页，完成后可分析授权数据、发帖及管理私信、评论。",
    "Add-Public-Desc": "通过搜索，轻松添加社交媒体上公开的社交号。全面分析其公开数据，精准评估该社交号的运营表现。",
    "Authorize-Platform-Sub": "请选择需要授权的平台，授权完成后账号将自动同步到列表中",
    "WhatsApp-Register-Sub": "选择 WhatsApp Business 注册方式",
    "Add-Ecommerce-Auth": "新增电商授权",
    "Shop-Auth-Sub": "选择店铺类型并填写授权信息",
    "Set-Label": "设置标签",
    "Add-New-Label": "添加新标签",
    "New-Label-Success": "新增标签成功",
    "Set-Label-Success": "设置标签成功",
    "Selected-Pages": "已选中 {count} 个主页",
    "Authorize-New-Page": "授权新主页",
    "Select-Bind-Page": "请选择您需要绑定的主页",
    "Select-Page-Warning": "请选择主页",
    "Select-Platform": "请选择主页平台",
    "Confirm-Add": "确认新增",
    "Page-Added-Monitor": "主页已添加到监控",
    "Added-Monitor": "已添加监控",
    "Bound": "已绑定",
    "Auth-Partial-Failed": "部分社交号授权失败",
    "Added-Other-Team": "已添加到其他团队",
    "Authorized": "已授权",
    "Authorized-Other-Team": "已授权到其他团队",
    "No-Result": "没有找到您要搜索的主页",
    "Auth-Success": "授权成功",
    "Auth-Failed": "授权失败",
    "Auth-In-Progress": "正在授权...",
    "Auth-Cancelled": "您取消了授权。",
    "Global-Page": "全球主页",
    "All": "全部",
    "Tip": "提示",
    // Telegram 授权
    "Phone-Number": "手机号：",
    "Enter-Phone": "请输入手机号",
    "Verification-Code": "验证码：",
    "Enter-Code": "请输入验证码",
    "Get-Code": "获取验证码",
    "Resend-In": "{seconds}秒后重新获取",
    "Code-Sent": "验证码已发送",
    "Check-Telegram-Notice": "请注意接收 Telegram 发送的验证码",
    "Enter-Second-Password": "请输入 Telegram 的二次密码",
    "Second-Password": "二次密码：",
    "Enter-Second-Password-Placeholder": "请输入二次密码",
    "Select-Channel-Title": "选择要授权的频道",
    "Search-Channel-Placeholder": "请输入你要搜索的主页名称",
    "Public-Channel": "公开频道",
    "Private-Channel": "私有频道",
    // LinkedIn 授权
    "Auth-Company-Page": "授权公司主页",
    "Auth-Personal-Page": "授权个人主页",
    "Personal-Not-Open": "个人主页授权暂未开放",
    "No-Company-Page": "没有找到可以用于授权的公司主页",
    "Check-Following": "您可以按以下方法进行检查",
    "Check-Item-1": "1.检查并确认授权时登陆了正确的 LinkedIn 用户账号。",
    "Check-Item-2": "2.检查授权的 LinkedIn 用户账号下是否拥有公司主页，并且是公司主页的高级管理员。",
    // WhatsApp 授权
    "WA-Confirm-Auth": "确认授权",
    "WA-Sync-Title": "同步联系人和聊天记录",
    "WA-Sync-Desc": "正在从 WhatsApp Business App 同步数据，请稍候，同步数据需要一段时间，您可以先进行其他操作",
    "WA-Stats-Period": "统计区间",
    "WA-Stats-Period-Desc": "接入当日起 180 天内所有发送、接收消息",
    "WA-Filter-Range": "过滤范围",
    "WA-Filter-Range-Desc": "群聊相关消息不展示",
    "WA-View-Contacts": "查看联系人",
    "WA-API-Desc": "对于中大型企业，通过程序化访问实现与客户的规模化沟通",
    "WA-App-Title": "WhatsApp Business APP 共享",
    "WA-App-Desc": "使用现有的 WhatsApp Business 应用账号和电话号码进行注册",
    "WA-Coexistence-Fail-Title": "共存开通失败",
    "WA-Coexistence-Fail-Content": "错误原因：您未选择共存模式，误勾选了关联业务资产入口，当前流程无法实现手机端 WhatsApp 企业版 + API 同时在线的共存能力<br><br>重新授权选择【WhatsApp 共存】通道提交即可",
    "WA-Auth-Incomplete": "WhatsApp 授权未完成",
    "WA-Auth-Success": "WhatsApp 授权成功",
    "WA-Auth-Failed": "WhatsApp 授权失败",
    "WA-App-Auth-Incomplete": "WhatsApp Business App 共存授权未完成",
    "WA-App-Auth-Failed": "WhatsApp Business App 共存授权失败",
    "WA-App-Register-Timeout": "注册超时，未能获取到 WhatsApp Business App 共存账号信息",
    "WA-App-Coexist-Timeout": "等待 WhatsApp Business App 共存账户数据超时",
    "WA-Select-Mode": "请选择 WhatsApp Business 注册方式",
    "WA-Auth-Start-Failed": "WhatsApp 授权启动失败",
    "WA-Register-Timeout": "注册超时，未能获取到 WhatsApp Business 账号信息",
    // Shop 授权（含 Shoplazza）
    "Url-Invalid": "地址格式不正确",
    "Shopify-Desc": "Shopify 店铺授权",
    "Shopline-Desc": "Shopline 店铺授权",
    "Shoplazza-Desc": "Shoplazza 店铺授权",
    "Website-Name": "独立站",
    "Website-Desc": "独立站店铺授权",
    "Enter-Shop-Name": "请输入店铺名称",
    "Enter-Shop-Url": "请输入店铺网址",
    "Enter-Shop-Address": "请输入您的店铺地址",
    "Website-Auth-Success": "独立站授权成功",
    "Network-Error": "网络错误，请稍后重试",
    "Shopify-Auth-Success": "Shopify授权成功",
    "Shopify-Auth-Failed": "Shopify授权失败",
    "Shopline-Auth-Success": "Shopline授权成功",
    "Shopline-Auth-Failed": "Shopline授权失败",
    "Shoplazza-Auth-Started": "已打开 Shoplazza 授权弹窗，请在弹窗中完成授权",
    "Shoplazza-Auth-Window-Closed": "Shoplazza 授权已结束",
    "Shoplazza-Auth-Success": "Shoplazza 授权成功",
    "Shoplazza-Callback-Params-Missing": "Shoplazza 授权回调参数不完整",
    "Shoplazza-Order-Search-Placeholder": "订单号/姓名/邮箱/手机号",
    "Shoplazza-Published-Status": "上架状态",
    "Shoplazza-Published": "已上架",
    "Shoplazza-Unpublished": "未上架",
    "Shoplazza-Product-Image": "商品图片",
    "Shoplazza-Product-Info": "商品信息",
    "Shoplazza-Inventory": "库存",
    "Shoplazza-Variant-Count": "款式数量",
    "Shoplazza-Variant-Inventory": "款式及库存",
    "Shoplazza-Variant-Total": "共 {count} 个款式",
    "Shoplazza-Variant-Available": "{count} 个款式有库存",
    "Shoplazza-Customer-Name": "客户名称：",
    "Shoplazza-Customer-Phone": "客户电话：",
    "Shoplazza-Customer-Email": "客户邮箱：",
    "Shoplazza-Order-Pending": "待处理",
    "Shoplazza-Order-Cancelled": "已取消",
    "Shoplazza-Order-Placed": "进行中",
    "Shoplazza-Order-Finished": "已处理",
    // Shoplazza 订单表使用通用状态和国家标题，避免 i18n 缺失时直接显示 key。
    "Order-Status": "订单状态",
    "Country": "国家",
    "Shop-Name-Label": "店铺名称：",
    "Enter-Website-Name": "请输入您的独立站店铺名",
    "Domain-Label": "网站域名：",
    "Enter-Domain": "请输入您店铺首页的域名",
    "Shop-Address-Label": "{name}店铺地址：",
    "Enter-Shop-Address-Name": "请输入您的{name}店铺地址",
    "Shoplazza-Domain-Label": "店铺系统域名：",
    "Enter-Shoplazza-Domain": "请输入店铺系统域名前缀",
    "Shoplazza-Store-Id-Label": "店铺 ID：",
    "Enter-Shoplazza-Store-Id": "请输入店铺 ID",
    "Shoplazza-Store-Id-Invalid": "店铺 ID 必须为整数",
    "Shop-Confirm-Auth": "确定授权",
    // Ecommerce platform list page and compact order/product statistic tags.
    "Shop-Platform": "电商平台",
    "EC-Shop-Info": "店铺信息",
    "EC-Order-Info": "订单信息",
    "EC-Phone": "手机号",
    "EC-Authorizer": "授权人",
    "EC-Join-Time": "加入时间",
    "EC-Update-Time": "更新时间",
    "EC-Auth-Status": "授权状态",
    "EC-Authorized": "已授权",
    "EC-Operation": "操作",
    "EC-View-Detail": "查看详情",
    "EC-More": "更多",
    "EC-View-Product": "查看商品",
    "EC-Info-Update": "信息更新",
    "EC-Mall-Home": "商城主页",
    "EC-Delete": "删除",
    "EC-Delete-Mall": "删除商城",
    "EC-View-Order": "查看订单",
    "EC-Author-At": "授权于",
    "EC-Last-Update": "最后更新于",
    "EC-Updating": "信息更新中...",
    "EC-Total-Orders": "共{count}条订单信息",
    "EC-Products": "，{count}件商品信息",
    "EC-Order-Count": "订单 {count}",
    "EC-Product-Count": "商品 {count}",
    "EC-Search-Order": "请输入邮箱/手机号/客户姓名",
    "EC-Order-Number": "订单编号",
    "EC-Transaction-Number": "交易单号",
    "EC-Platform": "平台",
    "EC-Logistics-Info": "物流信息",
    "EC-Logistics-Channel": "物流渠道：",
    "EC-Waybill-Number": "货运单号：",
    "EC-Internal-Number": "内部单号：",
    "EC-Country-Code": "国家二字码",
    "EC-Order-Status": "订单状态",
    "EC-Payment-Delivery-Time": "付款及发货时间",
    "EC-Payment-Time": "付款时间：",
    "EC-Delivery-Time": "发货时间：",
    "EC-Customer-Info": "客户信息",
    "EC-Upload-Title": "上传订单",
    "EC-Select-File": "选择文件",
    "EC-Upload-Format": "上传格式为.xls/.xlsx",
    "EC-Download-Template": "下载模板",
    "EC-Cancel": "取消",
    "EC-Start-Upload": "开始上传",
    "EC-Order-Start-Time": "下单开始时间",
    "EC-Order-End-Time": "下单结束时间",
    "EC-Select-Logistics-Status": "请选择物流状态",
    "EC-Order": "订单",
    "EC-Transaction-No": "交易单号：",
    "EC-Order-No": "订单号：",
    "EC-Order-Time": "下单时间：",
    "EC-Unit-Price": "单价：$",
    "EC-Total": "总计",
    "EC-Logistics-Number": "物流单号",
    "EC-Product-Info": "商品信息",
    "EC-Sale-Price": "售价",
    "EC-Style": "款式",
    "EC-Spec": "规格",
    "EC-Price": "价格",
    "EC-Stock": "库存",
    "EC-Enter-Product-Name": "请输入商品名称",
    "EC-Delete-Confirm": "取消授权后，商城中的商品和订单将被同时移出，涉及到的在线客服也将不能同时引用此商城中的信息",
    "EC-Auth-Cancel": "授权取消",
    "EC-Delete-Success": "删除成功",
    "EC-Delete-Failed": "删除失败",
    "EC-Upload-Success": "上传成功",
    "EC-Upload-Failed": "上传失败",
    "EC-Only-Xls": "只能上传xls和xlsx文件",
    "EC-One-File": "一次只能上传一个文件",
    "EC-Shopify-Order-Title": "{name}-订单信息",
    "EC-Shopify-Shop-Title": "{name}-商品",
    "WA-Avatar": "头像",
    "WA-Status-Unverified": "未认证",
    "WA-Status-Reviewing": "审核中",
    "WA-Status-Verified": "已认证",
    "WA-Status-Rejected": "未通过",
    "WA-Account-Rejected": "已拒绝",
    "WA-Account-Approved": "已批准",
    "WA-Account-Pending": "等待中",
    "WA-Unbound": "已解绑",
    "WA-Header-Account": "账号信息",
    "WA-Header-CompanyAuth": "公司认证状态",
    "WA-Header-AccountStatus": "账号状态",
    "WA-Header-BM": "归属BM",
    "WA-Header-RelatedPhone": "关联手机",
    "WA-Header-MsgUsage": "消息使用/上限",
    "WA-Header-AuthTime": "授权时间",
    "WA-Header-Authorizer": "授权人",
    "WA-Filter-Company": "按公司认证筛选",
    "WA-Filter-Account": "按账号状态筛选",
    "WA-Clear": "清空",
    "WA-Confirm": "确定",
    "WA-AuthStatus": "认证状态：",
    "WA-Pop-UnverifiedDesc": "完成认证，可提升品牌可信度和账号稳定性",
    "WA-Pop-ReviewingDesc": "预计还需1个工作日完成审核",
    "WA-Pop-VerifiedDesc": "恭喜您，您的企业认证已通过 Meta 审核",
    "WA-Pop-RejectedDesc": "很遗憾，您的企业认证申请未通过 Meta 审核",
    "WA-Pop-Trust1": "· 增强客户信任，提升询盘转化",
    "WA-Pop-Trust2": "· 账号更稳定，降低封禁与拦截风险",
    "WA-AuditProgress": "审核进度",
    "WA-Step-Submit": "提交申请",
    "WA-Step-PlatformReview": "平台初审",
    "WA-Step-MetaReview": "Meta 审核",
    "WA-Step-Complete": "审核完成",
    "WA-PlatformPassed": "平台初审通过",
    "WA-MetaReviewing": "Meta 审核中",
    "WA-VerifiedCompany": "认证企业",
    "WA-VerifiedTime": "认证时间",
    "WA-Fail3Title": "您的认证已经失败3次",
    "WA-Fail3Desc": "无法在 JoinMC 中进行企业认证，请登录 WhatsApp 官方平台进行认证",
    "WA-FailReason": "失败原因",
    "WA-CertInfo": "认证说明",
    "WA-CertNow": "立即认证",
    "WA-ViewProgress": "查看完整进度",
    "WA-FailDetail": "失败详情",
    "WA-WACert": "WhatsApp 认证",
    "WA-Reapply": "重新申请",
    "WA-ApplyCert": "申请认证",
    "WA-Recertify": "重新认证",
    "WA-ViewCert": "查看认证",
    "WA-Broadcast": "消息群发",
    "WA-PhoneMgmt": "手机号管理",
    "WA-GetQR": "获取二维码",
    "WA-ViewDetail": "查看详情",
    "WA-TemplateMgmt": "模板管理",
    "WA-ConversationMgmt": "对话管理",
    "WA-ContactsMgmt": "联系人管理",
    "WA-Drawer-ReviewingDesc": "预计还需 1 个工作日完成审核。",
    "WA-Drawer-VerifiedDesc": "恭喜，您的企业认证已通过 Meta 审核。",
    "WA-Drawer-Fail3Status": "认证已经失败 3 次",
    "WA-Drawer-Fail3Desc1": "您的认证已经失败3次，无法在 JoinMC 中进行企业认证",
    "WA-Drawer-Fail3Desc2": "请登录 WhatsApp 官方平台进行认证",
    "WA-Drawer-RejectedDesc": "很遗憾，您的企业认证申请未通过 Meta 审核。",
    "WA-Drawer-UnverifiedDesc": "完成认证后，可提升客户信任、提高询盘转化，并降低风险。",
    "WA-Title-Trust": "一. 增强客户信任，提升询盘转化",
    "WA-Trust-1": "自动展示企业品牌名称：即便客户未保存你的手机号码，聊天页面顶部也会直接显示公司名，避免陌生号码带来的抵触感。",
    "WA-Trust-2": "官方资质背书防诈骗：带有认证标识，经过 Meta 企业资质核验，客户更愿意沟通洽谈、提交收货信息、完成付款，消息打开率、回复率可提升 50%~70%，有效提高询盘转化率。",
    "WA-Trust-3": "防范账号仿冒风险：可有效杜绝他人注册相似账号冒充公司行骗，方便客户辨别官方账号；遇到仿冒账号可向 Meta 提交申诉下架，维护海外品牌声誉。",
    "WA-Title-Stability": "二. 账号更稳定，降低封禁与拦截风险",
    "WA-Stability-1": "风控审核更宽松，大幅减少封号概率：个人号、未认证商业账号批量群发消息极易限流封禁；完成企业认证后平台风控容错性更高，适合批量触达老客户、推送营销通知，误封概率下降约 60%。",
    "WA-Stability-2": "降低被标记骚扰消息的概率：陌生外发消息容易被客户举报、屏蔽，认证账号被判定垃圾信息的比例更低，消息整体送达更稳定。",
    "WA-Stability-3": "消息发送配额更高：初始每日可发送消息上限远超普通商业账号，适配外贸、跨境电商大批量客户运营场景。",
    "WA-Feedback": "一. 申请反馈：",
    "WA-MetaFeedback": "Meta 反馈",
    "WA-Cancel": "取消",
    "WA-GotIt": "知道了",
    "WA-UploadCert": "证件上传",
    "WA-UploadDesc": "请上传以下证件，至少上传 1 份，支持 PDF/JPG/PNG 格式",
    "WA-AppLimit": "认证申请次数有限",
    "WA-AppLimitDesc": "JoinMC 最多支持提交 3 次认证申请。请确保企业名称、地址与证明材料完全一致，以提高审核通过率。",
    "WA-UsedCount": "已使用 {used}/{limit} 次",
    "WA-RemainCount": "剩余 {count} 次",
    "WA-CompanyDocs": "企业证明文件",
    "WA-CompanyDocsDesc": "营业执照/商业登记证等，银行对账单/水电账单/税务通知等，需包含企业名+地址",
    "WA-NoWatermark": "含水印的材料无法通过认证",
    "WA-NoWatermarkDesc": "上传附件不得包含任何水印，请上传清晰且无水印的证明材料",
    "WA-DragUpload": "拖拽文件到此处或点击上传",
    "WA-UploadSupport": "支持 PDF / JPG / PNG，单文件不超过 5MB",
    "WA-SelectFile": "选择文件",
    "WA-SubmitApp": "提交申请",
    "WA-DayLimit": "单日消息上限",
    "WA-SearchPhone": "搜索关联手机号",
    "WA-AddPhone": "添加手机号",
    "WA-Phone": "手机号",
    "WA-Status": "状态",
    "WA-QualityRating": "质量评分",
    "WA-Warn-UploadCert": "请上传企业证明文件",
    "WA-Success-Submitted": "申请已提交",
    "WA-Warn-NoBot": "当前 WABA 尚未绑定客服机器人，暂无法打开对话管理",
    "WA-Err-RegTimeout": "注册超时，未能获取到 WhatsApp Business 账号信息",
    "WA-Err-WaitTimeout": "等待嵌入式注册数据超时",
    "WA-Err-FileFmt": "不支持的文件格式{ext}，仅支持 PDF/JPG/PNG 格式",
    "WA-Err-FileSize": "文件大小超过限制（{size}MB），最大支持 5MB",
    "WA-Warn-Max3Files": "最多只能上传 3 个文件",
    "WA-Quality-GREEN": "高",
    "WA-Quality-YELLOW": "中",
    "WA-Quality-RED": "低",
    "WA-Quality-UNKNOWN": "未知",
    "WA-PhoneStatus-PENDING": "待定",
    "WA-PhoneStatus-UNVERIFIED": "未验证",
    "WA-PhoneStatus-MANUAL_REVIEW": "正在审核",
    "WA-PhoneStatus-DISCONNECTED": "离线",
    "WA-PhoneStatus-CONNECTED": "已连接",
    "WA-PhoneStatus-FLAGGED": "标记",
    "WA-PhoneStatus-WARNED": "警告",
    "WA-PhoneStatus-RATE_LIMITED": "消息受限",
    "WA-PhoneStatus-BANNED": "禁止",
    "WA-PhoneStatus-RESTRICTED": "限制",
    "WA-PhoneStatus-BLOCKED": "已达到消息限制",
    "WA-PhoneStatus-MIGRATED": "已迁移",
    "WA-PhoneStatus-UNKNOWN": "未知",
    // WhatsApp 模板创建页
    "WhatsApp-Template": "WhatsApp 模板",
    "New-Template": "新增模板",
    "Save-Settings": "保存设置",
    "Template-Name": "模板名称",
    "Template-Category": "模板类别：",
    "Template-Utility": "效用",
    "Template-Marketing": "营销",
    "Template-Authentication": "认证",
    "Template-Utility-Desc": "发送有关订单或账户信息",
    "Template-Marketing-Desc": "发送有关产品、服务或业务的促销信息",
    "Template-Authentication-Desc": "发送验证码验证交易或登录",
    "Template-Language": "模板语言：",
    "Select-Language": "请选择语言",
    "Header": "页头：",
    "None": "无",
    "Image": "图片",
    "Video": "视频",
    "Text": "文本",
    "Upload-Sample-Image": "上传示例图片",
    "Body": "正文：",
    "Footer": "页尾：",
    "Buttons": "按钮：",
    "Website-URL": "网址域名",
    "Phone": "电话",
    "Quick-Reply": "快速回复",
    "Button-Type": "按钮类型：",
    "Button-Text": "按钮文本：",
    "Please-Enter": "请输入",
    "URL-Type": "网址类型：",
    "Website": "网站：",
    "Phone-Number": "电话号码：",
    "Enter-Phone-Number": "请输入手机号",
    "Message-Content": "消息内容：",
    "Add-Safety-Advice": "添加安全建议",
    "Expire-In-Minutes": "分钟后过期",
    // WhatsApp 模板列表页
    To: "至",
    "Start-Date": "开始日期",
    "End-Date": "结束日期",
    "Select-Status": "请选择状态",
    "Template-Status-Pending": "待审核",
    "Template-Status-Quality-Pending": "质量待定",
    "Template-Status-High-Quality": "高等品质",
    "Template-Status-Medium-Quality": "中等品质",
    "Template-Status-Low-Quality": "低等品质",
    "Template-Status-Rejected": "拒绝",
    "Template-Status-Paused": "暂停",
    "Template-Status-Disabled": "禁用",
    "Enter-Template-Name": "请输入模板名称",
    Status: "状态",
    Language: "语言",
    "Last-Updated": "最后更新时间",
    Creator: "创建人",
    Duplicate: "复制",
    Continue: "继续",
    "Confirm-Delete-Template": "模板删除后不能回复，您还要继续删除吗？",
    "Confirm-Action": "操作确认",
    // Shopify / Shopline / WhatsApp API 管理
    "Shopify-Authorizing": "shopify 授权中，请稍后...",
    "Shopify-Auth-Success": "shopify 授权成功",
    "Shopify-Auth-Failed": "shopify 授权失败",
    "Shopline-Authorizing": "Shopline授权中，请稍后...",
    "Shopline-Auth-Success": "Shopline 授权成功",
    "Shopline-Auth-Failed": "Shopline 授权失败",
    Close: "关闭",
    "Update-Order": "更新订单",
    "Update-Product": "更新商品",
    "Batch-Upload": "批量上传",
    "Download-Template": "下载模板",
    "Order-Start-Time": "订单开始时间",
    "End-Time": "结束时间",
    "Logistics-Status": "物流状态",
    "Transaction-Search-Placeholder": "交易单号/邮箱/手机号/客户姓名",
    "Update-Start-Time": "更新开始时间",
    "Get-QR-Code": "获取二维码",
    "Create-Secret": "创建密钥",
    "Edit-Secret": "修改密钥",
    "Confirm-Create": "确认创建",
    "Confirm-Edit": "确认修改",
    "Secret-Name": "密钥名称",
    "Secret-Name-Min-Length": "密钥名称最少需要输入 2 个字",
    "Secret-Name-Duplicate": "密钥名称不能重复",
    "No-API-Secret": "暂无 API 密钥",
    "API-Secret-Desc": "创建密钥后即可通过 API 接口进行消息收发与账号管理",
    "Create-First-API-Secret": "创建第一个 API 密钥",
    "API-Instruction": "api 指导",
    "Webhook-Placeholder": "请输入 Webhook 回调地址，如：https://example.com/webhook",
    "Webhook-Desc": "接收消息送达状态、上行消息等事件推送的 URL",
    "Webhook-URL-Invalid": "Webhook 地址格式不正确",
    "Closing-Please-Wait": "正在关闭中，请稍候...",
    "API-Enabled": "API 已启用",
    "API-Disabled": "API 已关闭",
    "API-Delete-Success": "API 删除成功",
    "API-Add-Success": "新增API成功",
    "Enable-Secret-Confirm": "开启此密钥后，其他密钥将自动失效，确认启用吗？",
    "Confirm-Enable": "确认启用",
    Enable: "启用",
    "Operation-Failed": "操作失败",
    "Delete-Secret-Confirm": "密钥删除后，使用密钥调用的相关功能都将失效，确认删除吗？",
    "Confirm-Delete": "确认删除",
    "Secret-Copied": "密钥已复制到剪切板",
    "Secret-Copy-Error": "密钥复制出错",
    "Daily-Message-Limit": "单日消息上限",
    "Phone-QR-Code": "{phone} 的二维码",
    "Download-QR-Code": "下载二维码",
    "No-Phone-For-QR-Code": "暂无可生成二维码的手机号",
    Order: "订单",
    Product: "商品",
    "Upload-File": "上传文件",
    "Upload-Xls-Tip": "请上传 xls 文件，大小在60M以内",
    "Order-Replace-Tip": "新订单将添加，已经存在的订单将被替换成本次更新的信息。",
    "Product-Override-Tip": "当新上传的商品与系统中存在相同信息的时候，系统将使用新的信息覆盖旧信息。",
    "Contact-Search-Placeholder": "邮箱/手机号/客户姓名",
    "Social-Account": "社交账号",
    "API-Settings": "API 设置",
    "Secret-Table-Name": "名称",
    "Secret-Key": "密钥",
    "Webhook-Callback-URL": "Webhook 回调地址",
    "Created-At": "创建时间(UTC+8)",
    "Enable-Switch": "启用开关",
    "Copy-Secret": "复制密钥",
    More: "更多",
    "Secret-Name-Placeholder": "请输入密钥名称，如：生产环境密钥",
    "API-Edit-Success": "修改API成功",
    "Please-Enter-Secret-Name": "请输入密钥名称",
    "Please-Enter-Webhook": "请输入Webhook回调地址",
    "Shop-Detail": "店铺详情",
    "Mall-Avatar": "商城头像",
    "Upload-Title": "上传{name}",
    "Order-Manage": "订单管理",
    "Product-Manage": "商品管理",
    "Update-Success": "更新成功",
    "File-Too-Large": "文件过大，最大允许 60M",
    "Xls-Only": "仅允许上传 xls 文件",
    "Upload-Success": "上传成功",
    Currency: "币种",
    "Product-Name": "商品名称",
    "Order-Detail": "订单详情",
    Amount: "金额",
    Recipient: "收件人",
    Subtotal: "小计：",
    Tax: "税费：",
    "Total-Colon": "总计：",
    "Tracking-Number": "物流单号",
    "Total-Products": "共{count}条商品",
    "Payment-Time": "付款时间",
    "Delivery-Time": "发货时间",
    // ===== 媒体管理-社交账号成员授权 =====
    "Member-Authorization": "成员授权",
    "Member-Authorization-Add": "添加成员",
    "Member-Authorization-Add-Title": "添加团队成员",
    "Member-Authorization-Add-Desc": "只能选择普通团队成员，超级管理员和管理员拥有全部账号的权限无需添加",
    "Member-Authorization-Search": "搜索姓名/手机号",
    "Member-Authorization-Nickname": "成员昵称",
    "Member-Authorization-Able-Add": "可添加 {count} 位",
    "Member-Authorization-Selected": "已选 {count} 位",
    "Member-Authorization-Cancel-Select": "取消选择",
    "Member-Authorization-Added": "已添加到该账户",
    "Member-Authorization-Confirm-Add": "确认添加",
    "Member-Authorization-Remove-Title": "确认移除该团队成员？",
    "Member-Authorization-Remove-Desc": "从社交账号中移除后，该成员将失去查看此社交账号的权限，需重新添加才能恢复！",
    "Member-Authorization-Remove": "确认移除",
    "Member-Authorization-Success": "成员授权成功",
    "Product-Count": "商品数",
    "Order-Count": "订单数",
  },
  library: {
    "Library-Name": "知识库",
    "Training-Status": "训练状态",
    "Enter-Content-Name": "请输入资料名称",
    "Add-Content": "添加资料",
    "Write-Online": "在线撰写",
    "Upload-Content": "上传资料",
    "Select-From-Library": "从知识库选择",
    "Grab-By-Link": "按链接抓取",
    "Content-Name": "资料名称",
    "Source": "来源：",
    "Training-Progress": "训练进度",
    "Train-Not-Started": "未训练",
    "Train-Training": "训练中",
    "Train-Completed": "训练完成",
    "Train-Failed": "训练失败",
    "Use-Count": "使用次数",
    "Creator-Time": "创建人 / 创建时间",
    "Unknown": "未知",
    "Created-At": "创建时间",
    "Operation": "操作",
    "Edit-Content": "编辑资料",
    "Delete-Content": "删除资料",
    "Edit": "编辑",
    "Delete": "删除",
    "Delete-Confirm": "此操作不能恢复，是否继续？",
    "Warning": "警告",
    "New-Type": "新建类型",
    "Enter-Type-Name": "请输入类型名称",
    "All-Types": "全部类型",
    "Loading": "加载中...",
    "No-More": "没有更多了",
    "Type-Name": "类型名称",
    "Edit-Type": "编辑类型",
    "Add-Type": "新增类型",
    "Type-Name-Required": "类型名称不能为空",
    "Delete-Type-Confirm": "此操作不能恢复！是否删除「{name}」",
    "Tip": "提示",
    "Upload-Filter-Tip": "上传的内容中不支持表格和图片，若包含将被自动过滤！",
    "Select-File": "选择文件：",
    "Select-File-Btn": "选择文件",
    "Upload-Format-Tip": "支持.txt,.pdf,.ppt类型，txt不超过100K，pdf和PPTX不超过200M，最多可选择100个文件",
    "Cancel": "取 消",
    "Confirm": "确 定",
    "Please-Select-File": "请选择文件",
    "Uploading": "正在上传文件，请稍后提交",
    "File-Format-Error": "{name} 文件格式错误",
    "TXT-Size-Limit": "{name} TXT文件大小不能超过100K",
    "PDF-Size-Limit": "{name} PDF文件大小不能超过200M",
    "File-Limit": "当前限制选择 10 个文件",
    "Write-Online-Title": "在线撰写",
    "Enter-Content-Title": "请输入资料标题（2～45个字）",
    "Enter-Content": "请输入内容",
    "Word-Count": "共有 3000 字",
    "Source-Label": "资料来源：",
    "Enter-Source": "请输入资料来源",
    "Author-Label": "作者：",
    "Enter-Author": "请输入作者名称",
    "Publish": "发布",
    "Title-Required": "请输入资料名称",
    "Content-Required": "请输入资料内容",
    "Saved": "已保存",
    "Grab-Link-Content": "抓取链接内容",
    "Grabbed-Links": "抓取到的链接",
    "Grab-Warning-1": "请避免非法抓取他人网站的侵权行为，保证链接可公开访问，且网站内容可复制！",
    "Grab-Warning-2": "支持抓取单一网址和抓取URL相关全部网址的内容",
    "Grab-Warning-3": "抓取网址相关页面时，自动访问URL并获取所有文本内容和页面以URL开头的所有链接，网址越多速度越慢，单次最多抓取不超过600个网址！",
    "Grab-Warning-4": "系统将自动过滤已经抓取过的内容，当系统中已经存在相同内容时，将不重复抓取",
    "Grab-Type": "抓取方式：",
    "Single-Link-Page": "单一链接页面",
    "Related-Link-Page": "链接关联页面",
    "Link-Url": "网址链接：",
    "Enter-Link": "请输入链接",
    "Enter-Link-Url": "请输入http://或https://开头的链接",
    "Link-Example": "例如：您要抓取的内容地址是https://www.example.com/active/下的所有内容，只需要录入https://www.example.com/active/即可",
    "Add-Link": "添加链接",
    "Grabbed-Content": "抓取到的内容（共{n}个链接）",
    "Start-Parse-Url": "开始解析URL",
    "Back": "返回上级",
    "Grab-Store": "抓取资料并入库",
    "Grabbing-Tip": "链接正在抓取，请勿关闭浏览器",
    "Store-Classify": "入库分类",
    "Enter-Source-Name": "请输入资料来源网站名称",
    "Enter-Author-Name": "请输入资料作者名称",
    "Back-Confirm": "返回后，当前页面抓取到的页面将被删除！",
    "Careful-Operation": "谨慎操作",
    "Parsing-Link": "正在解析链接，请稍后...",
    "No-Content": "您输入的链接下无任何内容，请检查或更换链接",
    "Select-Cs-Content": "选择客服专属资料",
    "View-Detail": "查看详情",
  },
  dataReport: {
    "Data-Report": "数据报表",
    "All-Bots": "全部机器人",
    "Conversation-Bot": "对话机器人",
    "Homepage-Bot": "主页机器人",
    "Email-Bot": "邮箱机器人",
    "To": "至",
    "Start-Date": "开始日期",
    "End-Date": "结束日期",
    "Scene-Num": "场景数量",
    "Scene-Num-Desc": "用户触发的场景具体数量",
    "Scene-Interaction-Count": "场景互动次数",
    "Scene-Interaction-Desc": "用户互动行为触发场景的累计次数",
    "Scene-Interaction": "场景互动",
    "Interaction-Data": "互动数据",
    "Service-List": "客服列表",
    "Enter-Service-Name": "请输入客服名称",
    "Bot-Info": "机器人信息",
    "Created-At-Prefix": "创建于：",
    "User-Interaction-Count": "用户互动次数",
    "User-Interaction-Count-Desc": "用户和机器人进行互动所产生的互动次数",
    "User-Interaction-People": "用户互动人数",
    "User-Interaction-People-Desc": "与机器人进行互动的用户的具体人数",
    "Person-Reply-Count": "人工回复数",
    "Person-Reply-Count-Desc": "由客服人员负责回复的客户互动相关问题",
    "AI-Reply-Count": "AI自动回复数",
    "AI-Reply-Count-Desc": "由AI负责回复的客户互动相关问题",
    "Person-Reply-Proportion": "人工回复占比",
    "Person-Reply-Proportion-Desc": "客服人工回复在总回复数中所占的百分比",
    "Service-Person-Reply-Proportion": "客服人工回复占比",
    "AI-Reply-Proportion": "AI自动回复占比",
    "AI-Reply-Proportion-Desc": "AI回复在总回复数中所占的百分比",
    "Operation": "操作",
    "View-Detail": "查看详情",
  },
  mailStatistics: {
    "Mail-Bot-Statistics": "邮箱机器人统计",
    "Beijing-Time": "北京时间（UCT +8:00）",
    "Data-Overview": "数据概览",
    "Compared-To-Last": "较上期",
    "Total-Emails": "邮件总数",
    "All-History-Emails": "全部历史邮件",
    "Total-Emails-Tip": "截止到最新日期，累计收到的邮件总数",
    "Unreplied-Emails": "未回复邮件数",
    "All-Unreplied-Emails": "全部待回复邮件",
    "Unreplied-Emails-Tip": "截止到最新日期，未回复的邮件总数",
    "New-Emails": "新增邮件数",
    "New-Emails-Tip": "在统计时间范围内，收到的邮件数量",
    "Replied-Emails": "已回复邮件数",
    "Replied-Emails-Tip": "在统计时间范围内，完成回复的邮件数量",
    "Man-Replies": "人工回复数",
    "Man-Replies-Tip": "在统计时间范围内回复的邮件，由人工进行回复的数量",
    "AI-Replies": "AI 回复数",
    "AI-Replies-Tip": "在统计时间范围内回复的邮件，由AI进行回复的数量",
    "Mail-Processing-Analysis": "邮件处理分析",
    "Mail-Processing-Trend": "邮件处理趋势图",
    "Mail-Replied-Ratio": "邮件已回复占比",
    "New-Emails-Replies": "新增邮件回复数",
    "History-Emails-Replies": "历史邮件回复数",
    "Mail-Detail": "邮件明细",
    "Seat-Detail": "坐席明细",
    "Enter-Email-Address": "请输入邮箱地址",
    "Enter-User-Name": "请输入人员名称",
    "Mail-Name": "邮箱名",
    "Total-Emails-Colon": "邮件总数：",
    "Unreplied-Emails-Colon": "未回复邮件：",
    "New-Emails-Col": "新增邮件",
    "Replied-Emails-Col": "已回复邮件",
    "Man-Replied-Col": "人工回复",
    "AI-Replied-Col": "AI 回复",
    "User-Name": "人员名称",
    "Email-Count": "邮箱数",
    "Reply-Emails": "回复邮件数",
  },
  ctwa: {
    // ===== 通用 =====
    "Ad-Account": "广告账户",
    "Ad-Account-Detail": "广告账户详情",
    "Account-Info": "账号信息",
    "Account-Id": "账户ID",
    "Account-Id-Prefix": "账号ID：",
    "Account-Name": "账户名称",
    "Account-Status": "账号状态",
    "Channel": "归属渠道",
    "Auth-Time": "授权时间",
    "Status": "状态",
    "Operation": "操作",
    "Detail": "详情",
    "View-Detail": "查看详情",
    "Cancel-Auth": "取消授权",
    "Cancel-Auth-Confirm": "广告账户取消授权后，CTWA 数据将不再展示，确认取消授权？",
    "Confirm-Cancel-Auth": "确认取消",
    "Cancel-Auth-Success": "已取消授权：{name}",
    "Auth-Success": "广告账户授权成功",
    "Auth-Failed": "授权失败",
    "Auth-Loading": "广告账户授权中，请稍后...",
    // 搜索 / 输入
    "Search-Account-Placeholder": "请输入账号名称或账号ID",
    "Enter-Nickname": "请输入昵称",
    // 汇总指标
    "Spend": "花费金额($)",
    "Total-Spend": "总花费金额($)",
    "Impressions": "展示次数",
    "Ad-Impressions": "广告展示次数",
    "Total-Impressions": "总展示次数",
    "Clicks": "点击量",
    "Total-Clicks": "总点击量",
    "Reach": "覆盖人数",
    "Contact-Count": "联系人数",
    "Total-Contact-Count": "总联系人数",
    "Purchase-Count": "购买量",
    "Order-Amount": "下单金额($)",
    "Total-Order-Amount": "下单金额($)",
    "ROI": "ROI转化",
    "ROI-Rate": "ROI 转化率",
    // 转化漏斗
    "Conversion-Funnel": "转化漏斗",
    "Funnel-Ad-Reach": "广告覆盖人数",
    // Tab / 区块
    "Tab-Accounts": "广告账户",
    "Tab-Contacts": "联系人",
    "Tab-Ads": "广告统计",
    "Tab-Contacts-Data": "联系人数据",
    "Export-Data": "导出数据",
    // 广告详情抽屉
    "Ad-Detail": "广告详情",
    "Ad-Id": "广告ID",
    "Ad-Id-Account": "广告 ID · 所属账户 {name}",
    "Id-Detail": "ID {id} · 广告账户详情",
    "Total-People": "共 {count} 人",
    // 联系人列（无既有 key 可复用的两项）
    "First-Contact-Time": "首次联系时间(UTC+08:00)",
    "First-Order-Time": "首次下单时间(UTC+08:00)",
    // 广告账户状态（apiCTWA.js accountStatusMap）
    AccountStatus: {
      Normal: "正常投放",
      Disabled: "已停用",
      Unpaid: "账单未结清",
      RiskReview: "待风险审核",
      PendingSettlement: "待结算",
      GracePeriod: "宽限期内",
      PendingClose: "待关闭",
      Closed: "已关闭",
    },
    // 广告投放状态（CTWADetail.vue adStatusMap）
    AdStatus: {
      Active: "投放中",
      Paused: "已暂停",
      Deleted: "已删除",
      Archived: "已归档",
      CampaignPaused: "广告系列已暂停",
      AdsetPaused: "广告组已暂停",
      PendingReview: "等待审核",
      Disapproved: "违规拒审",
      Preapproved: "初审通过",
      PendingBillingInfo: "等待账单信息",
      InProcess: "正在创建",
      WithIssues: "存在问题",
    },
  },
  team: {
    "Team-Manage": "团队管理",
    "Member-Manage": "成员管理",
    "Member-Detail": "成员详情",
    // 成员编辑页使用独立标题和标签授权文案，和成员列表的操作入口保持一致。
    "Edit-Member": "编辑成员",
    "Edit-Basic-Info": "编辑基本信息",
    "Basic-Info-Update-Success": "基本信息已保存",
    "Basic-Info-Update-Failed": "基本信息保存失败，请稍后重试",
    "Label-Authorization": "按标签授权",
    "Authorized-Tag-List": "授权标签列表",
    "Authorized-Tag-Tip": "成员可查看带有这些标签的社交账号",
    "Tag-Count": "共 {count} 个标签",
    "Tag-Name": "标签名称",
    "Select-Tags": "请选择标签",
    "Delete-Tag-Confirm": "确定删除标签“{name}”吗？",
    "Save": "保存",
    "No-Data": "暂无数据",
    "User-Avatar": "用户头像",
    "Team-Settings": "团队设置",
    "Consumption-Records": "消费记录",
    "Billing-Rules": "计费规则",
    "Recharge": "团队余额充值",
    "Expenditure-Detail": "详情",
    "Search-Member-Name": "请输入成员姓名",
    // 新版成员列表的筛选、账号列和操作菜单统一走团队文案。
    "Search-Member-Details": "请输入成员姓名/手机号/邮箱",
    "Select-Member-Role": "请选择成员角色",
    "Authorized-Account-Count": "授权账号数量",
    "All-Accounts": "全部账号",
    // 管理员账号列的悬浮说明，解释全部账号入口的查看权限范围。
    "All-Accounts-Tip": "管理员拥有全部社交账号的查看权限，可以到社交账号模块中查看全部账号",
    "Account-Count": "{count} 个账号",
    "Set-Role-Permissions": "设置角色权限",
    "Transfer-Permissions": "移交权限",
    "More": "更多",
    // 设计稿的跳页组件沿用英文提示，保留在词条中便于后续统一调整。
    "Pagination-Go-To": "Go to",
    "Pagination-Page": "Page",
    "Select-Activation-Status": "请选择激活状态",
    "Inactive": "未激活",
    "Active": "已激活",
    "Select-Role": "请选择角色",
    "Super-Admin": "超级管理员",
    "Admin": "管理员",
    "Team-Member": "团队成员",
    "Member": "成员",
    "Invite-Member": "邀请成员",
    "Personal-Info": "个人信息",
    "New-Member": "新成员{id}",
    "Myself": "我",
    "Email-Not-Bound": "邮箱未绑定",
    "Email-Not-Set": "未设置邮箱",
    "Mobile-Not-Added": "手机号未添加",
    "Role": "角色",
    "Activation-Status": "激活状态",
    "Join-Time": "加入时间",
    "Operation": "操作",
    "Re-Invite": "重新邀请",
    "Recall-Invite": "撤销邀请",
    "Handover-Admin": "交接超级管理员",
    "Edit": "编辑",
    "Remove-Team": "移出团队",
    "Remove-Team-Success": "已移出团队",
    "Remove-Team-Failed": "移出团队失败，请稍后重试",
    "Remove-Team-Confirm": "已选择用户：{name}\n移出团队后，该用户将不能查看此团队下创建的文件！",
    "Remove-Team-Title": "移出团队",
    "Sent": "已发送",
    "Recalled": "已撤回",
    "Recall-Invite-Confirm": "邀请撤回后，用户将不能通过您之前发送的邀请链接加入团队",
    "Recall-Invite-Title": "撤回邀请用户",
    "Change-Name-Desc": "修改在当前团队备注名，其他团队内的备注名不会被修改",
    "Change-Name-Title": "修改名称",
    "Enter-New-Name": "请输入新的名称",
    "Add-Member": "添加成员",
    "Add-Member-Subtitle": "填写成员手机号与团队角色，完成团队邀请",
    "Add-Member-Success": "成员添加成功",
    "Add-Success-Tip-1": "1. 用户首次登录，需要使用手机号和验证码登录",
    "Add-Success-Tip-2": "2. 登录成功后，可以到「个人中心」设置自己的账号密码",
    "Admin-Desc": "可管理成员与团队配置",
    "Confirm-Add": "确认添加",
    "Confirm-Handover": "确认交接",
    "Current-Role": "当前角色",
    "Enter-Member-Name": "请输入成员名称",
    "Enter-Member-Email": "输入成员邮箱账号",
    "Handover-Success": "已移交",
    "Handover-Title": "移交超级管理员",
    "Handover-Warning-Header": "超级管理员权限交接",
    "Handover-Warning-Desc": "交接后您将转为「管理员」身份，不再拥有超级管理员权限；接手人将成为团队唯一的超级管理员；该操作不可撤销。",
    "Login-Phone": "登录手机号",
    "Member-Desc": "可以使用团队工具与资源",
    "Phone-Required": "请输入手机号",
    "Receiver": "接收人",
    "Team-Role": "团队角色",
    "Member-Nickname": "成员昵称",
    "Basic-Info": "基本信息",
    "Name": "姓名",
    "Phone": "手机号",
    "Email": "邮箱",
    "WeChat": "微信号",
    "Account-Rules": "账号分配规则",
    "Rules-Desc": "规则说明",
    "Rules-Name": "规则名称",
    "Self-Authorization": "自己授权",
    "Delete": "删除",
    "Add-Tag": "添加标签",
    "Submit": "提交",
    "Social-Accounts": "社交账号",
    "Social-Account-List": "社交账号列表",
    "Social-Account-List-Tip": "查看成员可访问的社交账号及其关联标签",
    "Social-Account-Total": "共 {count} 个账号",
    "Add-Account": "添加账号",
    "Remove-Account": "移除",
    "All-Platforms": "全部媒体平台",
    "All-Rules": "全部规则",
    "Search-Account-Name": "请输入社交账号名称",
    "Account-Info": "账号信息",
    "Page-Info": "主页信息",
    "Account-Tags": "账号标签",
    "Certified": "已认证",
    "Uncertified": "未认证",
    "No-Social-Account": "暂无社交账号",
    "Change-Avatar": "更换头像",
    "Social-Accounts-Count": "社交账号({count})",
    "Public-Page": "公共主页",
    "Authorized": "已授权",
    "Unauthorized": "未授权",
    "Followers": "{count}粉丝",
    "0-Followers": "0粉丝",
    "Delete-Auth-Confirm": "确定要删除此用户授权的主页权限吗？删除后该主页将对此用户不可见。",
    "Careful-Operation": "操作确认",
    "Delete-Success": "删除成功",
    "Delete-Failed": "删除失败",
    "Delete-Failed-Retry": "删除失败请稍后重试",
    "Fetch-Member-Failed": "获取成员详情失败",
    "Fetch-Tags-Failed": "获取成员标签失败",
    "Fetch-Tag-List-Failed": "获取标签列表失败",
    "Fetch-Account-Failed": "获取社交账号失败",
    "Missing-Info": "缺少成员或主页信息",
    "Finish-Tag-Selection": "请先完成当前标签选择",
    "Missing-Submit-Info": "缺少成员或团队信息暂时无法提交",
    "Avatar-Upload-Failed": "头像上传失败",
    "Change-Avatar": "更换头像",
    "Submit-Failed": "提交失败，请稍后重试",
    "Submit-Success": "提交成功",
    "Invite-Title": "邀请成员",
    "Invite-Email": "邮箱",
    "Invite-Name": "姓名",
    "Invite-Role": "角色",
    "Invite-Send": "发送邀请",
    "Invite-Link": "邀请链接",
    "Copy-Link": "复制链接",
    "Copy-Success": "复制成功",
    "Invite-Success": "邀请成功",
    "Select-Role-Required": "请选择成员角色",
    "Email-Valid": "请输入正确的邮箱地址",
    "Invite-Method": "邀请方式",
    "Link-Invite": "链接邀请",
    "Email-Invite": "邮件邀请",
    "Link-Info": "链接信息",
    "Invitee-Email": "被邀请人邮箱",
    "Email-Placeholder": "请输入邮箱账号，按回车键加入邀请列表",
    "Email-Address": "邮箱地址",
    "Invite-Link-Prefix": "邀请链接：",
    "Inviter-Prefix": "邀请人：",
    "Invite-Team-Prefix": "邀请团队：",
    "Link-Valid-Prefix": "链接有效期：",
    "Long-Term": "长期有效",
    "To": "至",
    "Change-Role-Title": "修改角色",
    "Handover-Super-Admin": "转移超级管理员",
    "Selected-User": "已选用户",
    "Target-Role": "目标角色",
    "Handover-Desc": "超级管理员转移完成后，当前超级管理员将被降级为管理员",
    "Select-Receiver": "请选择接收人",
    "Package-List": "团队套餐",
    "Current-Package": "当前套餐",
    "Upgrade-Package": "升级套餐",
    "Renew-Package": "续费",
    "Buy-Package": "购买套餐",
    "Package-Expire": "到期时间",
    "Package-Price": "价格",
    "Package-Duration": "时长",
    "Package-Details": "套餐详情",
    "Unpaid": "未付款",
    "Paid": "已付款",
    "Auto-Renew": "自动续费",
    "Package-Content": "套餐内容",
    "Manual-Renew": "人工续费套餐",
    "Modify-Settings": "修改设置",
    "Monthly": "按月计费",
    "Yearly": "按年计费",
    "Original-Price": "原价",
    "Current-Price": "现价",
    "Valid-Until": "有效期至",
    "Contact-Us": "联系我们",
    "Next-Month-Package": "下月套餐",
    "Current-Month-Package": "当月套餐",
    "Expired-Package": "已过期套餐",
    "Auto-Renew-Notice": "您的套餐将于下月自动续费，如需关闭，请前往团队套餐中的“下月套餐”设置中关闭“自动续费”以停止自动续费服务。",
    "Auto-Renew-Title": "自动续费通知",
    "Got-It": "知道了",
    "Auto-Renew-Closed": "已关闭",
    "Purchase-Title": "购买套餐",
    "Select-Package": "选择套餐",
    "Save-Settings": "保存设置",
    "Go-Pay": "去支付",
    "Selected-Package": "已选购套餐",
    "Package-Price-Label": "套餐售价",
    "Month": "月",
    "Change-Package": "更换套餐",
    "Package-Effective-Time": "套餐生效时间",
    "Days-Left": "本月剩余 {n} 天",
    "Payment-Channel": "支付渠道",
    "Bot-Settings": "机器人设置",
    "Bot-Settings-Desc": "调整机器人的运营策略，选择继续运营或放弃运营该机器人",
    "Fee-Details": "费用明细",
    "Total-Amount": "总金额",
    "Ad-Discount-Rate": "广告会员折扣比例",
    "Ad-Discount-Amount": "广告会员折扣金额",
    "Actual-Pay": "实际应付",
    "Date-Tip": "本产品套餐按自然月计算，有效期至当月最后一天，套餐费用根据本月剩余天数按比例收取。\n差价补充规则详情\n费用计算：套餐费用固定为158元，不随购买日期变化。\n购买时剩余天数计算：如果用户在自然月的中间购买套餐，我们提供优惠，即按照剩余天数的比例减少费用。具体计算方式如下：\n计算剩余天数：从购买当天到当月最后一天的天数。\n计算优惠后的费用：套餐费用乘以剩余天数占整个自然月的比例。\n示例：如果用户在1月15日购买套餐，1月共有31天，剩余天数为16天（31-15）。优惠后费用=158×(16/31)\n结果：根据上述计算，优惠后的费用为：158×(16/31)=80元\n",
    "Current-Month-Upgrade": "当月套餐升级",
    "Next-Month-Settings": "下月套餐设置",
    "Next-Month-Purchase": "下月套餐购买",
    "Next-Month-Upgrade": "下月套餐升级",
    "Set-Success": "已设置",
    "Tip": "提示",
    "Bot-Limit-Alert": "已选购套餐支持可运营机器人数为 {n}，请调整您的机器人运营状态！",
    "Operation-Success": "操作成功",
    "Next-Month-Rule-Notice": "下个月将按照此规则执行。如有不满意，您可随时修改设置。",
    "Pay-Success-Notice": "感谢您的购买！您的套餐将于下月自动续费，续费规则与本月相同。如需调整，请前往团队套餐的下月设置进行操作。",
    "Price-Changed-Alert": "当前套餐购买费用明细发生改变，点击「确定」重新获取价格",
    "Balance-Insufficient-Notice": "当前团队余额不足，无法完成机器人购买。请先进行团队余额充值，然后再尝试购买！",
    "Recharge-Success-Short": "充值成功",
    "Go-Recharge": "去充值",
    "First-Buy-Auto-Renew-Notice": "感谢您的购买！您还可以开通自动续费功能，系统会在次月一日自动为您的机器人进行续费操作，确保您持续享受不间断的机器人服务。",
    "Auto-Renew-Balance-Notice": "自动续费的金额来自团队的余额",
    "Enable-Auto-Renew": "开启自动续费",
    "Disable": "不开启",
    "Auto-Renew-Enabled-Notice": "系统将于每月一日，依据当前机器人的套餐进行自动扣款。请务必保证您的团队余额充足，以确保自动续费顺利进行。<br />若您希望关闭自动续费功能，可在 \"团队套餐 -> 下月套餐设置\" 中进行关闭操作。",
    "Auto-Renew-Enabled-Title": "自动续费开启成功",
    "Go-See": "去看看",
    "Verification-Code-Error": "验证码错误，请重新输入。",
    "Payment-Method": "支付方式",
    "Wechat-Pay": "微信支付",
    "Alipay-Pay": "支付宝支付",
    "Pay-Now": "立即支付",
    "Pay-Success": "支付成功",
    "Pay-Failed": "支付失败",
    "Total-Price": "应付金额",
    "Recharge-Amount": "充值金额",
    "Recharge-Rate": "充值费率",
    "Rate-Amount": "费率金额",
    "Enter-Recharge-Amount": "请输入充值金额",
    "Recharge-Success": "资金已进入团队余额，若您发现资金不正确，请联系产品顾问进行处理！",
    "Pay-Success-Title": "支付成功",
    "Team-Balance": "团队余额",
    "Balance-Insufficient": "余额不足",
    "Filter-All": "全部",
    "Select-Bot": "选择机器人",
    "Bot-Name": "机器人名称",
    "Search-Bot": "请输入机器人名称",
    "Default-AI-Model": "默认AI模型",
    "Default-AI-Model-Desc": "每次调用AI生成内容时，默认使用的机器人模型",
    "Modify-AI-Model": "修改AI模型",
    "Modify-AI-Model-Desc": "修改默认模型后，系统在调用AI的时候将使用此模型！",
    "Modify-AI-Model-Success": "修改AI模型成功",
    "Modify-Team-Name": "修改团队名称",
    "Team-Name-Input-Error": "请输入不含特殊字符2-10位团队名称",
    "Team-Name-Placeholder": "请输入团队名称",
    "Modify-Team-Name-Success": "修改团队名称成功",
    "Dissolve-Team": "解散团队",
    "Dissolve-Team-Confirm": "团队解散后将不能恢复，团队内容也将被删除，请谨慎操作！",
    "Delete-Success-Ex": "删除成功!",
    "Billing-Rules-Title": "计费规则说明",
    "Billing-Mode-1": "一、付费模式",
    "Billing-Mode-1-Desc": "{brand}采用预付费模式，在使用产品之前，需要预先通过微信或支付宝进行资金预付，保证账户中有足够的资金。",
    "Billing-Mode-2": "二、扣款模式",
    "Billing-Mode-2-Desc": "{brand}按照使用字数进行扣款，每使用一个字数系统会扣除对应的金额。不同AI模型的扣款比例不同，可以在使用的时候选择不同的模型。",
    "Billing-Mode-3": "三、模型对应金额比例",
    "Billing-Mode-3-Desc": "{model}&nbsp;&nbsp;&nbsp;&nbsp;1元 = {count} 字",
    "Billing-Mode-4": "四、出账单时间",
    "Billing-Mode-4-Desc": "每日0时生成前一日的账单，今日账单不显示详情。",
    "Consumption-Title": "消费记录",
    "Cost-Summary": "花费汇总数据",
    "Total-Cost": "总花费（元）",
    "Online-Cost": "在线客服（元）",
    "Posts-Cost": "帖文管理（元）",
    "Email-Cost": "邮件回复（元）",
    "Write-Cost": "写作模块（元）",
    "Adviser-Cost": "顾问模块（元）",
    "Library-Cost": "资料库（元）",
    "Consumption-Date": "消费日期",
    "Consumption-Type": "消费类型",
    "Consumption-Amount": "消费金额",
    "Expenditure-Detail-Title": "支出详情",
    "Bot-Robot": "机器人",
    "Created-At": "创建于",
    "Continue-Operating": "继续运营",
    "Stop-Operating": "放弃运营",
    "Bot-Info": "机器人信息",
    "Operating-Status": "运营状态",
    "Team-Balance-Payment": "团队余额支付",
    "Verification-Code": "验证码",
    "Enter-Verification-Code": "请输入验证码",
    "Enter-SMS-Code": "请输入短信验证码",
    "Resend-After-Seconds": "{n}秒后重新获取",
    "Get-Verification-Code": "获取验证码",
    "Verification-Code-Sent": "验证码发送成功",
    "Warning": "警告",
    "Team-Balance-Admin-Warning":
      "<p>为了使用团队余额支付，团队超级管理员需要提供手机号验证码。目前，您作为团队的超级管理员尚未绑定手机号，因此无法进行支付。请按照以下步骤完成手机号绑定：</p><br /><p>登录系统。</p><p>点击页面右上角的头像。</p><p>进入“个人中心”。</p><p>选择“修改手机号”模块。</p><p>绑定您的手机号。</p><p>完成绑定后，您即可使用团队余额进行支付。</p>",
    "Team-Balance-Member-Warning":
      "<p>为了使用团队余额进行支付，团队超级管理员需要提供手机号验证码。目前，团队超级管理员尚未绑定手机号，因此无法完成支付。请团队超级管理员按照以下步骤进行手机号绑定：</p><br /><p>登录系统。</p><p>点击页面右上角的头像。</p><p>进入“个人中心”。</p><p>选择“修改手机号”模块。</p><p>绑定您的手机号。</p><p>完成绑定后，您即可使用团队余额进行支付。</p>",
    "Finance-Info": "财务信息",
    "Account-Overview": "账户概览",
    "Available-Balance": "可用余额（$）",
    "Alipay": "支付宝",
    "Wechat": "微信",
    "System-Gift": "系统赠送",
    "Airwallex": "空中云汇",
    "Pending-Review": "待审核",
    "Review-Failed": "审核未通过",
    "Recharge-Button": "充值",
    "Account-Funds": "账户资金",
    "Balance-History-Desc": "当前余额与历史充值情况",
    "Recharge-Balance": "充值余额（$）",
    "Gift-Balance": "赠送余额（$）",
    "Total-Recharged": "累计充值（$）",
    "Spend-Statistics": "花费统计",
    "Payment-Frozen-Desc": "支付与冻结花费情况",
    "Frozen-Spend": "当前冻结花费（$）",
    "Frozen-Tip":
      "发起 WhatsApp 营销消息任务时，系统预冻结等额资金；任务发送完成后，冻结款项自动解冻，可正常用于后续扣费或提现",
    "Yesterday-Spend": "昨日花费（$）",
    "Total-Spend": "累计花费（$）",
    "Recharge-Records": "充值记录",
    "Payment-Status": "支付状态",
    "Select-Recharge-Channel": "请选择充值渠道",
    "Select-Consumption-Type": "请选择消费类型",
    "Start-Date": "开始日期",
    "End-Date": "结束日期",
    "Consumption-Time": "消费时间",
    // 消费记录需区分后端保存的北京时间和账号所在时区的本地时间。
    "Consumption-Time-Beijing": "消费时间（北京时间）",
    "Consumption-Time-Actual": "消费时间（实际时区）",
    "Beijing-Timezone": "北京时间（UTC+08:00）",
    "Remark": "说明",
    "Recharge-Time": "充值时间",
    "Order-Status": "订单状态",
    "Pending-Payment": "待支付",
    "Recharge-Status-Failed": "充值状态：充值失败",
    "Transaction-No": "交易单号：",
    "Failure-Reason": "失败原因",
    "Recharge-Again": "再次充值",
    "Online-Recharge": "在线充值",
    "Currency-Select": "币种选择",
    "USD-Label": "美金 （USD）",
    "Recharge-Channel": "充值渠道",
    "Confirm-Recharge": "确认充值",
    "Amount-Details": "金额明细",
    "Current-Team-Balance": "当前团队可用余额",
    "Recharge-Rate-Amount": "充值费率金额",
    "Actual-Pay-Amount": "实付金额",
    "Select-Currency": "请选择币种",
    "Invalid-Amount": "请输入有效金额，最多支持两位小数",
    "Amount-Greater-Zero": "金额必须大于 0",
    "LianLian": "连连",
    "Payment-Component-Failed": "支付组件加载失败，请稍后重试",
    "Recharge-Processing": "充值处理中，请稍后查看充值记录确认最终结果",
    "Recharge-Accepted": "充值已受理，等待最终确认",
    "Extra-Verification": "请完成额外的身份验证（如 3DS 验证）",
    "Payment-Session-Error": "支付会话异常，请重新尝试充值",
    "Recharge-Cancelled": "充值已取消或失败",
    "Recharge-Status-Unknown": "充值状态未知，请联系客服",
    "Query-Status-Failed": "查询支付状态失败",
    "Buy-Bot-Package": "购买机器人套餐",
    "Export": "导出",
    "Addon-Pack": "加量包",
    "Exceed-After": "变更后",
    "Exceed-Back-Adjust": "返回调整",
    "Exceed-Current-Used": "当前使用额度",
    "Exceed-Handle": "处理超额",
    "Exceed-Normal": "正常",
    "Exceed-Notice-Desc": "新套餐的部分资源额度低于您当前使用量。超出额度的资源不会被删除，但将在新套餐生效后暂停使用，需要先确认保留方案。",
    "Exceed-Notice-Title": "请先确认套餐变更对当前资源产生的影响",
    "Exceed-Over-N": "超出 {n} 个",
    "Exceed-Plan-Quota": "{name}额度",
    "Exceed-Resource": "资源",
    "Exceed-Table-Title": "额度变更",
    "Exceed-Title": "套餐变更确认",
    "Expansion-Addon-Payable": "叠加包应付金额",
    "Expansion-Buy": "拓展叠加包",
    "Expansion-Current-Remain-Valid": "当前套餐剩余有效期",
    "Expansion-Expired": "已到期",
    "Expansion-Resource-Situation": "资源情况",
    "Expansion-Selected-Addon": "已选叠加包",
    "Expansion-Subtitle": "加量包独立计费，且到期时间与主套餐一致，到期后自动失效",
    "Expansion-Title": "拓展您的资源额度",
    "Handle-Account-Info": "账号信息",
    "Handle-All-Status": "全部业务状态",
    "Handle-Busy": "有业务",
    "Handle-Cancel": "取消",
    "Handle-Confirm": "确认方案",
    "Handle-Data-Not-Ready": "资源数据尚未加载完成，请稍候重试",
    "Handle-Exceed-N": "超出额度 {n} 个",
    "Handle-Idle": "空闲中",
    "Handle-Keep-Current-N": "当前保留 {n} 个",
    "Handle-Max-Enable-NoLimit": "新套餐生效后不限制启用数量，未保留的账号将在新套餐生效后暂停。",
    "Handle-Max-Enable-Tip": "新套餐生效后最多启用 {n} 个，未保留的账号将在新套餐生效后暂停。",
    "Handle-Max-Enable-Warn": "新套餐生效后最多启用 {n} 个",
    "Handle-No-Data": "暂无数据",
    "Handle-No-Limit": "不限",
    "Handle-Reduce-Other": "其他资源类型仍超出额度，请在上方切换后继续取消勾选",
    "Handle-Reduce-Tip": "保留数量超出新套餐额度，请先取消勾选 {n} 个不需要保留的账号",
    "Handle-Operating-Status": "业务状态",
    "Handle-Search-Placeholder": "请输入账号名称",
    "Handle-Selected": "已选择",
    "Handle-Submit-Failed": "提交保留方案失败，请重试",
    "Handle-Subtitle": "请选择新套餐生效后继续使用的资源",
    "Handle-Title": "处理超额的资源",
    "List-Addon-Quota": "叠加额度：{n}",
    "List-Package-Quota": "套餐额度：{n}",
    "List-Quota-Composition": "额度构成",
    "List-Remaining": "剩余",
    "List-Total-Quota": "总额度",
    "List-Used": "已使用",
    "Package-Back-Subscribe": "返回订阅套餐",
    "Package-Buy-Title": "购买{name}",
    "Package-Carried-Notice": "已带入当前生效的叠加包配置，可按本次购买需求调整数量",
    "Package-Config-Addon": "配置叠加包",
    "Package-Current-Banner": "本次订阅套餐：JoinMC {name}",
    "Package-Current-Valid-Days": "当前套餐有效期",
    "Package-Day": "天",
    "Package-Days": "{n}天",
    "Package-Discount": "折扣",
    "Package-Fetch-Failed": "套餐信息获取失败，请返回重新选择套餐",
    "Package-Goods-Total": "商品合计金额",
    "Package-Missing-Param": "缺少套餐参数",
    "Package-Per-Month": "/月",
    "Package-Per-Unit": "/个",
    "Package-Per-Year": "/年",
    "Package-Price-Tip": "当前为商品价格，最终应付金额以支付页为准",
    "Package-Resources-Title": "套餐与资源",
    "Package-Selected-N": "已选 {n} 个",
    "Package-Subscribe-Page": "订阅套餐",
    "Package-This-Purchase": "本次购买",
    "Package-Valid-Immediately": "支付成功后，新套餐立即生效，套餐有效期自购买成功之日起计算。",
    "Payment-Actual-Amount": "实际支付",
    "Payment-Addon-Total": "叠加包合计金额",
    "Payment-Airwallex": "空中云汇",
    "Payment-Back-Addon": "返回拓展叠加包",
    "Payment-Balance-Pay": "余额支付",
    "Payment-Balance-Still-Insufficient": "充值后余额仍不足，请继续充值",
    "Payment-Confirm-Pay": "确认支付 {amount}",
    "Payment-Details": "支付明细",
    "Payment-Fee-Rate": "费率{rate}%",
    "Payment-Insufficient-Go-Recharge": "余额不足，去充值",
    "Payment-Invalid-Order": "无效订单，请返回重新选择套餐",
    "Payment-Months": "{n} 个月",
    "Payment-Months-Same-Expiry": "{n} 个月（与当前套餐同时到期）",
    "Payment-Online-Pay": "在线支付",
    "Payment-Package": "套餐",
    "Payment-Package-Amount": "套餐金额",
    "Payment-Paying": "支付中...",
    "Payment-Purchase-Failed": "购买失败",
    "Payment-Purchase-Failed-Retry": "购买失败，请稍后重试",
    "Payment-Purchase-Info": "购买信息",
    "Payment-Purchase-Success": "购买成功",
    "Payment-Refund-1": "支付新套餐费用后，新套餐立即生效，原套餐同时失效。",
    "Payment-Refund-2": "原套餐未使用部分将按剩余时长退款。",
    "Payment-Refund-Notice": "退费说明",
    "Payment-Service-Fee": "空中云汇支付服务费（{rate}%）",
    "Payment-Subscribe-Package-Fee": "订阅套餐费用",
    "Payment-Subscribe-Period": "订阅有效期",
    "Payment-This-Fee": "本次购买费用",
    "Payment-Time": "时间",
    "Payment-Valid-Period": "有效期",
    "Product-Type": "资源类型",
    "Product-Type-Email": "邮箱账号",
    "Product-Type-Listen": "社媒聆听关键词",
    "Product-Type-Listen-Short": "聆听关键词",
    "Product-Type-Social": "社媒账号",
    "Product-Type-Sub-1": "用于 WhatsApp 会话与群发的业务账号",
    "Product-Type-Sub-2": "Facebook、Instagram、TikTok 等社交平台账号",
    "Product-Type-Sub-3": "用于邮件营销与客户触达的邮箱账号",
    "Product-Type-Sub-4": "接入并管理电商独立站渠道",
    "Product-Type-Sub-5": "用于社媒监控与舆情聆听的关键词",
    "Product-Type-Website": "独立站",
    "Product-Type-WhatsApp": "WhatsApp 账号",
    "Quota-Addon-Of": "{name}叠加包",
    "Quota-Current-Of": "当前{name}额度",
    "Quota-Detail-Of": "{name}额度详情",
    "Resource-Type": "资源类型{type}",
    "Subscribe-Active": "订阅中",
    "Subscribe-Cheaper": "· 更优惠",
    "Subscribe-Current": "当前订阅",
    "Subscribe-Month": "按月订阅",
    "Subscribe-Monthly-Plan": "包月套餐",
    "Subscribe-Most-Popular": "最受欢迎",
    "Subscribe-Quota": "资源额度",
    "Subscribe-Quota-Value": "{n} 个",
    "Subscribe-Save-Percent": "年度订阅·立省 {n}%",
    "Subscribe-Subtitle": "统一管理社交账号、邮件、WhatsApp、独立站与社媒聆听，根据团队规模灵活选择套餐",
    "Subscribe-Trial": "试用中",
    "Subscribe-Trial-End-Notice": "天，试用结束后需订阅正式套餐才能继续使用",
    "Subscribe-Trial-Left": "试用剩余",
    "Subscribe-Trial-Remaining": "试用期剩余",
    "Subscribe-Year": "按年订阅",
    "Subscribe-Yearly-Plan": "包年套餐",
    "Subscribe-Your-Package": "订阅您的套餐",
  },
  personal: {
    "Personal-Center": "个人中心",
    "Personal-Profile": "个人资料",
    "Team-Profile": "团队资料",
    "Nickname": "昵称",
    "Mobile-Number": "手机号",
    "Email": "邮箱",
    "Login-Account": "账号",
    "Login-Password": "密码",
    "Modify": "修改",
    "Bind": "绑定",
    "Set-Up": "设置",
    "Change-Avatar": "更换头像",
    "Exit-Team": "退出团队",
    "Change-Phone": "更换手机号",
    "Change-Email": "更换邮箱",
    "Change-Phone-Title": "更换手机号",
    "Change-Email-Title": "更换邮箱",
    "Confirm-Exit-Team": "确认退出团队",
    "Mobile-Not-Bound": "未绑定手机号",
    "Email-Not-Bound": "未绑定邮箱",
    "Enter-Login-Account": "请输入登录账号",
    "Enter-Login-Password": "请输入登录密码",
    "Please-Enter-New": "请输入新{name}",
    "Current-Name": "当前{name}",
    "New-Name": "新{name}",
    "Modify-Success": "{name}修改成功",
    "Not-Bound": "未绑定",
    "Bound": "已绑定",
    "Bind-Success": "绑定成功",
    "Verification-Code": "验证码",
    "Enter-Verification-Code": "请输入验证码",
    "Get-Code": "获取验证码",
    "Mobile-Number-Short": "手机号",
    "Email-Short": "邮箱",
    "Confirm-Exit-Team-Desc": "退出团队后，您将无法再访问该团队的文件和数据，此操作不可撤销！",
    "Exit-Team-Success": "退出团队成功",
    "Enter-New-Nickname": "请输入新昵称",
    "Nickname-Length-Error": "昵称长度需为1-20个字符",
    "Nickname-Empty-Error": "昵称不能为空",
    "Nickname-Updated": "昵称更新成功",
    "Personal-Info": "个人信息",
    "Create-Account-Password": "创建账号密码",
    "Create-Account-Password-Desc": "您还没有创建登录账号，本次需要同时创建账号和密码",
    "Create-Account-Password-Success": "创建账号密码成功",
    "Change-Password": "更换密码",
    "Enter-Old-Password": "请输入旧密码",
    "Enter-New-Password": "请输入新密码",
    "Forgot-Password": "忘记密码",
    "Enter-Password-Error": "请输入密码",
    "Password-Format-Error": "请输入含数字+字母6位以上密码",
    "Change-Password-Success": "修改密码成功",
    "Modify-Login-Account": "修改登录账号",
    "Modify-Account": "修改账号",
    "Account-Format-Error": "请输入数字和字母",
    "Modify-Account-Success": "修改账号成功",
    "Modify-Nickname": "修改昵称",
    "Verify-Old-Tip": "为了保证您的账号安全，请验证原{name}：{value}",
    "Enter-New-And-Code": "请输入{isNew}{name}及验证码",
    "New": "新的",
    "Getting-Code": "正在获取验证码",
    "Resend-After": "s后重新获取",
    "Enter-New-Mobile": "请输入手机号",
    "Enter-New-Email": "请输入邮箱",
    "Enter-SMS-Code": "请输入短信验证码",
    "Enter-Email-Code": "请输入邮箱验证码",
    "Mobile-Format-Error": "请输入正确的手机号",
    "Email-Format-Error": "请输入合法邮箱",
    "Confirm-Replace-Tip": "确定要更换{name} {value} 吗？",
    "Confirm-Replace": "确定更换",
    "Replace": "更换",
    "Replace-Success": "更换成功",
    "Replace-Failed": "更换失败",
    "Code-Required": "验证码不能为空",
    "Get-Code-Success": "获取验证码成功",
    "Team-Module-Tip": "此模块展示您存在的团队组织",
    "Team-Info": "团队信息",
    "My-Role": "我的角色",
    "Action": "操作",
    "Exit-Team-Confirm-Tip": "您如果退出团队：{name}，对应团队中的权限也将被自动移除。",
    "Exit-Team-Switch-Tip": "已退出团队，自动切换至团队：{name}",
    "Warning": "警告",
  },
  "bot-list": {
    "All-Bots": "全部机器人",
    "Chat-Bot": "对话机器人",
    "Page-Bot": "主页机器人",
    "Email-Bot": "邮箱机器人",
    "Bot-Type-Chat": "对话",
    "Bot-Type-Page": "主页",
    "Bot-Type-Email": "邮箱",
    "Enter-Service-Name": "请输入客服名称",
    "All-Operating-Status": "全部运营状态",
    "Stop-Operation": "停止运营",
    "All-ToDos-Done": "所有的待办任务都已经处理完成",
    "Created-At": "创建于：",
    "Reply-Content": "回复内容：",
    "Reply": "回复",
    "Cancel-ToDo": "取消待办",
    "Reply-ToDo-Message": "回复待办消息",
    "Enter-Reply-Content": "请输入回复内容",
    "Bot-Stopped-Cannot-Reply": "当前机器人已停止运营，无法回复消息!",
    "Independent-Site": "独立站",
    "Create-Bot": "创建机器人",
    "Create-Bot-Desc": "快速创建一个属于团队的智能机器人",
    "Pending": "待处理",
    "Chat": "对话",
    "Comment": "评论",
    "Email": "邮件",
    "Unread-Count": "{count}条",
    "FB-Page-Unavailable": "当前Facebook主页不可用",
    "Auth-Invalid": "授权已失效",
    "Email-Auth-Invalid": "邮箱授权已失效",
    "Bot-Suffix": "机器人",
    "FB-And-INS": "Facebook 和 Instagram",
    "FB": "Facebook",
    "INS": "Instagram",
    "None": "暂无",
    "Bot-Operation": "机器人运营",
    "Set-Bot": "设置机器人",
    "Copy-Bot": "复制机器人",
    "Delete-Bot": "删除机器人",
    "Message-Center": "消息中心",
    "Config-Bot": "配置机器人",
    "Copy-Suffix": "副本",
    "Package-Quota-Used-Up": "套餐额度已用完",
    "Package-Quota-Used-Up-Desc": "您当前的团队套餐已达到机器人创建数量上限，请升级套餐以创建更多的机器人。",
    "Go-Buy": "去购买",
    "Cancel": "取消",
    "Delete-Bot-Confirm": "机器人删除后，将不再提供服务，是否继续？",
    "Warning": "警告",
    "Confirm": "确定",
    "Delete-Success": "删除成功!",
    "Bot-Close-Confirm": "机器人关闭后，需要等待24小时后才能重新开启。",
    "Operation-Confirm": "操作确认",
    "Operation-Success": "操作成功",
    "Operation-Failed": "操作失败",
    "Creating-Bot": "正在创建机器人...",
    "Create-Success": "创建成功",
    "Bind-Other-Platforms-Confirm": "当前机器人还可以绑定其他平台，是否继续绑定？",
    "Create-Complete-Settings-Confirm": "机器人已创建完成，是否继续完善设置？",
  },
  "bot-store": {
    "Next-Step-Set-Bot": "下一步：设置机器人",
    "Prev-Step": "上一步",
    "Save-Settings": "保存设置",
    "Bot-Avatar": "机器人头像：",
    "Bot-Name": "机器人名称：",
    "Bot-Desc": "机器人描述：",
    "Enter-Bot-Name": "请输入机器人名称",
    "Enter-Bot-Desc": "请输入机器人描述",
    "Related-Email": "关联的邮箱",
    "Publishable-Platforms": "可发布的平台",
    "Please-Select-Bot-Type": "请先选择机器人类型",
    "Chat-Bot": "对话机器人",
    "Page-Bot": "主页机器人",
    "Email-Bot": "邮箱机器人",
    "Chat-Bot-Desc": "支持Messenger、Instagram、WhatsApp、独立站",
    "Page-Bot-Desc": "支持Facebook、Instagram 评论",
    "Email-Bot-Desc": "支持绑定各种类型的邮箱",
    "Smart-Bot": "智能机器人",
    "Service-Settings": "客服设置",
    "New-Bot": "新建机器人",
    "Independent-Site": "独立站",
    "Messenger-About": "Facebook Messenger 是一款免费的综合通信应用，可以无限制地进行文本、语音和视频通话，以及群体视频聊天。",
    "Instagram-About": "Instagram，是Meta公司的一款免费提供在线图片及视频分享的社群应用软件。",
    "WhatsApp-About": "WhatsApp 是一款流行的即时通讯应用，允许用户通过互联网发送文本消息、语音消息、图片和视频，还支持语音和视频通话。",
    "Site-About": "插入一段JS代码，让您的网站轻松拥有智能客服机器人。",
    "Facebook-About": "Facebook是一个全球领先的社交媒体平台，用户可以在上面分享信息、照片、视频，与朋友和家人保持联系，并参与各种社群活动。",
    "Package-Quota-Used-Up": "套餐额度已用完",
    "Package-Quota-Used-Up-Desc": "您当前的团队套餐已达到机器人创建数量上限，请升级套餐以创建更多的机器人。",
    "Go-Buy": "去购买",
    "Cancel": "取消",
    "Create-Success-Msg-1": "机器人已经创建成功！您可以到基本信息 -> 可发布的平台中查看已经绑定的媒体信息。绑定更多媒体平台也可以到此模块中进行操作",
    "Create-Success-Msg-2": "机器人已经创建成功！您可以到基本信息 -> 可发布的平台中修改或绑定更多媒体平台。",
    "Create-Success": "创建成功",
    "Go-Set-Bot": "去设置机器人",
    "Back-To-List": "返回列表",
    "Notice": "提示",
    "Confirm": "确定",
    "Email-Create-Success-Msg": "机器人已经创建成功，如果您需要绑定邮箱请到 基本信息 -> 关联的邮箱 中进行操作",
    "Go-Edit": "去编辑",
    "Related-Email-Success": "关联邮箱成功",
    "Change-Avatar": "更换头像",
    "Menu-Directory-Navigation": "目录导航",
    "Menu-Basic-Settings": "基础设置",
    "Menu-Basic-Info": "基本信息",
    "Menu-Service-Admin": "客服管理员",
    "Menu-Publishable-Platforms": "可发布的平台",
    "Menu-Reply-Settings": "回复设置",
    "Menu-Reply-Basic-Settings": "回复基础设置",
    "Menu-Auto-Reply-Language": "自动回复语言设置",
    "Menu-Service-Role": "客服角色设置",
    "Menu-Knowledge-Base": "客服知识库",
    "Menu-Knowledge-Base-Settings": "客服知识库设置",
    "Menu-E-Commerce": "电商平台",
    "Menu-Related-E-Commerce": "已关联电商平台",
    "Menu-Product-Info": "商品信息",
    "Menu-Operation-Settings": "运营设置",
    "Menu-Operation-Scene": "运营场景设置",
    "Menu-Manual-Reply-Reminder": "人工回复提醒设置",
    "Menu-Public-Opinion": "舆情监测设置",
    "Menu-Specific-Post": "独立帖文运营设置",
    "Menu-Related-Emails": "关联的邮箱",
    "Menu-Email-Default-Format": "邮件默认头尾设定",
    "Btn-Save-Settings": "保存设置",
    "Btn-Add-Admin": "新增管理员",
    "Btn-Add-Exception-Rule": "新增例外规则",
    "Btn-Relate-Mall": "关联商城",
    "Btn-Update-Products": "更新商品",
    "Btn-Add-Scene": "添加场景",
    "Btn-Add-Post": "添加帖文",
    "Tip-Auto-Reply-Language": "当用户使用特定语言进行留言时，设定指定的语言进行回复",
    "Tip-Service-Role": "您可以在输入框中输入您希望的自定义的语言风格，按下回车即可选中！",
    "Tip-Operation-Scene": "客服的提问符合某个特定场景的时候，系统是否进行自动回复",
    "Tip-Manual-Reply": "设定人工回复通知推送规则，设定完后按统一时间向机器人管理员推送消息。",
    "Tip-Public-Opinion": "开启后，当系统检测到属于以下定义的恶意评论后后，系统将自动将恶意评论从系统中隐藏",
    "Tip-Email-Format": "启用预设的邮件模板后，系统将按照模板格式向客户发送邮件。",
    "Update-Shopify-Shopline-Tip": "仅更新Shopify和Shopline店铺下商品信息",
    "Desc-Basic-Info": "对机器人进行配置，包括设定其名称、选择头像以及撰写描述信息。",
    "Desc-Service-Admin": "配置机器人时可设定客服人员，当出现需要人工处理的咨询情况时，机器人会向微信推送通知。",
    "Desc-Publishable-Platforms": "配置机器人，使其能够在特定的社交媒体平台上工作，并获取独立站服务代码。",
    "Desc-Related-Emails": "对已经与机器人相关联的邮箱进行管理。",
    "Desc-Reply-Basic-Settings": "配置机器人时，可设置是否开启自动回复、回复频率、用户首次访问欢迎语及无答案默认回复。",
    "Desc-Auto-Reply-Language": "配置机器人可设定用户提问时的语种，并确定以相应语言进行回复。",
    "Desc-Service-Role": "设定机器人的 AI 自动回复时，可确定以特定身份及语气进行答复。",
    "Desc-Knowledge-Base-Settings": "配置机器人，可设定其自动回复时使用的资料，以确保回复问题更准确。",
    "Desc-E-Commerce": "配置机器人，选定其使用的电商平台，以此作为基础资料，辅助实现物流查询、售前咨询等功能。",
    "Desc-Product-Info": "查看与机器人相关联的电商平台上的商品。",
    "Desc-Operation-Scene": "配置机器人可以控制的场景，当AI识别到对应的场景时直接进行对应的处理。",
    "Desc-Manual-Reply": "设定人工回复通知推送规则，设定完后按统一时间向机器人管理员推送消息。",
    "Desc-Public-Opinion": "系统检测到满足设置规则的恶意评论后，自动将其从系统中隐藏。",
    "Desc-Specific-Post": "对指定的帖文进行自动回复设置，系统识别对应的场景后，进行相应的处理。",
    "Desc-Email-Default-Format": "系统按照设置的模板格式向客户发送邮件，保持邮件格式的一致性。",
    "Enter-Bot-Desc-Info": "请输入机器人的描述信息",
    "AI-Cmd-Introduce-Page": "我是【电商平台】，简短输出一段介绍自己的Facebook主页的通用模板",
    "Current-Model": "当前使用模型",
    "Set-As-Default": "设为默认",
    "Auto-Reply-Switch": "自动回复开关：",
    "Receive-Message": "收到留言：",
    "Auto-Reply-After-Minutes": "分钟后系统自动回复",
    "Welcome-Message": "欢迎语：",
    "AI-Cmd-Welcome": "我是【电商平台】，简短输出一段Facebook主页的欢迎语模板",
    "No-Answer-Reply": "无答案回复：",
    "AI-Cmd-No-Answer": "我是【电商平台】，一句话输出当Facebook主页遇到需要跟同事确认后才能回答的回复话术模板。",
    "Reply-Language-Style": "回复语言风格：",
    "Select-Or-Enter-Language-Style": "请选择或输入一种回复语言风格",
    "Mood-Formal": "正式",
    "Mood-Rigorous": "严谨",
    "Mood-Humorous": "幽默",
    "Mood-Friendly": "友好",
    "Mood-Professional": "专业",
    "Mood-Warm": "亲切",
    "Mood-Lively": "活泼",
    "Mood-Serious": "严肃",
    "Mood-Relaxed": "轻松",
    "Mood-Enthusiastic": "热情",
    "Mood-Calm": "冷静",
    "Character-Setting-Default-Template": "你是{name}的运营人员，\n拥有14年的社交媒体管理和运营经验，其中6年专门负责Facebook平台的贴文回覆和用户互动，熟悉Facebook社区准则和最佳实践。能迅速捕捉到用户评论中的情绪和需求，有出色的书面沟通能力，擅长用词，能够处理多种情境并为用户提供相应的答复和解决方案。熟悉品牌语言和调性。\n性格特点是：善于沟通，有耐心，专业且始终保持友善，对于用户反馈有高度的敏感度，有解决问题的热情。",
    "Translate": "翻译",
    "Character-Setting": "角色设定：",
    "Character-Setting-Placeholder": "请输入客服人员扮演的角色，设定完成后，用户提问客服身份的时候，系统将以告知用户系统的预设身份。用户提问的时候，系统将按照这个角色的角度进行思考并回答问题",
    "AI-Cmd-Character": "简短输出一段Ai【电商客服】服务态度和性格描述",
    "Select-Knowledge-Base": "选择知识库：",
    "All-Knowledge-Bases": "全部知识库",
    "Bot-Specific-Knowledge-Base": "客服专属知识库",
    "Knowledge-Base-Alert-1": "使用Join MC和团队专属知识库中的内容，作为该客服回复的知识库。",
    "Knowledge-Base-Alert-2": "为机器人设置专属知识范围，专属知识只在此客服下生效。",
    "Auto-Public-Opinion-Control": "自动舆情管控：",
    "Malicious-Comment-Definition": "恶意舆情定义：",
    "Please-Enter": "请输入",
    "AI-Cmd-Malicious": "我是【电商平台】，请列出电商平台经常遇到的恶意评论种类，要全面。",
    "Init-Malicious-Definition": "初始化恶意评论定义",
    "Facebook-Posts": "Facebook帖文",
    "Instagram-Posts": "Instagram帖文",
    "Select-Upload-Image": "请选择要上传的图片",
    "Only-Support-JPG-PNG": "仅支持JPG、PNG格式",
    "File-Size-Limit-5M": "文件大小不能超过 5M",
    "Current-Page-Unavailable": "当前主页不可用",
    "Auth-Expired": "授权已失效",
    "Current-Page-Normal": "当前主页状态正常",
    "Normal": "正常",
    "Media-Account": "媒体账号",
    "Auth-Time": "授权时间",
    "Operator": "操作人",
    "Visit-Page": "访问主页",
    "Unbind": "解除关联",
    "Edit-Site": "修改站点",
    "View-Code": "查看插码",
    "Not-Set": "未设置",
    "Go-Bind": "去绑定",
    "Site-Settings": "独立站设置",
    "Site-Name": "站点名称",
    "Enter-Site-Name": "请输入站点名称",
    "Domain-Address": "域名地址",
    "Enter-Domain-Address": "请输入http://或 https://的域名地址",
    "Domain-URL-Error": "请输入以http://或https://开头的域名地址",
    "Get-Deploy-Code": "获取部署代码",
    "Copy-Code-Tip": "请复制以下代码，粘帖到网站的<head>元素中",
    "Close": "关闭",
    "Copy-Code": "复制代码",
    "Delete-Site-Confirm": "删除独立站后，您部署在网站上的机器人将无法继续提供服务！",
    "Delete-WABA-Confirm": "删除WABA账号后，机器人将停止在 WhatsApp 平台上的服务！",
    "Delete-Page-Confirm": "删除主页后，机器人将不再对主页进行管理！",
    "Warning": "警告",
    "Email-Sync-Tip": "关联成功后将同步最近两天的邮件",
    "Email-Type": "邮箱类型",
    "Select-Email-Type": "请选择邮箱类型",
    "Email-Account": "邮箱账号",
    "No-Need-Account-Tip": "无需填写账号，请点击账户授权按钮进行账号授权",
    "Enter-Email-Address": "请输入正确的邮箱地址",
    "Auth-Login": "授权登录",
    "Account-Auth": "账户授权",
    "Auth-Failed": "授权失败",
    "Email-Auth-Code": "邮箱授权码",
    "Enter-Email-Auth-Code": "请输入邮箱授权码",
    "How-To-Get-Auth-Code": "如何获取授权码？",
    "Usage-Description": "用途描述",
    "Enter-Description": "请输入描述",
    "Service-Type": "服务类型",
    "Server": "服务器",
    "Server-Example-IMAP": "例如：imap.example.com",
    "Port-Example": "例如：993",
    "SMTP-Server": "SMTP服务器",
    "Server-Example-SMTP": "例如：smtp.example.com",
    "Fill-Email-Address": "请填写邮箱地址",
    "Fill-Usage-Description": "请填写用途描述说明",
    "Select-Service-Type": "请选择接受服务类型",
    "Enter-Receiving-Server": "请输入接收服务器地址",
    "Enter-Port": "请输入端口号",
    "Enter-Outbox-Server": "请输入发送服务器地址",
    "Enter-Port-Type": "请输入端口类型",
    "Enter-Tenant-ID": "请输入Tenant ID",
    "Enter-App-ID": "请输入App ID",
    "Enter-Client-Secret": "请输入Client Secret",
    "Auth-Success-Alert": "账户授权成功，请点击确定完成邮箱关联。",
    "Admin-Not-Follow-Tip": "该管理员还没有关注并绑定公众号，将无法收到推送通知",
    "Follow-Offical-Account": "关注公众号",
    "Role-Prefix": "角色：",
    "Email-Prefix": "邮箱：",
    "Phone-Prefix": "手机号：",
    "Add-Time-Prefix": "添加时间：",
    "Role-Super-Admin": "超级管理员",
    "Role-Admin": "管理员",
    "Role-Team-Member": "团队成员",
    "Set-Admin": "设置管理员",
    "Enter-Admin-Nickname-Or-Phone": "请输入管理员昵称/手机号",
    "No-Personnel": "暂无人员",
    "Message-Language": "留言语种",
    "Reply-Language": "回复语种",
    "Operation": "操作",
    "Message-Language-Manage": "留言语种管理",
    "Message-Language-Prefix": "留言语种：",
    "Reply-Language-Prefix": "回复语种：",
    "Select-Language": "请选择语种",
    "Delete-Language-Confirm": "此操作不能恢复！是否删除？",
    "Role-Placeholder": "请输入客服人员扮演的角色，设定完成后，用户提问客服身份的时候，系统将以告知用户系统的预设身份。\n用户提问的时候，系统将按照这个角色的角度进行思考并回答问题",
    "AI-Help-Generate": "智慧助手辅助生成",
    "Tip": "提示",
    "Customer-Service-Operation-Settings": "客服运营设置",
    "Independent-Post-Operation-Settings": "{0}独立帖文运营设置",
    "Select-Post": "选择帖文",
    "Remarks-Info": "备注信息",
    "Enter-Remarks": "请输入备注信息",
    "Unified-Reply-Mode": "统一回复模式",
    "Enter-Reply-Content": "请输入回复内容",
    "Keyword-Mode": "关键词模式",
    "Scene-Reply-Mode": "场景回复模式",
    "Please-Select-Post": "请选择帖文",
    "Add-Post": "添加{0}帖文",
    "Enter-Post-Keyword": "请输入帖文关键词",
    "Enter-Post-Id": "请输入帖文编号",
    "Go-To-Facebook-Add": "去 Facebook 添加",
    "Go-To-Instagram-Add": "去 Instagram 添加",
    "Update-Posts": "更新帖文",
    "Updating": "正在更新",
    "Posts-Updated": "已更新了 {0} 篇帖文",
    "Background-Update": "后台更新",
    "Not-Bound-Platform": "您还未关联平台，请先关联平台",
    "Add-Rule": "新增规则",
    "Reply-Rule": "回复规则",
    "Reply-Comment": "回复评论",
    "Send-Messenger-Notification": "发送一次 Messenger 通知",
    "Messenger-Notification-Tooltip": "当用户对帖文进行评论时，系统将进行一次 Messenger 消息的推送。每个 Facebook 主页在{Facebook规定时间}日内，只能推送一次。开启此功能需要开通 Messenger 助手",
    "Priority": "优先级",
    "Priority-Tooltip": "系统将根据优先级进行回复匹配。如果存在优先级相同的情况，将按照添加时间进行匹配，优先匹配添加时间较早的回复。",
    "Keywords-Label": "关键词",
    "Enter-Keyword-Enter-Confirm": "输入关键词，回车确认",
    "Remember-Enter-Confirm": "记得回车确认哦",
    "Comment-Reply": "评论回复",
    "Enter-Comment-Reply-Content": "请输入评论回复内容",
    "Messenger-Notification": "Messenger通知",
    "Enter-Messenger-Notification-Content": "请输入Messenger通知内容",
    "Highest": "最高",
    "Higher": "较高",
    "Medium": "中",
    "Lower": "较低",
    "Lowest": "最低",
    "Please-Set-Reply-Rule": "请至少设置一种回复规则",
    "Keyword-Cannot-Be-Empty": "关键词不能为空",
    "Please-Enter-Reply-Or-Upload": "请补充回复内容或者上传图片",
    "Keyword-Already-Exists": "关键词已存在，请重新输入",
    "Messenger-Assistant-Create-Msg": "因为涉及到Messenger的通知，你需要创建一个Messenger助手才可以开启此功能。点击确定按钮系统将给您配置一个Messenger助手！",
    "Messenger-Assistant-Quota-Msg": "因为涉及到Messenger的通知，你需要创建一个Messenger助手才可以开启此功能。但是您当前的团队套餐已达到机器人创建数量上限，请先升级套餐。",
    "Scene-Setting": "场景设定",
    "Enter-Scene-Setting": "请输入场景设定",
    "Ad-Post": "广告帖",
    "Video-Only": "「仅视频」",
    "Image-Only": "「仅图片」",
    "Auto-Operation": "自动运营",
    "Post-Id": "帖文编号",
    "Created-At": "创建于",
    "Remarks": "备注",
    "No-Data": "暂无数据",
    "Start-Date": "开始日期",
    "End-Date": "结束日期",
    "Date-Range-Separator": "至",
    "Operation-Success": "操作成功",
    "All-Post-Types": "全部帖文类型",
    "Enter-Remarks-Content": "请输入备注内容",
    "Delete-Specific-Reply-Confirm": "是否删除该特定回复规则？",
    "Reminder-Switch": "提醒开关",
    "Push-Time": "推送时间",
    "Time-Oclock": "点",
    "Follow-Wechat-Account": "关注公众号",
    "Admin-Not-Follow-Wechat": "该客服下的管理员还没有关注并绑定公众号，将无法收到微信推送通知",
    "Comment-Count": "评论数",
    "Reply-Count": "回复数",
    "Suggest-Reply-Prefix": "建议回复{index}",
    "Use-Answer": "使用答案",
    "Created-At-Colon": "创建于：",
    "Comment-Hidden": "该评论已隐藏",
    "Forward": "转发",
    "More-Scenes": "+ 更多场景",
    "All-Comments": "所有评论（{count}）",
    "Only-Show-Unreplied": "仅显示未回复",
    "Comment-Sending": "评论发送中...",
    "Delete-Confirm-Msg": "删除后不可恢复, 是否确认删除?",
    "Warning": "警告",
    "Unhide": "取消隐藏",
    "Hide": "隐藏",
    "Generate-AI-Reply": "生成AI建议回复",
    "Cancel-Reply": "取消回复",
    "Reply": "回复",
    "Reply-Input-Placeholder": "输入回复内容，Enter发送",
    "Select-Platform": "请选择平台",
    "Comment-Content": "评论内容",
    "Corresponding-Post": "对应帖文",
    "Platform": "平台",
    "Deal-Info": "处理信息",
    "Deal-Method-Colon": "处理方式：",
    "Deal-Time-Colon": "处理时间：",
    "View-Post": "查看帖文",
    "Post-Detail": "帖文详情",
    "Intelligent-Assist": "智能辅助",
    "Stop-AI-Confirm": "您要终止AI的响应吗?",
    "Restore-Confirm": "确定要将评论恢复成正常吗？",
    "Confirm-Restore": "确认恢复",
    "Commented-On-Post": "评论了 {platform} 主页 {page} 的帖文",
    "Set-Not-Reply": "设置不回复",
    "Not-Reply-Confirm": "将此条评论设置为不回复吗？",
    "Set-Success": "设置成功",
    "Delete-Success": "删除成功",
    "Operation-Success": "操作成功",
    "Updating-Post": "正在更新帖文，当前已更新：{count}篇",
    "Select-Comment-Importance": "请选择评论重要程度",
    "Post-Id-Colon": "编号：",
    "Normal-Post": "普通帖",
    "Like-Count": "点赞数",
    "Share-Count": "分享数",
    "Pending-Reply-Count": "待回复评论数",
    "Post-Id-Prefix": "帖文编号：",
    "Pending-Comments": "未处理的评论",
    "Page-Posts": "主页帖文",
    "Hidden-Comments": "已隐藏评论",
    "Deleted-Comments": "已删除评论",
    "All-Post-Types": "全部帖文类型",
    "Comment-Restored": "评论恢复完成",
    "Set-Status": "已设置",
    "Select-Set-Status": "请选择设置状态",
    "AI-Prompt-Product-Promo": "我是【电商平台】，在对单一【产品宣传】类帖文设置默认回复的时候，这篇帖文需要包含什么，输出回复模板。",
    "AI-Prompt-List-Scenes": "我是【电商平台】，帮我列出几种遇到客户常问的场景。",
    "AI-Prompt-Greeting": "我是【电商平台】，我要在Messenger里跟客户打招呼引导完成下单动作，作为一个专业的客服人员，请输出一段打招呼模板。",
    "AI-Prompt-Logistics": "我是【电商平台】，我在设置【物流时长】为回复关键词，作为一个专业的客服，针对这一关键词请做出针对性的回复模板，要包含【发货时间】和【物流时间】。",
    "AI-Prompt-Price": "我是【电商平台】，我在设置【多少钱】为回复关键词，作为一个专业的客服，针对这一关键词请做出针对性的回复模板，要包含【购买链接】和【价格】。",
    "AI-Prompt-Buy-Intent": "我是【电商平台】，在某篇帖文中设置【所有有购买意向的评论】为场景，作为一个专业的客服，针对这一场景请做出针对性的回复模板，回复要要包含【购买链接】和【价格】，以【邮件的格式】输出。",
    "Choose-Bot-Type": "选择机器人类型",
    "New-Bot-With-Name": "新建{name}",
    "Bind-Other-Platforms-Confirm-With-Name": "{name}还可以绑定其他媒体平台，您是否还需要绑定？",
    "Keyword-Rule-Settings": "关键词规则设置",
    "Reply-Rule-Colon": "回复规则：",
    "Messenger-Notify-Once": "发送一次Messenger通知",
    "Messenger-Notify-Desc": "当用户对帖文进行评论时，系统可以进行一次 Messenger 的消息推送，每个评论只能推送一次。开启此功能需要开通对话机器人",
    "Keyword-Colon": "关键词：",
    "Enter-Keyword-Tip": "输入关键词，回车确认",
    "Press-Enter-Confirm": "记得回车确认哦",
    "Scene-Setting-Colon": "场景设定：",
    "Max-3000-Chars": "最多可输入3000字的内容",
    "Comment-Reply-Colon": "评论回复：",
    "Max-12-Images": "最多允许上传 12 张图片",
    "Messenger-Colon": "Messenger：",
    "Keyword-Required": "关键词不能为空",
    "Answer-Required": "答案不能为空",
    "Uploading-Image-Tip": "正在上传图片，请稍后提交",
    "Only-Image-Error": "{name} 只能上传图片",
    "File-Too-Large-Error": "{name} TXT文件大小不能超过5M",
    "Max-12-Images-Limit": "当前限制选择12张图片",
    "Messenger-Quota-Desc": "因为涉及到Messenger的通知，你需要创建一个Messenger助手才可以开启此功能。但是您当前的团队套餐已达到机器人创建数量上限，请先升级套餐。",
    "Messenger-Create-Assistant-Confirm": "因为涉及到Messenger的通知，你需要创建一个Messenger助手才可以开启此功能。点击确定按钮系统将给您配置一个Messenger助手！",
    "AI-Prompt-Logistics-Email": "我是【电商平台】，我在设置【物流时常】为回复关键词，作为一个专业的客服，针对这一关键词请做出针对性的回复模板，要包含【发货时间】和【物流时间】，以【邮件的格式】输出。",
    "AI-Prompt-Logistics-Scene": "我是【电商平台】，我在设置【物流时长】为回复场景，作为一个专业的客服，针对这一场景请做出针对性的回复模板，要包含【发货时间】和【物流时间】。",
    "Save-Success": "保存成功",
    "Notify-Success-Title": "成功",
    "Update-Saved": "修改已保存",
    "Enter-Service-Name": "请填写客服名称",
    "Enter-Service-Desc": "请填写客服说明",
    "Enter-Welcome-Message": "请输入欢迎语",
    "Bind-Page": "请绑定主页",
    "Please-Set-Admin": "请设置管理员",
    "Set-Default-Model": "请设置该客服的默认AI模型",
    "Select-Language-Style": "请选择一种回复的语言风格",
    "Character-Setting-Desc": "请详细描述该客服的角色设定以便AI回复内容具有更强的相关性",
    "Enter-0-120": "请输入0-120之间的数字",
    "Enter-Email-Addr": "请填写邮箱地址",
    "Enter-Malicious-Desc": "请详细描述对于恶意评论的定义",
    "Malicious-Example": "人身攻击、辱骂与谩骂、歧视行为、性别歧视、年龄歧视、信仰歧视、身体形象歧视、精神健康歧视、专业歧视、地域歧视、家庭状况歧视、性取向歧视、文化歧视：发布针对个人或群体的攻击性言论或偏见，损害他们的尊严和权利。\n\n恶意诋毁、挑衅与煽动仇恨、种族主义与仇恨言论、心理虐待：以虚假信息或恶意言论攻击他人，引起冲突或伤害对方的情感和身心健康。\n\n色情内容、色情骚扰：发布淫秽或不雅内容，造成对他人的困扰或不适感。\n\n恶意揭露个人信息、身份盗窃：公开他人的私人信息或冒用他人身份，侵犯他人的隐私权或名誉权。\n\n骚扰与威胁：通过连续的骚扰性言论或恐吓行为，对他人造成心理压力或恐惧。\n\n不当内容、政治干预、虚假信息与欺诈、非法行为、反社会行为、非法贩卖与违禁品、自残与自杀威胁、侮辱记忆、虚假表态、对儿童的伤害：发布违法、虚假、不当或有害内容，可能引发社会不稳定、伤害他人或违反法律法规。",
  },
  "workbench": {
    "Chat-Bot": "对话机器人",
    "Page-Bot": "主页机器人",
    "Email-Bot": "邮箱机器人",
    "Mail-Bot": "邮件机器人",
    "Todo-Tasks": "待办任务",
    "Search-Placeholder": "输入关键词按回车搜索",
    "Bot-Settings": "机器人设置",
    "Data-Analysis": "数据分析",
    "Workbench": "工作台",
  },
  "chat-room": {
    // TODO
  },
  "fb-posts": {
    // TODO
  },
  "mail-manage": {
    // TODO
  },
  "scene-setting": {
    "Select-Enable-Status": "请选择启用状态",
    "Enabled": "已启用",
    "Disabled": "未启用",
    "Enter-Scene-Name": "请输入场景名称",
    "Total-Scene-Settings": "共有 {count} 条场景设置",
    "Reply-Strategy": "回复策略：",
    "WeChat-Reminder": "公众号提醒：",
    "Is-Enabled": "是否启用：",
    "Customer-Service-Settings": "客服运营设置",
    "Scene-Settings-Crumb": "场景设置",
    "Scene-Type": "场景类型：",
    Custom: "自定义",
    "Track-Logistics": "查物流",
    "Scene-Name": "场景名称：",
    "Enter-Scene-Desc": "请输入场景描述",
    "Scene-Definition-Placeholder": "请输入用户咨询内容中包含的场景定义",
    "AI-Command-Scene": "我是【电商平台】，帮我列出几种遇到客户常遇到的询问场景。",
    "AI-Command-Track": "我是【电商平台】，帮我列出：当客户发邮件查询物流信息时，可能会遇到的询问场景。",
    "AI-Command-Reply": "我是【电商平台】，我在设置【物流时常】为回复关键词，作为一个专业的客服，针对这一关键词请做出针对性的回复模板，要包含【发货时间】和【物流时间】",
    "Auto-Reply": "自动回复",
    "Manual-Reply": "人工回复",
    "No-Reply": "不回复",
    "Reply-Form": "回复形式：",
    "Scene-Specific-Reply": "场景特定回复",
    "Keyword-Specific-Reply": "关键词特定回复",
    "Knowledge-Base-Reply": "使用知识库内容进行回复",
    "Scene-Definition": "场景定义：",
    "Header-Tail-Template": "邮件头尾模板：",
    "Manage-Template": "管理模板",
    "Reply-Accuracy": "回复准确性：",
    Strict: "严谨的",
    Free: "自由的",
    "KB-No-Answer-Tip": "当知识库中没有对应内容时，系统将不会给出答案",
    Keyword: "关键词：",
    "Enter-Keyword-Confirm": "输入关键词，回车确认",
    "Press-Enter-Tip": "记得回车确认哦",
    "Reply-Content": "回复内容：",
    "Enter-Reply-Content": "请输入回复的内容",
    "17Track-Auth": "17TRACK平台授权：",
    "17Track-Not-Auth": "您的 17TRACK 平台还没有授权给我们，系统无法为您提供服务",
    "Go-Auth": "去授权",
    "17Track-Fee": "单一订单进行查询收费 0.03 元",
    "Add-Track-Rule": "添加物流规则",
    "Add-Rule": "添加规则",
    "Email-Tag": "邮件标签：",
    "Manage-Tag": "管理标签",
    "Save-Settings": "保存设置",
    "Add-Template-Variable": "添加模板变量",
    "Header-Tail-Empty": "邮件头尾模板中没有填写任何内容！",
    "Header-Empty": "邮件头部文件中没有填写内容！",
    "Tail-Empty": "邮件尾部文件中没有填写内容！",
    Oclock: "点",
    "Enter-Keyword": "请添加关键词",
    "Enter-Reply-Content-Rule": "请输入回复内容",
    "17Track-Confirm": "使用 JoinMC 平台授权的 17 TRACK 平台进行物流查询，每进行一次查询收费 0.01 元, 是否继续?",
    "17Track-Auth-Title": "17 TRACK 授权",
    "Keyword-Exists": "关键词已存在，请重新输入",
    "Save-Success": "保存成功",
    "Rule-Define": "规则定义：",
    "Enable-Status": "启用状态：",
    "Expand": "展开",
    "Collapse": "收起",
    "Query-From-Order-Time": "查询时距离下单时间",
    "Enter-Content": "请输入内容",
    "Min": "最小",
    "Max": "最大",
    "Days": "天",
    "Reply-Pattern": "回复模式：",
    "Add-Variable": "添加变量",
    "AI-Command-Shipped": "我是【电商平台】，请对顾客输出一段商品已发货的回复模板，以【邮件的格式】输出。",
    "AI-Command-Not-Shipped": "我是【电商平台】，请对顾客输出一段商品还未发货的回复模板，以【邮件的格式】输出。",
    "AI-Command-Order-Not-Exist": "我是【电商平台】，请对顾客输出一段已提供订单号不存在情况下的回复模板，以【邮件的格式】输出。",
    "AI-Command-Order-Not-Found": "我是【电商平台】，请对顾客输出一段未找到订单号，需要顾客提供的回复模板，以【邮件的格式】输出。",
    "Logistics-Stage": "物流阶段：",
    "Use-Knowledge-Base-Reply": "使用知识库内容进行回复",
    "Edit-Scene": "修改场景",
    "Delete-Scene": "删除场景",
    "No-Scene": "暂无场景",
    "Delete-Scene-Confirm": "场景删除后将不能恢复！是否删除？",
    "Reply-Form-Colon": "回复形式：",
    "Reply-Mode-Colon": "回复模式：",
    "System-Auto-Reply": "系统自动回复",
    "Reply-Content-Colon": "回复内容：",
    "Query-From-Payment-Min-Max": "查询时距离付款时间，最小 {min} 天，最大 {max} 天",
    "No-Product-In-Scene": "该场景下无任何商品",
  },
  chat: {
    "new-chat": "新建对话",
    "ai-model-select": "AI模型选择：",
    "history-records": "历史记录",
    "input-title": "请输入标题",
    "input-new-name": "请输入新的对话名称",
    "rename-title": "修改对话名称",
    "input-name-required": "请填写对话名称",
    "attention": "注意",
    "delete-confirm": "此操作不能恢复！是否删除「{name}」该对话",
    "current-model": "当前会话AI模型：",
    "no-answer": "无答案",
    "copy-answer": "复制答案",
    "input-reply": "请输入回复的内容",
    "browser-not-support-title": "提示",
    "browser-not-support-msg": "当前浏览器无法使用此功能，建议使用Chrome浏览器!",
  },
  socialMedia: {
    SocialMediaMonitor: "社媒监控",
    HomepageManagement: "主页管理",
    DataSummary: "数据汇总",
    SocialMedia: "社媒",
    StartDate: "开始日期",
    EndDate: "结束日期",
    AllMediaPlatforms: "全部媒体平台",
    AllAuthStatus: "全部授权状态",
    AllLabels: "全部标签",
    All: "全部",
    FansTrend: "粉丝数趋势",
    FansTrendTip: "在搜索时间范围内，各平台粉丝数变化趋势",
    FansDistribution: "粉丝分布",
    FansDistributionTip: "截止到搜索的截至时间，各平台粉丝数占比",
    FansNetGrowthTrend: "粉丝净增长趋势",
    FansNetGrowthTrendTip: "在搜索时间范围内，各平台粉丝净增长趋势",
    PostTrend: "发帖数趋势",
    PostTrendTip: "在搜索时间范围内，各平台发帖数量变化趋势",
    PostDistribution: "发帖分布数",
    PostDistributionTip: "在搜索时间范围内，各平台发帖数量占比",
    PostInteractionTrend: "帖文互动次数趋势",
    PostInteractionTrendTip: "在搜索时间范围内，各平台帖文互动次数变化趋势",
    PostInteractionDistribution: "帖文互动次数分布",
    PostInteractionDistributionTip: "在搜索时间范围内，各平台互动次数占比",
    PostExposureTrend: "帖文曝光次数趋势",
    PostExposureTrendTip: "在搜索时间范围内，各平台帖文曝光次数变化趋势",
    PostExposureDistribution: "帖文曝光次数分布",
    PostExposureDistributionTip: "在搜索时间范围内，各平台曝光次数占比",
    PostImpressionsTrend: "帖文覆盖人数趋势",
    PostImpressionsTrendTip: "在搜索时间范围内，各平台帖文覆盖人数变化趋势",
    PostImpressionsDistribution: "帖文覆盖人数分布",
    PostImpressionsDistributionTip: "在搜索时间范围内，各平台帖文覆盖人数占比",
    InteractionRateTrend: "帖文互动率趋势",
    TopPostTOP10: "最佳帖文TOP10",
    Collapse: "收起",
    Expand: "展开",
    ImageLoadFailed: "图片加载失败",
    PublicData: "公开数据",
    AuthData: "授权数据",
    NoTopPostData: "暂无最佳帖文数据",
    NoAccountForPlatform: "当前平台暂无社交号",
    NoAccountForPlatformDesc: "您选择的平台还没有添加社交号，请尝试选择其他平台",
    ResetFilter: "重置查询条件",
    NoAccountAtAll: "您还没添加任何社交号",
    NoAccountAtAllDesc: "您需要添加社交号之后，才可以查看相关的数据",
    AddNow: "立即添加",
    Followers: "粉丝数",
    FollowersTip: "截止到搜索的截至时间，各个社交号的粉丝总数",
    FollowerNetGrowth: "粉丝净增长",
    FollowerNetGrowthTip: "在搜索时间范围内，各个社交号增长的粉丝总数",
    PostCount: "发帖数",
    PostCountTip: "在搜索时间范围内，各个社交号发帖的总数",
    PostInteractionCount: "帖文互动次数",
    PostInteractionCountTip: "在搜索时间范围内，各个社交号获取到的互动总次数",
    PostExposureCount: "帖文曝光次数",
    PostExposureCountTip: "在搜索时间范围内，各个社交号的帖文被用户查看的总次数",
    PostImpressionsCount: "帖文覆盖人数",
    PostImpressionsCountTip: "在搜索时间范围内，各个社交号帖文覆盖的唯一用户数量",
    AvgFollowerInteractionRate: "平均粉丝互动率",
    AvgFollowerInteractionRateTip: "在搜索时间范围内，各个社交号发布的帖文互动比例",
    AvgExposureInteractionRate: "平均曝光互动率",
    AvgExposureInteractionRateTip: "在搜索时间范围内，各个社交号发布的帖文曝光互动比例",
    AvgCoverageInteractionRate: "平均覆盖互动率",
    AvgCoverageInteractionRateTip: "在搜索时间范围内，各个社交号发布的帖文的用户互动次数占覆盖人数的比例",
    VideoViewCount: "视频观看次数",
    VideoViewCountTip: "在搜索时间范围内，各个社交号发布的帖文中视频观看次数",
    FollowerInteractionRate: "粉丝互动率",
    FollowerInteractionRateTip: "在搜索时间范围内，各平台粉丝互动率变化趋势",
    FollowerInteractionRateAuth: "粉丝互动率（授权）",
    FollowerInteractionRateAuthTip: "在搜索时间范围内，各平台授权粉丝互动率变化趋势",
    ExposureInteractionRate: "曝光互动率",
    ExposureInteractionRateTip: "在搜索时间范围内，各平台曝光互动率变化趋势",
    CoverageInteractionRate: "覆盖互动率",
    CoverageInteractionRateTip: "在搜索时间范围内，各平台覆盖互动率变化趋势",
    ExposureViewCount: "曝光次数/查看数",
    ImpressionsAuth: "覆盖人数(授权)",
    InteractionCount: "互动次数",
    FollowerInteractionRateAuth2: "粉丝互动率(授权)",
    ExposureInteractionRateMixed: "曝光互动率(混合)",
    CoverageInteractionRateAuth: "覆盖互动率(授权)",
    HundredMillion: "亿",
    TenThousand: "万",
    To: "至",
    AuthStatusLabel: "授权状态",
    EnterPageName: "请输入主页名称",
    AddAccount: "新增账号",
    AdjustList: "调整列表",
    Verified: "已认证",
    Unverified: "未认证",
    Authorized: "已授权",
    Unauthorized: "未授权",
    ManageLabel: "管理标签",
    CancelMonitor: "取消监控",
    Cancel: "取消",
    Confirm: "确定",
    NewLabel: "新增标签",
    AddNewLabel: "添加新标签",
    NotSet: "未设置",
    EnterLabelName: "请输入标签名称",
    LabelAddSuccess: "标签添加成功",
    SetLabels: "设置标签",
    SetLabelsTip: "完成社交账号标签设置后，您在数据筛选环节可直接按标签进行选择。",
    TotalPages: "共{count}个主页",
    CancelMonitorConfirm: "一旦取消监控，系统将立即停止对该主页数据的跟踪与收集，同时主页相关的所有历史数据将永久性删除，且不可恢复!",
    OperationConfirm: "操作确认",
    SelectedLabelCount: "已选 {count} 个标签",
    TagSuccess: "标签添加成功",
    SettingLabelMsg: "正在设置标签，请稍后...",
    SocialPage: "社交主页",
    FollowersCount: "粉丝数",
    FollowersCountAuth: "粉丝数（授权）",
    FollowerNetGrowthCol: "粉丝净增长",
    // 主页管理列表的帖子相关字段统一使用“帖子”，避免同一列表中混用不同称谓。
    PostCountCol: "发帖数",
    PostCountColAuth: "发帖数（授权）",
    PostInteractionCountCol: "帖子互动次数",
    PostInteractionCountColAuth: "帖子互动次数（授权）",
    PostExposureCountCol: "帖子曝光次数",
    PostImpressionsCol: "帖子覆盖人数",
    PostImpressionsColAuth: "帖子覆盖人数（授权）",
    HeartsCount: "心情数",
    CommentsCountCol: "评论数",
    SharesCountCol: "分享数",
    PerMilleInteractionCol: "千粉互动",
    FollowerInteractionRateCol: "粉丝互动率",
    FollowerInteractionRateColAuth: "粉丝互动率（授权）",
    ExposureInteractionRateCol: "曝光互动率",
    VideoViewsCol: "视频观看次数",
    AvgVideoWatchTimeCol: "视频观看平均时长",
    VideoCompletionRateCol: "视频完播率",
    LikesCountCol: "点赞数",
    RetweetsCountCol: "转发数",
    RepliesCountCol: "回复数",
    ClicksCountCol: "点击数",
    SavesCountCol: "收藏次数",
    UpvotesCountCol: "点顶数",
    ViewInteractionRateCol: "观看互动率",
    VideoViewInteractionRateCol: "视频观看互动率",
    EmojiReactionsCountCol: "表情回复数",
    FollowerNetGrowthColAuth: "粉丝净增长（授权）",
    PostExposureCountColAuth: "帖子曝光次数（授权）",
    PostCoverageCountAuth: "帖子覆盖次数（授权）",
    CommentsRepliesCol: "评论数/回复数",
    ClicksCountAuth: "点击数（授权）",
    CommentsCountAuth: "评论数（授权）",
    PostInteractionNum: "帖子互动数",
    PostInteractionNumAuth: "帖子互动数（授权）",
    RepliesCountAuth: "回复数（授权）",
    SearchMetric: "请输入要搜索的指标",
    ListItem: "列表项",
    SupportedMedia: "支持媒体",
    AdjustOrder: "调整排序",
    GoAuth: "去授权",
    PageDetail: "主页详情",
    SinglePost: "单一帖子",
    PaidPost: "付费帖",
    NormalPost: "普通帖",
    OpenPost: "打开帖子",
    CreatedAt: "创建于：",
    PostID: "编号：",
    PacificTime: "太平洋时间 (UTC -07:00)",
    UTCTime: "UTC +00:00",
    // YouTube 单一帖子接口同时返回太平洋时间，页头时区与 Facebook 统一为 UTC -07:00。
    PacificUtcTime: "UTC -07:00",
    StartTime: "开始时间",
    EndTime: "结束时间",
    ChannelData: "频道数据",
    PageData: "主页数据",
    FollowersData: "粉丝数据",
    VideoData: "视频数据",
    PostData: "帖子数据",
    VideoWatchData: "视频观看",
    VideoInteractionData: "视频互动",
    PostsData: "帖子",
    ReelsData: "快拍数据",
    LastUpdate: "最后更新：",
    // 主页监控右上角的数据更新时间面板文案。
    DataUpdate: "数据更新：",
    UpdatedPlatformCount: "{count}个平台",
    LatestPlatformUpdateTimes: "各平台最近更新时间",
    UtcUpdateTimeHint: "统一按 UTC 00:00 展示",
    UpdateData: "更新数据",
    Updating: "更新中",
    Update: "更新",
    UpdateDataDesc: "选择需要更新的数据时间范围（最多支持当前日期前一年的数据）",
    UpdateDataRange: "更新范围",
    UpdatingWait: "数据更新中，请稍后...",
    Cancel: "取消",
    CoverageInteractionRateCol: "互动覆盖率",
    CoverageInteractionRateColAuth: "覆盖互动率（授权）",
    ReactionsLikesCol: "心情数/点赞数",
    SharesRetweetsCol: "分享次数/转发次数",
    PostClickCountCol: "帖子点击次数",
    PageViewsCol: "浏览量",
    PageVideoViewsCol: "主页视频观看次数",
    PagePostImpressionsCol: "主页帖子曝光次数",
    PageNegativeActionsCol: "主页消极操作次数",
    AvgPostInteractionsCol: "平均单帖互动数",
    AvgPostInteractionsAuthCol: "平均单帖互动数（授权）",
    AvgInteractionPer1KFollowersCol: "平均千粉互动数",
    AvgInteractionPer1KFollowersAuthCol: "平均千粉互动数（授权）",
    PageLikesPublicCol: "主页赞（公开）",
    PageLikesNetGrowthPublicCol: "主页赞净增长（公开）",
    PageLikesAuthCol: "主页赞（授权）",
    PageLikesNetGrowthAuthCol: "主页赞净增长（授权）",
    BrandCol: "品牌",
    PostContentCol: "帖子内容",
    PostTypeCol: "帖子类型",
    PostStatusCol: "帖子状态",
    PostTimeCol: "帖子时间",
    PostTimeBeijingCol: "发帖时间（北京时间）",
    PostTimePacificCol: "发帖时间（太平洋）",
    PostTimeUTCCol: "帖子时间（UTC）",
    PostViewsCol: "浏览量",
    InteractionCountCol: "互动次数",
    LikesCol: "点赞数",
    // X 平台将 like_count 称为“喜欢数”，单独保留键避免影响其他平台的点赞指标。
    LikesXCol: "喜欢数",
    CommentsCol: "评论数",
    SharesCol: "分享数",
    ImpressionsCol: "曝光次数",
    ReachCol: "覆盖人数",
    ReachInteractionRateCol: "覆盖互动率",
    TotalWatchTimeCol: "视频观看总时长",
    AvgWatchTimeCol: "视频平均观看时长",
    VideoDurationCol: "视频时长",
    PositiveCommentsCol: "正面评论",
    NegativeCommentsCol: "负面评论",
    NeutralCommentsCol: "中立评论",
    OriginalStatusCol: "原创状态",
    RepliesCol: "回复数",
    RetweetsCol: "转发数",
    VideoViewsAuthCol: "视频观看次数（授权）",
    QuoteCountCol: "引用转发数",
    ImpressionsAuthCol: "曝光次数（授权）",
    ReachAuthCol: "覆盖人数（授权）",
    SharesAuthCol: "分享数（授权）",
    SavedCountAuthCol: "收藏次数（授权）",
    ExitCountAuthCol: "退出次数（授权）",
    ForwardCountAuthCol: "轻触前进次数（授权）",
    ReturnCountAuthCol: "轻触后退次数（授权）",
    PaidViewsCol: "付费浏览量",
    OrganicViewsCol: "自然浏览量",
    UniqueViewersAuthCol: "浏览人数（授权）",
    ClickPhotoViewAuthCol: "点击-图片浏览（授权）",
    ClickVideoPlayAuthCol: "点击-视频播放（授权）",
    ClickLinkAuthCol: "点击-链接点击（授权）",
    ClickOtherAuthCol: "点击-其他点击（授权）",
    // Facebook 的视频观看次数沿用平台 3 秒观看统计口径，仅调整界面展示名称。
    Views3SecCol: "视频观看次数",
    TotalWatchTimeAuthCol: "视频观看总时长（授权）",
    AvgWatchTimeAuthCol: "视频平均观看时长（授权）",
    VideoCompletionRateAuthCol: "视频完播率（授权）",
    Views30SecAuthCol: "观看达30秒次数（授权）",
    PositiveCommentsAuthCol: "正面评论数（授权）",
    NegativeCommentsAuthCol: "负面评论数（授权）",
    NeutralCommentsAuthCol: "中立评论数（授权）",
    // Facebook Page Detail
    FacebookHomepageDetail: "Facebook 主页详情",
    NeedAuthForPageViews: "查看主页浏览量，需先完成社交主页授权！",
    NeedAuthForViewersCount: "查看主页浏览人数，需先完成社交主页授权！",
    NeedAuthForVisits: "查看主页访问量，需先完成社交主页授权！",
    NeedAuthForInteraction: "查看千粉互动，需先完成社交主页授权！",
    NeedAuthForReactions: "查看帖子心情，需先完成社交主页授权！",
    NeedAuthForVideoViews: "查看视频播放次数，需先完成社交主页授权！",
    NeedAuthForVideoViews30s: "查看视频播放30秒次数，需先完成社交主页授权！",
    NeedAuthForVideoViews30sPosts: "查看观看达30秒次数，需先完成社交主页授权！",
    FacebookApiRangeTip: "Facebook 接口仅支持返回：当天、前一天、近 7 天和近 28 天四个时间范围",
    // 浏览人数和访问量标题右侧共用的接口限制说明，保持与页面可选范围一致。
    FacebookApiRangeNotice: "受 Facebook 数据接口限制，当前仅支持查看当天、前一天、近 7 天和近 28 天的数据",
    TimeDimension: "时间维度：",
    DataDimension: "数据维度：",
    DataDetail: "数据详情",
    ExportReport: "导出报表",
    TimeCol: "时间",
    PageViews: "浏览量",
    PageVisits: "访问量",
    ViewersCount: "浏览人数",
    PageEngagementCount: "主页互动次数",
    PostReactions: "帖子心情",
    PostReactionsPublic: "帖子心情（公开）",
    PostReactionsAuth: "帖子心情（授权）",
    Views3SecCountTitle: "视频观看次数",
    Views30SecCountTitle: "观看达30秒的次数",
    Views3SecCount: "视频观看次数",
    Views30SecCount: "观看达30秒次数",
    TypeCol: "类型",
    CountCol: "数量",
    ProportionCol: "占比",
    Today: "当天",
    PrevDay: "前一天",
    Last7Days: "近7天",
    Last28Days: "近28天",
    Day: "日",
    Week: "周",
    Month: "月",
    Total: "汇总",
    Paid: "付费",
    Organic: "自然",
    Social: "社交",
    PaidOrganic: "付费/自然",
    AutoClick: "自动/点击",
    Auto: "自动",
    Click: "点击",
    InteractionPer1K: "千粉互动数",
    EngagementCount: "互动次数",
    NewPageLikes: "新增主页赞",
    NetPageLikes: "净增主页赞",
    TotalPageLikes: "累计主页赞",
    NewPaidPageLikes: "新增付费主页赞",
    NewOrganicPageLikes: "新增自然主页赞",
    AvgInteraction: "平均互动数",
    MaxSingleDayInteraction: "单日最大互动数",
    MinSingleDayInteraction: "单日最小互动数",
    TotalInteraction: "互动总数",
    MaxSingleDayVisits: "单日最大访问量",
    MinSingleDayVisits: "单日最小访问量",
    TotalReactions: "心情总数",
    MaxSingleDayReactions: "单日最大心情数",
    MinSingleDayReactions: "单日最小心情数",
    TotalViewsTitle: "总浏览量",
    TotalViews3Sec: "汇总播放数",
    OrganicViews3Sec: "自然播放数",
    PaidViews3Sec: "付费播放数",
    AutoPlayViews3Sec: "自动播放数",
    ClickPlayViews3Sec: "点击播放数",
    MaxSingleDayViewers: "单日最大浏览人数",
    MinSingleDayViewers: "单日最小浏览人数",
    MoodLike: "赞",
    MoodLove: "大爱",
    MoodHaha: "笑趴",
    MoodWow: "哇",
    MoodAngry: "怒",
    MoodSad: "心碎",
    // Posts Page
    PostPublishedDate: "帖子发布日期",
    PostCreatedTime: "帖子发布时间",
    AuthPostEngagements: "帖子互动（授权）",
    AuthPostImpressions: "帖子浏览量（授权）",
    InteractionRateCol: "互动率",
    PostContent: "帖子内容",
    MediaType: "媒体类型",
    PostLink: "帖子链接",
    ViewCount: "观看次数",
    Search: "搜索",
    Reset: "重置",
    Export: "导出",
    HasLink: "有链接",
    NoLink: "无链接",
    Published: "已发布",
    Deleted: "已删除",
    // Fans page
    FansData: "粉丝数据",
    FansGrowth: "粉丝增长",
    FansDemographics: "粉丝画像",
    FansOverview: "粉丝概览",
    NewFans: "新增粉丝",
    NetFansGrowth: "净增粉丝",
    TotalFans: "累计粉丝",
    NewPaidFans: "新增付费粉丝",
    NewOrganicFans: "新增自然粉丝",
    AvgFans: "平均粉丝数",
    MaxSingleDayFans: "单日最大粉丝数",
    MinSingleDayFans: "单日最小粉丝数",
    TotalNewFans: "总新增粉丝",
    MaxSingleDayNewFans: "单日最大新增粉丝",
    MinSingleDayNewFans: "单日最小新增粉丝",
    GenderAge: "性别与年龄",
    TopCities: "热门城市",
    TopCountries: "热门国家/地区",
    Male: "男",
    Female: "女",
    Unknown: "未知",
    // Signal post page
    SignalPostList: "信号帖文列表",
    SignalPostDetail: "信号帖文详情",
    PostId: "帖子ID",
    ChannelName: "渠道名称",
    AccountName: "账号名称",
    // Signal post comments
    CommentsList: "评论列表",
    CommentContent: "评论内容",
    CommentTime: "评论时间",
    CommentSentiment: "评论情感",
    Positive: "正面",
    Negative: "负面",
    Neutral: "中立",
    ReplyTo: "回复给",
    Hashtags: "话题标签",
    Mentions: "提及",
    LinksInPost: "帖子链接",
    NoData: "暂无数据",
    Loading: "加载中...",
    LoadMore: "加载更多",
    AllLoaded: "已加载全部",
    NeedAuthForViews: "查看浏览量，需先完成社交主页授权！",
    NeedAuthForPostEngagements: "查看帖子互动数，需先完成社交主页授权！",
    NeedAuthForPostTrend: "查看发帖及帖子互动趋势，需先完成社交主页授权！",
    NeedAuthForReach: "查看帖文覆盖人数，需先完成社交主页授权！",
    NeedAuthForVideoViewers: "查看视频观看人数，需先完成社交主页授权！",
    NeedAuthForVideoWatchTime: "查看视频观看时长及播放方式，需先完成社交主页授权！",
    NeedAuthForCommentsTrend: "查看评论趋势，需先完成社交主页授权！",
    NeedAuthForClicks: "查看点击次数，需先完成社交主页授权！",
    PostInteractionCount: "帖子互动数",
    PostInteractionCountAuth: "帖子互动数（授权）",
    PostCount: "帖子数量",
    PostInteractionRate: "帖子互动率",
    PostInteraction: "帖子互动",
    PostsAndInteractionTrend: "发帖及互动趋势",
    ReachCoverage: "帖文覆盖人数",
    VideoViewers: "视频观看人数",
    VideoWatchTimeAndMethod: "视频观看时长及播放方式",
    CommentsTrend: "评论趋势",
    ClickCount: "点击次数",
    PostsPublished: "帖文发布数",
    PublishedPosts: "发布帖文数",
    AvgPostsPublished: "平均发布帖文数",
    MaxPostsPublished: "单日最多发布帖文数",
    MinPostsPublished: "单日最少发布帖文数",
    AvgInteractionRate: "平均互动率",
    MaxInteractionRate: "单日最高互动率",
    MinInteractionRate: "单日最低互动率",
    AvgImpressions: "平均浏览量",
    MaxImpressions: "单日最高浏览量",
    MinImpressions: "单日最低浏览量",
    AvgReach: "平均覆盖人数",
    MaxReach: "单日最高覆盖人数",
    MinReach: "单日最低覆盖人数",
    AvgVideoViews: "平均视频观看",
    MaxVideoViews: "单日最高视频观看",
    MinVideoViews: "单日最低视频观看",
    AvgWatchTime: "平均观看时长",
    MaxWatchTime: "单日最高观看时长",
    MinWatchTime: "单日最低观看时长",
    AvgComments: "平均评论数",
    MaxComments: "单日最高评论数",
    MinComments: "单日最低评论数",
    AvgClicks: "平均点击数",
    MaxClicks: "单日最高点击数",
    MinClicks: "单日最低点击数",
    InteractionTrend: "互动趋势",
    ExposureTrend: "浏览量趋势",
    NetFansGrowthTrend: "净增粉丝趋势",
    NewFansTrend: "新增粉丝趋势",
    NeedAuthForFansTrend: "查看粉丝趋势，需先完成社交主页授权！",
    NeedAuthForCountryDistribution: "查看国家分布，需先完成社交主页授权！",
    NeedAuthForCityDistribution: "查看城市分布，需先完成社交主页授权！",
    NeedAuthForLanguageDistribution: "查看语言分布，需先完成社交主页授权！",
    NewFansCount: "新增粉丝数",
    NetFansCount: "净增粉丝数",
    TotalFansCount: "累计粉丝数",
    NetFansCountAuth: "净增粉丝数（授权）",
    TotalFansCountAuth: "累计粉丝数（授权）",
    FansTrend: "粉丝趋势",
    CountryDistribution: "国家分布",
    CityDistribution: "城市分布",
    LanguageDistribution: "语言分布",
    AgeDistribution: "年龄分布",
    GenderDistribution: "性别分布",
    LgCodeCount: "频道数",
    AccountCount: "账号数",
    FansOverviewTitle: "粉丝概览",
    Day: "日",
    Week: "周",
    Month: "月",
    PublicData: "公开数据",
    AuthData: "授权数据",
    AvgInteractions: "平均互动数",
    MaxInteractions: "单日最大互动数",
    MinInteractions: "单日最小互动数",
    AvgPosts: "平均发布数",
    MaxPosts: "单日最大发布数",
    MinPosts: "单日最小发布数",
    AvgExposure: "平均曝光数",
    MaxExposure: "单日最大曝光数",
    MinExposure: "单日最小曝光数",
    AvgReachCount: "平均覆盖数",
    MaxReachCount: "单日最大覆盖数",
    MinReachCount: "单日最小覆盖数",
    AvgTopics: "平均话题数",
    MaxTopics: "单日最大话题数",
    MinTopics: "单日最小话题数",
    AvgSaved: "平均收藏数",
    MaxSaved: "单日最大收藏数",
    MinSaved: "单日最小收藏数",
    AvgViews: "平均观看数",
    MaxViews: "单日最大观看数",
    MinViews: "单日最小观看数",
    AvgCommentsCount: "平均评论数",
    MaxCommentsCount: "单日最大评论数",
    MinCommentsCount: "单日最小评论数",
    TotalExposure: "曝光总数",
    TotalExposureCount: "曝光总次数",
    TotalCoverage: "覆盖总数",
    TotalCoveragePeople: "覆盖总人数",
    TotalFollowing: "关注总数",
    NewFollowing: "新增关注数",
    LostFollowing: "取消关注数",
    NetFollowing: "净增关注数",
    TotalFollowers: "粉丝总数",
    NewFans: "新增粉丝",
    LostFans: "流失粉丝",
    NetFans: "净增粉丝",
    NewFansCountReal: "新增粉丝数",
    LostFansCount: "取消粉丝数",
    NetFansCount: "净增粉丝数",
    TotalFans: "累计粉丝数",
    OnlineUsers: "在线人数",
    AvgOnlineUsers: "平均在线人数",
    MaxOnlineUsers: "最大在线人数",
    MinOnlineUsers: "最小在线人数",
    SinglePostInteraction: "单帖互动",
    SingleCoverage: "单条覆盖",
    CompletionRate: "完播率",
    MaxCompletionRate: "单日最大完播率",
    MinCompletionRate: "单日最小完播率",
    TotalReplies: "回复总数",
    MaxReplies: "单日最大回复",
    MinReplies: "单日最小回复",
    TotalExits: "退出总数",
    MaxExits: "单日最大退出",
    MinExits: "单日最小退出",
    TotalCount: "全部次数",
    ImageCount: "图片次数",
    VideoCount: "视频次数",
    Image: "图片",
    Video: "视频",
    ReelsCount: "快拍数",
    ReelsExposureCount: "快拍曝光次数",
    TotalSaved: "收藏总人数",
    MaxSavedCount: "单日最大收藏数",
    MinSavedCount: "单日最小收藏数",
    ExposureCount: "曝光次数",
    ReachCount: "覆盖数",
    Reach: "覆盖人数",
    SavedCount: "收藏数",
    CommentsCount: "评论数",
    ImpressionsCount: "曝光数",
    TopicsCount: "话题数",
    TotalPosts: "发帖总数",
    TotalViews: "观看总数",
    TotalComments: "评论总数",
    NewComments: "新增评论",
    NewRetweets: "新增转发",
    NewLikes: "新增点赞",
    VideoPlayCount: "视频播放次数",
    CarouselAlbumInteractions: "轮播专辑互动次数",
    CarouselAlbum: "轮播专辑",
    InsTopicsUsedCount: "使用话题数量",
    InsTopicsUsedCountTip: "指定日期发布的帖文中使用话题标签（hashtag）的数量。",
    InsTopicsUsedTotal: "使用话题总数",
    InsPostInteractionTrend: "发帖及帖文互动趋势",
    InsPostInteractionTrendTip: "主页发布的帖文及帖文所获帖文互动的关联性变化。",
    InsPostExposureCountTip: "所选日期区间内， Instagram 照片、视频、动态或相册被看到的次数。",
    InsNeedAuthForPostExposure: "查看帖文曝光次数，需先完成社交主页授权！",
    InsPostCoverageCount: "帖文覆盖数",
    InsPostCoverageCountTip: "所选日期区间内，看到Instagram 照片、视频、动态或相册的用户数。",
    InsPostSavedCount: "帖文收藏数",
    InsPostSavedCountTip: "所选日期区间内，收藏Instagram 照片、视频、动态或相册的用户数。",
    InsNeedAuthForPostSaved: "查看帖文收藏数，需先完成社交主页授权！",
   InsCarouselAlbumTip: "轮播图相册的相关数据。",
   InsNeedAuthForCarouselAlbum: "查看轮播图相册，需先完成社交主页授权！",
   InsVideoWatchDataTip: "所选日期区间内，Instagram主页上的视频被观看的次数（不含轮播图中的视频）。",
   PostInteractionsCount: "帖文互动数",
   InsInteractionDetailTip: "公开数据：指定日期帖文{interactions} = 主页在指定日期所发帖文累计获得帖文互动次数 (点赞数+评论数), 按互动类型细分。如某个日期主页未发帖，则当日的帖文{interactions}为0 \n指定日期帖文{interactions} = 主页在指定日期所发帖文累计获得帖文互动次数 (点赞数+评论数+分享次数+收藏次数)，按互动类型细分。其中分享次数指标仅支持 Reels；如某个日期主页未发帖，则当日的帖文{interactions}为0",
   AuthViewInteractions: "查看帖文互动数，请先完成社交主页授权",
   InsInteractionTrendTip: "主页发布的帖文及帖文所获帖文互动的关联性变化。",
   AuthViewPostInteractionTrend: "查看发帖及帖文互动趋势，请先完成社交主页授权",
   InsHashtagTip: "指定日期发布的帖文中使用话题标签（hashtag）的数量。",
   AuthViewHashtag: "查看使用话题数量，请先完成社交主页授权",
   InsPostExposureCount: "帖文曝光次数",
   InsImpressionsTip: "所选日期区间内， Instagram 照片、视频、动态或相册被看到的次数",
   AuthViewImpressions: "查看帖文曝光次数，请先完成社交主页授权",
   InsReachTip: "所选日期区间内，看到Instagram 照片、视频、动态或相册的用户数。",
   AuthViewReach: "查看帖文覆盖数，请先完成社交主页授权",
   InsSavedTip: "所选日期区间内，收藏Instagram 照片、视频、动态或相册的用户数。",
   AuthViewSaved: "查看帖文收藏数，请先完成社交主页授权",
   InsCarouselAlbum: "轮播图相册",
   InsCarouselTip: "{carousel}图相册的相关数据。",
   InsShareCount: "分享次数",
   InsCollectionCount: "收藏",
   AuthViewCarousel: "查看轮播图相册数据，请先完成社交主页授权",
   InsVideoViewTip: "所选日期区间内，Instagram主页上的视频被观看的次数（不含{carousel}图中的视频）",
   AuthViewVideoViews: "查看视频观看次数，请先完成社交主页授权",
    XPostTypeTooltip: "帖子类型指用户发布推文的类型，包括发帖、转推及回复。发帖即社交主页发布的帖子；转推即社交号转发的帖子；回复即社交号对其他用户的回复。",
    XVideoPlayTooltip: "播放视频至少满3秒或几乎完整播放（如果视频的总时长不足3秒）的次数",
    XPostCreated: "发帖",
    XRetweeted: "转推",
    // X 主页详情页签明确为“帖子数据”，与同页“主页数据”“粉丝数据”保持一致。
    XPostData: "帖子数据",
    XPostsData: "帖子数据",
    XSinglePost: "单一帖子",
    XTotalPosts: "帖子总数",
    XPostCount: "帖子数",
    XPostInteractionCount: "帖子互动次数",
    XPostInteractionTrend: "帖子互动趋势",
    XPostInteractionTooltip:
      "公开数据：公开帖子{interaction} = 主页在指定日期所发帖子累计获得帖子{interaction}（心情+分享+评论），按互动类型细分。如某个日期主页未发帖，则当日的帖子{interaction}为0\n授权数据：授权帖子{interaction}= 主页在指定日期所发帖子截止日期累计获得帖子{interaction}（心情+分享+评论+帖子点击数），按互动类型细分。如某个日期主页未发帖，则当日的帖子{interaction}为0",
    XPostExposure: "帖子曝光",
    XPostType: "帖子类型",
    XPostStatus: "帖子状态",
    XPostContent: "帖子内容",
    XPostTimeBeijing: "帖子时间（北京时间）",
    XPostTimeUTC: "帖子时间（UTC）",
    XPostInteractionNum: "帖子互动数",
    XPostInteractionRatio: "帖子互动占比",
    XPostCountDailyTooltip: "所选日期区间内，主页每天发布的帖子条数。",
    XCommentSentimentTrendTooltip: "所选日期区间内，用户对帖子评论的正负向倾向走势",
    XSelectPostStatus: "请选择帖子状态",
    XSelectPostType: "请选择帖子类型",
    XEnterPostContent: "请输入帖子内容",
   InsNeedAuthForReelsCount: "查看快拍数，需先完成社交主页授权！",
    InsReelsExposureTip: "所选日期区间内，媒体文件的总浏览次数，若少于5将显示为0",
    InsNeedAuthForReelsExposure: "查看快拍曝光次数，需先完成社交主页授权！",
    ReelsCoveragePeople: "快拍覆盖人数",
    InsReelsCoverageTip: "所选日期区间内，查看快拍的独立用户总数，若少于5将显示为0。",
    InsNeedAuthForReelsCoverage: "查看快拍覆盖人数，需先完成社交主页授权！",
    ReelsSingleCoveragePeople: "单条覆盖人数",
    InsReelsSingleCoverageTip: "所选日期区间内，平均查看每个快拍的独立用户数。",
    InsNeedAuthForReelsSingleCoverage: "查看单条覆盖人数，需先完成社交主页授权！",
    ReelsCompletionRate: "快拍完播率",
    InsReelsCompletionRateTip: "用户查看快拍时未中断（退出、轻触前进、轻触返回）的浏览次数占比。快拍完播率=（曝光次数-退出-轻触前进-轻触返回）/ 曝光次数*100%；若为负数则显示为0%。",
    InsNeedAuthForReelsCompletionRate: "查看快拍完播率，需先完成社交主页授权！",
    ReelsRepliesCount: "回复次数",
    InsReelsReplyTip: "所选日期区间内，快拍收到的回复（评论）总数，若少于5将显示为0。该值不包括部分地区的用户做出的回复，包括：欧洲（从 2020 年 12 月 1 日开始）和日本（从 2021 年 4 月 14 日开始）。如果快拍由上述任一地区的用户创建，则回复次数为0。",
    InsNeedAuthForReelsReply: "查看回复次数，需先完成社交主页授权！",
    ReelsExitsCount: "退出次数",
    InsReelsExitTip: "所选日期区间内，用户退出快拍的次数，若少于5将显示为0。",
    InsNeedAuthForReelsExit: "查看退出次数，需先完成社交主页授权！",
    ForwardBackwardCount: "轻触前进/返回次数",
    PostInteractionTrend: "帖文互动趋势",
    ReelsViewTrend: "快拍观看趋势",
    ReelsReachTrend: "快拍覆盖趋势",
    ReelsCompletionTrend: "快拍完播趋势",
    ReelsReplyTrend: "快拍回复趋势",
    ReelsExitTrend: "快拍退出趋势",
    FansOnlineTrend: "粉丝在线趋势",
    AvgInteraction: "平均互动",
    MaxInteraction: "最大互动",
    MinInteraction: "最小互动",
    ImpressionsDetail: "曝光次数明细",
    ReachDetail: "覆盖数明细",
    ReelsExposureDetail: "快拍曝光次数明细",
    ReachPeopleDetail: "覆盖人数明细",
    SingleCoverageDetail: "单条覆盖人数明细",
    CompletionRateDetail: "完播率明细",
    ReplyCountDetail: "回复次数明细",
    ExitCountDetail: "退出次数明细",
    PostImpressionsDetail: "帖子曝光明细",
    PostReachDetail: "帖子覆盖明细",
    VideoViewsDetail: "视频观看明细",
    CommentsDetail: "评论明细",
    TopicsDetail: "话题数明细",
    SavedDetail: "收藏明细",
    AlbumDetail: "轮播专辑明细",
    ViewsDetail: "观看次数明细",
    ViewDetail: "观看明细",
    NewFansDetail: "新增粉丝明细",
    NetFansDetail: "净增粉丝明细",
    TotalFansDetail: "累计粉丝明细",
    FollowersDetail: "粉丝数明细",
    CountryDetail: "国家分布明细",
    CityDetail: "城市分布明细",
    LanguageDetail: "语言分布明细",
    OnlineUsersDetail: "在线人数明细",
    SignalPostDataDetail: "单帖数据明细",
    SignalPostCommentsDetail: "单帖评论明细",
    CarouselAlbumDetail: "轮播专辑明细",
    NeedAuthForInteractions: "查看互动数据，需先完成社交主页授权！",
    NeedAuthForFollowers: "查看粉丝数据，需先完成社交主页授权！",
    NeedAuthForOnlineUsers: "查看在线人数，需先完成社交主页授权！",
    NeedAuthForReels: "查看快拍数据，需先完成社交主页授权！",
    NeedAuthForPosts: "查看帖文数据，需先完成社交主页授权！",
    NeedAuthForSaved: "查看收藏数据，需先完成社交主页授权！",
    NeedAuthForAlbum: "查看轮播专辑数据，需先完成社交主页授权！",
    NeedAuthForExposure: "查看曝光数据，需先完成社交主页授权！",
    NeedAuthForCoverage: "查看覆盖数据，需先完成社交主页授权！",
    NeedAuthForVideoData: "查看视频数据，需先完成社交主页授权！",
    NeedAuthForComments: "查看评论数据，需先完成社交主页授权！",
    NeedAuthForTopics: "查看话题数据，需先完成社交主页授权！",
    MainPageInteraction: "主页互动",
    MainPageFollowers: "主页关注用户",
    MainPageExposure: "主页曝光",
    MainPageCoverage: "主页覆盖人数",
    FollowingCount: "频道关注数",
    MediaCount: "内容数量",
    PostData: "帖文数据",
    ReelsData: "快拍数据",
    CommentData: "评论数据",
    SignalPostData: "单帖数据",
    SignalPostComments: "单帖评论",
    Overview: "概览",
    FollowerProfile: "粉丝画像",
    FansOnline: "粉丝在线",
    VideoViewCount: "视频观看次数",
    FollowerInteractionRate: "粉丝互动率",
    QuoteRetweetCount: "引用转发数",
    Text: "文本",
    Combined: "组合",
    Link: "链接",
    Gif: "动图",
    Other: "其他",
    Original: "原创",
    Quote: "引用",
    DataOverview: "数据概览",
    PostInteractionRatio: "帖文互动占比",
    PostInteractionRatioTooltip: "不同互动类型占总互动的比例。",
    TotalInteractions: "互动总数",
    Like: "喜欢",
    Reply: "回复",
    Retweet: "转发",
    Reels: "Reels",
    SingletonInteractionTitle: "单帖互动",
    SingletonInteractionTooltip: "单帖互动数指平均每个帖文可获得的帖文互动数，即所选日期范围内的帖文互动数/所选日期范围内的帖文数。",
    InteractionPer1KTooltip: "千粉互动即指定日期平均每1000个粉丝产生的帖文互动次数。指定日期千粉互动(公开) = 主页在指定日期所发帖文累计获得帖文互动次数 (点赞数+评论数) / 发帖日期对应的主页粉丝数 x 1000。如某个日期主页未发帖，则当日的千粉互动数为0。",
    FollowingListTitle: "主页关注用户",
    FollowingListTooltip: "当前 X 平台主页正在关注的用户数。",
    ListedListTitle: "主页归属列表",
    ListedListTooltip: "当前 X 平台主页属于的列表的总数。属于的列表：当主页被某列表收录为成员时，则社交号属于该列表。",
    ListedTotal: "归属总数",
    ListedNew: "新增归属数",
    FollowingUserInfo: "关注用户信息",
    FollowingTime: "关注时间",
    UnfollowTime: "取关时间",
    BelongedList: "所属列表",
    JoinTime: "加入时间",
    RemoveTime: "移除时间",
    SingletonInteractionNum: "单帖互动数",
    NeedAuthTooltip: "授权后数据可见",
    SinglePostInteractionTitle: "单帖互动",
    SinglePostInteractionAuth: "查看单帖互动，需先完成社交主页授权！",
    FollowingUsersTitle: "主页关注用户",
    FollowingUsersTooltip: "Instagram 社交主页正在关注的用户数。",
    FollowingUsersAuthMsg: "查看主页关注数，需先完成主页授权",
    ExposureAuthTitle: "主页曝光-授权",
    ExposureAuthMsg: "查看主页曝光，需先完成主页授权",
    CoverageAuthTitle: "主页覆盖-授权",
    CoverageAuthMsg: "查看主页覆盖，需先完成主页授权",
    InteractionPer1KPublic: "千粉互动（公开）",
    InteractionPer1KAuth: "千粉互动（授权）",
    SinglePostInteractionPublic: "单帖互动（公开）",
    SinglePostInteractionAuth: "单帖互动（授权）",
    TotalFollowingUsers: "主页关注用户总数",
    NewFollowingUsers: "主页新增用户数",
    NetFollowingUsers: "主页净增关注用户数",
    ExposureAuthCol: "主页曝光（授权）",
    CancelFollowing: "取消关注",
    NetFollowing: "净增关注",
    TotalCoverage: "覆盖总数",
    SinglePostInteractionTooltip: "指定日期单帖互动数(公开) = 主页在指定日期所发帖文累计获得公开互动次数 (点赞数+评论数) / 指定日期的发帖数。如某个日期主页未发帖，则当日的帖文互动数为0。",
    Exposure: "曝光",
    Coverage: "覆盖",
    FollowersCol: "粉丝",
    FansCol: "粉丝",
 
    CarouselType: "轮播",
    StoryType: "快拍",
    UpvoteType: "顶",
    DownvoteType: "踩",
    ShareType: "分享",
    CommentType: "评论",
    LikeType: "点赞",
    TipLabel: "提示",
    ConfirmLabel: "确认",
    TranslateBtn: "翻译",
    DownloadLink: "下载链接",
    GoToVideoDetails: "前往视频详情",
    LikesCount: "喜欢数",
    RepostsCount: "转推数",
    ReactionsCount: "表情数",
    DislikesCount: "点踩数",
    InteractionsCount: "互动数",
    PostsCountLabel: "帖文数",
    TotalPostsCount: "帖文总数",
    VideosCount: "视频数",
    ViewsCount: "观看数",
    PostContentLabel: "贴文内容",
    PostTypeLabel: "贴文类型",
    PostTimeLabel: "贴文时间",
    PostInteractionRateLabel: "帖文互动率",
    InteractionRateAuthLabel: "互动率（授权）",
    ViewInteractionRateLabel: "浏览互动率",
    TotalInteractionsCount: "互动总次数",
    VideoInteractionsCount: "视频互动数",
    VideoPlayLabel: "视频播放",
    TotalWatchTime: "总观看时长",
    TotalViewersCount: "观看总人数",
    TotalViewsCount: "观看总次数",
    ViewsAndInteractionRate: "观看次数及观看互动率",
    ViewsAndCompletionRate: "观看次数及视频完播率",
    LostFollowersCount: "流失粉丝数",
    NewVideosCount: "新增视频",
    TotalVideosCount: "视频总数",
    TotalVideoDurationLabel: "视频总时长",
    TotalSavedCount: "收藏总数",
    HashtagsUsedCount: "使用话题数",
    CommentCountLabel: "评论次数",
    StatusNormal: "正常",
    StatusPaid: "已付费",
    StatusReplied: "已回复",
    StatusNotReplied: "未回复",
    SentimentNeutral: "中性",
    PositiveCommentsCount: "正面评论数",
    NegativeCommentsCount: "负面评论数",
    NeutralCommentsCount: "中立评论数",
    AllComments: "全部评论",
    ReplyStatusLabel: "回复状态",
    PostExposureAuth: "帖文曝光（授权）",
    PostReachAuth: "帖文覆盖（授权）",
    PostSavedAuth: "帖文收藏（授权）",
    NeutralCommentsAuth: "中性评论数（授权）",
    TotalCommentsAuth: "评论总数（授权）",
    SavedAuth: "收藏（授权）",
    AuthVisibleTip: "授权后数据可见",
    CreationPostCountCol: "发帖数",
    RepliesCountCol: "回复数",
    ReactionsCountCol: "心情数",
    ReactionsCountColAuth: "心情数（授权）",
    ClickCountColAuth: "点击数（授权）",
    FollowerInteractionRateCol: "粉丝互动率",
    FollowerInteractionRateColAuth: "粉丝互动率（授权）",
    InteractionPer1KCol: "千粉互动数",
    InteractionPer1KColAuth: "千粉互动数（授权）",
    PostImpressionsCol: "浏览量",
    PostImpressionsPaidCol: "付费浏览量",
    PostImpressionsOrganicCol: "自然浏览量",
    ExposureInteractionRateCol: "曝光互动率",
    ExposureInteractionRateColAuth: "曝光互动率（授权）",
    PhotoClickColAuth: "点击-图片浏览（授权）",
    VideoClickColAuth: "点击-视频播放（授权）",
    LinkClickColAuth: "点击-链接点击（授权）",
    OtherClickColAuth: "点击-其他点击（授权）",
    VideoViewsCol: "视频观看次数",
    VideoViewsColAuth: "视频观看次数（授权）",
    VideoPaidViewsColAuth: "付费观看次数（授权）",
    VideoOrganicViewsColAuth: "自然观看次数（授权）",
    VideoUniqueViewersColAuth: "视频观看人数（授权）",
    VideoPaidUniqueViewersColAuth: "付费观看人数（授权）",
    VideoOrganicUniqueViewersColAuth: "自然观看人数（授权）",
    VideoTotalWatchTimeColAuth: "视频观看总时长（授权）",
    VideoAvgWatchTimeColAuth: "视频平均观看时长（授权）",
    VideoCompletionRateColAuth: "视频完播率（授权）",
    Video30sViewsColAuth: "观看达30秒次数（授权）",
    PositiveCommentsCol: "正面评论",
    NegativeCommentsCol: "负面评论",
    NeutralCommentsCol: "中立评论",
    PositiveCommentsColAuth: "正面评论数（授权）",
    NegativeCommentsColAuth: "负面评论数（授权）",
    NeutralCommentsColAuth: "中立评论数（授权）",
    SharesCountColAuth: "分享（授权）",
    CarouselAlbumViewsColAuth: "轮播图相册-曝光次数（授权）",
    CarouselAlbumReachColAuth: "轮播图相册-覆盖人数（授权）",
    CarouselAlbumSavedColAuth: "轮播图相册-收藏人数（授权）",
    ViewInteractionRateCol: "观看互动率",
    CompletionRateCol: "视频完播率",
    ReachInteractionRateCol: "覆盖互动率",
    TotalWatchTimeCol: "视频观看总时长",
    AvgWatchTimeCol: "视频平均观看时长",
    // Facebook 数据详情列说明
    PostCountColDesc: "所选日期区间内，主页每天发布的帖子条数。",
    PostInteractionCountColDesc: "帖子互动数 = 主页在指定日期所发帖文累计获得帖文互动数（心情+分享+评论）。",
    ReactionsCountColDesc: "把点赞、爱心、哇喔、哈哈、心碎、愤怒全部情绪反应，按类型分别统计并合计汇总。",
    CommentsCountColDesc: "帖子获得的全部评论数。",
    SharesCountColDesc: "帖子被分享的次数。",
    ClickCountColAuthDesc: "用户点击帖子任意位置的次数。",
    FollowerInteractionRateColDesc: "粉丝互动率 = 帖子公开互动次数（心情数 + 评论数 + 分享次数）/ 发帖日期公开的粉丝数 × 100%。",
    FollowerInteractionRateColAuthDesc: "粉丝互动率(授权) = 帖子授权互动次数（心情数 + 评论数+ 分享次数 ）/ 发帖日期授权的粉丝数× 100%。",
    InteractionPer1KColDesc: "千粉互动 = 帖子公开互动次数 (心情数+ 评论数 + 分享次数）/ 发帖日期公开的粉丝数 × 1000。",
    InteractionPer1KColAuthDesc: "千粉互动 (授权) = 帖子授权互动次数（心情数 + 评论数 + 分享次数 ）/ 发帖日期授权的粉丝数× 1000。",
    PostImpressionsColDesc: "在时间范围内，你发布的内容被播放或展示的次数。内容包括视频、帖子、动态和广告。",
    PostImpressionsPaidColDesc: "付费浏览量是指通过付费展示 (例如广告)，帖子展示给用户的次数。",
    PostImpressionsOrganicColDesc: "自然覆盖是指通过非付费展示，帖子展示给用户的次数。",
    ExposureInteractionRateColAuthDesc: "曝光互动率(授权) = 帖子授权互动次数（心情数 + 评论数 + 分享次数 + 点击次数 *）/ 曝光次数 * × 100%。",
    PhotoClickColAuthDesc: "点击查看图片的次数。",
    VideoClickColAuthDesc: "视频播放是指帖子中的视频被点击播放的次数。",
    LinkClickColAuthDesc: "链接点击是指帖子中的链接（可跳转至Facebook站内或站外的目标位置）的点击量。",
    OtherClickColAuthDesc: "点击帖子其他位置的次数。",
    VideoPaidViewsColAuthDesc: "视频付费观看次数是指播放推广视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数。",
    VideoOrganicViewsColAuthDesc: "视频自然观看次数是指在自然覆盖的用户播放视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数。",
    VideoUniqueViewersColAuthDesc: "视频观看人数是指观看视频至少满 3 秒或几乎完整观看（如果视频总时长不足 3 秒）的用户人数。",
    VideoPaidUniqueViewersColAuthDesc: "视频通过推广方式下，观看视频至少满 3 秒或几乎完整观看（如果视频总时长不足 3 秒）的用户人数。",
    VideoOrganicUniqueViewersColAuthDesc: "视频自然观看人数是指自然覆盖的用户观看视频至少满 3 秒或几乎完整观看（如果视频总时长不足 3 秒）的用户人数。",
    VideoTotalWatchTimeColAuthDesc: "视频播放的总时长。",
    VideoAvgWatchTimeColAuthDesc: "用户观看视频的平均时长。",
    Video30sViewsColAuthDesc: "视频观看达30秒的次数是指播放视频至少满30秒或几乎完整播放（如果视频的总时长不足30秒）的次数。",
    TotalCommentsColAuthDesc: "新发布的评论数量，不包含已经被用户删除的评论。",
    PositiveCommentsColAuthDesc: "表达满意、赞赏、喜爱或支持等积极情感的言论次数。",
    NegativeCommentsColAuthDesc: "表达不满、批评、厌恶或反对等消极情感的言论次数。",
    NeutralCommentsColAuthDesc: "不明显表示积极情感，也不明显表示消极情感的言论次数。",
    // TikTok 数据详情列说明
    NewVideosCountDesc: "所选日期内发布的视频数",
    InteractionsCountDesc: "所选日期内发布的视频的互动次数",
    LikesCountDesc: "所选日期内发布的视频的点赞数",
    CommentsCountDesc: "所选日期内发布的视频的评论数",
    SharesCountDesc: "所选日期内发布的视频的分享数",
    FollowerInteractionRateDesc: "粉丝互动率 = 视频公开互动次数 (点赞数 + 评论数 + 分享数) / 发帖日期的粉丝数 × 100%",
    VideoViewsColDesc: "所选日期发布的视频被观看的次数",
    ViewInteractionRateColDesc: "视频观看互动率 = 视频公开互动数（点赞数+评论数+分享数）/ 视频观看次数 x 100%",
    ExposureCountColDesc: "TikTok视频不支持曝光次数指标，为方便进行跨平台数据对比，取所选日期内发布视频观看次数作为曝光次数",
    ExposureInteractionRateColDesc: "曝光互动率= 视频公开互动次数（点赞数 + 评论数 + 分享数）/ 曝光次数 × 100%。取视频观看次数作为曝光次数",
    EmojiCommentCount: "表情评论数",
    RepostsCountCol: "转发数",
    BrandLabel: "所属品牌",
    IndustryLabel: "所属行业",
    RegionGroup: "地域群体",
    AboutPage: "关于主页",
    CreatedTime: "创建日期",
    ContactInfo: "联系信息",
    WebsiteLabel: "网站",
    PhoneLabel: "电话",
    EmailLabel: "邮箱",
    AddressLabel: "地址",
    GoTo: "去",
    Platform: "平台",
    GoToPlatform: "前往{platform}平台",
    NeedAuthForPostCount: "查看发帖数，请先完成社交主页授权",
    VideoWatchDurationTooltip: "视频播放的总时长及平均时长。",
    PostInteractionTooltip:
      "公开数据：公开帖文{interaction} = 主页在指定日期所发帖文累计获得帖文{interaction}（心情+分享+评论），按互动类型细分。如某个日期主页未发帖，则当日的帖文{interaction}为0\n授权数据：授权帖文{interaction}= 主页在指定日期所发帖文截止日期累计获得帖文{interaction}（心情+分享+评论+帖文点击数），按互动类型细分。如某个日期主页未发帖，则当日的帖文{interaction}为0",
    PostExposure: "帖文曝光",
    PostInteractionFormula: "帖子互动数 = 主页在指定日期所发帖文累计获得帖文互动数（心情+分享+评论）。",
    HeartsTotalTooltip: "帖子获得的心情总数。",
    CommentsTotalTooltip: "你的帖子被评论的次数。",
    SharesTotalTooltip: "你的帖子被分享的次数。",
    FollowerInteractionRateTooltip: "帖子互动数除以主页粉丝数的百分比。",
    TotalInteractionsTooltip: "所选日期区间内，主页发布帖子获取的互动总数。",
    TotalPostsTooltip: "所选日期区间内发布的帖子总条数。",
    TotalWatchTimeTooltip: "所选日期内，视频观看的总时长，重播也计算在内。",
    AvgWatchTimeTooltip: "所选日期内，视频的平均播放时长，包括单次展示时的重播时间。",
    TotalCommentsTooltip: "所选日期区间内，用户对帖子评论的总数。",
    PositiveCommentsColDesc: "表达满意、赞赏、喜爱或支持等积极情感的言论次数。",
    NegativeCommentsColDesc: "表达不满、批评、厌恶或反对等消极情感的言论次数。",
    NeutralCommentsColDesc: "不明显表示积极情感，也不明显表示消极情感的言论次数。",
    ClickTotalLabel: "点击总数",
    ClickTotalTooltip: "所选日期范围内，帖子内容被点击的次数。",
    ImageViewTooltip: "用户点击查看图片的次数。",
    VideoPlayTooltip: "用户点击播放视频的次数。",
    LinkClickTooltip: "用户点击帖子中链接的次数。",
    OtherClickTooltip: "其他类型的帖子点击次数。",
    ImageViewLabel: "图片浏览",
    CommentsInfo: "评论信息",
    OnlyAuthorizedComments: "仅支持查看授权主页的评论",
    AuthorizePage: "授权主页",
    ViewMoreReplies: "查看更多",
    ViewMoreRepliesCount: "共{count}条回复，查看更多",
    BasicInfo: "基本信息",
    CommentCount: "评论数",
    FanInteractionRate: "粉丝互动率",
    HeartsCountAuth: "心情数（授权）",
    LikeCount: "点赞数",
    LinkClickLabel: "链接点击",
    OtherClickLabel: "其他点击",
    OrganicImpressionsCount: "自然曝光数",
    PaidImpressionsCount: "付费曝光数",
    OrganicReachCount: "自然覆盖人数",
    PaidReachCount: "付费覆盖人数",
    OrganicViewsCount: "自然观看人数",
    PaidViewsCount: "付费观看人数",
    FollowerImpressionsCount: "粉丝曝光数",
    NonFollowerImpressionsCount: "非粉丝曝光数",
    PaidPromotion: "付费推广",
    NormalPromotion: "普通推广",
    LanguageChinese: "中文",
    LanguageSimplifiedChinese: "简体中文",
    LanguageTraditionalChinese: "繁体中文",
    CommentListFailed: "评论列表获取失败",
    GetDataFailed: "获取数据失败",
    DeleteFailed: "删除失败",
    ReplyFailed: "回复失败",
    ReplySuccess: "回复成功",
    TranslationFailed: "翻译失败",
    CancelTranslation: "取消翻译",
    NoDataAvailable: "目前尚未获取到对应的数据",
    EnterReplyContent: "请输入回复内容",
    EnterCommentContent: "请输入评论内容",
    EnterPostContent: "请输入帖文内容",
    SelectOriginalStatus: "请选择原创状态",
    SelectPostStatus: "请选择帖文状态",
    SelectPostType: "请选择帖文类型",
    SelectPromotionType: "请选择推广方式",
    SelectPaidStatus: "请选择付费情况",
    MissingParams: "缺少主页或帖子参数",
    DeleteCommentConfirm: "删除后该评论将无法恢复，是否确认删除？",
    AllCommentsWithCount: "所有评论（{count}条）",
    PacificTimeZone: "太平洋时间 (UTC -07:00)",
    AllCommentsFilter: "全部评论",
    // Facebook 单一帖子评论区的页签、筛选和时区文案随当前语言同步切换。
    FacebookPostDetailTabs: "帖子详情页签",
    FacebookPostDataTab: "帖子数据",
    FacebookCommentsInfoTab: "评论信息",
    FilterComments: "筛选评论",
    BeijingTimeZone: "北京时间 (UTC +08:00)",
    LanguageEnglish: "英语",
    FbPositiveComment: "正面评论",
    FbNegativeComment: "负面评论",
    FbNeutralComment: "中立评论",
    ReplyStatusFilter: "回复状态",
    RepliedStatus: "已回复",
    NotRepliedStatus: "未回复",
    ExportComments: "导出评论",
    CancelReply: "取消回复",
    Processing: "处理中",
    UnhideComment: "取消隐藏",
    CommentHiddenStatus: "当前评论已隐藏，用户不可见",
    Deleting: "删除中",
    Emoji: "表情",
    ExceedCharsLimit: "超出 {count} 个字符",
    NoCommentsData: "暂无评论数据",
    DataUpdatingTip: "数据更新中，请稍后...",
    DsInteractionCountLabel: "互动次数",
    DsReactionTotalLabel: "心情数",
    DsCommentsLabel: "评论数",
    DsSharesLabel: "分享数",
    DsPer1KInteractionsLabel: "千粉互动",
    DsFollowerInteractionRateLabel: "粉丝互动率",
    DsClickCountLabel: "点击数",
    DsImpressionsLabel: "曝光次数",
    DsReachCountLabel: "覆盖人数",
    DsImpInteractionRateLabel: "曝光互动率",
    DsReachInteractionRateLabel: "覆盖互动率",
    DsLikesLabel: "喜欢数",
    DsRepliesLabel: "回复数",
    DsRetweetsLabel: "转发数",
    DsViewsLabel: "查看数",
    DsThumbsUpLabel: "点赞数",
    DsShareCountLabel: "分享次数",
    DsSavedLabel: "收藏次数",
    DsVideoViewCountLabel: "视频观看次数",
    DsLikeCountLabel: "点赞次数",
    DsViewInteractionRateLabel: "观看互动率",
    DsAvgWatchTimeLabel: "视频平均观看时长",
    DsCompletionRateLabel: "视频完播率",
    DsYtLikeCountLabel: "点顶数",
    DsReactionsLabel: "表情回复数",
    DsVideoViewInteractionRateLabel: "视频观看互动率",
    DsInteractionTotalTip: "帖子获得的总互动次数",
    DsInteractionTotalAuthTip: "帖子获得的总互动次数（授权）",
    DsInteractionFbTip: "互动次数 = 心情数+评论数+分享数",
    DsReactionTotalTip: "对帖子表达了心情（“赞”、“大爱”、“笑趴”、“哇”、“心碎”或“怒” ）的唯一用户数，同一用户对帖子表达多个不同心情时，只计算1次",
    DsFollowerRateFbTip: "粉丝互动率 = 帖子公开互动次数（心情数 + 评论数 + 分享次数）/ 发帖日期公开的粉丝数 × 100%",
    DsInteractionAuthFbTip: "互动次数 (授权) = 心情数 + 评论数 + 分享次数 + 点击次数",
    DsClickCountTip: "用户点击帖子任意位置的次数",
    DsImpressionsTip: "帖子展示给用户的次数",
    DsReachCountTip: "看到了帖子的唯一用户人数",
    DsReachCountDotTip: "看到了帖子的唯一用户人数。",
    DsPer1KAuthFbTip: "千粉互动 (授权) = 帖子授权互动次数 （心情数 + 评论数 + 分享次数 + 点击次数 ）/ 发帖日期授权的粉丝数× 1000",
    DsFollowerRateAuthFbTip: "粉丝互动率(授权) = 帖子授权互动次数（心情数 + 评论数+ 分享次数 + 点击次数 ）/ 发帖日期授权的粉丝数× 100%",
    DsImpRateAuthFbTip: "曝光互动率(授权)  = 帖子授权互动次数（心情数 + 评论 数+ 分享次数+ 点击次数）/ 曝光次数 * × 100%",
    DsReachRateAuthFbTip: "覆盖互动率(授权)  = 帖子授权互动次数（心情数 + 评论数 + 分享次数 + 点击次数 *）/ 覆盖人数 * × 100%",
    DsLikesTip: "帖子获得的喜欢数",
    DsRepliesTip: "帖子获得的回复数",
    DsRetweetsTip: "帖子被转发的次数",
    DsPer1KXTip: "千粉互动 = 帖子公开互动次数 / 发帖日期的粉丝数 × 1000",
    DsFollowerRateXTip: "粉丝互动率 = 帖子公开互动次数 / 发帖日期的粉丝数 × 100%",
    DsImpRateXTip: "曝光互动率 = 帖子公开互动次数 / 查看数 × 100%",
    DsThumbsUpTip: "帖子获得的点赞数",
    DsPer1KIGTip: "千粉互动 = 帖子公开互动次数（点赞数 + 评论数）/ 发帖日期的粉丝数 × 1000",
    DsFollowerRateIGTip: "粉丝互动率 = 帖子公开互动次数（点赞数 + 评论数）/ 发帖日期的粉丝数 × 100%",
    DsInteractionIGAuthTip: "互动次数（授权）= 点赞数 + 评论数 + 分享次数 + 收藏次数，分享次数仅 Reels 类型有数据",
    DsSavedTip: "帖子被用户收藏的次数",
    DsPer1KIGAuthTip: "千粉互动  = 帖子授权互动次数 (点赞数 + 评论数 + 分享次数+ 收藏次数 ) / 发帖日期的粉丝数 × 1000，分享次数 *仅Reels类型有数据。",
    DsFollowerRateIGAuthTip: "粉丝互动率 = 帖子授权互动次数 (点赞数+评论数+分享次数+收藏次数) / 发帖日期的粉丝数 × 100%；分享次数 *仅Reels类型有数据。",
    DsImpRateIGAuthTip: "曝光互动率 = 帖子授权互动次数（点赞数 + 评论数 + 分享次数+ 收藏次数）/ 曝光次数 × 100%。对于 Reels，取播放次数作为曝光次数。分享次数仅Reels类型有数据。",
    DsReachRateIGAuthTip: "覆盖互动率 (授权) = 帖子授权互动次数 (点赞数 + 评论数 + 分享次数 + 收藏次数 ) / 覆盖人数 × 100%，分享次数仅Reels类型有数据。",
    DsInteractionTikTokTip: "互动次数 = 点赞次数 + 评论数 + 分享数",
    DsLikeCountTip: "帖子获得的点赞次数",
    DsPer1KTikTokTip: "千粉互动 = 视频互动次数（点赞数 + 评论数 + 分享数） / 视频发布日期的粉丝数 × 1000",
    DsFollowerRateTikTokTip: "粉丝互动率 = 视频公开互动次数（点赞数 + 评论数 + 分享数） / 发帖日期的粉丝数 × 100%",
    DsImpRateTikTokTip: "曝光互动率 = 视频公开互动次数（点赞数 + 评论数 + 分享数） / 曝光次数 × 100%，取视频观看次数作为曝光次数",
    DsViewRateTikTokTip: "视频观看互动率 = 视频公开互动次数（点赞数 + 评论数 + 分享数） / 视频观看次数 × 100%",
    DsReachRateTikTokTip: "覆盖互动率 = 视频公开互动次数（点赞数 + 评论数 + 分享数） / 覆盖人数 × 100%",
    DsAvgWatchTimeTip: "用户观看视频的平均时长",
    DsCompletionRateTip: "完整观看视频的次数占总观看次数的百分比",
    DsInteractionYtTip: "互动次数 = 点顶数 + 评论数",
    DsYtLikeCountTip: "视频获得的点顶总数",
    DsVideoCommentsTip: "视频获得的评论数",
    DsPer1KYtTip: "千粉互动 = 视频公开互动次数（点顶数 + 评论数） / 视频发布日期的频道订阅者数 × 1000",
    DsFollowerRateYtTip: "粉丝互动率 = 视频公开互动次数（点顶数 + 评论数） / 视频发布日期的频道订阅者数 × 100%",
    DsViewRateYtTip: "视频观看互动率 = 视频公开互动次数（点顶数 + 评论数） / 视频观看次数 × 100%",
    DsInteractionThreadsTip: "互动次数 = 表情回复数 + 评论数 + 分享数",
    DsReactionsTip: "使用表情进行评论的数量",
    DsPer1KThreadsTip: "千粉互动 = （表情回复数 + 评论数 + 分享数） / 发帖日期的粉丝数 × 1000",
    DsFollowerRateThreadsTip: "粉丝互动率 = 帖子公开互动次数（表情回复数 + 评论数 + 分享数） / 发帖日期的粉丝数 × 100%",
    VideoAddCount: "新增视频数",
    VideoTotalDuration: "视频总时长",
    YtVideoDataTooltip: "频道发布的视频数。",
    YtVideoDataTooltipDot: "频道在所选日期区间内发布的视频数。",
    VideoAdd: "新增视频",
    ViewsAddCount: "新增观看次数",
    ViewsTotalCount: "观看总次数",
    YtViewsTooltip: "频道获得的视频观看次数。",
    YtViewsTooltipDot: "频道在所选日期区间内新发布的视频所获得的观看次数。",
    // YouTube 视频互动卡片、趋势图和详情表统一使用完整指标名称，详情表提示明确列出四项互动构成。
    UpVote: "点赞数",
    DownVote: "不喜欢数",
    YtInteractionTooltip1: "频道在所选日期区间内发布的视频所获得的互动次数，即点赞数+不喜欢数+分享数+评论数。",
    YtInteractionTooltip2: "频道在所选日期区间内发布的视频所获得的互动次数，即：点赞数+不喜欢数+分享数+评论数",
    YtCommentTrendTooltip: "所选日期区间内，用户对帖文评论的正负向倾向走势",
    VideoWatchData: "视频观看",
    VideoInteractionData: "视频互动",
    CommentTrend: "评论趋势",
    VideoDurationCol: "视频时长",
    YtViewRateTooltip: "频道发布的视频及视频所获互动的关联性变化。",
    TableSummaryTotal: "总计",
    CommentTimeLaBeijing: "评论时间：太平洋 (UTC -07:00) {laTime} · 北京 {beijingTime}",
    CommentTimeBeijing: "评论时间：北京 {beijingTime}",
    CommentTimeLa: "评论时间：太平洋 (UTC -07:00) {laTime}",
    CommentTimeEmpty: "评论时间：-",
    ReplyToUser: "回复 @{name}",
    User: "用户",
    Translate: "翻译",
    ReplyExceedCharsLimit: "回复内容超出 {count} 个字符",
    DeleteSuccess: "删除成功",
    Tip: "提示",
    Confirm: "确认",
    PostCommentCountDesc: "帖子获得的评论数量",
    PostViewCountDesc: "帖子被查看的次数",
    PostCommentedCountDesc: "帖子被评论的次数",
    InteractionFormula1: "互动次数 = 点赞数 + 评论数 + 分享数",
    InteractionFormula2: "互动次数 = 表情评论数 + 评论数 + 分享数",
    PostInteractionTooltip: "帖子累计获得帖文互动数（心情+分享+评论+点击）。",
    ContentDisplayedTooltip: "你的内容被播放或展示的次数。内容包括视频、帖子、快拍和广告。",
    ContentReachTooltip: "看过你的内容至少一次的Meta账户数量。",
    VideoPlay3SecTooltip: "播放视频至少满3秒或几乎完整播放（如果视频的总时长不足3秒）的次数。",
    FbTextCountTooltip: "类型为纯文本的帖子数量。",
    FbImgCountTooltip: "包含图片的帖子数量。",
    FbVideoCountTooltip: "包含视频的帖子数量。",
    FbGroupCountTooltip: "包含多种媒体组合的帖子数量。",
    FbLinkCountTooltip: "包含链接的帖子数量。",
    FbReelsCountTooltip: "Reels 短视频帖子数量。",
    FbGifCountTooltip: "包含动图的帖子数量。",
    FbOtherCountTooltip: "其他类型的帖子数量。",
    FbFollowerNonFollower: "粉丝/非粉丝",
    FbPageViewsTooltip: "在时间范围内，你发布的内容被播放或展示的次数。内容包括视频、帖子、动态和广告。",
    FbPaidViewsTooltip: "付费浏览量是指通过付费展示 (例如广告)，帖子展示给用户的次数。",
    FbOrganicViewsTooltip: "自然覆盖是指通过非付费展示，帖子展示给用户的次数。",
    FbFollowerViewsTooltip: "你的内容被粉丝浏览的次数。",
    FbNonFollowerViewsTooltip: "你的内容被非粉丝浏览的次数。",
    FbTotalPlayCount: "播放总数",
    FbPaidViews3SecTooltip: "视频付费观看次数是指播放推广视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数。",
    FbOrganicViews3SecTooltip: "视频自然观看次数是指在自然覆盖的用户播放视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数。",
    FbAutoPlayViewsTooltip: "视频自动开始播放的次数。",
    FbClickPlayViewsTooltip: "用户主动点击播放视频的次数。",
    FbViews30SecTooltip: "视频播放时长达到30秒的次数。",
    FbPaidViews30SecTooltip: "播放推广视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。每一次视频展示均单独统计时长达标的观看量，且不计算任何视频重播时间。",
    FbOrganicViews30SecTooltip: "播放视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数，按自然覆盖人数细分。对于每次视频播放，我们不会计算任何视频重播时间。",
    FbAutoPlayViews30SecTooltip: "自动播放视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。",
    FbClickPlayViews30SecTooltip: "用户点击播放后，播放视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。",
    FbCompletionRateTooltip: "视频被完整播放到结束的比例。",
    FollowTrendTooltip: "关注主页的人数变化趋势。",
    SubscriberCountTooltip: "订阅频道的人数。",
    ChannelVideoCountTooltip: "频道发布的视频数。",
    ChannelVideoViewsTooltip: "频道获得的视频观看次数。",
    ChannelInteractionTooltip: "频道在所选日期区间内发布的视频所获得的互动次数，即顶+踩+评论，",
    PageInteractionsTooltip: "主页在所选日期区间内发布的帖文所获得的互动次数，即点赞+评论+分享。",
    StoryTapTooltip: "在快拍中点击查看下一个/上一个照片或视频的总次数，若少于5将显示为0。",
    StoryCountTooltip: "所选日期区间内，主页每天发布的快拍条数。",
    CommentSentimentTrendTooltip: "所选日期区间内，用户对帖文评论的正负向倾向走势",
    CommentSentimentTrendTooltip2: "所选日期区间内，用户对帖文评论的正负向倾向走势。",
    PostsPublishedTooltip: "所选日期区间内，主页发布的帖文数",
    PostsViewedTooltip: "所选日期区间内，发布的帖子被查看的次数。",
    FansOnlineHourlyTooltip: "所选日期区间内，在最近一周的各天 Instagram 用户的在线粉丝总数，按每小时细分。",
    FollowerCountryTooltip: "所选日期区间最后一日，粉丝所在的国家/地区。",
    VideoUniqueViewersTooltip: "所选日期发布的视频观看的唯一用户人数",
    NeutralCommentCountDesc: "所选日期发布视频的中立评论数",
    PositiveCommentCountDesc: "所选日期发布视频的正面评论数",
    TotalWatchTimeDesc: "所选日期发布视频的观看总时长",
    NegativeCommentCountDesc: "所选日期发布视频的负面评论数",
    AvgWatchTimeDesc: "用户观看所选日期视频的平均时长",
    NeedAuthForFollowerCountry: "查看粉丝国家分布，需先完成社交主页授权",
    NeedAuthForFollowerOnline: "查看粉丝在线时间，需先完成社交主页授权！",
    NeedAuthForFollowerAge: "查看粉丝年龄分布，需先完成社交主页授权！",
    NeedAuthForFollowerCount: "查看粉丝数，需先完成社交主页授权！",
    NeedAuthForTapCount: "查看轻触前进/返回次数，需先完成社交主页授权！",
    InteractionPer1KAuthFormula: "千粉互动(授权) = 帖子授权互动次数（心情数 + 评论数 + 分享次数 + 点击次数）/ 发帖日期授权的粉丝数 × 1000。",
    FollowerInteractionRateAuthFormula: "粉丝互动率(授权) = 帖子授权互动次数（心情数 + 评论数+ 分享次数 + 点击次数）/ 发帖日期授权的粉丝数× 100%。",
    ReachInteractionRateAuthFormula: "覆盖互动率 (授权) = 视频公开互动次数（点赞数 + 评论数 + 分享数）/ 覆盖人数 * × 100%",
    InteractionPer1KFormula: "千粉互动 = 视频互动次数（点赞数 + 评论数 +分享数）/ 视频发布日期的粉丝数 × 1000",
    VideoCompletionAuthFormula: "视频完播率(授权) = 视频观看达30秒的次数 / 视频观看次数 × 100%。",
    NewViewsCount: "新增观看数",
    NewViewsCountAlt: "新增观看次数",
    // TODO
 
    PostAndInteractionTrend: "发帖及帖子互动趋势",
    PostReachAuth2: "帖文覆盖人数-授权",
    PostExposureAuth2: "帖文曝光人数-授权",
    VideoViewsAndCompletionRate: "视频观看次数及视频完播率",
    VideoCompletionRateAuthLabel: "视频完播率授权",
    PaidImpressionTooltip: "通过付费展示（例如广告），你的任何公共主页帖子或快拍、或公共主页相关内容出现在用户设备屏幕中的次数。",
    OrganicImpressionTooltip2: "你的任意公共主页内容（不包括围绕你公共主页生成的带有社交信息的内容）出现在用户设备屏幕中的次数。",
    FollowerViewsLabel: "粉丝浏览量",
    FollowerViewsTooltip: "你的公共主页内容在屏幕上对已关注或赞你公共主页的帐户展示的次数。",
    NonFollowerViewsLabel: "非粉丝浏览量",
    NonFollowerViewsTooltip: "你的公共主页内容在屏幕上对未关注或赞你公共主页的帐户展示的次数。",
    Watch30Sec: "观看达30秒",
    PaidVideoImpressionTooltip: "通过付费展示，你的任何视频内容出现在用户设备屏幕中的次数。",
    VideoImpressionTooltip: "你的任意视频内容出现在用户设备屏幕中的次数。",
    PostReachUsersTooltip: "所选日期区间内，设备屏幕中出现过你的任意主页帖的用户人数",
    VideoViewerDefinitionTooltip: "视频观看人数是指观看视频至少满 3 秒或几乎完整观看（如果视频总时长不足 3 秒）的用户人数",
    ViewSourceLabel: "观看来源",
    PlayTriggerTypeLabel: "播放触发方式",
    Watch30SecComplete: "30秒/完整观看",
    ReplyToFollower: "回复粉丝",
    OverallDataLabel: "整体数据",
    Last24Hours: "近24个小时",
    CountryDistributionTooltip: "统计时间最后一天的，公共主页点赞用户人数，按国家/地区统计。系统只显示公共主页点赞人数最多的 45 个国家/地区。",
    CityDistributionTooltip: "所选日期区间最后一日，主页点赞用户的城市分布；仅显示人数最多的前45个城市。城市名称可能会以多语种显示。",
    AgeGenderDistributionLabel: "年龄和性别分布",
    OnlineFansPerHour: "每小时在线粉丝量",
    UserRetentionLabel: "用户留存",
    NewFollowersLabel: "新关注者",
    NetFollowerChange: "净增/净减粉丝数",
    DataTrendOverview: "数据趋势概览",
    PostEngagedUsers: "帖子互动人数",
    PostReachCount: "帖子覆盖人数",
    CommentSourceLabel: "评论的来源",
    CommentFilterLabel: "评论过滤",
    CommentInteractionFormula: "评论总互动次数 = 点赞数 + 评论数（含粉丝回复）+ 分享数",
    CommentEngagedFormula: "评论总互动人数 = 点赞人数 + 评论人数（含粉丝回复）+ 分享人数",
    CommentPercentageLabel: "评论占比",
    CommentSentimentDistribution: "评论情感分布",
    PostViewTooltip2: "所选日期范围内帖子被查看的次数。",
    PostInteractionTooltip2: "所选日期范围内帖子累计获得帖文互动数（心情+分享+评论+点击）。",
    ViewCompletionRateFormula: "观看完播率 = 30秒完整观看数 / 浏览人数。",
    VideoRetentionTooltip: "所选日期发布视频的用户留存率",
    PageIdLabel: "主页ID",
    PageNameLabel: "主页名称",
    PageFollowersCount: "主页粉丝数",
    PageLinkLabel: "主页链接",
    PageAvatarLabel: "主页头像",
    AuthorizationExpirationLabel: "授权到期时间",
    AuthorizationTypeLabel: "授权类型",
    PageAuthorizationLabel: "本页授权",
    DataFetchTimeLabel: "数据获取时间",
    CommentsAuth: "评论（授权）",
    CommentsPublic: "评论（公开）",
    TranslationNotSupported: "公开数据不支持翻译",
    ShowTranslation: "显示翻译",
    HideTranslation: "隐藏翻译",
    TranslatingStatus: "翻译中...",
    TranslatedStatus: "已翻译",
    OriginalLanguageLabel: "原始语言",
    TranslationLanguageLabel: "翻译语言",
    TranslatedContentLabel: "翻译内容",
    HideLabel: "隐藏",
    DeleteLabel: "删除",
    MoreLabel: "更多",
    ViewOriginalBtn: "查看原文",
    LoadingText: "正在加载...",
    NoMoreDataText: "没有更多数据",
    LoadFailedText: "加载失败",
    ClickToRetryText: "点击重试",
    CancelledStatus: "已取消",
    FilterLabel: "筛选",
    ClearLabel: "清空",
    CopyLinkBtn: "复制链接",
    OpenLinkBtn: "打开链接",
    PublishPostBtn: "发布帖子",
    NoCommentsText: "暂无评论",
    CommentDeletedText: "评论已删除",
    CommentHiddenText: "评论已隐藏",
    AuthorLabel: "作者",    DataDimensionColon: "数据维度：",
    CountryRegion: "国家/地区",
    FansCount: "粉丝数",
    Proportion: "占比",
    CountryRegionAndCity: "（国家/地区）和城市",
    Time: "时间",
    ActiveFansCount: "活跃粉丝数",
    AuthorizedDataVisible: "授权后数据可见",
    Language: "语言",
    NetFansGrowthTooltip: "选定时段内的关注次数减去取关次数。",
    NewFollowsTooltip: "公共主页的新增关注数。",
    UnfollowsTooltip: "在所选时段内取关你公共主页的账户中心账户数量。",
    ActiveFansTooltip: "在所选时段内有过互动行为的粉丝数量。",
    TotalFansFacebookTooltip: "你的 Facebook 公共主页或个人主页获得的粉丝人数。计算方式：Facebook 公共主页或个人主页创建至今所获得的关注次数减去取关次数。",
    LanguageDistributionTooltip: "所选日期区间最后一日，主页点赞用户的语言分布，基于用户访问 Facebook 时选择的默认语言设置。",
    PageLikesTotalTooltip: '所选日期区间内, 赞过公共主页的总人数变化趋势。对于全球页架构中的市场主页，授权后可在 "授权数据" 图表中查看市场主页自身的主页赞数。在未授权的情况下，仅可在 "公开数据" 图表中查看全球主页赞数',
    PageLikes: "主页赞",
    AuthorizedData: "授权数据",
    ProfileViews: "主页资料查看人数",
    ProfileViewsTooltip: "所选日期范围内，TikTok主页资料的查看人数趋势。此信息不适用于粉丝数少于100的社交号。",
    VideoInteractionsPer1000Tooltip: "平均每1000个订阅者产生的视频互动数，即所选日期范围内的视频互动数/所选日期范围内的订阅者数*1000。",
    InteractionProportion: "互动占比",
    PostDetail: "单帖详情",
    TwitterFollowersTrendTooltip: '所选日期区间内, 主页的关注者人数变化趋势。对于全球页架构中的市场主页，授权后可在 "授权数据" 图表中查看市场主页自身的关注者人数。在未授权的情况下，仅可在 "公开数据" 图表中查看全球关注者人数。',
    FansChangeTooltip: "所选日期范围内，粉丝变化的情况。",
    FacebookLoginNetworkError: "当前网络环境无法登录Facebook，请检查网络！",
    InstagramLoginNetworkError: "当前网络环境无法登录Instagram，请检查网络！",
    TikTokLoginNetworkError: "当前网络环境无法登录TikTok，请检查网络！",
    XLoginNetworkError: "当前网络环境无法登录X，请检查网络！",
    YouTubeLoginNetworkError: "当前网络环境无法登录YouTube，请检查网络！",
    TelegramLoginNetworkError: "当前网络环境无法登录Telegram，请检查网络！",
    MostInteractionsDayTooltip: "用户互动量最多的一天。",
    LeastInteractionsDayTooltip: "用户互动量最少的一天。",
    PostInteractionsTooltip: "用户通过点赞、评论和分享等方式与帖子互动的次数。",
    ThousandFanInteractionsTooltip: "千粉互动即指定日期平均每1000个粉丝产生的帖文互动数。指定日期千粉互动数 =（主页在指定日期所发帖文累计获得帖文互动数（心情+分享+评论）÷ 指定日期的粉丝数）x 1000。如某个日期主页未发帖，则当日的千粉互动数为0。",
    PageViewsTooltip: "登录和未登录用户查看主页的次数。",
    MostViewsDayTooltip: "访问量最多的一天。",
    LeastViewsDayTooltip: "访问量最少的一天。",
    PostReactionsTooltip: "公共主页帖每天获得的心情总数，按类型细分。",
    MostReactionsDayTooltip: "公共主页帖获得心情总数最多的一天。",
    LeastReactionsDayTooltip: "公共主页帖获得心情总数最少的一天。",
    PageLikesCountTooltip: "所选日期区间最后一日，赞过公共主页的人数。",
    PageLikesNetChangeTooltip: "主页赞总数净变化值（所选日期区间最后一日减去前一日的赞总数）。",
    PositiveCommentCol: "正面评论",
    NegativeCommentCol: "负面评论",
    NeutralCommentCol: "中立评论",
    TwitterFollowersTrendFullTooltip: "所选日期区间内, 主页的关注者人数变化趋势。对于全球页架构中的市场主页，授权后可在 \"授权数据\" 图表中查看市场主页自身的关注者人数。在未授权的情况下，仅可在 \"公开数据\" 图表中查看全球关注者人数。",
    ProfileViewsAuthorized: "主页资料查看人数（授权）",
    ContentCoverageTooltip: "看过你的内容至少一次的Meta 账户数量。内容包括 Reels、帖子、快拍、直播视频和广告。",
    ContentCoverageMostDayTooltip: "看过你的内容的Meta账户数量最多的一天",
    ContentCoverageLeastDayTooltip: "看过你的内容的Meta账户数量最少的一天",
    Video3SecViewsTooltip: "播放主页视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数。",
    AutoPlay3SecViewsTooltip: "自动播放主页视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数。",
    ClickPlay3SecViewsTooltip: "用户点击播放后，播放主页视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数。",
    Video30SecViewsTooltip: "播放主页视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。",
    PromotedVideo30SecViewsTooltip: "播放主页推广视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。",
    AutoPlay30SecViewsTooltip: "播放主页自动播放视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。",
    ClickPlay30SecViewsTooltip: "用户点击播放后，播放主页视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。",
    ReactionLike: "赞",
    ReactionWow: "哇",
    ReactionAngry: "怒",
    MaxDailyViews: "单日最大查看人数",
    MinDailyViews: "单日最小查看人数",
    OnlineTime: "在线时间",
    GoToAuth: "去授权",
    NeedAuthForGenderDistribution: "查看粉丝性别分布，需先完成社交主页授权！",
    NeedAuthForGenderDistributionShort: "查看粉丝性别分布，需先完成社交主页授权",
    NeedAuthForOnlineTime: "查看粉丝在线时间，需先完成社交主页授权",
    VideoViewsCount: "主页视频观看次数",
    VideoInteractionsTooltip: "所选日期范围内，社交号所有视频的互动次数趋势。互动包含点赞、评论、分享。",
    NeedAuthForVideoInteractions: "查看主页视频互动次数，需先完成社交主页授权！",
    VideoViewsAuthorized: "主页视频观看次数（授权）",
    VideoInteractionsAuthorized: "主页视频互动次数（授权）",
    CommentsCountAuthorized: "评论数（授权）",
    SharesCountAuthorized: "分享数（授权）",
    ProfileFollowers: "主页关注用户",
    ProfileLists: "主页归属列表",
    InteractionCountTooltip: "互动次数 = 点赞数 + 评论数 + 分享数",
    CommentCountTooltip: "帖子获得的评论数量",
    // 单一帖子详情的区块标题统一使用“帖子”，避免沿用旧版“贴文”用语。
    PostInteractionProportion: "帖子互动占比",
    YouTubePostInteractionDistribution: "帖子互动分布图",
    CumulativeFollowers: "累计粉丝",
    SinglePostInteractionCount: "单贴互动数",
    AvgVideoInteractionsTooltip: "平均每个视频可获得的视频互动数，即所选日期范围内的视频互动数/所选日期范围内的视频数。",
    ViewInteractionRate: "视频观看互动率",
    VideoDuration: "视频时长",
    ThousandFanInteractionsDetailTooltip: "千粉互动即指定日期平均每1000个粉丝产生的帖文互动数。指定日期千粉互动数 =（主页在指定日期所发帖文累计获得帖文互动数（心情+分享+评论）÷ 指定日期的粉丝数）x 1000。如某个日期主页未发帖，则当日的千粉互动数为0。",
    Video3SecOrganicTooltip: "播放主页视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数，按自然覆盖人数细分。",
    Video3SecPaidTooltip: "播放主页视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数，按付费覆盖人数细分。",
    Video30SecOrganicTooltip: "播放主页视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数，按自然覆盖人数细分。",
    ThousandFanInteractionsFormulaTooltip: "千粉互动 = 帖子公开互动次数 (心情数+ 评论数 + 分享次数）/ 发帖日期公开的粉丝数 × 1000",
    ThousandFanInteractionsAuthorized: "千粉互动（授权）",
    AvgThousandFanInteractionsTooltip: "平均每1000个粉丝产生的帖文互动数（授权）。",
    // Facebook 主页数据的浏览人数需要保留内容类型，避免与单一帖子去重浏览人数混淆。
    ContentViewsCountTooltip: "看过你的内容至少一次的 Meta 账户数量。内容包括 Reels、帖子、快拍、直播视频和广告。",
    AllReactionsTooltip: "把点赞、爱心、哇喔、哈哈、心碎、愤怒 全部情绪反应，按类型分别统计并合计汇总。",
    Video3SecViewsShortTooltip: "播放主页视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的次数",
    Video30SecViewsShortTooltip: "播放主页视频至少满 30 秒或几乎完整播放（如果视频总时长不足 30 秒）的次数。",
    NeedAuthForPageLikes: "查看主页赞，需先完成社交主页授权！",
    Year: "年",
    ParamError: "参数错误",
    NeedAuthForProfileViews: "查看主页资料查看人数，需先完成社交主页授权！",
    VideoInteractionsTrendTooltip: "所选日期范围内，社交号所有视频的互动次数趋势。互动包含点赞、评论、分享。",
    InteractionCountFormulaTooltip: "互动次数 = 点赞数 + 评论数 + 分享数",
    PostCommentCountTooltip: "帖子获得的评论数量",
    VideoInteractionsPer1000YT: "平均每1000个订阅者产生的视频互动数，即所选日期范围内的视频互动数/所选日期范围内的订阅者数*1000。",
    StatusDeleted: "已删除",
    FollowerCountFBTip: "截止所选日期区间的最后一日, Facebook公共主页的关注者人数，通过公开数据API获取。关注者人数是 Facebook API 新近支持的指标，为了便于统计分析，对于历史数据中空缺的关注者人数，取与之近似的 “主页赞数” 作为替代。",
    FollowerCountXTip: "截止所选日期区间的最后一日, X账号的关注者人数",
    FollowerCountIGTip: "截止所选日期区间的最后一日, Instagram账户的关注者人数",
    FollowerCountTikTokTip: "截止所选日期区间的最后一日, TikTok账号的关注者人数。",
    FollowerCountYTTip: "截止所选日期区间的最后一日, YouTube频道的订阅者人数。此数值四舍五入到前三位有效数字。",
    FollowerCountTGTip: "截止所选日期区间的最后一日，Telegram频道净增的订阅者人数",
    FollowerCountLinkedInTip: "截止所选日期区间的最后一日, Linkedin公司主页的关注者人数。",
    FollowerCountThreadsTip: "截止所选日期区间的最后一日, Threads账号的关注者人数。",
    FollowerNetGrowthFBTip: "所选日期区间内，Facebook公共主页净增的关注者人数，通过公开数据API获取。关注者人数是 Facebook API 新近支持的指标，为了便于统计分析，对于历史数据中空缺的关注者人数，取与之近似的 “主页赞数” 作为替代",
    FollowerNetGrowthXTip: "所选日期区间内，X账号净增的关注者人数。",
    FollowerNetGrowthIGTip: "所选日期区间内，Instagram账户净增的关注者人数。",
    FollowerNetGrowthTikTokTip: "所选日期区间内, TikTok账号净增的关注者人数。",
    FollowerNetGrowthYTTip: "所选日期区间内, YouTube频道净增的订阅者人数。",
    FollowerNetGrowthTGTip: "所选日期区间内, Telegram频道净增的订阅者人数。",
    FollowerNetGrowthLinkedInTip: "所选日期区间内，Linkedin公司主页净增的关注者人数。",
    FollowerNetGrowthThreadsTip: "截止所选日期区间的最后一日, Threads账号净增的关注者人数。",
    PostCountFBTip: "所选日期区间内，社交号发布的帖子 (含Reels，不含快拍) 数量。",
    PostCountXTip: "所选日期区间内，社交号发布的帖子（不含转发帖、回复帖）数量。",
    PostCountTikTokTip: "所选日期区间内，社交号发布的视频数量。",
    PostCountYTTip: "所选日期区间内，社交号发布的视频 (含Shorts) 数量。",
    PostCountTGTip: "所选日期区间内，在Telegram发布的帖子数量",
    // 社媒监控各平台统一以“帖子”描述发布内容，图表提示和筛选页面保持同一术语。
    PostCountLinkedInTip: "所选日期区间内，社交号发布的帖子数量。",
    InteractionFBTip: "互动次数 = 心情数 + 评论数 + 分享次数",
    InteractionXTip: "互动次数 = 喜欢数 + 回复数 + 转发次数",
    InteractionIGTip: "互动次数 = 点赞数 + 评论数\n因API限制，IG专业账户为自然数据，IG个人账户为自然和付费的总数据。",
    InteractionTikTokTip: "互动次数 = 点赞数 + 评论数 + 分享次数",
    // YouTube 列表页的互动指标统一计入点赞、不喜欢、分享和评论，三个比率提示沿用同一组成口径。
    InteractionYTTip: "互动次数 = 点赞数+不喜欢数+分享数+评论数",
    InteractionTGTip: "互动次数 = 表情数+评论数+转发数",
    InteractionLinkedInTip: "互动次数 = 心情数 + 评论数 + 转发次数",
    InteractionThreadsTip: "互动次数 = 点赞数 + 回复数 + 转发数",
    ImpressionsFBTip: "曝光次数指内容展示给用户的次数",
    ImpressionsXTip: "查看数指帖子被查看的次数。",
    ImpressionsIGTip: "曝光次数指帖子及快拍展示给用户的次数；对于 Reels，取播放次数作为曝光次数。",
    ImpressionsIGShortTip: "曝光次数指帖子及快拍展示给用户的次数；对于 Reels，取播放次数作为曝光次数",
    ImpressionsTikTokTip: "TikTok视频不支持曝光次数指标，为方便进行跨平台数据对比，取视频观看次数作为曝光次数。",
    ImpressionsTikTokShortTip: "TikTok视频不支持曝光次数指标，为方便进行跨平台数据对比，取视频观看次数作为曝光次数",
    ImpressionsTGTip: "帖子被浏览的次数",
    ImpressionsLinkedInTip: "曝光次数指帖子展示给用户的次数。",
    ImpressionsThreadsTip: "曝光次数指内容或视频展示给用户的次数。通过授权数据API获取。",
    ReachTip: "覆盖人数是指看到了帖子的唯一用户人数。",
    ReachShortTip: "覆盖是指看到了帖子的唯一用户人数",
    VideoViewsFBTip: "播放视频至少满3秒或几乎完整播放（如果视频的总时长不足3秒）的次数。",
    VideoViewsXTip: "视频在所有帖子中被观看的总次数。",
    VideoViewsIGTip: "视频被观看的次数。对不含视频的轮播图帖子此指标将会显示为0；对 Instagram Reels，其播放次数计为观看次数。播放次数是指播放时长至少 1 毫秒的视频会话次数，不包括重播。",
    VideoViewsShortTip: "视频被观看的次数",
    FollowerRateFBTip: "粉丝互动率 = 帖子公开互动次数（心情数 + 评论数 + 分享数）/ 发帖日期的公开粉丝数 × 100%。",
    FollowerRateXTip: "粉丝互动率 = 帖子公开互动次数（喜欢数 + 回复数 + 转发次数) / 发帖日期的粉丝数 × 100%。",
    FollowerRateIGTip: "粉丝互动率 = 帖子公开互动次数（点赞数 + 评论数) / 发帖日期的粉丝数 × 100%\n因API限制，IG专业账户为自然数据，IG个人账户为自然和付费的总数据。",
    FollowerRateTikTokTip: "粉丝互动率 = 视频公开互动次数 (点赞数 + 评论数 + 分享次数) / 发帖日期的粉丝数 × 100%。",
    FollowerRateYTTip: "粉丝互动率 = 视频公开互动次数（ 点赞数+不喜欢数+分享数+评论数）/ 发帖日期的粉丝数 * 100%",
    FollowerRateTGTip: "粉丝互动率 = 视频公开互动次数( 表情数+评论数+转发数) /发帖日期的粉丝数 * 100%",
    FollowerRateLinkedInTip: "粉丝互动率 = 帖子公开互动次数（心情数 + 评论数 + 转发次数) / 发帖日期的粉丝数 × 100%。",
    FollowerRateThreadsTip: "粉丝互动率 = 帖子公开互动次数（心情数 + 回复数 + 转发数）/ 发帖日期的粉丝数 × 100%。",
    ExposureRateFBTip: "曝光互动率 = 帖子授权互动次数（心情数 + 评论数 + 分享次数 + 点击次数*）/ 曝光次数* × 100%。",
    ExposureRateXTip: "曝光互动率 = 帖子公开互动次数（喜欢数 + 回复数 + 转发次数）/ 曝光次数 × 100%。",
    ExposureRateIGTip: "曝光互动率 = 帖子授权互动次数（点赞数 + 评论数 + 分享次数* + 收藏次数*）/ 曝光次数* × 100%。对于 Reels，取播放次数作为曝光次数。",
    ExposureRateTikTokTip: "曝光互动率 = 视频公开互动次数（点赞数 + 评论数 + 分享次数）/ 曝光次数 × 100%。取视频观看次数作为曝光次数。",
    ExposureRateYTTip: "曝光互动率 = 视频互动次数（ 点赞数+不喜欢数+分享数+评论数） / 曝光次数 * 100%",
    ExposureRateTGTip: "曝光互动率= 视频互动次数(表情数+评论数+转发数) / 曝光次数 * 100%",
    ExposureRateLinkedInTip: "曝光互动率 = 帖子授权互动次数（心情数 + 评论数 + 转发次数 + 点击次数*）/ 曝光次数* × 100%\n因 LinkedIn API 限制，带 * 的指标指仅包含自然数据",
    ExposureRateThreadsTip: "曝光互动率(授权) = 帖子公开互动次数（心情数 + 回复数 + 转发数）/ 帖子曝光次数* × 100%",
    ReachRateFBTip: "覆盖互动率 = 帖子授权互动次数（心情数 + 评论数 + 分享次数 + 点击次数*）/ 覆盖人数* × 100%。",
    ReachRateTGTip: "覆盖互动率 = 视频公开互动次数（点赞数 + 评论数 + 分享次数）/ 覆盖人数* × 100%。",
    ReachRateIGTip: "覆盖互动率 = 帖子授权互动次数（点赞数 + 评论数 + 分享次数* + 收藏次数*）/ 覆盖人数* × 100%；",
    ReachRateLinkedInTip: "覆盖互动率 = 帖子授权互动次数（心情数 + 评论数 + 转发次数 + 点击次数*）/ 覆盖人数* × 100%\n因 LinkedIn API 限制，带 * 的指标指仅包含自然数据。",
    ReactionsFBTip: "对帖子表达了心情（“赞”、“大爱”、“笑趴”、“哇”、“心碎”或“怒” ）的唯一用户数，同一用户对帖子表达多个不同心情时，只计算1次。",
    LikesXTip: "帖子获得的喜欢数。",
    LikesIGTip: "帖子获得的点赞数。因API限制，IG专业账户为自然数据，IG个人账户为自然和付费的总数据。",
    LikesTikTokTip: "视频获得的点赞数。",
    LikesYTTip: "视频获得的点赞数；点踩数指标自2021年12月13日起不再支持。",
    ReactionsTGTip: "帖子获得的心情数",
    CommentsFBTip: "帖子获得的评论数。",
    RepliesXTip: "帖子获得的直接回复数。",
    CommentsIGTip: "帖子获得的评论数。因API限制，IG专业账户为自然数据，IG个人账户为自然和付费的总数据。",
    CommentsShortTip: "帖子获得的评论数",
    SharesFBTip: "帖子被分享的次数。",
    RetweetsXTip: "帖子被转发的次数，包含引用转发的次数。",
    SharesShortTip: "帖子被分享的次数",
    SavedIGTip: "帖子被用户收藏的次数。",
    ClicksFBTip: "用户点击帖子任意位置的次数。",
    ViewRateTikTokTip: "TikTok：视频观看互动率 = 视频公开互动次数 (点赞数 + 评论数 + 分享次数) / 视频观看次数 × 100%",
    ViewRateYTTip: "YouTube：视频观看互动率 = 视频公开互动次数（点赞数 + 评论数) / 视频观看次数 × 100%",
    PageImpressionsFBTip: "任何公共主页内容或公共主页相关内容出现在用户设备屏幕中的次数。这包括公共主页上的帖子、快拍、广告，以及其他内容或信息。",
    PageImpressionsIGTip: "任何 Instagram 账户内容展示给用户的次数，不包括个人资料页面的浏览次数。",
    PageVideoViewsFBTip: "所选日期区间内，主页任何视频至少满 3 秒或几乎完整播放（如果视频总时长不足 3 秒）的总次数。",
    PageVideoViewsTikTokTip: "所选日期区间内，主页任何视频被观看的总次数。",
    PagePostImpressionsFBTip: "你的主页帖出现在用户设备屏幕中的次数。包括状态、照片、链接、视频等类型的帖子。",
    NegativeActionsFBTip: "用户执行消极操作的次数（例如：取消赞或隐藏帖子）。",
    AvgPostInteractionsTip: "所选日期区间内，发布的帖子平均获得的公开互动次数。计算公式为：总帖子互动次数 / 发帖数。",
    AvgPostInteractionsAuthTip: "所选日期区间内，发布的帖子平均获得的授权互动次数。计算公式为：总帖子互动次数 (授权) / 发帖数。",
    PerMilleFBTip: "千粉互动数 = 帖子公开互动次数 (心情数 + 评论数 + 分享次数) / 发帖日期的公开粉丝数 × 1000",
    PerMilleXTip: "千粉互动数 = 帖子互动次数（喜欢数 + 回复数 + 转发次数) / 发帖日期的粉丝数 × 1000",
    PerMilleIGTip: "千粉互动数 = 帖子公开互动次数 (点赞数 + 评论数) / 发帖日期的粉丝数 × 1000；因API限制，IG专业账户为自然数据，IG个人账户为自然和付费的总数据。",
    PerMilleTikTokTip: "千粉互动数 = 视频互动次数（点赞数 + 评论数 +分享次数）/ 视频发布日期的粉丝数 × 1000",
    PerMilleYTTip: "千粉互动数 = 视频互动次数（点顶数 + 点踩数 + 评论数）/ 视频发布日期的频道订阅者数 × 1000",
    PerMilleTGTip: "千粉互动数 = 帖子互动次数( 表情数+评论数+转发数) / 发帖日期的粉丝数 * 1000",
    PerMilleFBAuthTip: "千粉互动授权 (授权) = 帖子授权互动次数（心情数 + 评论数 + 分享次数 + 点击次数*）/ 发帖日期的授权粉丝数 × 1000。",
    PerMilleIGAuthTip: "千粉互动数 (授权) = 帖子授权互动次数（点赞数 + 评论数 + 分享次数* + 收藏次数* + 快拍回复数*）/ 发帖日期的粉丝数 × 1000",
    PageLikesFBTip: "截止所选日期区间的最后一日, Facebook公共主页的获赞数，通过公开数据API获取。",
    PageLikesNetGrowthFBTip: "所选日期区间内, Facebook公共主页净增的获赞数，通过公开数据API获取。",
    PageLikesFBAuthTip: "Facebook：截止所选日期区间的最后一日, Facebook公共主页的获赞数，通过授权数据API获取。",
    PageLikesNetGrowthFBAuthTip: "Facebook：所选日期区间内, Facebook公共主页净增的获赞数，通过授权数据API获取。",
    PostTypeFBTip: "帖子的类型包括：文本、图片、视频、链接、组合、Reels、动图、其他",
    PostTypeIGTip: "帖子的类型包括：图片、视频、轮播、Reels",
    PostStatusFBTip: "帖子的状态：已发布、已删除",
    PostStatusIGTip: "帖子当前的状态",
    PostTimeBeijingTip: "帖子发布的时间（北京时间）",
    PostTimePacificTip: "帖子发布的时间（太平洋时间）",
    PostImpressionsFBTip: "你的内容被播放或展示的次数。内容包括视频、帖子、快拍和广告。",
    PostInteractionsFBTip: "帖子累计获得帖子互动数（心情+分享+评论）。",
    PostReactionsFBTip: "把点赞、爱心、哇喔、哈哈、心碎、愤怒全部情绪反应，按类型分别统计并合计汇总。",
    PostSharesIGTip: "帖子被分享的次数,分享次数 *仅Reels类型有数据",
    FollowerRateFBSingleTip: "粉丝互动率 = 帖子公开互动次数（心情数 + 评论数 + 分享次数）/ 发帖日期公开的粉丝数 × 100%。",
    FollowerRateIGSingleTip: "粉丝互动率 = 帖子公开互动次数（点赞数 + 评论数) / 发帖日期的粉丝数 × 100%。",
    FollowerRateFBAuthSingleTip: "粉丝互动率(授权) = 帖子授权互动次数（心情数 + 评论数+ 分享次数 ）/ 发帖日期授权的粉丝数× 100%。",
    FollowerRateIGAuthTip: "粉丝互动率 = 帖子公开互动次数（点赞数 + 评论数) / 发帖日期的粉丝数 × 100%。因API限制，IG专业账户为自然数据，IG个人账户为自然和付费的总数据。",
    PerMilleFBSingleTip: "千粉互动 = 帖子公开互动次数 (心情数+ 评论数 + 分享次数）/ 发帖日期公开的粉丝数 × 1000。",
    PerMilleFBAuthSingleTip: "千粉互动 (授权) = 帖子授权互动次数（心情数 + 评论数 + 分享次数 ）/ 发帖日期授权的粉丝数× 1000。",
    PaidViewsFBTip: "付费浏览量是指通过付费展示 (例如广告)，帖子展示给用户的次数。",
    OrganicReachFBTip: "自然覆盖是指通过非付费展示，帖子展示给用户的次数。",
    UniqueViewsFBTip: "看过你的内容至少一次的Meta 账户数量。",
    ReachIGSingleTip: "覆盖是指看到了帖子的唯一用户人数。",
    ImageClicksFBTip: "用户点击查看图片的次数。",
    VideoClicksFBTip: "用户点击播放视频的次数。",
    LinkClicksFBTip: "用户点击帖子中链接的次数。",
    OtherClicksFBTip: "其他类型的帖子点击次数。",
    TotalWatchTimeFBTip: "视频播放的总时长。",
    AvgWatchTimeFBTip: "用户观看视频的平均时长。",
    VideoCompletionRateTip: "视频完播率(授权) = 视频观看达30秒的次数 * / 视频观看次数 * × 100%",
    Views30SecTip: "视频观看达30秒的次数是指播放视频至少满30秒或几乎完整播放（如果视频的总时长不足30秒）的次数。",
    AllCommentsFBTip: "帖子获得的全部评论数。",
    PositiveCommentsTip: "表达满意、赞赏、喜爱或支持等积极情感的言论次数。",
    NegativeCommentsTip: "表达不满、批评、厌恶或反对等消极情感的言论次数。",
    NeutralCommentsTip: "不明显表示积极情感，也不明显表示消极情感的言论次数。",
    PostDateTip: "帖子发布的日期",
    PerMilleTTTip: "千粉互动 = 视频互动次数（点赞数 + 评论数 +分享数）/ 视频发布日期的粉丝数 × 1000",
    InteractionTTCheckTip: "互动次数 = 点赞数 + 评论数 + 分享数",
    LikesTTShortTip: "视频获得的点赞数",
    FollowerRateTTTip: "粉丝互动率 = 视频公开互动次数 (点赞数 + 评论数 + 分享数) / 发帖日期的粉丝数 × 100%",
    ExposureRateTTTip: "曝光互动率= 视频公开互动次数（点赞数 + 评论数 + 分享数）/ 曝光次数 × 100%。取视频观看次数作为曝光次数",
    ReachRateTTTip: "覆盖互动率 (授权) = 视频公开互动次数（点赞数 + 评论数 + 分享数）/ 覆盖人数 * × 100%",
    ViewRateTTTip: "视频观看互动率 = 视频公开互动数（点赞数+评论数+分享数）/ 视频观看次数 x 100%",
    TotalWatchTimeShortTip: "视频播放的总时长",
    AvgWatchTimeShortTip: "用户观看视频的平均时长",
    VideoDurationTip: "视频的时间长度",
    PositiveCommentsTTTip: "视频的正面评论数",
    NegativeCommentsTTTip: "视频的负面评论数",
    NeutralCommentsTTTip: "视频的中立评论数",
    InteractionXCheckTip: "互动次数 = 喜欢数 + 回复数 + 转发数",
    LikesXShortTip: "帖子获得的喜欢数",
    RepliesXShortTip: "帖子获得的直接回复数",
    RetweetsXShortTip: "帖子获得的转发数，包含引用帖子的次数",
    ImpressionsXShortTip: "帖子被查看的次数",
    PerMilleXShortTip: "千粉互动 = 帖子公开互动次数（喜欢数 + 回复数 + 转发数）/ 发帖日期的粉丝数 × 1000",
    FollowerRateXShortTip: "粉丝互动率 = 帖子公开互动次数（喜欢数 + 回复数 + 转发数) / 发帖日期的粉丝数 × 100%",
    ExposureRateXShortTip: "曝光互动率 = 帖子公开互动次数（喜欢数 + 回复数 + 转发数）/ 曝光次数 × 100%，曝光次数是指查看数",
    QuoteCountXTip: "引用帖子指用户引用帖子的次数",
    PerMilleIGAuthShortTip: "千粉互动 (授权) = 帖子授权互动次数（点赞数 + 评论数 + 分享次数 * + 收藏次数 *）/ 发帖日期的粉丝数 × 1000",
    InteractionIGCheckTip: "互动次数 = 点赞数 + 评论数",
    LikesIGShortTip: "帖子获得的点赞数",
    CommentsIGShortTip: "帖子获得的评论数",
    ReachRateIGShortTip: "覆盖互动率 (授权) = 帖子授权互动次数 (点赞数 + 评论数 + 分享次数 * + 收藏次数 *) / 覆盖人数 * × 100%，分享次数 *仅Reels类型有数据",
    // TikTok 监控页的帖子相关文案统一使用“帖子”，与 INS 和 YouTube 的页面称谓保持一致。
    TikTokHomepageDetail: "TikTok 主页详情",
    TikTokMainData: "主页数据",
    TikTokFansData: "粉丝数据",
    TikTokSignalPostTab: "单一帖子",
    TikTokPacificTime: "太平洋时间（UTC + 00:00）",
    TikTokNeedAuthDesc: "查看数据，需先完成社交主页授权！",
    TikTokGoAuthorize: "去授权",
    // YouTube 新版详情页复用 TikTok / INS 容器，单独维护页签和时区文案以支持语言切换。
    YouTubeHomepageDetail: "YouTube 主页详情",
    YouTubeMainData: "主页数据",
    YouTubeFansData: "粉丝数据",
    YouTubeVideosData: "视频数据",
    // YouTube 粉丝和视频页共用此标题，避免误显示为仅当前页数据的“数据详情”。
    YouTubeDataSummaryTable: "数据汇总表",
    YouTubeSignalPostTab: "单一帖子",
    YouTubePacificTime: "太平洋时间（UTC - 07:00）",
    YouTubeNeedAuthForModule: "查看{title}，需先完成社交主页授权！",
    // YouTube 粉丝页按新版 Figma 展示四项订阅指标和可切换的数据趋势。
    YouTubeFansCount: "粉丝数",
    YouTubeFansTrend: "粉丝数趋势图",
    YouTubeNewFansTip: "所选日期范围内频道新增的订阅者数量。",
    YouTubeLostFansTip: "所选日期范围内取消订阅频道的人数。",
    YouTubeNetFansTip: "所选日期范围内新增订阅者数减去流失订阅者数。",
    YouTubeTotalFansTip: "截至当前统计日期，频道累计拥有的订阅者数量。",
    TikTokNeedAuthForInteractionPer1K: "查看千粉互动数，需先完成社交主页授权！",
    TikTokNeedAuthForInteractionCount: "查看互动次数，需先完成社交主页授权！",
    TikTokNeedAuthForInteractionTrend: "查看互动次数及粉丝互动率趋势，需先完成社交主页授权！",
    TikTokNeedAuthForCoverage: "查看覆盖人数，需先完成社交主页授权！",
    TikTokNeedAuthForVideoWatchTime: "查看视频观看时长，需先完成社交主页授权！",
    TikTokNeedAuthForTrafficSource: "查看视频流量来源，需先完成社交主页授权！",
    TikTokNeedAuthForViewerSource: "查看观众来源，需先完成社交主页授权！",
    TikTokInteractionFanRateTrend: "互动次数及粉丝互动率趋势",
    TikTokInteractionFanRateTrendTip: "互动次数及粉丝互动率的趋势",
    TikTokVideoViewsInteractionTrend: "视频观看及互动趋势",
    TikTokVideoViewsInteractionTrendTip: "所选日期范围内，视频被观看的信息。",
    TikTokViewsInteractionTrend: "观看次数及互动趋势",
    TikTokExposureCount: "曝光次数",
    TikTokExposureCountTip: "TikTok视频不支持曝光次数指标，为方便进行跨平台数据对比，取视频观看次数作为曝光次数。",
    TikTokReachTip: "覆盖是指看到了帖子的唯一用户人数。",
    TikTokVideoWatchTime: "视频观看时长",
    TikTokWatchTimeTip: "视频播放的总时长及平均时长。",
    TikTokVideoTrafficSource: "视频流量来源",
    TikTokTrafficSourceTip: "视频的观看来源。",
    TikTokViewerSource: "观众来源",
    TikTokTrendChartLabel: "趋势图：",
   TikTokSourceTypeCol: "来源类型",
   TikTokPublishVideosTitle: "发视频数",
   TikTokVideoTrendTip: "所选日期范围内，发布{video}的趋势。",
   TikTokAuthViewVideoCount: "查看发视频数，需先完成社交主页授权！",
   TikTokNeedAuthForVideoInteractionTrend: "查看视频观看及互动趋势，需先完成社交主页授权！",
   TikTokNeedAuthForExposure: "查看曝光次数，需先完成社交主页授权！",
   TikTokViewsAndInteractionRate: "观看次数及观看互动率",
   TikTokViewsAndCompletionRate: "观看次数及视频完播率",
   TikTokCreativePreferences: "创作偏好",
   TikTokTopHashtags: "使用最多的话题标签",
   TikTokHashtagCol: "标签",
   TikTokUsageCountCol: "使用次数",
   TikTokTopSounds: "使用最多的声音",
   TikTokNameCol: "名称",
   TikTokVideoReleaseDuration: "视频发布时长",
   TikTokTopMentionedUsers: "提及最多用户",
   TikTokMentionedUserCol: "用户名称",
   TikTokVideoReleaseTimeSlot: "视频发布时段",
   TikTokTopUrls: "提及最多的URL",
   TikTokUrlCol: "URL",
   TikTokSourceName: "来源",
   TikTokViewerCount: "查看人数",
   VideoAvgDurationMin: "视频平均时长(min)",
   VideoTotalWatchDurationMin: "视频观看总时长(min)",
   TikTokMostActiveTime: "最活跃时段",
    TikTokActiveTimeTrend: "活跃时段趋势图",
    TikTokActivePeak: "你的大多数粉丝在 {time} 最活跃",
    TikTokActivePeakEn: "Your followers are most active at {time}",
    TikTokActiveFollowers: "活跃粉丝数",
    TikTokHourUnit: "时",
    TikTokDayUnit: "天",
   TikTokMonthDay: "{month}月{day}日",
   TikTokYearMonthDay: "{year}年{month}月{day}日",
   MonthDayFormat: "{month}月{day}日",
    Authorizing: "正在与 YouTube 授权",
    AuthProcessing: "请稍候，我们正在处理您的授权请求...",
    AuthCodeNotFound: "未找到授权码，请重新尝试授权。",
    AuthSuccessTip: "您已成功授权我们访问您的 YouTube 账户。",
    AuthNetworkError: "网络错误，请检查您的网络连接并重试。",
    AuthSuccess: "授权成功",
    AuthFailed: "授权失败",
    CloseWindow: "关闭窗口",
    Retry: "重 试",
    TotalSocialAccounts: "总计：{count}个社交号",
    PlatformDataDetail: "平台 数据详情",
    NoSocialAccountData: "暂无社交号数据",
    TotalInteractionCount: "互动总次数",
    TotalInteractionTip: "主页在所选日期区间内发布的帖子所获得的互动次数，即点赞+评论+分享。",
    CommentTrendTip: "所选日期区间内，用户对帖子评论的正负向倾向走势",
    ViewsTip: "所选日期区间内，发布的帖子被查看的次数。",
    PositiveCommentCount: "正面评论数",
    NegativeCommentCount: "负面评论数",
    NeutralCommentCount: "中立评论数",
    TikTokYearMonthDayTime: "{year}年{month}月{day}日 {time}",
    TikTokFansTrend: "粉丝趋势图",
    TikTokTotalFans: "粉丝总数",
    TikTokTotalFansMeta: "累计粉丝总数",
    TikTokTotalFansTip: "TikTok的粉丝总数。",
    TikTokNetNewFans: "净增粉丝数",
    TikTokNetNewFansTip: "在选定时间范围内，净增长的粉丝数。",
    TikTokComparedToLast: "较上期",
    TikTokDataSummaryTable: "数据汇总表",
    TikTokTotalCount: "共计 {count} 条",
    TikTokSummary: "汇总",
    TikTokTimeCol: "时间",
    TikTokViewsCol: "观看次数",
    TikTokViewsColTip: "您的视频的每日观看次数",
    TikTokVisitsCol: "访问量",
    TikTokVisitsColTip: "每日用户查看您的个人主页的次数。",
    TikTokInteractionCol: "互动数",
    TikTokInteractionColTip: "用户对已发布的视频的点赞、评论、分享的总次数。",
    TikTokLikesCol: "点赞数",
    TikTokLikesColTip: "每日用户对已发布视频的点赞次数",
    TikTokCommentsCol: "评论数",
    TikTokCommentsColTip: "每日用户对已发布视频的评论次数。",
    TikTokSharesCol: "分享数",
    TikTokSharesColTip: "每日用户对已发布视频的分享次数",
    TikTokViewersCol: "观众数",
    TikTokViewersColTip: "每日至少观看过一次已发布内容的用户。",
    TikTokInteractionViewersCol: "互动观众数",
    TikTokInteractionViewersColTip: "每日与您发布的至少一项内容有过互动（点赞、评论、分享）的用户",
    TikTokViewCount: "观看次数",
    TikTokViewTrend: "观看趋势图",
    TikTokTotalViews: "观看总数",
    TikTokTotalViewsTip: "在选定的日期范围内，观众观看你的视频的次数。",
    TikTokMaxDailyViews: "单日最大观看数",
    TikTokMaxDailyViewsTip: "在选定的日期范围内，观众观看你的视频次数最多的一天。",
    TikTokMinDailyViews: "单日最小观看数",
    TikTokMinDailyViewsTip: "在选定的日期范围内，观众观看你的视频次数最少的一天。",
    TikTokDateColon: "日期：",
    TikTokProfileVisits: "主页访问量",
    TikTokVisitsTrend: "访问量趋势图",
    TikTokTotalVisits: "访问量总数",
    TikTokTotalVisitsTip: "在选定的日期范围内，你的个人主页的浏览次数。",
    TikTokMaxDailyVisits: "单日最大访问量",
    TikTokMaxDailyVisitsTip: "在选定的日期范围内，你的个人主页被浏览次数最多的一天。",
    TikTokMinDailyVisits: "单日最小访问量",
    TikTokMinDailyVisitsTip: "在选定的日期范围内，你的个人主页被浏览次数最少的一天。",
    TikTokInteractionCount: "主页互动次数",
    TikTokInteractionTrend: "互动次数趋势图",
    TikTokTotalInteractions: "互动总数",
    TikTokTotalInteractionsTip: "在选定的日期范围内，用户对已发布的视频的点赞、评论、分享的总次数。",
    TikTokLikesCount: "点赞数",
    TikTokLikesCountTip: "用户对已发布视频的点赞次数。",
    TikTokCommentsCount: "评论数",
    TikTokCommentsCountTip: "用户对已发布视频的评论次数。",
    TikTokSharesCount: "分享数",
    TikTokSharesCountTip: "用户对已发布视频的分享次数。",
    TikTokAudienceCount: "观众数量",
    TikTokAudienceTrend: "观众数量趋势图",
    TikTokTotalAudience: "观众总数",
    TikTokTotalAudienceTip: "在选定的日期范围内，至少观看过一次已发布内容的用户。",
    TikTokMaxDailyAudience: "单日最大观众数",
    TikTokMaxDailyAudienceTip: "在选定的日期范围内，观众观看已发布内容最多的一天。",
    TikTokMinDailyAudience: "单日最小观众数",
    TikTokMinDailyAudienceTip: "在选定的日期范围内，观众观看已发布内容最少的一天。",
    TikTokInteractionAudienceCount: "互动观众数量",
    TikTokInteractionAudienceTrend: "互动观众数量趋势图",
    TikTokTotalInteractionAudience: "互动观众总数",
    TikTokTotalInteractionAudienceTip: "在选定的日期范围内，与您发布的至少一项内容有过互动（点赞、评论、分享）的用户。",
    TikTokMaxDailyInteractionAudience: "单日最大互动观众数",
    TikTokMaxDailyInteractionAudienceTip: "在选定的日期范围内，与您发布的至少一项内容有过互动的用户最多的一天。",
    TikTokMinDailyInteractionAudience: "单日最小互动观众数",
    TikTokMinDailyInteractionAudienceTip: "在选定的日期范围内，与您发布的至少一项内容有过互动的用户最少的一天。",
    TikTokAllPromotions: "全部推广",
    TikTokPaidPromotion: "付费推广",
    TikTokNormalPromotion: "普通推广",
    TikTokAllStatus: "全部状态",
    TikTokDisplaying: "展示中",
    TikTokDeleted: "已删除",
    TikTokPostNamePlaceholder: "请输入帖子名称",
    TikTokExportReport: "导出报表",
    TikTokPostContent: "帖子内容",
    TikTokStatus: "状态",
    TikTokCountryDistribution: "按国家分布",
    TikTokCountryDetail: "国家/地区分布明细",
    TikTokCountryRegion: "国家/地区",
    TikTokFollowers: "粉丝数",
    TikTokPercentage: "占比",
    TikTokFansColon: "粉丝数：",
    TikTokPercentColon: "占比：",
    TikTokCityDistribution: "按城市分布",
    TikTokCityDetail: "城市分布明细",
    TikTokGenderAgeDistribution: "性别年龄分布",
    TikTokGenderChart: "性别分布图",
    TikTokAgeChart: "年龄分布图",
    TikTokFemale: "女性",
    TikTokMale: "男性",
    TikTokUnknown: "未知",
    TikTokTimeDimension: "时间维度",
    TikTokDay: "日",
    TikTokWeek: "周",
    TikTokMonth: "月",
    TikTokGenderSeries: "性别分布",
    TikTokAgeSeries: "年龄分布",
    TikTokFan: "粉丝",
    TikTokNonFan: "非粉丝",
    TikTokNewViewer: "新观众",
    TikTokReturningViewer: "回访观众",
    TikTokPositive: "正面",
    TikTokNeutral: "中立",
    TikTokNegative: "负面",
    TikTokPostDetail: "帖子详情",
    TikTokDataOverview: "数据概览",
    TikTokAudienceType: "观众类型",
    TikTokFansNonFans: "粉丝 / 非粉丝",
    TikTokNewReturningViewers: "新观众 / 回访观众",
    TikTokGenderComments: "性别与评论",
    TikTokAudienceGenderChart: "观众性别分布图",
    TikTokCommentAnalysisChart: "评论分析分布图",
    TikTokTotalComments: "评论总数",
    TikTokAudienceCountry: "观众国家/地区",
    TikTokAudienceCountryChart: "观众国家/地区占比图",
    TikTokTrafficSource: "流量来源",
    TikTokTrafficSourceChart: "流量来源占比图",
    TikTokAudienceRetention: "观众留存率",
    TikTokAudienceRetentionChart: "观众留存率趋势图",
    TikTokDropOffTip: "您的大多数观众在 {time} 停止了观看",
    TikTokTotalWatchTime: "总播放时间",
    TikTokTotalWatchTimeTip: "观众观看你的视频帖子的时长。",
    TikTokAvgWatchTime: "平均观看时间",
    TikTokAvgWatchTimeTip: "观众观看你的视频帖子的平均时长。",
    TikTokSecondUnit: "秒",
    TikTokFullWatchRate: "已完整观看视频",
    TikTokFullWatchRateTip: "观看你的完整视频帖子的观众百分比。",
    TikTokNewFollowers: "新增粉丝",
    TikTokNewFollowersTip: "新关注你的观众人数。",
    TikTokSignalPostViews: "观众观看你的视频帖子的次数。",
    TikTokSignalPostAudience: "观众人数",
    TikTokSignalPostAudienceTip: "至少浏览过一次你发布的内容的人数。",
    TikTokSignalPostInteractions: "互动数",
    TikTokSignalPostInteractionsTip: "帖子获得的互动总数（点赞、评论、分享）",
    TikTokSignalPostLikes: "点赞数",
    TikTokSignalPostLikesTip: "帖子获得的总点赞数。",
    TikTokSignalPostComments: "评论数",
    TikTokSignalPostCommentsTip: "帖子获得的总评论数。",
    TikTokSignalPostShares: "分享数",
    TikTokSignalPostSharesTip: "帖子被分享的总次数。",
    TikTokCollectCount: "收藏数",
    TikTokCollectCountTip: "帖子被加入收藏的总次数。",
    TikTokPublishTimeUTC: "发布时间（UTC00:00)",
    TikTokPublishTimeUTCTip: "帖子发布的日期和时间",
    TikTokPublishTimeBJ: "发布时间(北京时间)",
    TikTokPublishTimeBJTip: "帖子发布的北京时间",
    TikTokRetentionColon: "留存率：",
    TikTokVisitHomepage: "访问 TikTok 主页",
    TikTokCollapse: "收起",
    TikTokExpand: "展开",
    TikTokPublishTime: "发布时间",
    TikTokPostSerialNumber: "帖子编号",
    TikTokTags: "标签",
    TikTokProfileIntro: "简介",
    TikTokNotAuthorized: "未授权",
    TikTokAuthorized: "已授权",
    TikTokBusinessAccount: "企业号",
    TikTokAdPost: "广告贴",
    TikTokNormalPost: "普通贴",
    InsHomepageDetail: "Instagram 主页详情",
    InsMainData: "主页数据",
    InsFansData: "粉丝数据",
    InsPostsData: "帖子数据",
    InsStoriesData: "快拍数据",
    InsSignalPostTab: "单一帖子",
    PostDetail: "帖子详情",
    InsPacificTime: "太平洋时间（UTC - 07:00）",
    InsNeedAuthForModule: "查看{title}，需先完成社交主页授权！",
    XFansNeedAuthDescription: "查看粉丝数，需要先完成社交主页授权！",
    TikTokNeedAuthForModule: "查看{title}，需先完成社交主页授权！",
    TikTokHigh: "高",
    TikTokLow: "低",
    MonitoringData: "数据",
    DataOverview: "数据概览",
    MonitoringTotalCount: "共计 {count} 条",
    VisitPlatformHomepage: "访问 {platform} 主页",
    PublishTime: "发布时间",
    // 监控详情侧栏的编号标签供 TikTok、INS 等平台共用，统一显示为“帖子编号”。
    PostSerialNumber: "帖子编号",
    AccountLabels: "标签",
    ContactInformation: "联系信息",
    Location: "所在地",
    ProfileIntro: "简介",
    AccountBasicInfo: "基本信息",
    AccountOverview: "账号概况",
    BrandName: "品牌名称",
    MainCategory: "主分类",
    SubCategories: "子分类",
    AccountCreatedAt: "创建时间",
    // Facebook 单一帖子侧栏的标题与付费状态标签随当前语言同步切换。
    PostUpdatedAt: "更新时间",
    FacebookPaidPost: "付费帖",
    FacebookOrganicPost: "普通帖",
    AccountType: "账号类型",
    PersonalAccount: "个人号",
    OfficialWebsite: "官方网站",
    ContactPhone: "联系电话",
    Email: "邮箱",
    FullAddress: "完整地址",
    BelongingBrand: "所属品牌",
    BelongingIndustry: "所属行业",
    AudienceRegion: "地域群体",
    AboutHomepage: "关于主页",
    WebsiteLink: "网站链接",
    ContactAddress: "联系地址",
    City: "城市",
    Country: "国家",
    InstagramAdPost: "广告贴",
    InstagramNormalPost: "普通贴",
    // 详情工具栏与 INS、TikTok 平台共用该短文案，切换中文时保持原始中文展示。
    More: "更多",

  },

  massEmail: {
    NewBlastTask: "新建群发",
    TaskStatus: "任务状态",
    StatusPending: "待发送",
    StatusSending: "发送中",
    StatusCompleted: "已完成",
    StatusCancelled: "已取消",
    StatusAbnormal: "异常",
    StatusUnsent: "未发送",
    StatusDelivered: "已送达",
    StatusFailed: "送达失败",
    CreateStartTime: "创建开始时间",
    CreateEndTime: "创建结束时间",
    SearchTaskPlaceholder: "搜索任务名称",
    TaskCancelled: "任务取消成功",
    TaskName: "任务名称",
    Delivered: "已送达",
    Read: "已读",
    CreatedAtUtc8: "创建时间(UTC+08:00)",
    SendTimeUtc8: "发送时间(UTC+08:00)",
    SendTimeActualTimezone: "发送时间(实际时区)",
    PacificTimeUtcMinus3: "太平洋时间（UTC-03:00）",
    Operation: "操作",
    ViewDetails: "查看详情",
    CancelTaskConfirm: "任务取消后将无法恢复，确定取消？",
    Confirm: "确定",
    ThinkAgain: "再想想",
    CancelTask: "取消",
    TaskDetail: "任务详情",
    ExportReport: "导出报表",
    TaskMeta: "ID {id} · 邮件群发 · 创建于 {createdAt}",
    Statistics: "数据指标",
    TaskSettings: "任务设置",
    SendList: "发送列表",
    ManualEmails: "手动添加的邮箱",
    EmailAddress: "邮件地址",
    TotalRecords: "共 {count} 条记录",
    AllSendStatus: "全部发送状态",
    SendStartTime: "发送开始时间",
    SendEndTime: "发送结束时间",
    OpenedStartTime: "打开开始时间",
    OpenedEndTime: "打开结束时间",
    Email: "邮箱",
    SendStatus: "发送状态",
    DeliveredAtUtc8: "发送时间(UTC+8:00)",
    OpenedAtUtc8: "已读时间(UTC+8:00)",
    ValidUsers: "有效用户",
    MetricDelivered: "送达",
    MetricOpened: "已读",
    DeliveredRate: "送达率",
    OpenedRate: "打开率",
    ActualMetrics: "实际指标",
    ConversionFunnel: "转化漏斗",
    PreviousRingRate: "相对上一环转化率",
    BasicInfo: "基本信息",
    EmailContent: "邮件内容",
    EmailBody: "邮件正文",
    TargetUsers: "目标用户",
    PushRules: "推送规则",
    EmailPreview: "邮件预览",
    SendImmediately: "立即发送",
    ScheduledSend: "定时发送",
    Attachment: "附件",
    FrequencyPerMail: "{count} 分钟/封",
    TaskNameColon: "任务名称：",
    SenderEmailColon: "发件邮箱：",
    EmailSubjectColon: "邮件主题：",
    UploadAttachmentColon: "上传附件：",
    EstimatedScaleColon: "预估规模：",
    LocalUploadColon: "本地上传：",
    ManualAddEmailColon: "手动添加邮箱：",
    ImportEmailColon: "导入邮箱：",
    SendFrequencyColon: "发送频率：",
    SendMethodColon: "发送方式：",
    SelectedTimezoneColon: "所选时区：",
    ScheduledTimeColon: "定时时间：",
    NewTaskTitle: "新建群发任务",
    TaskNamePlaceholder: "请输入任务名称，如：大促通知推送",
    MaxTaskNameChars: "最多输入 30 个字，任务名称不可重复",
    SenderEmail: "发件邮箱",
    AddEmail: "添加邮箱",
    SelectSenderEmailAccount: "请选择发件邮箱账号",
    EmailSubject: "邮件主题",
    EmailBodyPlaceholder: "请输入邮件正文",
    UploadAttachment: "上传附件",
    DragFileToUpload: "拖拽文件到此处或点击上传",
    UploadAttachmentHint: "支持 PDF、图片、文档等，单文件不超过 10MB",
    UploadEmailTable: "上传邮箱表格",
    DownloadTemplate: "下载导入模板",
    UploadCsvHint: "请上传 csv 文件，大小在60M以内",
    ManualAddEmail: "手动添加邮箱",
    ContactsInputHint: "可批量输入，多个邮箱之间请使用半角逗号(,)、半角分号(;)或换行分隔",
    ContactsPlaceholder: "请输入或粘贴邮箱地址，例如：\nUsers1@examile.com\nUsers2@example.com",
    SendFrequency: "发送频率",
    MinPerMail: "分钟/封",
    SendTime: "发送时间",
    SendDate: "发送日期",
    PleaseSelect: "请选择",
    ScheduledSendHint: "消息将在指定时区的该时间点开始推送",
    EmailBodyPreview: "邮件正文......",
    ConfirmBlastTask: "确认群发任务",
    CreateTask: "创建任务",
    Source: "来源",
    Summary: "汇总",
    Valid: "有效",
    Invalid: "无效",
    Duplicate: "重复",
    SendSettings: "发送设置",
    TimeIntervalColon: "时间间隔：",
    TimezoneColon: "时区：",
    SendTimeColon: "发送时间：",
    ConfirmBlast: "确认群发",
    Cancel: "取消",
    UploadFileOrFillEmailsRequired: "请上传目标用户文件或手动填写邮箱地址",
    InvalidEmailFormat: "邮箱格式不正确：{email}",
    InvalidSeparatorFormat: "检测到全角分隔符号，请使用半角逗号(,)、半角分号(;)或换行来分隔邮箱地址",
    DuplicateEmail: "邮箱地址重复：{email}",
    EnterTaskName: "请输入任务名称",
    SelectSenderEmail: "请选择发件邮箱",
    EnterEmailSubject: "请输入邮件主题",
    UploadOrFillTargetUsers: "请上传或者填写目标用户",
    SendTimeMustBeFuture: "发送时间必须晚于当前时间（已考虑所选时区）",
    FileTooLarge: "文件大小超过限制（{size}MB），最大支持 {limit}MB",
    AttachmentUploadFailed: "附件上传失败",
    CsvOnlyError: "只允许上传 csv 文件！",
    ReselectFilesWarning: "附件与目标用户文件请重新选择",
    UploadSource: "附件上传",
    ManualSource: "手动添加",
    AddEmailAddress: "新增发件邮箱",
    NewProviderTitle: "新增{name}",
    SelectProviderHint: "请选择需要绑定的邮箱服务商，将根据服务商提供对应的授权方式。",
    FillEmailInfoHint: "填写邮箱信息与授权码，完成绑定",
    EmailAccount: "邮箱账号",
    NoAccountNeededHint: "无需填写账号，请点击账户授权按钮进行账号授权",
    EnterValidEmailAddress: "请输入正确的邮箱地址",
    OauthLogin: "授权登录",
    AccountAuthorize: "账户授权",
    AuthorizeFailed: "授权失败",
    EmailAuthCode: "邮箱授权码",
    EnterAuthCode: "请输入邮箱授权码或密码",
    HowToGetAuthCode: "如何获取授权码？",
    UsageDescription: "用途描述",
    UsageDescriptionPlaceholder: "请输入用户描述（选填）",
    ServiceTypeColon: "服务类型：",
    ProtocolServerLabel: "{protocol}服务器：",
    SmtpServerLabel: "SMTP服务器：",
    ExamplePlaceholder: "例如：{example}",
    ConfirmNew: "确认新增",
    EnterEmailAddress: "请填写邮箱地址",
    SelectServiceType: "请选择接受服务类型",
    EnterReceivingHost: "请输入接收服务器地址",
    EnterPortNumber: "请输入端口号",
    EnterOutboxHost: "请输入发送服务器地址",
    EnterPortType: "请输入端口类型",
    AuthorizeFirstWarning: "请先点击账户授权完成授权",
    Tip: "提示",
    CreateBotFailed: "创建机器人失败",
    EmailBindSuccess: "邮箱绑定成功",
    EmailBindFailed: "邮箱绑定失败",
    OauthSuccessAlert: "账户授权成功，请点击确定完成邮箱关联。",
    // 授权模式（媒体管理新增授权）的弹窗文案，服务商名称通过 provider 参数拼接。
    NewAuthorizationTitle: "新增邮箱授权",
    SelectProviderAuthorizationHint: "选择邮箱服务商，并根据服务商要求完成授权",
    ProviderConfigUnavailable: "该邮箱服务商配置不可用，请稍后重试",
    AuthorizationSuccessTitle: "邮箱授权成功",
    AuthorizationFailedTitle: "邮箱授权失败",
    AuthorizationPartialFailedTitle: "部分邮箱授权失败",
    AuthorizationSuccessHint: "{success} 个邮箱授权成功",
    AuthorizationFailedHint: "{failed} 个邮箱授权失败，请检查失败账号后重试",
    AuthorizationPartialFailedHint: "{success} 个邮箱授权成功，{failed} 个授权失败，请检查失败账号后重试",
    SelectBindingAccountsTitle: "选择绑定账号",
    SelectBindingAccountsHint: "您当前还可绑定 {count} 个邮箱账号，请选择本次要绑定的邮箱",
    AuthorizationStatusSuccess: "已授权",
    AuthorizationStatusOtherTeam: "已授权其他团队",
    AuthorizationStatusFailed: "授权失败",
    SkipLabelAssociation: "暂不关联",
    AssociateLabelAction: "关联标签",
    LabelAssociationSuccess: "标签关联成功",
    LabelAssociationFailed: "标签关联失败",
    LabelAssociationNoAccount: "暂无可关联标签的邮箱",
    AuthorizationTitle: "授权绑定 {provider} 邮箱",
    ConfirmAuthorizationBinding: "确认授权绑定",
    OauthConfirmHint: "{provider} 授权已完成，请确认邮箱信息",
    OauthGuideHint: "前往 {provider} 完成账号授权，授权成功后将自动获取邮箱地址",
    OauthGuideStepLogin: "前往 {provider} 登录进行账户授权",
    OauthGuideStepScope: "查看并确认所需的邮箱访问权限",
    OauthGuideStepFinish: "授权成功后返回 JoinMC，并完成新增授权",
    OauthUrlFailed: "获取授权地址失败，请重试",
    ConfirmAuthorization: "确认授权",
    GetAuthCode: "获取授权码",
    SwitchProvider: "切换邮箱平台",
    AddMailAuthorizationHint: "填写邮箱账号、授权码和服务类型",
    MultiMailAuthorizationHint: "填写邮箱账号和授权码，可添加多个邮箱",
    EmailIndex: "邮箱 {index}",
    DeleteEmail: "删除邮箱 {index}",
    EnterYourEmail: "请输入您的邮箱号",
    UsageDescriptionOptional: "请输入用途描述（选填）",
  },

  marketing: {
    MarketingTools: "营销工具",
    WhatsAppBlast: "WhatsApp 群发",
    AbnormalReason: "异常原因",
    ViewWhatsAppAccount: "查看WhatsApp账号",
    WhatsAppContacts: "WhatsApp 联系人",
    TagManagement: "标签管理",
    // 优惠券库的列表、导入和详情页统一维护在此，接口字段可直接复用这些文案。
    CouponLibrary: "优惠券库",
    MaterialCreation: "AI素材制作",
    ImportCoupon: "导入优惠券",
    // 优惠券库覆盖导入、详情、日期筛选、报表导出、拖拽上传、接口校验和异常明细的统一文案。
    CouponImportHint: "请填写优惠券名称并上传券码文件",
    CouponNamePlaceholder: "请输入优惠券名称",
    CouponNameRequired: "请输入优惠券名称",
    CouponFileRequired: "请上传券码文件",
    UploadCouponCode: "上传券码",
    DownloadCouponTemplate: "下载券码模板",
    SelectCouponFile: "选择 Excel 文件",
    DragOrSelectCouponFile: "拖拽文件到此处或点击上传",
    CouponFileFormatHint: "支持 .csv / .xlsx / .xls，文件不超过 10MB",
    CouponFileTypeInvalid: "请上传 csv、xls 或 xlsx 格式的券码文件",
    CouponFileTooLarge: "券码文件不能超过 10MB",
    DeleteCouponTaskTitle: "删除优惠券任务",
    DeleteCouponTaskConfirm: "确定删除优惠券任务“{name}”吗？删除后不可恢复。",
    DeleteCouponTaskSuccess: "优惠券任务删除成功",
    CouponFileValidationFailed: "券码文件校验未通过",
    CouponFileValidationHint: "检测到 {count} 条异常券码；请修改券码文件后，重新上传。",
    ViewExampleData: "查看异常数据",
    CouponImportErrorTitle: "异常券码",
    CouponErrorRow: "序号",
    CouponErrorCode: "券码",
    CouponErrorReason: "异常原因",
    CouponErrorClose: "关闭",
    ConfirmImport: "确认导入",
    CouponCreated: "优惠券创建成功",
    CouponTemplateDownloadFailed: "优惠券模板下载失败，请稍后重试",
    CouponReportExportFailed: "优惠券报表导出失败，请稍后重试",
    SearchCouponPlaceholder: "请输入优惠券名称",
    CouponName: "优惠券名称",
    CouponTotal: "优惠券总数",
    SentQuantity: "已发送数量",
    UnsentQuantity: "未发送数量",
    // 动态优惠券在创建群发任务前的库存校验提示。
    CouponAvailabilityTitle: "优惠券数量不足",
    CouponAvailabilityInsufficient: "优惠券“{name}”可用数量不足，至少需要 {count} 张",
    CouponAvailabilityCheckFailed: "优惠券可用数量校验失败，请稍后重试",
    CreatedAt: "创建时间",
    Authorizer: "授权人",
    Action: "操作",
    ViewDetails: "查看详情",
    CouponFeaturePending: "功能暂未开放",
    CouponDetail: "优惠券详情",
    CouponSendData: "发送数据",
    CouponList: "券号列表",
    CouponCode: "券码",
    CouponFaceValue: "面额",
    CouponImportTime: "导入时间 (UTC+08:00)",
    CouponSendTime: "发送时间 (UTC+08:00)",
    CouponImportStartTime: "导入开始时间",
    CouponImportEndTime: "导入结束时间",
    CouponSendStartTime: "发送开始时间",
    CouponSendEndTime: "发送结束时间",
    CouponRecipientName: "接收人昵称",
    CouponRecipientPhone: "接收人手机号",
    CouponRecipientCountry: "接收人国家",
    CouponStatusAll: "全部状态",
    CouponNotSent: "未发送",
    CouponSent: "已发送",
    CouponSending: "发送中",
    CouponCreatedBy: "创建人",
    CouponTaskInfo: "{user} · 创建于 {time}",
    CouponUnknownTask: "优惠券任务",
    CouponTaskMissing: "未找到优惠券任务，请返回优惠券库重新选择。",
    CreateBlast: "创建群发",
    TaskStatus: "任务状态",
    Pending: "待发送",
    Sending: "发送中",
    Completed: "已完成",
    CreateStartTime: "创建开始时间",
    CreateEndTime: "创建结束时间",
    // WhatsApp 群发列表搜索支持任务与 WABA 相关信息的统一提示。
    SearchTaskPlaceholder: "搜索任务名称 / 创建人 / WABA ID / WABA 名称",
    SearchWabaIdPlaceholder: "输入WABA ID或名称",
    TaskCancelled: "任务取消成功",
    NoBlastTasks: "暂无群发任务",
    TaskName: "任务名称",
    Delivered: "已送达",
    DeliveredTooltip: "joinmc收到的WhatsApp的消息传递确认",
    // 群发列表基于 no_service_user_num 和 fail_rate 展示未送达情况。
    DeliveryFailed: "送达失败",
    DeliveryFailedTooltip: "未成功送达的用户数量",
    FailureRate: "异常率",
    FailureReasons: "失败原因",
    FailureReason: "原因 {number}",
    FailureCount: "{count} 条",
    ViewAllFailureRecords: "查看全部失败记录",
    ValidUser: "有效用户数",
    ValidUserTooltip: "群发用户总数",
    Read: "已读",
    ReadTooltip: "您发送的消息已被用户阅读。已读功能仅对启用了已读回执的用户启用。对于未启用此功能的用户，您只能收到已送达的状态",
    Clicked: "已点击",
    ClickedTooltip: "消息中按钮被点击的次数，仅支持启用了跟踪功能的模板",
    ActualCost: "实际花费",
    // 群发任务列表显示任务执行前冻结的金额。
    FreezeAmount: "冻结金额",
    BelongsWaba: "归属WABA",
    WabaIdPrefix: "WABA ID：",
    SenderPhone: "发送手机号",
    CreatedAtUtc8: "创建时间 (UTC+08:00)",
    SendTimeUtc8: "发送时间 (UTC+08:00)",
    SendTimeActualTimezone: "发送时间 (实际时区)",
    Creator: "创建人",
    ViewDetails: "查看详情",
    ReadRate: "阅读率",
    ClickRate: "点击率",
    ConversionRate: "触达率",
    Operation: "操作",
    OperationConfirm: "操作确认",
    Cancel: "取消",
    DeleteTaskConfirm: "任务删除后，任务相关的数据信息也将同步被删除！",
    CancelTaskConfirm: "任务取消后，系统将不再推送通知给未发送的手机号！",
    CancelTask: "取消",
    Cancelled: "已取消",
    ExportReport: "导出报表",
    SyncData: "同步数据",
    AllCountries: "全部国家",
    SelectTagsPlaceholder: "请选择关联标签",
    // 模板变量模式的两种展示状态，动态数据源将在后续需求中接入。
    StaticParameter: "静态参数",
    DynamicParameter: "动态参数",
    SelectParameter: "请选择参数",
    // 动态参数抽屉的演示分类和字段文案，后续可与真实字段配置复用。
    DynamicParameterTitle: "选择参数",
    DynamicParameterTip: "为「{name}」选择一个动态数据参数",
    ContactInformation: "联系人信息",
    ContactInformationTip: "可选联系人姓名、电话、地址等",
    ProductInformation: "商品信息",
    ProductInformationTip: "可选商品名称、价格、库存等",
    CouponInformation: "优惠券信息",
    CouponInformationTip: "可选优惠券码、折扣、有效期等",
    AvailableParameters: "可选参数",
    ContactNickname: "昵称",
    ContactNicknameTip: "WhatsApp 联系人的昵称",
    ContactPhone: "联系人电话",
    ContactPhoneTip: "WhatsApp 联系人的联系电话",
    ContactEmail: "邮箱地址",
    ContactEmailTip: "WhatsApp 联系人的邮箱地址",
    ProductName: "商品名称",
    ProductNameTip: "商品名称",
    ProductPrice: "商品价格",
    ProductPriceTip: "商品当前价格",
    CouponName: "优惠券名称",
    CouponNameTip: "优惠券名称",
    CouponDiscount: "优惠券折扣",
    CouponDiscountTip: "优惠券优惠金额或折扣",
    // 商品和优惠券关联控件使用这组文案，接口失败时保留空选择状态。
    ProductAssociationTip: "按商城筛选后，选择要关联的商品",
    CouponAssociationTip: "选择要关联的优惠券模板后，选择要关联的内容",
    SelectStore: "请选择商城",
    SelectProduct: "请选择商品",
    SelectCouponTemplate: "请选择优惠券模板",
    AvailableCouponParameters: "可选商品参数",
    ProductImage: "商品图片",
    ProductImageTip: "商品主图",
    ProductLowestPrice: "最低售价",
    ProductLowestPriceTip: "商品款式最低售价",
    ProductHighestPrice: "最高售价",
    ProductHighestPriceTip: "商品款式最高售价",
    ProductVariantTotal: "款式数量",
    ProductVariantTotalTip: "商品全部款式数量",
    ProductAvailableVariantTotal: "有库存款式数量",
    ProductAvailableVariantTotalTip: "可售商品款式数量",
    ProductCurrency: "币种",
    ProductCurrencyTip: "商品标价币种",
    ProductBrand: "品牌",
    ProductBrandTip: "商品品牌",
    ProductUpdatedAt: "更新时间",
    ProductUpdatedAtTip: "商品最后更新时间",
    CouponCode: "优惠券码",
    CouponCodeTip: "用户可使用的优惠券码",
    CouponAmount: "金额",
    CouponAmountTip: "优惠券优惠金额",
    OrderFirstName: "名字",
    OrderFirstNameTip: "客户的名字",
    OrderLastName: "姓氏",
    OrderLastNameTip: "客户的姓氏",
    OrderEmail: "邮箱",
    OrderEmailTip: "客户邮箱地址",
    OrderProductCount: "商品数量",
    OrderProductCountTip: "订单中的商品总件数",
    OrderTotalAmount: "订单金额",
    OrderTotalAmountTip: "订单总金额",
    OrderOrderId: "订单号",
    OrderOrderIdTip: "系统订单号",
    OrderCreatedAt: "下单时间",
    OrderCreatedAtTip: "订单创建时间",
    OrderSubtotal: "小计",
    OrderSubtotalTip: "商品小计金额",
    OrderTax: "税费",
    OrderTaxTip: "订单税费金额",
    OrderLogisticsChannel: "物流渠道",
    OrderLogisticsChannelTip: "物流渠道名称",
    OrderWaybillNumber: "货运单号",
    OrderWaybillNumberTip: "物流运单号",
    OrderInternalNumber: "内部单号",
    OrderInternalNumberTip: "内部物流编号",
    SearchContactPlaceholder: "请输入用户名、手机号或 WABA ID",
    Nickname: "昵称",
    Country: "国家",
    PhoneNumber: "手机号",
    BSUID: "BSUID",
    ParentBSUID: "父 BSUID",
    Email: "电子邮件",
    BelongsToWaba: "归属 WABA",
    // WhatsApp 联系人列表支持按来源筛选、展示广告归因，并从更多菜单打开广告链接。
    ContactSource: "来源",
    SelectContactSource: "请选择来源",
    ContactAdId: "广告 ID",
    OpenAdLink: "打开广告链接",
    ContactSourceImport: "名单导入",
    ContactSourceOrganic: "自然关注",
    ContactSourceAdvertisement: "广告引流",
    LinkedTags: "关联标签",
    ContactCount: "联系次数",
    Add: "添加",
    LastContactNumber: "最后联系号码",
    FirstChatTime: "首次交流时间",
    LastContactTime: "最后联系时间",
    CreatedAt: "创建时间",
    ViewHistory: "查看历史对话",
    NotBoundToBot: "该联系人未绑定客服机器人",
    HistoryChat: "历史对话",
    LinkTags: "关联标签",
    Deleting: "删除中",
    Delete: "删除",
    More: "更多",
    LinkTagsDesc: "关联标签后，您在数据筛选环节可直接按标签进行选择。",
    NoLinkedTags: "暂无关联标签",
    TagSelection: "标签选择",
    AddTag: "添加标签",
    SearchTagsPlaceholder: "搜索选择需要关联的标签",
    Linking: "关联中",
    ConfirmLink: "确认关联",
    DeleteContactTitle: "删除该联系人",
    DeleteContactConfirm: "删除后，该联系人将从联系人列表中移除，确认删除吗？",
    SyncDataDesc: "受 WhatsApp 平台规则限制，仅可在授权完成后的 24 小时内同步数据。若后续需要重新同步数据，需再次发起授权。",
    WabaAccount: "WABA 账号",
    SearchWabaPlaceholder: "搜索 WABA 账号",
    Account: "账号",
    LastSyncTime: "最近同步时间",
    Updating: "更新中",
    NoWabaAccount: "暂无 WABA 账号",
    Syncing: "同步中",
    StartSync: "开始同步",
    MissingContactId: "缺少联系人 ID，暂时无法删除",
    DeleteContactFailed: "删除联系人失败",
    DeleteSuccess: "删除成功",
    MissingContactIdForTag: "缺少联系人 ID，暂时无法关联标签",
    LinkTagFailed: "关联标签失败",
    LinkSuccess: "关联成功",
    AddCategory: "添加分类",
    SearchTagPlaceholder: "请输入标签名称",
    Category: "分类",
    Tag: "标签",
    ClickTagToEdit: "（点击标签可编辑）",
    DeleteTagConfirm: "标签删除后，将不可恢复。标签将从系统中包括但不限于用户、优惠券等位置被删除。",
    DeleteCategoryConfirm: "标签分类删除后，将不可恢复。分类下的标签将同步被删除",
    OperationSuccess: "操作成功",
    NoTags: "暂无标签",
    EditCategory: "编辑分类",
    DeleteCategory: "删除分类",
    Edit: "编辑",
    NamePlaceholder: "请输入{title}名称",
    BlastTools: "群发工具",
    SummaryData: "汇总数据",
    DataDetails: "数据详情",
    EffectiveUsers: "有效用户数",
    UserCountries: "用户国家和地区",
    SpendAmount: "花费金额（$）",
    Sent: "已发送",
    DeliveredCount: "已送达",
    Opened: "已打开",
    NotOpened: "未打开",
    NotSent: "未发送",
    SentNotOpened: "已发送未打开",
    DeliveryOpenRate: "送达打开率",
    SelectSendStatus: "请选择发送状态",
    SelectDeliveryStatus: "请选择送达状态",
    SelectOpenStatus: "请选择打开状态",
    NotDelivered: "未送达",
    SelectStartDate: "请选择开始日期",
    SelectEndDate: "请选择结束日期",
    UserName: "用户姓名",
    CountryRegion: "国家和地区",
    SendStatus: "发送状态",
    DeliveryStatus: "送达状态",
    OpenStatus: "打开状态",
    DeliveryFailed: "送达失败",
    SendTime: "发送时间",
    NewBlast: "新建群发",
    BasicInfo: "基本信息",
    SelectTemplate: "选择模板",
    TargetUsers: "目标用户",
    SendChannel: "发送通道",
    PushRules: "推送规则",
    StepBasicInfo: "1. 基本信息",
    StepSelectTemplate: "2. 选择模板",
    StepTargetUsers: "3. 目标用户",
    StepSendChannel: "4. 发送通道",
    StepPushRules: "5. 推送规则",
    TaskNameLabel: "任务名称",
    TaskNamePlaceholder: "请输入任务名称",
    TaskNameHelp: "最多输入 30 个字，任务名称不可重复",
    WabaPlatform: "WABA 平台",
    WabaAccountPlaceholder: "请选择 WABA 账号",
    PushNumber: "推送号码",
    SelectPhone: "选择手机号",
    VerifiedCompany: "已验证的公司",
    MessageTemplate: "消息模板",
    MessageTemplatePlaceholder: "请选择消息模板",
    SelectLocation: "选择地点",
    LocationPlaceholder: "搜索地点，如：深圳万象城",
    // 地图地点必须通过候选结果确定，才能同时获取名称和经纬度。
    LocationRequired: "请选择地图地点",
    DragUploadText: "拖拽文件到此处或点击上传",
    Uploading: "文件上传中...",
    UploadHeaderRequired: "请先上传模板头部媒体",
    MediaUploadFailed: "媒体文件上传失败，请重试",
    TagSelectLabel: "标签选择",
    SelectTargetTags: "请选择目标用户标签",
    LocalUpload: "本地上传",
    DownloadNumberTemplate: "下载号码模板",
    NumberCountSuffix: "个号码",
    UploadHint: "请上传 xls 文件，大小在60M以内",
    SelectedTargetUsers: "已选目标用户",
    CustomNumbers: "自定义号码",
    People: "人",
    Valid: "有效",
    Invalid: "无效",
    Duplicate: "重复",
    Unsubscribed: "退订",
    FinalSend: "最终发送",
    ChannelType: "通道类型",
    NormalChannel: "普通通道",
    NormalChannelDesc: "标准投递，适用于所有消息类型，支持双向通信",
    MarketingChannel: "营销专用通道",
    PendingActivation: "待开通",
    Activated: "已开通",
    MarketingChannelDesc: "AI 优化投递，送达率提升约 9%，仅限营销模板消息",
    ActivateNow: "立即开通",
    ViewAdvantages: "查看优势",
    MessageExpiry: "消息过期时间",
    SelectExpiry: "请选择过期时间",
    TTL12Hours: "12小时",
    TTL1Day: "1天",
    TTL3Days: "3天",
    TTL7Days: "7天",
    TTL14Days: "14天",
    TTL30Days: "30天",
    Custom: "自定义",
    Day: "天",
    Hour: "时",
    ExpiryHelp: "消息若未在有效期内送达将被自动丢弃。",
    SendTimeLabel: "发送时间",
    SendNow: "立即发送",
    ScheduleSend: "定时发送",
    SendDate: "发送日期",
    SelectPlaceholder: "请选择",
    SendTimeHelp: "消息将在指定时区的该时间点开始推送",
    SaveChanges: "保存修改",
    CreateTask: "创建任务",
    SelectStatusPlaceholder: "请选择状态",
    TaskNotStarted: "未开始",
    TaskInProgress: "进行中",
    // 自动化任务数据统计
    DataMetrics: "数据指标",
    InteractionUsers: "互动用户",
    InteractedUsers: "互动人数",
    ActualMetrics: "实际指标",
    UsageTrend: "使用趋势",
    TriggerCount: "触发次数",
    TagCount: "打标签次数",
    TriggerCountTip: "统计周期内任务被触发的总次数",
    InteractedUsersTip: "统计周期内与任务产生互动的用户数",
    TagCountTip: "统计周期内任务执行打标签动作的总次数",
    BeijingTimeUtc8: "北京时间（UTC+08:00）",
    AutomateTaskMeta: "ID {id} · 自动化任务-{monitorType} · 创建于 {createdAt}",
    InteractionList: "互动列表",
    ContactInfo: "联系人信息",
    Country: "国家",
    RelatedTags: "关联标签",
    LastTriggerTimeUtc8: "最后触发时间 (UTC+08:00)",
    Operation: "操作",
    TotalContacts: "共 {count} 联系人",
    InteractionUserDetail: "互动用户详情",
    TriggerRecords: "触发记录",
    TriggerRecordTotal: "共 {count} 次",
    ActionSendMessage: "发消息",
    ActionAddTag: "打标签",
    ActionAddTagDesc: "本次执行动作添加指定标签",
    ViewMessageDetail: "查看消息详情",
    CollapseMessageDetail: "收起消息详情",
    MessageSendTime: "发送时间：{time}",
    MessageDeliveredTime: "送达时间：{time}",
    MessageContent: "发送内容：",
    NormalTask: "普通任务",
    SelectPhoneTitle: "选择手机号",
    NoAvailablePhone: "没有可用的手机号",
    NoVerifiedPhone: "暂无已完成核验的手机号码",
    VerifyFirstTip: "请您先完成手机号验证后再继续创建群发操作",
    ConfirmAdd: "确认添加",
    Close: "关闭",
    AddTargetUsers: "添加目标用户",
    UploadByTag: "按标签上传",
    CountryRegionColon: "国家和地区：",
    AllCountriesRegions: "全部国家和地区",
    TagColon: "标签：",
    UploadFile: "上传文件",
    TotalPhoneNumbers: "共{{count}}个手机号",
    DownloadPhoneTemplate: "下载电话号码模板",
    Confirm: "确定",
    SelectedPhones: "选择的手机号",
    Name: "姓名",
    LastInteractionTime: "最后一次交互时间",
    Tags: "标签",
    ConfirmBlastTask: "确认群发任务",
    InsufficientBalance: "账户余额不足",
    CurrentBalance: "当前余额",
    EstimatedCost: "预计花费",
    Difference: "差额",
    TemplateName: "模板名称",
    WabaId: "WABA ID",
    PushCode: "推送码号",
    Summary: "汇总",
    EstimatedSpend: "预估花费",
    EstimatedConversations: "预估对话数",
    EstimatedCostAmount: "预估花费金额 ($)",
    CurrentBalanceAmount: "当前余额 ($)",
    GoRecharge: "去充值",
    ConfirmBlast: "确认群发",
    CertificationDesc: "认证说明",
    SevenAdvantages: "开通即享 7 大优势",
    SevenAdvantagesDesc: "相比普通云端 API，在送达、素材、数据、运维与合规上全面增强",
    ActivateMarketingChannel: "开通营销专用通道",
    Adv1Title: "一. 送达效率提升",
    Adv1Body1Title: "1. 质量分层送达机制",
    Adv1Body1Text: "系统识别高互动、高相关性的营销消息，优先发送，相比普通云端 API，优质消息送达率可提升 9% 以上，且不限制营销消息总量。",
    Adv1Body2Title: "2. 自定义超长消息有效期",
    Adv1Body2Text: "营销模板可设置 12 小时至 30 天的投递有效期，通用云端 API 仅支持验证码、通知类消息的 TTL，不支持营销消息。",
    Adv2Title: "二. 模板素材与链接格式更强",
    Adv2Body1Title: "1. 模板标题支持 GIF 动图",
    Adv2Body1Text: "视觉吸引力更强，通用 API 不支持。",
    Adv2Body2Title: "2. 内置 Android 应用深度链接",
    Adv2Body2Text: "可一键跳转商户 App，普通云端 API 无该功能。",
    Adv2Body3Title: "3. 完整支持全类型营销组件",
    Adv2Body3Text: "基础营销模板组件：商品轮播、多商品目录、折扣码、限时活动、地点卡片、互动按钮、列表菜单等。",
    Adv3Title: "三. 素材自动优化",
    Adv3Body1Title: "1. 平台自动优化模板图片与视觉素材",
    Adv3Body1Text: "提升打开、点击互动数据，标准云端 API 无素材自动优化能力。",
    Adv4Title: "四. 营销数据与转化分析能力",
    Adv4Body1Title: "1. 行业对标基准数据",
    Adv4Body1Text: "可查看本地同行业商家的同类型模板平均已读率、点击率数据，判断模板表现。",
    Adv4Body2Title: "2. 智能优化建议",
    Adv4Body2Text: "基于平台大数据，对模板文案、素材、按钮设置给出优化建议。",
    Adv4Body3Title: "3. 完整转化链路指标",
    Adv4Body3Text: "追踪消息带来的深层转化：加购、发起结算、完成订单等。",
    Adv4Body4Title: "4. 完整成本统计",
    Adv4Body4Text: "单模板成本、单次发送成本、单次点击成本，便于 ROI 计算。",
    Adv5Title: "五. 接入与运维更友好",
    Adv5Body1Title: "1. 接入渠道更丰富",
    Adv5Body1Text: "嵌入式注册、Intent API、Intent UI 等多种开通路径，云端 API 仅支持嵌入式注册。",
    Adv5Body2Title: "2. 精细化接入状态查询",
    Adv5Body2Text: "专属状态字段与错误详情提示，快速定位开通失败原因。",
    Adv5Body3Title: "3. 独立专属错误码体系",
    Adv5Body3Text: "区分营销场景各类异常，排障效率更高。",
    Adv5Body4Title: "4. 自动扩容消息吞吐量",
    Adv5Body4Text: "流量高峰自动提升发送配额，并推送 Webhook 通知。",
    Adv6Title: "六. 合规、安全基础保障",
    Adv6Body1Title: "1. 全套合规认证",
    Adv6Body1Text: "GDPR、LGPD、ISO27001、SOC 审计报告，满足各地区营销合规要求。",
    Adv6Body2Title: "2. 支持号码本地数据存储部署",
    Adv6Body2Text: "支持号码本地数据存储部署。",
    Adv6Body3Title: "3. 实时平台服务状态监控",
    Adv6Body3Text: "故障实时同步。",
    Adv7Title: "七. 业务营销专属模板类型全覆盖",
    Adv7Body1Title: "1. 原生提供多种营销专用模板，开箱即用",
    Adv7Body1Text: "优惠码模板、限时促销模板；商品图文轮播模板、多商品目录模板；门店引流模板、活动邀请模板；呼叫授权申请、CTA 下单支付模板。",
    GotIt: "知道了",
    PleaseEnterTaskName: "请输入任务名称",
    PleaseSelectWaba: "请选择 WABA 账号",
    PleaseSelectPhone: "请选择手机号",
    PleaseSelectTemplate: "请选择营销模板",
    PleaseSelectTargetUser: "请选择目标用户",
    PleaseSelectPushTime: "请选择推送时间",
    ImageContent: "图片内容",
    VideoContent: "视频内容",
    DocumentContent: "文档内容",
    MediaContent: "媒体内容",
    UploadImage: "上传图片",
    UploadVideo: "上传视频",
    UploadDocument: "上传文档",
    // 模板头部附件类型限制，拖拽与文件选择会共用此提示。
    MediaFileTypeInvalid: "请上传以下格式的文件：{types}",
    MarketingType: "营销",
    Utility: "实用型",
    Authentication: "身份验证",
    InvalidTTL: "请输入有效的正整数作为过期时间",
    TTLExceed30Days: "过期时间不能超过 30 天（720 小时）",
    TTLExceed30DaysShort: "过期时间不能超过 30 天",
    SelectPushPhone: "请选择推送手机号",
    SelectWabaFirst: "请先选择 WABA 平台",
    OnlyXlsAllowed: "仅允许上传 xls 和 xlsx 文件",
    FileTooLarge: "文件过大，最大允许 60M",
    PleaseUploadFile: "请先上传文件",
    TaskUpdateSuccess: "任务修改成功，您可以在群发任务列表查看任务进度！",
    TaskCreateSuccess: "任务已经创建成功，您可以在群发任务列表查看任务进度！",
    AutomateTaskCreateSuccess: "自动化任务创建成功",
    AutomateTaskUpdateSuccess: "自动化任务已更新",
    OperationTip: "操作提示",
    SendTimeMustBeLater: "发送时间必须晚于当前时间（已考虑所选时区）",
    RefreshSuccess: "刷新成功",
    PleaseEnter: "请输入{name}",
    EditBlastTask: "编辑群发任务",
    NewBlastTask: "新建群发任务",
    TTLCustom: "自定义",
    PleaseSelectWabaAccount: "请选择 WABA 账号",
    UtilityType: "实用型",
    AuthenticationType: "身份验证",
    TemplateTypeImage: "图片消息",
    TemplateTypeVideo: "视频消息",
    TemplateTypeText: "文字消息",
    TemplateTypeDocument: "文档消息",
    TemplateTypeLocation: "位置消息",
    TTLExceed30DaysHours: "过期时间不能超过 30 天（720 小时）",
    MissingContactIdForDelete: "缺少联系人 ID，暂时无法删除",
    SelectedTargetUsers: "已选目标用户",
    ViewUsers: "查看用户",
    AddTagsToTargetUsersTip: "为本次有效目标用户添加标签（选填）",
    TagsAppliedAfterCreation: "暂未设置，任务创建成功后才会执行添加。",
    NoTargetUsers: "尚未添加用户",
    NoTargetUsersTip: "支持按条件筛选或上传本地名单，系统将自动合并、校验并去重。",
    AddNow: "立即添加",
    AddTargetUsers: "添加目标用户",
    SelectByCondition: "按条件选择",
    TargetUserTags: "目标用户标签",
    InteractionStatus: "互动情况",
    SelectInteractionPlaceholder: "请选择互动情况",
    HasInteraction: "有互动",
    NoInteraction: "无互动",
    Recent: "最近",
    DaysUnit: "天",
    TargetUserScope: "目标用户范围",
    IncludeLabel: "包含",
    ExcludeLabel: "排除",
    IncludedStatus: "包含",
    ExcludedStatus: "排除",
    FilterInteractionDesc: "将选择 <span class=\"label-highlight\">最近{days}天内{interaction}</span> 的用户。",
    FilterCountryDesc: "来自 <span class=\"label-highlight\">{countries}</span> 的用户将被{status}。",
    FilterLabelDesc: "带有 <span class=\"label-highlight\">{labels}</span> 标签的用户将被{status}。",
    UploadList: "上传名单",
    ConfirmAdd: "确认添加",
    AddTagsForContacts: "为本次联系人添加标签",
    // WhatsApp 客服对单个联系人打标签时沿用设计稿标题。
    AddTagForContact: "为联系人添加标签",
    // 标签筛选与联系人打标签共用选择组件，标题和确认文案按模式切换。
    SearchByTag: "按标签查询",
    ConfirmSelection: "确认",
    SearchTagPlaceholder: "搜索标签名称",
    NoCategories: "暂无分类",
    NoTags: "暂无标签",
    SelectedTagsCount: "已选：{count}个",
    AddNewCategory: "新增分类",
    AddNewTag: "新增标签",
    EnterCategoryName: "请输入分类名称",
    EnterTagName: "请输入标签名称",
    ConfirmCreate: "确认新增",
    SelectWabaFirst: "请先选择 WABA 平台",
    NoTargetUsersFound: "没有找到目标用户",
    SelectCategoryFirst: "请先选择分类",
    UploadFailed: "上传失败",
    TaskModifiedSuccess: "任务修改成功，您可以在群发任务列表查看任务进度！",
    OperationTip: "操作提示",
    // 自动化任务模块：创建 / 列表 / 统计 / 互动详情
    AutomateNewTask: "新建自动化任务",
    AutomateTaskDetailCrumb: "自动化任务：{name}",
    AutomateStepScene: "场景设置",
    AutomateStepAction: "执行动作",
    AutomateStepRule: "执行规则",
    AutomateSectionBasic: "1. 基本信息",
    AutomateSectionScene: "2. 任务场景",
    AutomateSectionAction: "3. 执行动作",
    AutomateSectionRule: "4. 执行规则",
    AutomateTaskNamePlaceholder: "请输入至少2个字符的任务名称",
    AutomateTaskNameMin: "请输入最少两个字的任务名称",
    AutomateTaskTime: "任务时间",
    AutomateLongTerm: "长期有效",
    AutomateCustomTime: "自定义时间",
    AutomateStartDate: "任务开始时间",
    AutomateEndDate: "任务结束时间",
    AutomateDateTo: "至",
    AutomateSceneScope: "场景范围",
    AutomateSceneDialog: "对话场景",
    AutomateSceneOrder: "订单信息",
    AutomateSceneUser: "用户群体",
    AutomateSceneHint: "何时和如何触发后续执行动作",
    AutomateScenePlaceholder: "请清晰表达您的想法，AI 可以根据您的描述理解何时或如何触发后续执行动作。\n例如：# 场景-当客户首次提交关注或添加企业微信时，发送欢迎语消息。",
    AutomateSaveAsTemplate: "保存为模板",
    AutomateUseSceneTemplate: "使用场景模板",
    AutomateSceneTemplate: "场景模板",
    AutomateManageTemplate: "管理模板",
    AutomateSearchTemplate: "搜索模板名称",
    AutomateSystemPreset: "系统预设",
    AutomateMyTemplate: "我的模板",
    AutomateSceneTemplateEmpty: "暂无场景模板",
    AutomateUserCountryRegion: "用户国家/地区",
    AutomateUserInteraction: "用户互动",
    AutomateDaysAgo: "距今",
    AutomateWithinDays: "天内",
    AutomateSelectScene: "请选择场景",
    AutomateSelectStoreLabel: "选择商城",
    AutomateOrderUnpaid: "订单未付款",
    AutomateOrderPaid: "订单已付款",
    AutomateOrderShipped: "订单已发货",
    AutomateOrderDelivered: "订单已送达",
    AutomateOrderCancelled: "订单已取消",
    AutomateAddTagDesc: "AI 为满足条件的联系人自动添加指定标签",
    AutomateNoTagSelected: "暂未添加标签，",
    AutomateSelectTagTip: "请选择需要自动添加给联系人的标签",
    AutomateSendMessageDesc: "AI 自动向满足条件的联系人发送 WhatsApp 模板消息",
    AutomateNoTemplateSelected: "尚未选择消息模板，",
    AutomateSelectTemplateTip: "选择模板后即可配置消息中的动态参数",
    AutomateExecutionTime: "执行时间",
    AutomateConversationEnd: "对话结束",
    AutomateHourUnit: "小时",
    AutomateMinuteUnit: "分钟",
    AutomateExecuteAfter: "后执行",
    AutomateTriggerFrequency: "触发频率",
    AutomateTriggerOnce: "触发一次",
    AutomateTriggerEveryTime: "每次都触发",
    AutomateExecuteImmediately: "立即执行",
    AutomateExcludeUsers: "排除用户",
    AutomateNotExclude: "不排除",
    AutomateExcludeProcessed: "排除已处理联系人",
    AutomateTaskPreview: "任务预览",
    AutomateTemplateManagement: "模板管理",
    AutomateTemplateColumn: "模板",
    AutomateTypeColumn: "类型",
    AutomateCustomScene: "自定义",
    AutomateApplyTemplate: "应用模板",
    AutomateEditTemplate: "编辑模板",
    AutomateTemplateDialogTip: "填写模板名称与场景内容，完成场景模板设置",
    AutomateTemplateNamePlaceholder: "请输入您的模板名称",
    AutomateSceneContent: "场景内容",
    AutomateSave: "保存",
    AutomateDeleteSceneConfirm: "确定删除团队场景「{name}」吗？删除后不可恢复。",
    AutomateDeleteSceneTitle: "删除团队场景",
    AutomateSelectAction: "请选择执行动作",
    AutomateInteractionRequired: "请选择用户互动",
    AutomateInteractionDaysRequired: "请输入互动天数",
    AutomateTaskEnded: "已结束",
    AutomateTaskAbnormal: "有异常",
    AutomateInteractionNotOrdered: "未下单",
    AutomateInteractionOrdered: "有下单",
    AutomateInteractionFirstFollow: "首次关注",
    AutomateDeleteConfirm: "删除后任务将不能恢复，确认删除该任务？",
    AutomateDeleteTitle: "删除任务",
    AutomateDeleted: "任务已删除",
    AutomateFilterWaba: "所属 WABA",
    AutomateCreateStart: "创建开始日期",
    AutomateCreateEnd: "创建结束日期",
    AutomateSearchNameCreator: "请输任务名称或创建人",
    AutomateEnableSwitch: "启用开关",
    AutomateTriggerScene: "触发场景",
    AutomateMonitorConversation: "对话",
    AutomateMonitorOrder: "订单",
    AutomateMonitorUser: "用户",
    AutomateNoAvailablePhone: "没有可用于群发的手机号，请先在 WhatsApp 账号中绑定可用手机号",
    MessageNotDelivered: "未送达",
    MessageDelivered: "已送达",
    MessageDeliveryFailed: "送达失败",
    EveryDay: "每日",
    CustomerName: "客户姓名",
    IsMaxPriceAlertText: "当前模板暂不支持最高出价调整，需要您先在模板中设置最高出价后，才能编辑该参数。",
    IsMaxPriceAlertTitle: "无法设置最高出价",
    IsWabaMaxPriceWhitelist: "如需设置最高出价功能，请先将 WABA 账号加入白名单，您可联系专属销售负责人申请开通。",
    // WhatsApp 群发-设置最高出价抽屉
    BestBidTitle: "设置最高出价",
    BestBidSearchPlaceholder: "请输入国家/地区",
    BestBidTargetCoveragePrefix: "目标用户覆盖",
    BestBidSelectedPrefix: "已选",
    BestBidCountryRegionUnit: "个国家/地区",
    BestBidBatchAdjust: "批量调整",
    BestBidClearSelection: "取消选择",
    BestBidCountryRegion: "国家/地区",
    BestBidTargetUserCount: "{count} 位目标用户",
    BestBidAdjustment: "调整幅度",
    BestBidPercentagePlaceholder: "请输入",
    BestBidHighestBid: "最高出价",
    BestBidOriginalPrice: "原价",
    BestBidIncrease: "提高",
    BestBidNoChange: "不调整",
    BestBidDecrease: "降低",
    BestBidAdjustedSummary: "{total} 个国家/地区 {adjusted} 个已调整",
    BestBidSaveSettings: "保存设置",
    BestBidBatchAdjustTitle: "批量调整出价",
    BestBidAdjustScope: "调整范围：已选 {count} 个国家/地区",
    BestBidConfirmAdjust: "确认调整",
    BestBidSelectCountryFirst: "请选择要调整的国家/地区",
    BestBidOutOfRange: "国家/地区“{country}”的{adjust}百分比（{percentage}%）超出范围（1%~{max}%）",
    BestBidPercentageRange: "{adjust}时，百分比范围是 1% ~ {max}%",
    // WhatsApp 群发-新建/编辑任务页的最高出价、风控审核与不支持出价地区文案。
    BestBidCustomCostTitle: "自定义单条营销消息成本",
    BestBidCustomCostDesc: "最高出价为 Meta 白名单能力，灵活控制群发成本与投递优先级",
    BestBidSet: "设置出价",
    BestBidConfigured: "已设置",
    BestBidEdit: "编辑出价",
    RiskCheckReviewingTitle: "正在进行审核",
    RiskCheckReviewingDesc: "系统正在检查任务内容是否符合平台规范，<br />请稍候…",
    RiskCheckFailureTitle: "风控提醒",
    RiskCheckAdjust: "去调整",
    RiskCheckFailureDefault: "你的 WhatsApp 群发任务触发平台风控规则，请调整消息模板内容后重新提交任务。",
    MaxPriceUnsupportedTitle: "部分联系人所在地区不支持最高出价",
    MaxPriceUnsupportedSubtitle: "当前目标用户涉及以下 {count} 个不支持最高出价的地区",
    MaxPriceAffectedRegions: "本次涉及国家/地区：",
    MaxPriceAffectedRegionCount: "共 {count} 个",
    MaxPriceUnsupportedDesc: "这些地区的联系人将会发送失败，你可以返回修改目标用户，或直接确定继续创建任务。",
    MaxPriceUnsupportedTooltip: "不支持最高出价的地区（共18个）：欧洲经济体、美国、英国、中国、日本、韩国、泰国、伊朗、叙利亚、阿布哈兹、尼日利亚、南非、美国、古巴、朝鲜、委内瑞拉、克里米亚、顿涅茨克、卢甘斯克、俄罗斯、白俄罗斯、圣马丁岛、瓜德罗普、格陵兰、圣皮耶与密克隆、法属圭亚那、福克兰群岛、阿森松岛、新喀里多尼亚、法属波利尼西亚",
    MaxPriceUnsupportedFullList: "不支持地区全部名单",
    BalanceWarningDetail: "当前余额&nbsp;{balance}，预计花费&nbsp;{cost}，<span class=\"balance-warning__diff\">差额&nbsp;{diff}</span>",
    TaskNameLabelWithColon: "任务名称：",
    TemplateNameWithColon: "模板名称：",
    WabaIdWithColon: "WABA ID：",
    PushCodeWithColon: "推送码号：",
    ListSeparator: "、",
    FilterLabelItem: "「{name}」"
  },
  instruct: {
    "My-Templates": "我的模板",
    "Create-Template": "创建模板",
    "Edit-Template": "编辑模板",
    Template: "模板",
    "Step1-Basic-Command": "第一步：基础命令设置",
    "Using-Scene": "使用场景",
    "Using-Scene-Placeholder": "用于文档撰写还是行业顾问",
    "Doc-Writing": "文档撰写",
    "Industry-Advisor": "行业顾问",
    "Role-Setting": "角色设定（假设你是一位）",
    "Role-Placeholder": "互联网营销专家",
    "Output-Language-Style": "输出语言风格",
    "Mood-Placeholder": "选择以什么样的语言风格输出内容",
    "Task-Goal": "任务目标",
    "Task-Placeholder": "根据我的要求，写一份市场需求报告",
    "Step2-Form-Fields": "第二步：表单字段设置",
    "Custom-Fields": "需要用户填写的自定义字段",
    "Field-Name": "字段名称",
    "Field-Placeholder-Example": "请输入要求引导，例如：请输入品牌名称",
    "Add-Field": "增加字段",
    "Template-Preview": "模板效果预览",
    "Save-Template": "保存模板",
    "AI-Model": "使用的AI模型",
    "Output-Language": "输出语种",
    "Language-Placeholder": "选择您需要输出的语种",
    "Full-Command-Preview": "完整命令预览",
    "Command-Preview-Tip": "命令只会在创建时展示，不会在正式使用时展示",
    "Start-Generating": "开始生成",
    "Generated-Result": "生成结果预览",
    "Generated-Result-Short": "生成结果",
    Back: "返回",
    "Stop-Generating": "终止生成",
    "Template-Name": "模板名称",
    "Enter-Template-Name": "请输入模板名称",
    "Template-Desc": "模板描述",
    "Enter-Template-Desc": "请输入模板描述",
    "Use-Permission": "使用权限设置",
    "Only-Self": "仅自己使用",
    "Team-Usable": "团队可用",
    "Rule-Select-Feature": "请选择功能模块",
    "Rule-Enter-Role": "请输入角色设定",
    "Rule-Select-Mood": "请选择语气",
    "Rule-Enter-Task": "请输入任务目标",
    "Rule-Select-Permission": "请选择此模板的权限设置",
    "Rule-Add-Field": "请添加自定义字段",
    "Brand-Name": "品牌名称",
    "Enter-Brand-Name": "请输入品牌名称",
    "Instruct-You-Are": "你是一位",
    "Instruct-Role-Empty": "「角色设定未填」",
    "Instruct-Task-Empty": "「任务目标未填」",
    "Instruct-Empty": "「未填写」",
    "Instruct-Please-Use": "请使用",
    "Instruct-Mood-Output": "的语气输出内容；\n\n输出语种是：",
    "Instruct-Mood-Output-Use": "的语气输出内容，输出的语种是：",
    "Instruct-Not-Selected": "「未选择」",
    "Confirm-Stop-AI": "您要终止AI的响应吗?",
    "Confirm-Delete-Template": "此操作将永久删除该模板, 是否继续?",
    "Created-By-Me": "我创建的",
    "Created-By-Others": "其他人创建的",
    "New-Template": "新建模板",
    Generating: "正在生成...",
    "Copy-Result": "复制结果",
    All: "全部",
  },
  bot: {
    "Add-Mail-Title": "绑定新邮箱",
    "Email-Account": "邮箱账号：",
    "Enter-Correct-Email": "请输入正确的邮箱地址",
    "Email-Auth-Code": "邮箱授权码：",
    "Enter-Email-Auth-Code": "请输入邮箱授权码",
    "Usage-Desc": "用途描述：",
    "Enter-Desc": "请输入描述",
    "Service-Type": "服务类型：",
    "Enter-Email": "请输入邮箱地址",
    Server: "服务器：",
    "Host-Example": "例如：{host}",
    "Port-Example": "例如：{port}",
    "Enter-Email-Rule": "请填写邮箱地址",
    "Enter-Auth-Code-Rule": "请输入邮箱授权码",
    "Enter-Cs-Desc": "请填写客服说明",
    "Select-Service-Type": "请选择接受服务类型",
    "Enter-Receiving-Host": "请输入接收服务器地址",
    "Enter-Port": "请输入端口号",
    "Enter-Outbox-Host": "请输入发送服务器地址",
    "Enter-Port-Type": "请输入端口类型",
    "Create-Success-Confirm": "邮箱助手创建成功，并使用全局默认设置。若需要修改，请点击编辑按钮进行修改！",
    "Create-Success-Title": "创建成功",
    "Go-Edit": "去编辑",
    "Associate-Email-Success": "关联邮箱成功",
    Submit: "提交",
    "Not-Exist-Correlation": "未关联商城",
    "Mall-Name": "商城名称",
    "Mall-Platform": "商城平台",
    "Self-Build-Site": "自建站",
    "Products-Orders-Count": "商品及订单数量",
    "Order-Colon": "订单：",
    "Product-Colon": "商品：",
    "Update-Time": "更新时间",
    Operation: "操作",
    "Update-Data": "更新数据",
    "Authorized-Platforms": "已授权电商平台",
    "Select-Platform-Type": "请选择平台类型",
    "Refresh-List": "刷新列表",
    "Authorize-New-Account": "授权新账号",
    "Shopify-Shopline-Tip": "只可选择一个Shopify、Shopline店铺，可选择多个独立站",
    "Independent-Site": "独立站",
    Updating: "信息更新中...",
    "Total-Orders-Info": "共{count}条订单信息",
    "Product-Info-Suffix": "，{count}件商品信息",
    "Already-Added": "已添加到该电商",
    "Media-Account": "媒体账户：",
    "Website-Colon": "网址：",
    "Last-Update-Time": "最后更新时间：",
    "Info-Update-Success": "信息更新成功",
    "Shopify-Shopline-Only-One": "Shopify和Shopline店铺只能选择一个，请重新选择！",
    "Cancel-Correlation-Confirm": "商城的关联被取消后，机器人将不能引用商城中的数据",
    "Cancel-Correlation-Title": "取消商城关联",
    "Header-Content": "头部内容：",
    "Header-Content-Short": "头部内容",
    "Header-Content-Tip": "这是邮件的开场白部分，用于向收件人打招呼并表达问候。您可以根据邮件的正式程度选择适当的问候语",
    "Enter-Header-Content": "尊敬的客户，您好！",
    "AI-Command-Header": "请为我生成一段邮件开头模板",
    "Footer-Content": "尾部内容：",
    "Footer-Content-Short": "尾部内容",
    "Footer-Content-Tip": "结尾感谢：感谢收件人阅读邮件并可能采取的行动，这有助于传达礼貌和尊重。签名：包括您的姓名、职位和联系方式等信息，以便收件人更好地识别和联系您。",
    "AI-Command-Footer": "请为我生成一段邮件签名",
    "Enter-Mail-Header-Rule": "请输入邮件头部内容",
    "Enter-Mail-Footer-Rule": "请输入邮件尾部内容",
    "Footer-Placeholder": "如果您有任何问题或需要进一步的帮助，请随时与我们联系。我们将竭诚为您服务。\n\n\n再次感谢您的购买，祝您购物愉快！\n\n此致，\n[姓名]\n[职位]\n[公司名称]\n[手机号]\n[邮箱]\n[公司地址]",
    "Email-Preview-Title": "邮件效果预览",
    "Query-From-Payment": "查询时距离付款时间，最小 {min} 天，最大 {max} 天",
    "Join-Separator": "，",
    "Auth-Code-Help-Prefix": "（邮箱授权码说明链接请参考",
    "Auth-Code-Help-Mail": "163邮箱",
    "Auth-Code-Help-Suffix": "等）",
    "Mail-Pending-Reply": "待回复",
    "Mail-Replied": "已回复",
    "Last-Reply-Time": "最后回复时间",
    "Enter-Sender-Title-Search": "输入发件人或标题回车搜索",
    "Sender-Colon": "发件人：",
    "Handler-Colon": "处理人：",
    "Select-Email-Detail": "选择一封邮件可查看详情",
    "Mark-As-Read": "标记为已回复",
    "Sort-Method": "排序方式",
    "Sort-Desc": "倒序",
    "Sort-Asc": "正序",
    "Batch-Select": "批量选择",
    "Select-All": "全选",
    "Selected-Count": "已选择{n}个",
    "Dates-All": "全部",
    "Dates-Today": "今天",
    "Dates-Yesterday": "昨天",
    "Dates-Last-3-Days": "最近3天",
    "Dates-Last-30-Days": "最近30天",
    "Loading": "加载中...",
    "No-Data": "暂无数据",
    "Send": "发送",
    "AI-Suggest": "AI建议",
    "Reply-Colon": "回复：",
    "Enter-Reply-Content": "请输入回复内容",
    "AI-Assistant": "AI 小助手",
    "Assistant": "助手",
    "Email-Format-Invalid": "邮箱格式不正确",
    "Enter-Reply-Content-Tip": "请输入回复内容！",
    "Send-Success": "发送成功",
    "Mail-Reply": "邮件回复",
    "Confirm-Stop-AI-Reply": "您要终止AI的响应吗?",
    "Reply-Email": "回复邮件",
    "Customer-Email": "客户邮件",
    "Recipient-Colon": "收件人：",
    "Recipient": "收件人",
    "Enter-Email-Subject": "请输入邮件主题",
    "Enter-Mail-Content": "请在此处编辑邮件内容",
    "Send-Immediately": "立即发送",
    "Quick-Reply": "快捷回复",
    "Add-Quick-Reply": "添加快捷回复",
    "Edit-Quick-Reply": "编辑快捷回复",
    "Quick-Reply-Subtitle": "填写模板名称与回复内容，完成快捷回复模板设置",
    "Email-Template": "邮件模板",
    "Search-Template-Name": "搜索模板名称",
    "Add-Template": "添加模板",
    "Apply-Template": "应用模板",
    "Edit-Template": "编辑模板",
    "Save-Template": "保存模板",
    "Topic-Name": "模板名称",
    "Topic-Name-Required": "请输入模板名称",
    "Enter-Topic-Name": "请输入您的模板名称",
    "Reply-Content": "回复内容",
    "Confirm-Delete-Template": "确定删除该模板吗？",
    "More": "更多",
    "Translate": "翻译",
    "Translate-Result": "翻译结果：",
    "Translate-Success": "翻译成功",
    "Translate-Email": "翻译邮件",
    "Show-Original": "显示原文",
    "Original-Email-Below": "以下为原始邮件",
    "On-Wrote": "在 {time}，\"{user}\" 写道：",
    "Relate-Time": "关联时间：",
    "Operator-Colon": "操作人：",
    "Unbind-Relation": "解除关联",
    "Confirm-Delete-Bound-Mail": "确认删除当前绑定邮箱？",
    "Robot": "机器人",
    "Related-Mail": "关联邮箱",
    "Published-Platform": "已发布平台",
    "Customer-Service-Admin": "客服管理员",
    "Create-Time": "创建时间",
    "Scene-Data": "场景数据",
    "Scene-Count": "场景数量",
    "Scene-Count-Tip": "用户触发的场景具体数量",
    "Scene-Interaction-Count": "场景互动次数",
    "Scene-Interaction-Tip": "用户互动行为触发场景的累计次数",
    "Interaction-Data": "互动数据",
    "Export-Data": "导出数据",
    "Date": "日期",
    "User-Interaction-Count": "用户互动次数",
    "User-Interaction-Person": "用户互动人数",
    "Manual-Reply-Count": "人工回复数",
    "AI-Auto-Reply-Count": "AI自动回复数",
    "Manual-Reply-Ratio": "人工回复占比",
    "Manual-Reply-Ratio-Text": "客服人工回复占比",
    "AI-Auto-Reply-Ratio": "AI自动回复占比",
    "Scene": "场景",
    "Interaction-Count": "互动次数",
    "Crumb-Intelligent-Robot": "智能机器人",
    "Crumb-Data-Analysis": "数据分析",
    "Crumb-Robot-Detail": "机器人详情",
    "User-Interaction-Count-Desc": "用户和机器人进行互动所产生的互动次数",
    "User-Interaction-Person-Desc": "与机器人进行互动的用户的具体人数",
    "Manual-Reply-Count-Desc": "由客服人员负责回复的客户互动相关问题",
    "AI-Auto-Reply-Count-Desc": "由AI负责回复的客户互动相关问题",
    "Manual-Reply-Ratio-Desc": "客服人工回复在总回复数中所占的百分比",
    "AI-Auto-Reply-Ratio-Desc": "AI回复在总回复数中所占的百分比",
    "Email-Colon": "邮箱：",
    "Phone-Colon": "手机号：",
    "Todo-Count": "待办{count}条",
    "Pending-Message-Count": "待回复留言{count}条",
    "Only-Show-Todo": "仅显示待办",
    "Message-Importance": "留言重要程度",
    "Todo": "待办",
    "AI-Suggestion": "AI建议",
    "Mark-Todo": "标记待办",
    "Cancel-Todo": "取消待办",
    "WhatsApp-Audio": "WhatsApp 音频 {index}",
    "Audio-Not-Supported": "当前浏览器不支持播放音频。",
    "Location": "位置",
    "No-Chat-Seven-Days": "该用户超过七天未与您的主页进行互动，无法和用户进行对话",
    "No-Chat-One-Day": "该用户超过一天未与您的主页进行互动，无法和用户进行对话",
    "No-Chat": "无法和用户进行对话",
    "No-Chat-Days": "该用户超过{days}天未与您的主页进行互动，无法和用户进行对话",
    "Input-Enter-Send": "输入内容，Enter发送",
    "Unsupported-Message-Type": "暂不支持的消息类型：{type}",
    "Document": "文档",
    "Contact": "联系人",
    "Pending-Reply": "待回复",
    // WhatsApp 会话状态 Tab，避免语言切换后继续展示中文状态。
    "WhatsApp-Message-Pending": "未处理",
    "WhatsApp-Message-Processed": "已处理",
    "Search-Name-Enter": "输入名称回车搜索",
    "Only-Unread": "仅未读",
    "All-Scenes": "全部场景",
    "Media-Attachment": "[媒体附件]",
    "Loading": "加载中...",
    "No-Results": "暂无结果",
    "Today": "今天",
    "Yesterday": "昨天",
    "Last-3-Days": "最近3天",
    "Last-30-Days": "最近30天",
    "Effect-Preview": "效果预览",
    "Auto-Reply-Enabled": "已开启自动回复",
    "Start": "开始",
    "Start-Tip": "轻触开始后，{name}将看到你的公开信息",
    "Locating-History": "正在定位历史会话...",
    "Click-Left-To-Reply": "点击左侧列表进行消息回复",
    "Update-Start-Date": "更新开始日期",
    "Select-Source-Channel": "请选择来源渠道",
    "Enter-Product-Name": "请输入商品名称",
    "Total-Product-Info": "共有 {count} 条商品信息",
    "No-Related-Shopify-Shopline": "当前机器人未关联Shopify 和 Shopline平台店铺!",
    "Customer-Service-Bot": "客服机器人",
    "Configure-Bot": "配置机器人",
  },
  // AI 机器人接口列表、创建/编辑表单、场景设置、本地模拟交互及停用确认弹窗的可见文案。
  aiRobot: {
    pageTitle: "AI机器人",
    createRobot: "创建机器人",
    searchPlaceholder: "请输入机器人名称或创建人",
    statusPlaceholder: "请选择启用状态",
    allStatuses: "全部",
    enabled: "启用",
    disabled: "停用",
    disableConfirmTitle: "确认停用机器人？",
    disableConfirmDescription: "停用后，{name} 将停止自动回复消息。已设置场景将保留，可随时重新启用。",
    close: "关闭",
    robot: "机器人",
    enableSwitch: "启用开关",
    servicePlatform: "服务平台",
    robotType: "机器人类型",
    linkedAccounts: "关联账号数量",
    creator: "创建人",
    createdAt: "创建时间",
    actions: "操作",
    noDescription: "暂无描述",
    onlineService: "在线客服",
    // 列表操作进入完整的机器人设置流程，场景设置仍是流程内的子页面。
    configureRobot: "设置机器人",
    more: "更多",
    edit: "编辑",
    copyRobot: "复制机器人",
    deleteRobot: "删除",
    me: "我",
    // 列表分页的总条数来自接口，跳页提示随当前语言切换。
    totalCount: "共 {count} 条",
    goTo: "跳转至",
    page: "页",
    empty: "暂无机器人",
    // 列表请求失败单独提示，避免把网络错误误显示为空列表。
    listLoadFailed: "机器人列表加载失败",
    retry: "重试",
    createTitle: "创建机器人",
    editTitle: "编辑机器人",
    // 编辑抽屉先打开，再等待详情接口填充完整表单。
    detailLoading: "正在加载机器人信息...",
    // 创建和编辑抽屉共用头像提示、字段占位和启用说明，与两张设计稿保持一致。
    avatarLabel: "机器人头像",
    avatarChange: "点击更换机器人头像",
    avatarHint: "支持 JPG / PNG，建议 1:1 正方形，文件不超过 2MB",
    avatarInvalidType: "仅支持 JPG 或 PNG 图片",
    avatarTooLarge: "图片大小不能超过 2MB",
    name: "机器人名称",
    namePlaceholder: "请输入机器人名称，便于在列表中快速识别",
    description: "机器人描述",
    descriptionPlaceholder: "简要说明机器人的服务范围与能力，方便团队协作时快速了解",
    enableStatus: "启用状态",
    enableHint: "开启后，机器人将立即对该服务平台上的新联系人生效",
    cancel: "取消",
    save: "保存",
    create: "创建",
    // 创建与编辑请求分别显示进度；团队缺失、保存失败或头像缺少 OSS Key 时给出明确提示。
    creating: "创建中...",
    saving: "保存中...",
    createFailed: "创建机器人失败，请重试",
    editFailed: "保存机器人失败，请重试",
    teamMissing: "无法获取当前团队，请刷新页面后重试",
    avatarUploadFailed: "头像上传失败，请重试",
    nameRequired: "请输入机器人名称",
    created: "创建成功",
    saved: "保存成功",
    // 启停请求按机器人 ID 和目标状态核对回执，失败时保留原开关和停用确认弹窗。
    updatingStatus: "提交中...",
    statusUpdated: "机器人状态更新成功",
    statusUpdateFailed: "更新机器人状态失败，请重试",
    copied: "复制成功",
    // 复制由服务端执行，等待期间显示进度；旧会话中的本地演示副本不能作为接口源数据。
    copying: "复制中...",
    copyFailed: "复制机器人失败，请重试",
    copyUnavailable: "本地演示机器人无法复制",
    deleted: "删除成功",
    // 删除确认框展示具体机器人名称；软删除仅在服务端回传同一 ID 后显示成功。
    deleting: "删除中...",
    deleteFailed: "删除机器人失败，请重试",
    deleteDialogTitle: "确认删除机器人？",
    deleteDialogDescription: "删除后，{name} 将无法恢复。确认删除机器人吗？",
    deleteDialogConfirm: "确认",
    linkedSummary: "已关联 {count} 个账号",
    // 关联账号抽屉从 WhatsApp 主页接口读取明细，加载、空结果和失败分别提示。
    accountsDrawer: {
      title: "关联账号",
      accountCount: "{count} 个账号",
      linkedSummary: "已关联 {count} 个 WABA 账号",
      accountInfo: "账号信息",
      companyVerification: "公司认证状态",
      accountStatus: "账号状态",
      linkedPhone: "关联手机",
      messageUsage: "消息使用/上限",
      // 关联账号抽屉与列表分页保持相同的中文跳页文案。
      goTo: "跳转至",
      page: "页",
      empty: "暂无关联账号",
      loading: "加载中...",
      loadFailed: "账号加载失败",
      retry: "重试",
      close: "关闭",
      // 公司认证数值与账号审核枚举共用抽屉状态标签。
      statuses: {
        verified: "已认证",
        unverified: "未认证",
        companyRejected: "未通过",
        certificationFailed: "认证失败",
        reviewing: "审核中",
        approved: "已批准",
        disabled: "已禁用",
        pending: "等待",
        rejected: "拒绝",
        expired: "已过期",
        failed: "失败",
        ineligible: "不合格",
        notVerified: "未验证",
        pendingNeedMoreInfo: "待定",
        pendingSubmission: "待提交",
        revoked: "吊销",
        accountVerified: "已验证",
        disconnected: "未连接",
        unbound: "已解绑",
      },
    },
    sceneSummary: "已设置 {count} 个场景",
    // 场景设置与调试预览共用这些文案，便于机器人列表进入设置页后保持语言切换一致。
    settings: {
      breadcrumb: "设置机器人",
      back: "返回机器人列表",
      orchestration: "编排",
      capabilities: "能力",
      knowledgeBase: "知识库",
      ecommercePlatform: "电商平台",
      title: "场景设置",
      introduction: "定义机器人接待哪些咨询、以什么语气作答，以及资料不足时的回答边界",
      replyStyleTitle: "1. 回复风格",
      replyStyleDescription: "机器人回复客户时的语气与语种策略",
      toneLabel: "回复语气",
      // 五种服务端语气与旧会话中的友好、简洁文案并存，避免旧草稿显示空选项。
      toneFormal: "正式",
      toneProfessional: "专业",
      toneRelaxed: "轻松",
      toneRigorous: "严谨",
      toneHumorous: "幽默",
      toneFriendly: "友好",
      toneConcise: "简洁",
      fallbackLanguageLabel: "备用语言",
      // 备用语言说明以联系人语种检测失败为前提，默认回复仍使用原语言。
      fallbackLanguageTip: "无法检测到联系人语种的时候，使用此语言进行回复，默认使用原语言进行回复。",
      receptionTitle: "2. 接待范围",
      receptionDescription: "什么情况下由 AI 接待，以及资料不足时回答到什么程度",
      autoReplyScene: "自动回复场景设置",
      autoReplyPlaceholder: "请输入机器人自动回复场景及接待要求",
      promptRequired: "请填写自动回复场景设置",
      officialVersion: "使用官方模版",
      answerModeTitle: "命中场景后的回答方式",
      answerModeDescription: "命中自动回复场景后，AI 回答时是否可以使用知识库与电商数据以外的内容",
      answerStrictTitle: "只依据资料作答",
      answerStrictDescription: "资料未覆盖时不猜、不延伸，不做回答",
      answerBalancedTitle: "优先依据资料，未覆盖时自由发挥",
      answerBalancedDescription: "资料未覆盖的问题由 AI 自行回答",
      answerFreeTitle: "允许 AI 自由发挥",
      answerFreeDescription: "不要求回答来自资料，资料只作为参考",
      // 场景页只引导进入发布确认，真正发布仍在下一页完成。
      skip: "暂不设置",
      next: "下一步",
      published: "发布成功",
      previewTab: "调试预览",
      robotInfoTab: "机器人信息",
      previewPlaceholder: "Enter 发送，请输入消息测试机器人回复...",
      // 发送工具栏复用 WhatsApp 客服文案；场景未匹配转人工与请求失败分别提示。
      previewReplyFailed: "机器人回复失败，请重试",
      previewSendFailed: "回复失败",
      previewTransferred: "会话已转接给人工客服",
      previewRetry: "重试",
      previewUnavailable: "演示机器人无法调试，请选择已创建的机器人",
      previewToneInvalid: "请选择有效的回复语气",
      previewAnswerModeInvalid: "请选择有效的回答方式",
      previewUploadFailed: "文件上传失败",
      previewAttachmentInvalid: "文件格式、大小或数量不符合要求",
      previewAiReply: "由 AI 自动回复",
      robotName: "机器人名称",
      robotDescription: "机器人描述",
      robotStatus: "启用状态",
      // 机器人信息页签按设计展示摘要、版本和完整字段，版本时间保留本地模拟发布日期。
      // 新版信息页签将发布时间与版本分行展示，并按基础信息、描述和发布信息分组。
      infoType: "机器人类型",
      infoPlatform: "服务平台",
      infoVersion: "当前版本",
      infoDescription: "机器人描述",
      infoPublishTitle: "发布信息",
      infoPublishedAt: "发布时间",
      infoEnabled: "已启用",
      infoDisabled: "已停用",
      infoEmptyDescription: "暂无描述",
    },
    // 发布确认页校验说明并显示提交进度；待确认结果及历史接口的加载与重试状态也使用这组文案。
    publishPage: {
      title: "发布与版本",
      subtitle: "查看发布记录，发布当前配置为新版本",
      currentVersion: "当前生效版本：{version}",
      noVersion: "暂无生效版本",
      releaseMeta: "{date} 由 {name} 发布",
      releasedAt: "发布时间",
      releasedBy: "发布人",
      sectionSettings: "1. 发布设置",
      impactLabel: "发布后对进行中的会话",
      impactNew: "仅新会话生效（推荐）",
      impactAll: "所有会话立即生效",
      noteLabel: "发布说明",
      notePlaceholder: "简要描述本次修改内容，便于回溯",
      noteRequired: "请输入发布说明",
      toneUnsupported: "当前回复语气不支持发布，请重新选择",
      answerModeInvalid: "请选择有效的回答方式",
      sectionHistory: "2. 版本历史",
      versionLabel: "版本 {version}",
      currentTag: "当前",
      previous: "上一步",
      publish: "发布",
      publishLoading: "发布中...",
      publishFailed: "发布失败，请重试",
      publishPending: "服务端已返回成功，但版本暂未确认，请稍后查看历史记录",
      unknownPublisher: "未知",
      emptyHistory: "暂无发布记录",
      historyLoadFailed: "版本历史加载失败",
      historyRetry: "重试",
      historyLoadMore: "加载更多",
      historyLoading: "加载中...",
    },
    // 知识库列表共用服务端状态、错误提示和本地演示抽屉文案。
    knowledge: {
      searchPlaceholder: "请输入资料名称",
      statusPlaceholder: "请选择训练状态",
      add: "新增资料",
      addUpload: "上传资料",
      addLink: "按链接提取",
      tableName: "机器人",
      status: "训练状态",
      usageCount: "使用次数",
      creator: "创建人",
      createdAt: "创建时间",
      actions: "操作",
      sourcePrefix: "来源：",
      sourceUpload: "上传文档",
      sourceLink: "网页链接",
      sourceOnline: "在线撰写",
      statusTraining: "训练中",
      statusCompleted: "训练完成",
      statusFailed: "训练失败",
      loadFailed: "知识库加载失败",
      retry: "重试",
      createFailed: "新增资料失败，请重试",
      updateFailed: "更新资料失败，请重试",
      edit: "编辑资料",
      // 三种来源编辑前都查询标题与正文，避免列表摘要替代原文。
      detailFetching: "加载中...",
      detailLoadFailed: "资料详情加载失败，请重试",
      delete: "删除",
      empty: "暂无资料",
      addTitle: "新增资料",
      editTitle: "编辑资料",
      nameLabel: "资料名称",
      namePlaceholder: "请输入资料名称",
      sourceLabel: "资料来源",
      detailLabel: "资料内容",
      detailPlaceholder: "请输入资料内容",
      chooseFile: "选择文件",
      cancel: "取消",
      save: "保存",
      // 删除弹窗展示具体资料名称和训练影响；真实资料以服务端删除结果为准。
      deleteDialogTitle: "删除资料",
      deleteDialogDescription: "删除后，{name} 将不再参与回复训练；删除后这类问题的作答质量可能下降。确认删除吗？",
      deleteDialogCancel: "取消",
      deleteDialogConfirm: "确定",
      created: "新增成功",
      saved: "保存成功",
      deleted: "删除成功",
      deleteFailed: "删除资料失败，请重试",
      nameRequired: "请输入资料名称",
      // 在线撰写按设计稿提供标题、富文本正文和确认操作，不触发真实上传接口。
      onlineTitle: "在线撰写",
      onlineNameLabel: "资料标题",
      onlineNamePlaceholder: "请输入资料标题",
      onlineNameRequired: "请输入资料标题",
      onlineContentLabel: "资料内容",
      onlineContentPlaceholder: "请输入资料内容，例如：产品介绍、常见问题与标准答复话术……",
      onlineUndo: "撤销",
      onlineRedo: "重做",
      onlineConfirm: "确认",
      onlineContentRequired: "请输入资料内容",
      // 上传抽屉先提交临时文件，再调用入库接口；两个请求阶段分别显示加载文案。
      uploadTitle: "上传资料",
      uploadLocalLabel: "本地上传",
      uploadDropPrompt: "拖拽文件到此处或点击上传",
      // 文件格式与大小以知识库单文件上传接口为准，上传后再解析入库。
      uploadHintLine1: "支持 .txt、.pdf、.ppt、.pptx、.doc、.docx；TXT 不超过 800KB，其他不超过 200MB，",
      uploadHintLine2: "最多可选择 100 个文件",
      uploadSelectedFiles: "已选文件",
      uploadConfirm: "确认",
      uploadFile: "上传文件",
      uploadUploading: "上传中...",
      uploadStore: "解析入库",
      uploadStoring: "解析中...",
      uploadReady: "已上传，待入库",
      uploadFailed: "文件上传失败，请重试",
      uploadStoreFailed: "解析入库失败，请重试",
      uploadStored: "{count} 份资料已入库",
      uploadStorePartial: "{count} 份文件入库失败，请重新上传",
      uploadReselect: "文件已失效，请移除后重新选择",
      uploadPickFile: "选择文件",
      uploadRemoveFile: "移除文件：{name}",
      uploadNoFiles: "请先选择文件",
      uploadInvalidType: "仅支持 TXT、PDF、PPT、PPTX、DOC 和 DOCX 文件",
      uploadTxtTooLarge: "TXT 文件不能超过 800KB",
      uploadOtherTooLarge: "文件不能超过 200MB",
      uploadTooManyFiles: "最多可选择 {count} 个文件",
      uploadDuplicateFile: "文件已添加：{name}",
      // 抓取链接抽屉保留设计稿的提醒、两种抓取方式及各自的输入说明；解析结果暂存本地模拟数据。
      linkTitle: "抓取链接内容",
      linkNoticeTitle: "请避免非法抓取他人网站的侵权行为，保证链接可公开访问，且网站内容可复制！",
      linkNoticeLine1: "支持抓取单一网址和网页 URL 相关全部网址的内容；",
      linkNoticeLine2:
        "抓取网站关键字页面时，自动过滤 JS 并获取所有文本内容和以 URL 开头的所有链接。网址越多速度越慢，单次最多提交 600 个网址；",
      linkNoticeLine3: "系统将自动过滤已抓取过的内容，当系统中已存在相同内容时，将不再重复抓取。",
      linkModeLabel: "抓取方式",
      linkModeSingle: "单一链接页面",
      linkModeRelated: "链接关联页面",
      linkUrlLabel: "网站链接",
      linkUrlPlaceholder: "请输入需要抓取内容的网页链接，如 https://www.example.com",
      linkRelatedPlaceholder: "请输入http://或https://开头的链接",
      linkRelatedHint:
        "例如：您要抓取的内容地址是 https://www.example.com/active/ 下的所有内容，只需要录入 https://www.example.com/active/ 即可",
      linkAddUrl: "添加链接",
      linkRemoveUrl: "移除链接",
      linkStartParse: "开始解析URL",
      linkUrlRequired: "请至少输入一个网站链接",
      linkInvalidUrl: "请输入有效的 HTTP 或 HTTPS 网站链接",
      linkDuplicateUrl: "请勿输入重复的网站链接",
      linkTooManyUrls: "单次最多可添加 {count} 个网站链接",
      // 启动和列表接口未完成时显示虚拟进度；接口失败时保留链接输入并展示提示。
      linkParsingTitle: "正在解析链接",
      linkParsingMessage: "正在抓取网页内容，请稍候...",
      linkNoContentTitle: "提示",
      linkNoContentMessage: "您输入的链接下无任何内容，请检查或更换链接。",
      linkDialogConfirm: "确定",
      linkTaskStarted: "抓取任务已启动",
      linkStartFailed: "启动抓取失败，请重试",
      // 解析结果核对页只提交保留项；确认接口返回前保持按钮禁用并显示进度文案。
      capturedTitle: "抓取到的链接",
      capturedContent: "抓取到的内容",
      capturedCountPrefix: "共",
      capturedCountSuffix: "个链接",
      capturedBack: "上一步",
      capturedImport: "抓取资料并入库",
      capturedSubmitting: "抓取中...",
      capturedSubmitted: "已提交抓取任务",
      capturedConfirmFailed: "抓取资料失败，请重试",
      capturedOpen: "打开链接：{url}",
      capturedRemove: "移除链接：{url}",
      capturedEmpty: "暂无可入库的链接",
      capturedLoading: "正在查询链接资料...",
      capturedLoadFailed: "链接资料加载失败，请重试",
      capturedNoResults: "暂无链接资料",
      // 返回输入页会舍弃当前抓取结果，确认弹窗与设计稿保持一致。
      backConfirmTitle: "谨慎操作",
      backConfirmDescription: "返回后，当前抓取到的链接列表将被清空！",
      backConfirmCancel: "取消",
      backConfirmAccept: "确定",
    },
    // 真实机器人通过接口关联及解除电商平台；演示机器人继续使用本地样例。
    commerce: {
      title: "电商平台",
      description: "已关联的商城将作为该机器人回复时的商品与订单信息来源",
      searchPlaceholder: "请输入店铺名称或域名",
      linkButton: "关联电商平台",
      domain: "域名",
      connectedAt: "接入时间",
      independent: "独立站",
      unknownPlatform: "平台 {type}",
      empty: "暂无关联的电商平台",
      searchEmpty: "未找到匹配的电商平台",
      loading: "正在加载电商平台...",
      loadFailed: "电商平台加载失败",
      retry: "重试",
      bindLoading: "关联中...",
      bindFailed: "关联结果异常，请刷新后重试",
      bindSuccess: "已关联 {count} 个电商平台",
      bindSkipped: "所选电商平台已关联",
      // 批量关联可能部分成功；向用户说明跳过量及具体未找到的平台。
      bindWithSkipped: "已关联 {bound} 个，已跳过 {skipped} 个已关联的平台",
      bindPartial: "已关联 {bound} 个，已跳过 {skipped} 个，未找到 {notFound} 个：{missing}",
      bindNoChanges: "本次没有关联新的电商平台",
      remove: "取消关联",
      linkDialogDescription: "选择要接入该机器人的电商网站，接入后可查询其商品与订单信息，支持多选",
      linkSelectPlaceholder: "请输入平台名称",
      linkSearch: "搜索平台",
      linkAvailableCount: "可关联 {count} 个",
      linkSelectedCount: "已选 {count} 个",
      alreadyLinked: "已关联",
      linkedAt: "接入于 {time}",
      linkNone: "暂无可关联的电商平台",
      linkSearchEmpty: "未找到匹配的电商平台",
      linkCancel: "取消",
      linkConfirm: "确认",
      chooseStore: "请先选择店铺",
      linked: "关联成功",
      unlinkTitle: "解除关联",
      unlinkConfirm: "解除后，{name} 将不再为该机器人的回复提供商品与订单信息，确认解除关联吗？",
      unlinkAccept: "确定",
      // 解除关联使用平台 ID；响应异常时保留确认弹窗供用户核对或重试。
      unlinkMissingPlatformId: "缺少电商平台 ID，无法解除关联",
      unlinkFailed: "解除关联失败，请重试",
      unlinked: "已解除关联",
    },
  },
  // JoinCompass 首页全部可见文案，供头部语言控件切换。
  joinCompass: {
    header: {
      menu: "打开菜单",
      stock: "上市公司 · 股票代码002279",
      demo: "预约演示",
      trial: "免费试用",
    },
    actions: {
      trial: "开启免费试用",
      demo: "立即预约演示",
    },
    hero: {
      tag: "· Meta 广告一级代理 ·",
      titleFirst: "JoinCompass",
      titleSecond: "AI+跨境全域交互运营平台",
      description: "广告引流 + 公域运营 + 私域承接 = 闭环增长",
      productAlt: "JoinCompass 全渠道客户触点追踪示意图",
      carouselLabel: "JoinCompass 产品展示轮播图",
      carouselItemLabel: "切换至第 {number} 张首屏切图",
    },
    // WhatsApp 方案作为首页第二张首屏切图，文案与现有首页轮播保持同一语言切换能力。
    whatsappHero: {
      tag: "· Meta 广告一级代理 ·",
      titleFirst: "开启 WhatsApp 全生命周期",
      titleSecond: "驱动私域持续增长",
      description: "触达 - 留存 - 激活 - 转化 - 复购",
      primaryAction: "使用 WhatsApp",
      secondaryAction: "获取更多信息",
      productAlt: "WhatsApp 全生命周期私域增长示意图",
    },
    channels: {
      title: "全渠道聚合",
      description: "连接社媒、通讯、邮件与电商渠道，统一连接每一个客户触点",
    },
    capabilities: {
      title: "核心能力",
      tabList: "核心能力分类",
      publicLabel: "公域运营",
      publicDescription: "全渠道一键发布 + 社媒评论管理 + 恶评自动隐藏",
      privateLabel: "私域承接",
      privateDescription: "统一沉淀客户触点，持续推动每一次有效沟通",
      managementLabel: "企业管理",
      managementDescription: "统一管理业务数据与团队协作，让增长过程更清晰",
    },
    growth: {
      titleFirst: "每一次交互",
      titleSecond: "都是一次增长机会",
    },
    demoDialog: {
      close: "关闭预约演示弹窗",
      title: "预约产品演示",
      description: "扫码添加专属顾问，预约一对一演示，详细了解 JoinCompassAI 功能",
      qrcodeAlt: "预约演示产品联系人二维码",
      hint: "扫码添加专属顾问",
    },
    // JoinCompassAI 专属注册弹窗文案，不复用旧产品的推荐码中文硬编码。
    register: {
      referralLabel: "推荐人编码（选填）",
      referralPlaceholder: "请输入推荐人编码",
    },
    footer: {
      platform: "AI+跨境全域交互运营平台",
      officialAccount: "官方公众号",
      productContact: "产品联系人",
      compliance: "合规准则",
      privacy: "隐私协议",
      agreement: "用户协议",
      about: "关于我们",
      listedCompany: "上市公司简介",
      overseasResources: "出海广告资源",
      aiMaterials: "JoinSpark AI素材制作",
      copyright: "版权所有 ©2012-2026 久其数字传播有限公司",
      icp: "京ICP备18018614号-6",
      license: "增值电信业务经营许可证：京B2-20203609",
      police: "京公网安备11030102011668号",
    },
  },
};
